
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("22lcC", function(module, exports) {

$parcel$export(module.exports, "WelcomeModalRenderer", () => (parcelRequire("4pZOP")).WelcomeModalRenderer);
$parcel$export(module.exports, "TransitionHomeRenderer", () => (parcelRequire("bZaKv")).TransitionHomeRenderer);

var $hhjRL = parcelRequire("hhjRL");


var $1ZNqu = parcelRequire("1ZNqu");

var $4is2C = parcelRequire("4is2C");

var $7EfKv = parcelRequire("7EfKv");

var $7eOF3 = parcelRequire("7eOF3");



var $91SM8 = parcelRequire("91SM8");

var $2Q2AK = parcelRequire("2Q2AK");

var $dc8n7 = parcelRequire("dc8n7");

var $4pZOP = parcelRequire("4pZOP");

var $bZaKv = parcelRequire("bZaKv");

var $hO8H1 = parcelRequire("hO8H1");


var $14cXh = parcelRequire("14cXh");

var $5W4zT = parcelRequire("5W4zT");

var $7gA9Z = parcelRequire("7gA9Z");

var $9z07y = parcelRequire("9z07y");

var $lzGyk = parcelRequire("lzGyk");

});
parcelRegister("1ZNqu", function(module, exports) {

$parcel$export(module.exports, "IconBoxColor", () => $22894bb701968d0f$export$623c74fa92b04e19);
$parcel$export(module.exports, "IconBox", () => $22894bb701968d0f$export$7b426249814eb7c3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");
const $22894bb701968d0f$export$623c74fa92b04e19 = {
    Blue: 'blue',
    Gray: 'gray',
    Green: 'green',
    Lime: 'lime',
    Orange: 'orange',
    Purple: 'purple',
    Red: 'red',
    Teal: 'teal',
    Yellow: 'yellow',
    Magenta: 'magenta'
};
const $22894bb701968d0f$export$7b426249814eb7c3 = ({ color: color, icon: icon, iconSize: iconSize = 'medium', withCustomContainer: withCustomContainer })=>{
    const getColorStyle = ()=>{
        switch(color){
            case 'gray':
                return {
                    xcss: $22894bb701968d0f$var$grayStyles,
                    color: "var(--ds-icon-accent-gray, #758195)"
                };
            case 'green':
                return {
                    xcss: $22894bb701968d0f$var$greenStyles,
                    color: "var(--ds-icon-accent-green, #00875A)"
                };
            case 'lime':
                return {
                    xcss: $22894bb701968d0f$var$limeStyles,
                    color: "var(--ds-icon-accent-lime, #6A9A23)"
                };
            case 'orange':
                return {
                    xcss: $22894bb701968d0f$var$orangeStyles,
                    color: "var(--ds-icon-accent-orange, #FF991F)"
                };
            case 'purple':
                return {
                    xcss: $22894bb701968d0f$var$purpleStyles,
                    color: "var(--ds-icon-accent-purple, #6554C0)"
                };
            case 'red':
                return {
                    xcss: $22894bb701968d0f$var$redStyles,
                    color: "var(--ds-icon-accent-red, #FF5630)"
                };
            case 'teal':
                return {
                    xcss: $22894bb701968d0f$var$tealStyles,
                    color: "var(--ds-icon-accent-teal, #00A3BF)"
                };
            case 'yellow':
                return {
                    xcss: $22894bb701968d0f$var$yellowStyles,
                    color: "var(--ds-icon-accent-yellow, #FFE380)"
                };
            case 'magenta':
                return {
                    xcss: $22894bb701968d0f$var$magentaStyles,
                    color: "var(--ds-icon-accent-magenta, #CD519D)"
                };
            default:
                return {
                    xcss: $22894bb701968d0f$var$blueStyles,
                    color: "var(--ds-icon-accent-blue, #4C9AFF)"
                };
        }
    };
    const Icon = icon;
    if (withCustomContainer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: [
            $22894bb701968d0f$var$boxStyles,
            getColorStyle().xcss
        ],
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22894bb701968d0f$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        size: iconSize,
        primaryColor: getColorStyle().color,
        label: ""
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: [
            $22894bb701968d0f$var$boxStyles,
            getColorStyle().xcss
        ],
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        size: iconSize,
        primaryColor: getColorStyle().color,
        label: ""
    }));
};
const $22894bb701968d0f$var$boxStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.100',
    flexShrink: 0,
    width: 'size.200',
    height: 'size.200'
});
const $22894bb701968d0f$var$blueStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.blue.subtlest'
});
const $22894bb701968d0f$var$grayStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest'
});
const $22894bb701968d0f$var$greenStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.green.subtlest'
});
const $22894bb701968d0f$var$limeStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.lime.subtlest'
});
const $22894bb701968d0f$var$orangeStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.orange.subtlest'
});
const $22894bb701968d0f$var$purpleStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.purple.subtlest'
});
const $22894bb701968d0f$var$redStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.red.subtlest'
});
const $22894bb701968d0f$var$tealStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.teal.subtlest'
});
const $22894bb701968d0f$var$yellowStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.yellow.subtlest'
});
const $22894bb701968d0f$var$magentaStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.magenta.subtlest'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $22894bb701968d0f$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1b941txw _14ca1h6o _11nn1h6o _e2oogktf _1xjxgktf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4is2C", function(module, exports) {

$parcel$export(module.exports, "TransitionHelpPanelIcon", () => $a66a8e43ccc62794$export$aa2c1ff8866c1c62);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");
const $a66a8e43ccc62794$export$aa2c1ff8866c1c62 = (props)=>{
    const { primaryColor: primaryColor, size: size, label: label } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), {
        primaryColor: primaryColor,
        size: size,
        label: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "currentColor",
        d: "M8.1926 18.5576c-.27 0-.55-.11-.76-.32-.42-.42-.42-1.1 0-1.52l4.71-4.71-4.75-4.74c-.42-.42-.42-1.1 0-1.52.42-.42 1.1-.42 1.52 0l5.51 5.51c.2.2.32.48.32.76s-.11.56-.32.76l-5.47 5.47c-.21.21-.49.32-.76.32v-.01Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "currentColor",
        d: "M13.9524 18.5576c-.28 0-.55-.11-.76-.32-.42-.42-.42-1.1 0-1.52l4.71-4.71-4.75-4.74c-.42-.42-.42-1.1 0-1.52.42-.42 1.1-.42 1.52 0l5.51 5.51c.42.42.42 1.1 0 1.52l-5.47 5.47c-.21.21-.48.32-.76.32v-.01ZM5.8324 14.3275c1.2869 0 2.33-1.0432 2.33-2.33 0-1.2868-1.0431-2.33-2.33-2.33-1.2868 0-2.33 1.0432-2.33 2.33 0 1.2868 1.0432 2.33 2.33 2.33Z"
    }));
};

});

parcelRegister("7EfKv", function(module, exports) {

$parcel$export(module.exports, "Wizard", () => $0c4b28b142e261f5$export$c6a37f46d6629cf2);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $gpZWO = parcelRequire("gpZWO");

var $cSu9v = parcelRequire("cSu9v");

var $jWuk1 = parcelRequire("jWuk1");

var $aOw1G = parcelRequire("aOw1G");
var $dxopF = parcelRequire("dxopF");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $4q38b = parcelRequire("4q38b");

var $kGQen = parcelRequire("kGQen");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $fQpir = parcelRequire("fQpir");

var $3DX3T = parcelRequire("3DX3T");

var $h4zOy = parcelRequire("h4zOy");

var $ikbtU = parcelRequire("ikbtU");

var $8QX8y = parcelRequire("8QX8y");

var $fk1Jw = parcelRequire("fk1Jw");

var $1SlSv = parcelRequire("1SlSv");

var $eiz0L = parcelRequire("eiz0L");

var $cFzoW = parcelRequire("cFzoW");

var $lBrwc = parcelRequire("lBrwc");

var $fZ4Dk = parcelRequire("fZ4Dk");

var $lzGyk = parcelRequire("lzGyk");

var $hhjRL = parcelRequire("hhjRL");


var $9piru = parcelRequire("9piru");

var $gqg1q = parcelRequire("gqg1q");
var $iJ4iV = parcelRequire("iJ4iV");
var $hu1EK = parcelRequire("hu1EK");
var $lkWvS = parcelRequire("lkWvS");
var $ktcUm = parcelRequire("ktcUm");
const $0c4b28b142e261f5$export$c6a37f46d6629cf2 = ({ isOpen: isOpen, onClose: onClose, defaultStep: defaultStep = 0, onUnlock: onUnlock })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const theme = (0, $4q38b.default)();
    const isDarkMode = theme.colorMode === 'dark';
    const [currentStep, setCurrentStep] = (0, $eUqFw.useState)(defaultStep);
    const { update: update } = (0, $hhjRL.useOgConsolidationUserState)();
    const [isUnlocking, setIsUnlocking] = (0, $eUqFw.useState)(false);
    const { activateTransitionHome: activateTransitionHome, openTransitionHomeModal: openTransitionHomeModal, isTransitionHomeLoading: isTransitionHomeLoading } = (0, $lzGyk.useGlobalChangeboarding)();
    const steps = [
        {
            id: 'step-1',
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hu1EK.StepOne), null),
            vector: {
                light: (0, (/*@__PURE__*/$parcel$interopDefault($1SlSv))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($fk1Jw)))
            }
        },
        {
            id: 'step-2',
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ktcUm.StepTwo), null),
            vector: {
                light: (0, (/*@__PURE__*/$parcel$interopDefault($fZ4Dk))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($lBrwc)))
            }
        },
        {
            id: 'step-3',
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkWvS.StepThree), null),
            vector: {
                light: (0, (/*@__PURE__*/$parcel$interopDefault($cFzoW))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($eiz0L)))
            }
        },
        {
            id: 'step-4',
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJ4iV.StepFour), null),
            vector: {
                light: (0, (/*@__PURE__*/$parcel$interopDefault($8QX8y))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($ikbtU)))
            }
        },
        {
            id: 'step-5',
            // If started from step 5, it means we weren't the one unlocking it
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gqg1q.StepFive), {
                isFirstUnlocked: defaultStep !== (0, $c3a508c467a117cf$export$75f90732d1326d15)
            }),
            // todo: update the dark vector when it is ready
            vector: {
                light: (0, (/*@__PURE__*/$parcel$interopDefault($h4zOy))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($h4zOy)))
            }
        }
    ];
    const isFirstStep = currentStep === 0;
    const isUnlockStep = currentStep === 3;
    const isUnlockedStep = currentStep === (0, $c3a508c467a117cf$export$75f90732d1326d15);
    (0, $eUqFw.useEffect)(()=>{
        // Immediately update user state when entering the last step
        if (isUnlockedStep && isOpen) update({
            isWelcomeModalDisplayed: true
        }).catch(()=>{
            // If an error occurs, close the modal
            onClose();
        });
    // Here we don't include onClose as it is probably an inlined function
    // with a state update. It is totally fine to call the initial function
    // passed in when the update is first called even though it is now stale.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isUnlockedStep,
        update,
        isOpen
    ]);
    const handlePrevButton = (e, analyticsEvent)=>{
        if (isFirstStep) onClose();
        else if (isUnlockedStep) {
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'closeTransitionWizardInUnlockStep');
            onClose();
            activateTransitionHome();
        } else setCurrentStep((prevState)=>prevState - 1);
    };
    const handleNextButton = ()=>{
        if (isUnlockStep) {
            // should send request to BE for unlock
            setIsUnlocking(true);
            onUnlock?.().then(()=>{
                setCurrentStep((prevState)=>prevState + 1);
            }).finally(()=>{
                setIsUnlocking(false);
            });
            return;
        }
        if (isUnlockedStep) {
            activateTransitionHome();
            openTransitionHomeModal().then(()=>{
                onClose();
            });
            return;
        }
        setCurrentStep((prevState)=>prevState + 1);
    };
    const primaryButtonText = (0, $eUqFw.useMemo)(()=>{
        if (isUnlockStep) return formatMessage((0, $9piru.messages).unlockButton);
        if (isUnlockedStep) return formatMessage((0, $9piru.messages).getStartedButton);
        return formatMessage((0, $9piru.messages).nextButton);
    }, [
        formatMessage,
        isUnlockStep,
        isUnlockedStep
    ]);
    const secondaryButtonText = (0, $eUqFw.useMemo)(()=>{
        if (isFirstStep) return formatMessage((0, $9piru.messages).closeButton);
        if (isUnlockedStep) return formatMessage((0, $9piru.messages).remindMeLaterButton);
        return formatMessage((0, $9piru.messages).backButton);
    }, [
        formatMessage,
        isFirstStep,
        isUnlockedStep
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        height: "700px",
        width: 1100,
        onClose: onClose,
        shouldCloseOnOverlayClick: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $0c4b28b142e261f5$var$contentContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        xcss: [
            $0c4b28b142e261f5$var$halfWidthStyles,
            $0c4b28b142e261f5$var$leftColumnStyles,
            isUnlockedStep && $0c4b28b142e261f5$var$leftColumnUnlockedStyles
        ],
        justifyContent: isUnlockedStep ? 'end' : 'center',
        rowGap: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        rowGap: "space.100"
    }, !isUnlockedStep && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $0c4b28b142e261f5$var$locatorStyles
    }, formatMessage((0, $9piru.messages).stepLocator, {
        stepNumber: currentStep + 1,
        // last step is unlocked step
        totalSteps: steps.length - 1
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, steps[currentStep].component)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $0c4b28b142e261f5$var$actionsStyles,
        columnGap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: !isFirstStep && !isUnlockedStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gpZWO))), {
            label: ""
        }) : undefined,
        onClick: handlePrevButton,
        appearance: isUnlockedStep ? 'subtle' : 'default'
    }, secondaryButtonText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        iconAfter: !isUnlockStep && !isUnlockedStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
            label: ""
        }) : undefined,
        onClick: handleNextButton,
        appearance: "primary",
        isLoading: isUnlocking || isTransitionHomeLoading
    }, primaryButtonText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: [
            $0c4b28b142e261f5$var$halfWidthStyles,
            $0c4b28b142e261f5$var$rightColumnStyles,
            isDarkMode ? $0c4b28b142e261f5$var$rightColumnDarkStyles : $0c4b28b142e261f5$var$rightColumnLightStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        role: "img",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            backgroundImage: `url(${isDarkMode ? steps[currentStep].vector?.dark : steps[currentStep].vector?.light})`
        },
        xcss: $0c4b28b142e261f5$var$rightVectorStyles
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0c4b28b142e261f5$var$closeIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: ""
        }),
        "aria-label": formatMessage((0, $9piru.messages).closeButton),
        onClick: onClose
    }))))));
};
const $0c4b28b142e261f5$var$actionsStyles = (0, $1ZAYh.xcss)({
    alignSelf: 'flex-end'
});
const $0c4b28b142e261f5$var$contentContainerStyles = (0, $1ZAYh.xcss)({
    height: '100%',
    position: 'relative'
});
const $0c4b28b142e261f5$var$locatorStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $0c4b28b142e261f5$var$leftColumnStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.800',
    paddingRight: 'space.800'
});
const $0c4b28b142e261f5$var$leftColumnUnlockedStyles = (0, $1ZAYh.xcss)({
    paddingBottom: 'space.1000'
});
const $0c4b28b142e261f5$var$halfWidthStyles = (0, $1ZAYh.xcss)({
    width: '50%',
    flexShrink: 0
});
const $0c4b28b142e261f5$var$rightColumnStyles = (0, $1ZAYh.xcss)({
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderTopRightRadius: 'border.radius.100',
    borderBottomRightRadius: 'border.radius.100'
});
const $0c4b28b142e261f5$var$rightVectorStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $0c4b28b142e261f5$var$rightColumnLightStyles = (0, $1ZAYh.xcss)({
    backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($3DX3T)))})`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $0c4b28b142e261f5$var$rightColumnDarkStyles = (0, $1ZAYh.xcss)({
    backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($fQpir)))})`
});
const $0c4b28b142e261f5$var$closeIconStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    right: 'space.200',
    top: 'space.200'
});

});
parcelRegister("gpZWO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf3f089e16becc19$var$_react = $bf3f089e16becc19$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $bf3f089e16becc19$var$_arrowLeft = $bf3f089e16becc19$var$_interopRequireDefault((parcelRequire("f4v4a")));
function $bf3f089e16becc19$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $bf3f089e16becc19$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $bf3f089e16becc19$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M12.207 5.793a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.793 3.793a1 1 0 1 1-1.415 1.414l-5.499-5.5A1 1 0 0 1 5 12.028v-.057a1 1 0 0 1 .293-.678l5.499-5.5a1 1 0 0 1 1.415 0" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $bf3f089e16becc19$var$_arrowLeft.default
    }));
$bf3f089e16becc19$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $bf3f089e16becc19$var$_default = module.exports.default = $bf3f089e16becc19$var$ArrowLeftIcon;

});
parcelRegister("f4v4a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af8f53d2717afebc$var$_react = $af8f53d2717afebc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $af8f53d2717afebc$var$_UNSAFE_baseNew = $af8f53d2717afebc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $af8f53d2717afebc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "ArrowLeft".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af8f53d2717afebc$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $af8f53d2717afebc$var$_react.default.createElement($af8f53d2717afebc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 8H15M6.75 3l-5 5 5 5"/>`
    }, props));
$af8f53d2717afebc$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $af8f53d2717afebc$var$_default = module.exports.default = $af8f53d2717afebc$var$ArrowLeftIcon;

});


parcelRegister("cSu9v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9601eacac1d33448$var$_react = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9601eacac1d33448$var$_arrowRight = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("gTPnA")));
function $9601eacac1d33448$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9601eacac1d33448$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $9601eacac1d33448$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $9601eacac1d33448$var$_arrowRight.default
    }));
$9601eacac1d33448$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $9601eacac1d33448$var$_default = module.exports.default = $9601eacac1d33448$var$ArrowRightIcon;

});
parcelRegister("gTPnA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4d9a34bffd519bc$var$_react = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c4d9a34bffd519bc$var$_UNSAFE_baseNew = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c4d9a34bffd519bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4d9a34bffd519bc$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c4d9a34bffd519bc$var$_react.default.createElement($c4d9a34bffd519bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M14.25 8H1m8.25-5 5 5-5 5"/>`
    }, props));
$c4d9a34bffd519bc$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c4d9a34bffd519bc$var$_default = module.exports.default = $c4d9a34bffd519bc$var$ArrowRightIcon;

});


parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("bFXjh", function(module, exports) {

var $9eFtX = parcelRequire("9eFtX");

var $49axs = parcelRequire("49axs");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $880187c06210b759$var$pull = $9eFtX($49axs);
module.exports = $880187c06210b759$var$pull;

});
parcelRegister("49axs", function(module, exports) {

var $3cvRc = parcelRequire("3cvRc");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $30502d761f1085cf$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $3cvRc(array, values) : array;
}
module.exports = $30502d761f1085cf$var$pullAll;

});
parcelRegister("3cvRc", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $jkhuN = parcelRequire("jkhuN");

var $2Rm6I = parcelRequire("2Rm6I");

var $74vSq = parcelRequire("74vSq");

var $b69Sx = parcelRequire("b69Sx");
/** Used for built-in method references. */ var $254b343f3ff82813$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $254b343f3ff82813$var$splice = $254b343f3ff82813$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $254b343f3ff82813$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $2Rm6I : $jkhuN, index = -1, length = values.length, seen = array;
    if (array === values) values = $b69Sx(values);
    if (iteratee) seen = $kJvGp(array, $74vSq(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $254b343f3ff82813$var$splice.call(seen, fromIndex, 1);
            $254b343f3ff82813$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $254b343f3ff82813$var$basePullAll;

});
parcelRegister("2Rm6I", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2151ae143791d52b$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $2151ae143791d52b$var$baseIndexOfWith;

});




parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("fQpir", function(module, exports) {
module.exports = new URL("right_section_bg_dark.dc17e2a1.svg", import.meta.url).toString();

});

parcelRegister("3DX3T", function(module, exports) {
module.exports = new URL("right_section_bg_light.524451d7.svg", import.meta.url).toString();

});

parcelRegister("h4zOy", function(module, exports) {
module.exports = new URL("step_five_vector.ea9a3b76.png", import.meta.url).toString();

});

parcelRegister("ikbtU", function(module, exports) {
module.exports = new URL("step_four_vector_dark.2f4a898a.png", import.meta.url).toString();

});

parcelRegister("8QX8y", function(module, exports) {
module.exports = new URL("step_four_vector_light.c758c949.png", import.meta.url).toString();

});

parcelRegister("fk1Jw", function(module, exports) {
module.exports = new URL("step_one_vector_dark.2da797b4.png", import.meta.url).toString();

});

parcelRegister("1SlSv", function(module, exports) {
module.exports = new URL("step_one_vector_light.12925b2f.png", import.meta.url).toString();

});

parcelRegister("eiz0L", function(module, exports) {
module.exports = new URL("step_three_vector_dark.dfad81df.png", import.meta.url).toString();

});

parcelRegister("cFzoW", function(module, exports) {
module.exports = new URL("step_three_vector_light.d5a90ef9.png", import.meta.url).toString();

});

parcelRegister("lBrwc", function(module, exports) {
module.exports = new URL("step_two_vector_dark.ded2e120.png", import.meta.url).toString();

});

parcelRegister("fZ4Dk", function(module, exports) {
module.exports = new URL("step_two_vector_light.9f7e6b93.png", import.meta.url).toString();

});

parcelRegister("lzGyk", function(module, exports) {

$parcel$export(module.exports, "useGlobalChangeboarding", () => $00a6090d89168554$export$e618620d6c810888);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $h4Fhh = parcelRequire("h4Fhh");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $4Wgi4 = parcelRequire("4Wgi4");

var $5ua7k = parcelRequire("5ua7k");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");
var $c7H0g = parcelRequire("c7H0g");
var $1R3n5 = parcelRequire("1R3n5");
var $gd0Sp = parcelRequire("gd0Sp");

var $dc8n7 = parcelRequire("dc8n7");

var $8OZdV = parcelRequire("8OZdV");

var $3CBya = parcelRequire("3CBya");

var $2QBwV = parcelRequire("2QBwV");

var $iIei2 = parcelRequire("iIei2");

var $bkVBU = parcelRequire("bkVBU");

var $hjidz = parcelRequire("hjidz");

var $5e5rs = parcelRequire("5e5rs");

var $2Q2AK = parcelRequire("2Q2AK");

var $dW1PF = parcelRequire("dW1PF");

var $hhjRL = parcelRequire("hhjRL");


var $201R4 = parcelRequire("201R4");
const $00a6090d89168554$var$initialState = {
    isTransitionHomeActivated: false,
    isTransitionHomeModalOpen: false,
    isWelcomeModalActivated: false,
    opsgenieBaseUrl: undefined
};
const $00a6090d89168554$var$Store = (0, $a61MH.createStore)({
    initialState: $00a6090d89168554$var$initialState,
    actions: {
        openTransitionHomeModalAction: ()=>({ setState: setState })=>{
                setState({
                    isTransitionHomeModalOpen: true
                });
            },
        closeTransitionHomeModal: ()=>({ setState: setState })=>{
                setState({
                    isTransitionHomeModalOpen: false
                });
            },
        activateTransitionHome: ()=>({ setState: setState })=>{
                setState({
                    isTransitionHomeActivated: true
                });
            },
        activateWelcomeModal: ()=>({ setState: setState })=>{
                setState({
                    isWelcomeModalActivated: true
                });
            },
        deactivateWelcomeModal: ()=>({ setState: setState })=>{
                setState({
                    isWelcomeModalActivated: false
                });
            }
    },
    name: 'global-changeboarding'
});
const $00a6090d89168554$export$2285bd7a7d8d4d7b = (0, $ggKAj.createHook)($00a6090d89168554$var$Store);
const $00a6090d89168554$export$e618620d6c810888 = ()=>{
    const isOptimalTooling = (0, $1ybV0.ff)('platform.show-optimal-tooling_brgom');
    const [isTransitionHomeLoading, setIsTransitionHomeLoading] = (0, $eUqFw.useState)(false);
    const [{ isTransitionHomeActivated: isTransitionHomeActivated, isWelcomeModalActivated: isWelcomeModalActivated, isTransitionHomeModalOpen: isTransitionHomeModalOpen }, { openTransitionHomeModalAction: openTransitionHomeModalAction, closeTransitionHomeModal: closeTransitionHomeModal, activateTransitionHome: activateTransitionHome, activateWelcomeModal: activateWelcomeModal, deactivateWelcomeModal: deactivateWelcomeModal }] = $00a6090d89168554$export$2285bd7a7d8d4d7b();
    const [{ usersWithoutAdminRole: usersWithoutAdminRole, usersWithoutCustomRole: usersWithoutCustomRole, stakeholders: stakeholders }, { initialize: initializeUsersAndRoles }] = (0, $2Q2AK.useUsersAndRolesStore)();
    const [{ counts: counts, syncedIntegrations: syncedIntegrations, discontinuedIntegrations: discontinuedIntegrations, deprecatedIntegrations: deprecatedIntegrations, incomingCallIntegrations: incomingCallIntegrations }, { initialize: initializeIntegrations }] = (0, $2QBwV.useIntegrationsStore)();
    const [{ notificationPolicies: notificationPolicies, groups: groups, heartbeats: heartbeats }, { initialize: initializeDeprecatedCounts }] = (0, $8OZdV.useDeprecatedCountsStore)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const [{ integrations: integrations, connections: connections }, { initialize: initializeChatTools, initializeForTeamAdmin: initializeChatToolsForTeamAdmin }] = (0, $dc8n7.useChatToolsStore)();
    const [{ incidentsCopyStatus: incidentsCopyStatus }, { initialize: initializeIncidentsCopyStatus }] = (0, $3CBya.useIncidentsStore)();
    const [{ loading: transitioningStatusLoading, error: transitioningStatusError }, { initialize: initializeTransitioningStatus }] = (0, $5e5rs.useTransitioningStatus)();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    const hasJsmAboveStandard = !!tenantContext.licensedProducts[0, $2edfd53057852e41$export$c8c1c8c3f8ddba61] && appEditions.serviceDesk !== (0, $6WXNs.FREE_EDITION) && appEditions.serviceDesk !== (0, $6WXNs.STANDARD_EDITION);
    const [{ teams: teams }, { initialize: initializeTeams }] = (0, $hjidz.useTeams)();
    const [{ loading: jnaAppStatusLoading, error: jnaAppStatusError }, { initialize: initializeJNAAppStatus }] = (0, $iIei2.useJNAAppStatus)();
    const [{ teamAdminStatus: teamAdminStatus }, { initialize: initializeTeamAdminStatus }] = (0, $bkVBU.useTeamAdminStatus)();
    const [{ fetchStatus: fetchStatus, opsgenieBaseUrl: opsgenieBaseUrl }] = (0, $4Wgi4.useOpsgenieBaseUrl)('eocChangeboarding');
    const isOpsgenieBaseUrlLoaded = fetchStatus === 'SUCCESS';
    const [ref] = (0, $5ua7k.useQueryParam)((0, $672ccb48920b6462$export$203403aefc029c66));
    const [isWelcomeModalOpen, setIsWelcomeModalOpen] = (0, $eUqFw.useState)(true);
    const { data: data, error: error } = (0, $hhjRL.useOgConsolidationUserState)();
    const { isTransitioning: isTransitioning, loading: tenantLoading, error: tenantError } = (0, $h4Fhh.useOgTenantInfo)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isWelcomeModalDisplayedInitialValue = (0, $eUqFw.useRef)(data?.isWelcomeModalDisplayed);
    isWelcomeModalDisplayedInitialValue.current = isWelcomeModalDisplayedInitialValue.current ?? data?.isWelcomeModalDisplayed;
    const isTransitioningInitialValue = (0, $eUqFw.useRef)(isTransitioning);
    isTransitioningInitialValue.current = isTransitioningInitialValue.current ?? isTransitioning;
    // Both of the waiting states are loaded at the SSR and should be already fetched
    // when client starts to render but just in case we should check it
    const isAllWelcomeModalDataLoaded = isWelcomeModalOpen && !tenantLoading && !tenantError && // We need to wait for the data to decide on the final state
    data?.isWelcomeModalDisplayed !== undefined && isOpsgenieBaseUrlLoaded;
    // Do not show the welcome modal until everything is ready
    // This will also prevent a render if there is an error with the initial
    // loading.
    // // We only care for the initial value, it should not change if the
    // // displayed state changes later.
    const finalWelcomeModalIsOpen = isAllWelcomeModalDataLoaded && isTransitioningInitialValue.current && !isWelcomeModalDisplayedInitialValue.current;
    const handleCloseWelcomeModal = ()=>{
        setIsWelcomeModalOpen(false);
    };
    const initializeModalRequests = (0, $eUqFw.useCallback)(()=>{
        const minimalRequiredInitializations = [
            initializeTransitioningStatus(),
            initializeJNAAppStatus()
        ];
        const isUser = !isAdmin && !isSiteAdmin;
        if (isUser) {
            if (isOptimalTooling) {
                const optimalRequiredInitializations = [
                    ...minimalRequiredInitializations,
                    initializeTeamAdminStatus(),
                    initializeChatToolsForTeamAdmin(),
                    initializeIntegrations()
                ];
                return Promise.allSettled(optimalRequiredInitializations).then((0, $dW1PF.multiplePromiseSettler));
            }
            return Promise.allSettled(minimalRequiredInitializations).then((0, $dW1PF.multiplePromiseSettler));
        }
        const minimalToolingRequests = [
            initializeChatTools(),
            initializeUsersAndRoles(hasJsmAboveStandard),
            ...minimalRequiredInitializations
        ];
        if (isOptimalTooling) {
            const optimalToolingRequests = [
                ...minimalToolingRequests,
                initializeTeams(),
                initializeTeamAdminStatus(),
                initializeIntegrations(),
                initializeDeprecatedCounts(),
                initializeIncidentsCopyStatus()
            ];
            return Promise.allSettled(optimalToolingRequests).then((0, $dW1PF.multiplePromiseSettler));
        }
        return Promise.allSettled(minimalToolingRequests).then((0, $dW1PF.multiplePromiseSettler));
    }, [
        initializeTransitioningStatus,
        initializeJNAAppStatus,
        isAdmin,
        isSiteAdmin,
        initializeChatTools,
        initializeUsersAndRoles,
        hasJsmAboveStandard,
        isOptimalTooling,
        initializeTeamAdminStatus,
        initializeChatToolsForTeamAdmin,
        initializeTeams,
        initializeIntegrations,
        initializeDeprecatedCounts,
        initializeIncidentsCopyStatus
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Close the modal if an error occurs after the initial load
        // If the initial load errors out we don't render the modal at all.
        // This means we generated an error later in the process, let's just
        // get rid of the welcome modal.
        if (data && error) setIsWelcomeModalOpen(false);
    }, [
        error,
        data
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // if the decision data is not loaded don't activate anything
        if (!isAllWelcomeModalDataLoaded) return;
        // If one of the request failed then silently fail and activate transition home
        if (usersWithoutAdminRole.error || usersWithoutCustomRole.error || integrations.error || connections.error || transitioningStatusError || jnaAppStatusError || isOptimalTooling && (teams.error || teamAdminStatus.error || counts.error || syncedIntegrations.error || discontinuedIntegrations.error || deprecatedIntegrations.error || incomingCallIntegrations.error || heartbeats.error || notificationPolicies.error || groups.error || incidentsCopyStatus.error || hasJsmAboveStandard && stakeholders.error)) {
            deactivateWelcomeModal();
            activateTransitionHome();
            return;
        }
        // if one of the flow is activated or requests are loading then don't activate anything more
        if (isWelcomeModalActivated || isTransitionHomeActivated || usersWithoutAdminRole.loading || usersWithoutCustomRole.loading || integrations.loading || connections.loading || transitioningStatusLoading || jnaAppStatusLoading || isOptimalTooling && (teams.loading || teamAdminStatus.loading || counts.loading || syncedIntegrations.loading || discontinuedIntegrations.loading || deprecatedIntegrations.loading || incomingCallIntegrations.loading || heartbeats.loading || notificationPolicies.loading || groups.loading || incidentsCopyStatus.loading || hasJsmAboveStandard && stakeholders.loading)) return;
        // if the ref is exist on query parameter, we should activate the modal
        if (ref === (0, $672ccb48920b6462$export$8638ff77a0e20f0f) && finalWelcomeModalIsOpen) {
            initializeModalRequests().then(()=>{
                activateWelcomeModal();
            });
            return;
        }
        // if the ref is not present or we should not display welcome modal and the user is in transitioning state at first then activate transition home
        if (isTransitioningInitialValue.current) {
            deactivateWelcomeModal();
            activateTransitionHome();
        }
    }, [
        activateTransitionHome,
        activateWelcomeModal,
        connections.loading,
        deactivateWelcomeModal,
        finalWelcomeModalIsOpen,
        initializeUsersAndRoles,
        integrations.loading,
        isAllWelcomeModalDataLoaded,
        isTransitionHomeActivated,
        isWelcomeModalActivated,
        ref,
        initializeModalRequests,
        usersWithoutAdminRole.loading,
        usersWithoutCustomRole.loading,
        counts.loading,
        syncedIntegrations.loading,
        discontinuedIntegrations.loading,
        deprecatedIntegrations.loading,
        incomingCallIntegrations.loading,
        transitioningStatusLoading,
        jnaAppStatusLoading,
        usersWithoutAdminRole.error,
        usersWithoutCustomRole.error,
        integrations.error,
        connections.error,
        transitioningStatusError,
        jnaAppStatusError,
        isOptimalTooling,
        teams.error,
        teams.loading,
        teamAdminStatus.error,
        teamAdminStatus.loading,
        counts.error,
        syncedIntegrations.error,
        discontinuedIntegrations.error,
        deprecatedIntegrations.error,
        incomingCallIntegrations.error,
        heartbeats.error,
        notificationPolicies.error,
        groups.error,
        heartbeats.loading,
        notificationPolicies.loading,
        groups.loading,
        incidentsCopyStatus.loading,
        incidentsCopyStatus.error,
        stakeholders.error,
        stakeholders.loading,
        hasJsmAboveStandard
    ]);
    const openTransitionHomeModal = ()=>{
        setIsTransitionHomeLoading(true);
        return initializeModalRequests().then(()=>{
            activateTransitionHome();
            openTransitionHomeModalAction();
        }).catch(()=>{
            showFlag({
                type: 'error',
                title: (0, $201R4.default).errorTitleNonFinal,
                description: (0, $201R4.default).errorDescriptionNonFinal,
                actions: [
                    {
                        content: (0, $201R4.default).errorActionNonFinal,
                        onClick: openTransitionHomeModal
                    }
                ]
            });
        }).finally(()=>{
            setIsTransitionHomeLoading(false);
        });
    };
    return {
        opsgenieBaseUrl: opsgenieBaseUrl,
        openTransitionHomeModal: openTransitionHomeModal,
        closeTransitionHomeModal: closeTransitionHomeModal,
        activateTransitionHome: activateTransitionHome,
        isTransitionHomeLoading: isTransitionHomeLoading,
        isTransitionHomeActivated: isTransitionHomeActivated,
        isWelcomeModalActivated: isWelcomeModalActivated,
        isTransitionHomeModalOpen: isTransitionHomeModalOpen,
        finalWelcomeModalIsOpen: finalWelcomeModalIsOpen,
        handleCloseWelcomeModal: handleCloseWelcomeModal,
        activateWelcomeModal: activateWelcomeModal
    };
};

});
parcelRegister("4Wgi4", function(module, exports) {

$parcel$export(module.exports, "useOpsgenieBaseUrl", () => $8057d1504c4c8df3$export$60d311c8b1ba6c11);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $bFzGY = parcelRequire("bFzGY");

var $6CPEe = parcelRequire("6CPEe");
const $8057d1504c4c8df3$export$d4c72bab9d6cc13a = {
    opsgenieBaseUrl: undefined,
    fetchStatus: undefined,
    error: undefined
};
const $8057d1504c4c8df3$var$opsgenieBaseUrlStore = (0, $a61MH.createStore)({
    name: 'opsgenieBaseUrl',
    initialState: $8057d1504c4c8df3$export$d4c72bab9d6cc13a,
    actions: (0, $6CPEe.actions)
});
const $8057d1504c4c8df3$export$7d5869fb9c3cabbd = (0, $ggKAj.createHook)($8057d1504c4c8df3$var$opsgenieBaseUrlStore);
const $8057d1504c4c8df3$export$60d311c8b1ba6c11 = (packageName)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [state, { fetchOpsgenieBaseUrl: fetchOpsgenieBaseUrl }] = $8057d1504c4c8df3$export$7d5869fb9c3cabbd();
    const fetchOgBaseUrl = (0, $eUqFw.useCallback)(()=>fetchOpsgenieBaseUrl(createAnalyticsEvent({}), packageName), [
        createAnalyticsEvent,
        fetchOpsgenieBaseUrl,
        packageName
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (state.opsgenieBaseUrl === undefined && !state.fetchStatus) fetchOgBaseUrl();
    }, [
        fetchOgBaseUrl,
        state.opsgenieBaseUrl,
        state.fetchStatus
    ]);
    return [
        state,
        {
            fetchOgBaseUrl: fetchOgBaseUrl
        }
    ];
};

});
parcelRegister("6CPEe", function(module, exports) {

$parcel$export(module.exports, "actions", () => $d028f496c3752929$export$e324594224ef24da);

var $7WHQX = parcelRequire("7WHQX");
const $d028f496c3752929$export$e324594224ef24da = {
    fetchOpsgenieBaseUrl: $7WHQX.fetchOpsgenieBaseUrl
};

});
parcelRegister("7WHQX", function(module, exports) {

$parcel$export(module.exports, "fetchOpsgenieBaseUrl", () => $4f69155afcb64fd9$export$14e903f188de435b);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");

var $hVMYA = parcelRequire("hVMYA");
const $4f69155afcb64fd9$export$14e903f188de435b = (analyticsEvent, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
packageName)=>async ({ getState: getState, setState: setState })=>{
        const { opsgenieBaseUrl: currentOpsgenieBaseUrl, fetchStatus: currentFetchStatus } = getState();
        if (currentOpsgenieBaseUrl !== undefined || // @ts-expect-error - TS2345 - Argument of type 'FetchStatus | undefined' is not assignable to parameter of type '"SUCCESS" | "IN_PROGRESS_FETCH_STATUS"'.
        [
            (0, $hVMYA.FETCH_STATUS).inProgress,
            (0, $hVMYA.FETCH_STATUS).success
        ].includes(currentFetchStatus)) return;
        setState({
            fetchStatus: (0, $hVMYA.FETCH_STATUS).inProgress,
            error: undefined
        });
        try {
            const { baseUrl: baseUrl } = await (0, $2OdyW.default)('/rest/internal/2/opsgenie-base-url');
            analyticsEvent && (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'fetchOgBaseUrl succeeded');
            setState({
                fetchStatus: (0, $hVMYA.FETCH_STATUS).success,
                opsgenieBaseUrl: baseUrl
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.trackFetchErrors)({
                error: error,
                id: 'fetchOgBaseUrl',
                packageName: packageName,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                fetchStatus: (0, $hVMYA.FETCH_STATUS).error,
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("hVMYA", function(module, exports) {

$parcel$export(module.exports, "FETCH_STATUS", () => $78888933c485ee94$export$7279934be2ca35bc);
const $78888933c485ee94$export$7279934be2ca35bc = {
    inProgress: 'IN_PROGRESS_FETCH_STATUS',
    error: 'ERROR_FETCH_STATUS',
    success: 'SUCCESS'
};

});




const $2edfd53057852e41$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $2edfd53057852e41$export$e9c56aa3b027d98f = 'jira-customer-service';
const $2edfd53057852e41$export$1346c9aa3cbb477d = 'jira-software';
const $2edfd53057852e41$export$202f50ee62667e32 = 'jira-product-discovery';
const $2edfd53057852e41$export$db515c8cec1e6f79 = 'jira-core';
const $2edfd53057852e41$export$c811f21c9ad05dc2 = 'confluence';
const $2edfd53057852e41$export$961148c98d198270 = 'opsgenie';

parcelRegister("dc8n7", function(module, exports) {

$parcel$export(module.exports, "ChatToolsContainer", () => $d4e00f7a1a306e30$export$a144a4b0356ed94f);
$parcel$export(module.exports, "useChatToolsActions", () => $d4e00f7a1a306e30$export$bc3c9253d84bc2bf);
$parcel$export(module.exports, "useChatToolsStore", () => $d4e00f7a1a306e30$export$a1388873c4cbfadc);
$parcel$export(module.exports, "useChatToolsConnections", () => $d4e00f7a1a306e30$export$74071b1e2400c285);
$parcel$export(module.exports, "useChatToolsIntegrations", () => $d4e00f7a1a306e30$export$a985a8cf780397ec);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $fJD67 = parcelRequire("fJD67");
var $a61MH = parcelRequire("a61MH");

var $k8Qyf = parcelRequire("k8Qyf");

var $gd0Sp = parcelRequire("gd0Sp");

var $7gA9Z = parcelRequire("7gA9Z");

var $9o8VG = parcelRequire("9o8VG");

var $jQErs = parcelRequire("jQErs");

var $28tBY = parcelRequire("28tBY");
const $d4e00f7a1a306e30$export$d4c72bab9d6cc13a = {
    connections: (0, $7gA9Z.emptyResource),
    integrations: (0, $7gA9Z.emptyResource),
    loadingConnectionId: '',
    loadingIntegrationId: '',
    mstConnectionUrls: {}
};
const $d4e00f7a1a306e30$var$Store = (0, $a61MH.createStore)({
    initialState: $d4e00f7a1a306e30$export$d4c72bab9d6cc13a,
    actions: $28tBY.actions,
    name: 'chat-tools'
});
const $d4e00f7a1a306e30$export$a144a4b0356ed94f = (0, $fJD67.createContainer)($d4e00f7a1a306e30$var$Store, {
    Wrapper: (0, $fJD67.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
            const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
            return {
                cloudId: cloudId,
                showFlag: showFlag
            };
        },
        useContainerHook: ()=>{
            const { initialize: initialize } = $d4e00f7a1a306e30$export$bc3c9253d84bc2bf();
            const { slackConnectHandler: slackConnectHandler, slackUserLevelAuthoriseHandler: slackUserLevelAuthoriseHandler } = (0, $jQErs.useSlackConnection)({
                onSuccess: initialize
            });
            const { mstConnectHandler: mstConnectHandler, adminAuthoriseHandler: adminAuthoriseHandler, mstUserLevelAuthoriseHandler: mstUserLevelAuthoriseHandler } = (0, $9o8VG.useMSTConnection)({
                onSuccess: initialize
            });
            const connectHandler = (0, $eUqFw.useCallback)((event)=>{
                if (!event.data || !event.data.event_id) return;
                if (event.data.event_id === (0, $7gA9Z.SLACK_CREATE_CONNECTION_EVENT_ID)) slackConnectHandler(event);
                else if (event.data.event_id === (0, $7gA9Z.MSTEAMS_CREATE_CONNECTION_EVENT_ID)) mstConnectHandler(event);
                else if (event.data.event_id === (0, $7gA9Z.ADMIN_CONSENT_REQUIRED_EVENT_ID)) adminAuthoriseHandler(event);
                else if (event.data.event_id === (0, $7gA9Z.MSTEAMS_USER_LEVEL_AUTH_EVENT_ID)) mstUserLevelAuthoriseHandler(event);
                else if (event.data.event_id === (0, $7gA9Z.SLACK_USER_LEVEL_AUTH_EVENT_ID)) slackUserLevelAuthoriseHandler(event);
            }, [
                slackConnectHandler,
                mstConnectHandler,
                adminAuthoriseHandler,
                mstUserLevelAuthoriseHandler,
                slackUserLevelAuthoriseHandler
            ]);
            (0, $eUqFw.useEffect)(()=>{
                window.addEventListener('message', connectHandler);
                return ()=>{
                    window.removeEventListener('message', connectHandler);
                };
            }, [
                connectHandler
            ]);
        }
    })
});
const $d4e00f7a1a306e30$export$a1388873c4cbfadc = (0, $ggKAj.createHook)($d4e00f7a1a306e30$var$Store);
const $d4e00f7a1a306e30$export$bc3c9253d84bc2bf = (0, $ggKAj.createActionsHook)($d4e00f7a1a306e30$var$Store);
const $d4e00f7a1a306e30$export$74071b1e2400c285 = (0, $ggKAj.createHook)($d4e00f7a1a306e30$var$Store, {
    selector: (state)=>state.connections
});
const $d4e00f7a1a306e30$export$a985a8cf780397ec = (0, $ggKAj.createHook)($d4e00f7a1a306e30$var$Store, {
    selector: (state)=>state.integrations
});

});
parcelRegister("fJD67", function(module, exports) {

$parcel$export(module.exports, "createDefaultEocWrapper", () => $a1279c5e7c754c96$export$a9264953429b0df);
$parcel$export(module.exports, "createContainer", () => $a1279c5e7c754c96$export$26ae5ca175b4ec5a);

var $eUqFw = parcelRequire("eUqFw");

var $heB5U = parcelRequire("heB5U");
/**
 * This component runs the useContainerHook with props that are sent from useSyncContainerProps.
 * We can use all features of react hooks inside here. Also, we created this component outside of
 * the createDefaultEocWrapper due to if we use this inside of the createDefaultEocWrapper,
 * it'll re-render on every child have changed.
 */ function $a1279c5e7c754c96$var$InnerElement({ children: children, useContainerHook: useContainerHook, containerProps: containerProps }) {
    useContainerHook?.(containerProps);
    return children;
}
function $a1279c5e7c754c96$export$a9264953429b0df({ useSyncContainerProps: useSyncContainerProps, useContainerHook: useContainerHook }) {
    return ({ children: children })=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(children)) {
            const containerProps = useSyncContainerProps ? useSyncContainerProps(children.props) : {};
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(children, {
                ...children.props,
                ...containerProps
            }, useContainerHook ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1279c5e7c754c96$var$InnerElement, {
                useContainerHook: useContainerHook,
                containerProps: containerProps
            }, children.props.children) : children.props.children);
        }
        return null;
    };
}
const $a1279c5e7c754c96$export$26ae5ca175b4ec5a = (store, options)=>{
    const OriginalContainer = (0, $heB5U.createContainer)(store, {
        ...options
    });
    const HOC = ({ ...props })=>{
        return options?.Wrapper ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(options.Wrapper, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(OriginalContainer, props, props.children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(OriginalContainer, props, props.children);
    };
    HOC.displayName = OriginalContainer.displayName + '-HOC'; // To track if error occure because of HOC
    return HOC;
};

});

parcelRegister("7gA9Z", function(module, exports) {

$parcel$export(module.exports, "emptyResource", () => $17da916ee573c56b$export$6ed870441802d126);
$parcel$export(module.exports, "SLACK_CREATE_CONNECTION_EVENT_ID", () => $17da916ee573c56b$export$f499a35a9a662ad8);
$parcel$export(module.exports, "SlackErrorCodes", () => $17da916ee573c56b$export$ca77fcbf65183d7a);
$parcel$export(module.exports, "MstErrorCodes", () => $17da916ee573c56b$export$7dd2cc6fd63b5d49);
$parcel$export(module.exports, "JIRA_SUPPORT_LINK", () => $17da916ee573c56b$export$4dc85a478189d1be);
$parcel$export(module.exports, "SLACK_IMAGE_URL", () => $17da916ee573c56b$export$c5dc119cdbeed3dc);
$parcel$export(module.exports, "MST_IMAGE_URL", () => $17da916ee573c56b$export$31622a6434c822c0);
$parcel$export(module.exports, "SLACK_TEXT", () => $17da916ee573c56b$export$d982cc6618dbc0f3);
$parcel$export(module.exports, "MST_TEXT", () => $17da916ee573c56b$export$80d888715be28a18);
$parcel$export(module.exports, "MSTEAMS_CREATE_CONNECTION_EVENT_ID", () => $17da916ee573c56b$export$37e742a41eacef56);
$parcel$export(module.exports, "ADMIN_CONSENT_REQUIRED_EVENT_ID", () => $17da916ee573c56b$export$fe93b230923a5912);
$parcel$export(module.exports, "SLACK_APP_TYPE", () => $17da916ee573c56b$export$2dfb4588bf1292d9);
$parcel$export(module.exports, "MST_APP_TYPE", () => $17da916ee573c56b$export$6838a40356798ab0);
$parcel$export(module.exports, "MSTEAMS_USER_LEVEL_AUTH_EVENT_ID", () => $17da916ee573c56b$export$d1ee2159a22b5eeb);
$parcel$export(module.exports, "SLACK_USER_LEVEL_AUTH_EVENT_ID", () => $17da916ee573c56b$export$40d44b9e20d7bd23);
$parcel$export(module.exports, "TRANSITION_HOME_BUTTON_SPOTLIGHT_NAME", () => $17da916ee573c56b$export$36dc24398b969929);
$parcel$export(module.exports, "HELP_PANEL_SPOTLIGHT_NAME", () => $17da916ee573c56b$export$47504886f4581388);
$parcel$export(module.exports, "UNLOCK_LINK", () => $17da916ee573c56b$export$25520e270c8e452f);
const $17da916ee573c56b$export$6ed870441802d126 = {
    data: null,
    error: null,
    loading: false
};
const $17da916ee573c56b$export$f499a35a9a662ad8 = 'slack_connection_creation_response';
const $17da916ee573c56b$export$ca77fcbf65183d7a = {
    AUTH_CODE_MISSING: 'auth_code_missing',
    CONNECTION_ALREADY_EXIST: 'connection_already_exist',
    CONNECTION_CREATION_FAILED: 'connection_creation_failed',
    FETCH_TOKEN_FAILED: 'failed_to_fetch_token',
    FORBIDDEN_TENANT: 'forbidden_tenant',
    INVALID_STATE: 'invalid_state',
    LINK_EXPIRED: 'link_expired',
    STATE_DECRYPTION_FAILED: 'state_decryption_failed',
    WORKSPACE_MISSMATCH: 'workspace_mismatch'
};
const $17da916ee573c56b$export$7dd2cc6fd63b5d49 = {
    TENANT_CONFLICT: 'tenant_conflict',
    TENANT_MISMATCH: 'tenant_mismatch'
};
const $17da916ee573c56b$export$4dc85a478189d1be = 'https://support.atlassian.com/contact/';
const $17da916ee573c56b$export$c5dc119cdbeed3dc = 'https://resources.opsgeni.us/resources/images/public/integration/logos/SlackApp.png';
const $17da916ee573c56b$export$31622a6434c822c0 = 'https://resources.opsgeni.us/resources/images/public/integration/logos/MSTeams.png';
const $17da916ee573c56b$export$d982cc6618dbc0f3 = 'Slack';
const $17da916ee573c56b$export$80d888715be28a18 = 'Microsoft Teams';
const $17da916ee573c56b$export$37e742a41eacef56 = 'microsoft_create_connection_response';
const $17da916ee573c56b$export$fe93b230923a5912 = 'microsoft_admin_permission_response';
const $17da916ee573c56b$export$2dfb4588bf1292d9 = 'jsm-it-service-desk';
const $17da916ee573c56b$export$6838a40356798ab0 = 'jsm-msteams-app';
const $17da916ee573c56b$export$d1ee2159a22b5eeb = 'microsoft_delegated_permission_response';
const $17da916ee573c56b$export$40d44b9e20d7bd23 = 'slack_user_auth_response';
const $17da916ee573c56b$export$36dc24398b969929 = 'eoc-changeboarding_transition_home_lozenge';
const $17da916ee573c56b$export$47504886f4581388 = 'help-spotlight';
const $17da916ee573c56b$export$25520e270c8e452f = '/jira/settings/products/ops/unlock';

});

parcelRegister("9o8VG", function(module, exports) {

$parcel$export(module.exports, "useMSTConnection", () => $7b9d9ddef7f3daf1$export$4c0b85f07dbab21c);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $7gA9Z = parcelRequire("7gA9Z");

var $4EZjF = parcelRequire("4EZjF");

var $jszHO = parcelRequire("jszHO");
const $7b9d9ddef7f3daf1$export$4c0b85f07dbab21c = ({ onSuccess: onSuccess })=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const mstConnectHandler = (0, $eUqFw.useCallback)((event)=>{
        (0, $4EZjF.chatOpsMessageHandler)({
            event: event,
            requiredEventId: (0, $7gA9Z.MSTEAMS_CREATE_CONNECTION_EVENT_ID),
            onSuccessCallback: onSuccess,
            onFailedCallback: (errorCode)=>{
                switch(errorCode){
                    case (0, $7gA9Z.MstErrorCodes).TENANT_CONFLICT:
                        showFlag({
                            type: 'error',
                            title: (0, $jszHO.default).tenantConflictErrorTitleNonFinal,
                            description: (0, $jszHO.default).tenantConflictErrorDescriptionNonFinal
                        });
                        break;
                    case (0, $7gA9Z.MstErrorCodes).TENANT_MISMATCH:
                        showFlag({
                            type: 'error',
                            title: (0, $jszHO.default).tenantMissmatchErrorTitleNonFinal,
                            description: (0, $jszHO.default).tenantMissmatchErrorDescriptionNonFinal
                        });
                        break;
                    default:
                        showFlag({
                            type: 'error',
                            title: (0, $jszHO.default).teamsLoginErrorTitleNonFinal,
                            description: (0, $jszHO.default).teamsLoginErrorTitleNonFinal,
                            actions: [
                                {
                                    content: (0, $jszHO.default).contactSupportBtnLabelNonFinal,
                                    href: (0, $7gA9Z.JIRA_SUPPORT_LINK),
                                    target: '_blank'
                                }
                            ]
                        });
                }
            }
        });
    }, [
        onSuccess,
        showFlag
    ]);
    const adminAuthoriseHandler = (0, $eUqFw.useCallback)((event)=>{
        (0, $4EZjF.chatOpsMessageHandler)({
            event: event,
            requiredEventId: (0, $7gA9Z.ADMIN_CONSENT_REQUIRED_EVENT_ID),
            onSuccessCallback: ()=>{
                onSuccess();
            },
            onFailedCallback: ()=>{
                showFlag({
                    type: 'error',
                    title: (0, $jszHO.default).teamsLoginErrorTitleNonFinal,
                    description: (0, $jszHO.default).teamsLoginErrorTitleNonFinal,
                    actions: [
                        {
                            content: (0, $jszHO.default).contactSupportBtnLabelNonFinal,
                            href: (0, $7gA9Z.JIRA_SUPPORT_LINK),
                            target: '_blank'
                        }
                    ]
                });
            }
        });
    }, [
        onSuccess,
        showFlag
    ]);
    const mstUserLevelAuthoriseHandler = (0, $eUqFw.useCallback)((event)=>{
        (0, $4EZjF.chatOpsMessageHandler)({
            event: event,
            requiredEventId: (0, $7gA9Z.MSTEAMS_USER_LEVEL_AUTH_EVENT_ID),
            onSuccessCallback: ()=>{
                onSuccess();
            }
        });
    }, [
        onSuccess
    ]);
    return {
        mstConnectHandler: mstConnectHandler,
        adminAuthoriseHandler: adminAuthoriseHandler,
        mstUserLevelAuthoriseHandler: mstUserLevelAuthoriseHandler
    };
};

});
parcelRegister("4EZjF", function(module, exports) {

$parcel$export(module.exports, "chatOpsMessageHandler", () => $2730a0dbf93b0ee1$export$6e5d249d884395f6);
const $2730a0dbf93b0ee1$export$9fb6e800e02bf3ea = [
    'https://api-private.stg.atlassian.com',
    'https://api-private.atlassian.com'
];
const $2730a0dbf93b0ee1$export$6e5d249d884395f6 = ({ event: event, onSuccessCallback: onSuccessCallback, onFailedCallback: onFailedCallback, requiredEventId: requiredEventId })=>{
    if (!$2730a0dbf93b0ee1$export$9fb6e800e02bf3ea.includes(event.origin)) return;
    if (!event.data || !event.data.event_id || !event.data.data || event.data.event_id !== requiredEventId) return;
    const eventData = event.data;
    if (eventData?.data?.success === 'true') onSuccessCallback();
    else if (eventData?.data?.success === 'false') onFailedCallback?.(eventData.data.error);
};

});

parcelRegister("jszHO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f05780d027e28ce$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2f05780d027e28ce$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tenantConflictErrorTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.tenant-conflict-error-title-non-final",
        "defaultMessage": "Couldn't connect your Microsoft tenant"
    },
    tenantConflictErrorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.tenant-conflict-error-description-non-final",
        "defaultMessage": "Your Microsoft tenant is connected to a different Jira Service Management site. Disconnect your tenant from the other site or connect a different Microsoft tenant to this Jira Service Management site."
    },
    teamsLoginErrorTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.teams-login-error-title-non-final",
        "defaultMessage": "Couldn't sign in to your Microsoft account"
    },
    teamsLoginErrorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.teams-login-error-description-non-final",
        "defaultMessage": "Please try again or contact support for help."
    },
    contactSupportBtnLabelNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.contact-support-btn-label-non-final",
        "defaultMessage": "Contact support"
    },
    tenantMissmatchErrorTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.tenant-missmatch-error-title-non-final",
        "defaultMessage": "You aren't a member of the Microsoft tenant"
    },
    tenantMissmatchErrorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.tenant-missmatch-error-description-non-final",
        "defaultMessage": "Looks like you aren't part of the Microsoft tenant you're trying to connect with Jira. Join the Microsoft tenant and try again."
    }
});

});


parcelRegister("jQErs", function(module, exports) {

$parcel$export(module.exports, "useSlackConnection", () => $8660220d86522056$export$3912d4b50c1e1942);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $7gA9Z = parcelRequire("7gA9Z");

var $4EZjF = parcelRequire("4EZjF");

var $6hZQA = parcelRequire("6hZQA");
const $8660220d86522056$export$3912d4b50c1e1942 = ({ onSuccess: onSuccess })=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const slackConnectHandler = (0, $eUqFw.useCallback)((event)=>(0, $4EZjF.chatOpsMessageHandler)({
            event: event,
            requiredEventId: (0, $7gA9Z.SLACK_CREATE_CONNECTION_EVENT_ID),
            onSuccessCallback: onSuccess,
            onFailedCallback: (errorCode)=>{
                switch(errorCode){
                    case (0, $7gA9Z.SlackErrorCodes).AUTH_CODE_MISSING:
                        showFlag({
                            type: 'error',
                            title: (0, $6hZQA.default).slackNotConnectedTitleNonFinal,
                            description: (0, $6hZQA.default).slackAuthoriseErrorDescriptionNonFinal
                        });
                        break;
                    case (0, $7gA9Z.SlackErrorCodes).CONNECTION_ALREADY_EXIST:
                        showFlag({
                            type: 'error',
                            title: (0, $6hZQA.default).slackNotConnectedTitleNonFinal,
                            description: (0, $6hZQA.default).connectionAlreadyExistsDescriptionNonFinal
                        });
                        break;
                    case (0, $7gA9Z.SlackErrorCodes).CONNECTION_CREATION_FAILED:
                        showFlag({
                            type: 'error',
                            title: (0, $6hZQA.default).slackNotConnectedTitleNonFinal,
                            description: (0, $6hZQA.default).connectionFailedDescriptionNonFinal,
                            actions: [
                                {
                                    content: (0, $6hZQA.default).slackSupportBtnLabelNonFinal,
                                    href: (0, $7gA9Z.JIRA_SUPPORT_LINK),
                                    target: '_blank'
                                }
                            ]
                        });
                        break;
                    case (0, $7gA9Z.SlackErrorCodes).FETCH_TOKEN_FAILED:
                        showFlag({
                            type: 'error',
                            title: (0, $6hZQA.default).slackNotConnectedTitleNonFinal,
                            description: (0, $6hZQA.default).slackAuthoriseErrorDescriptionNonFinal
                        });
                        break;
                    case (0, $7gA9Z.SlackErrorCodes).FORBIDDEN_TENANT:
                        showFlag({
                            type: 'error',
                            title: (0, $6hZQA.default).somethingWentWrongTitleNonFinal,
                            description: (0, $6hZQA.default).slackContactSupportDescriptionNonFinal,
                            actions: [
                                {
                                    content: (0, $6hZQA.default).slackSupportBtnLabelNonFinal,
                                    href: (0, $7gA9Z.JIRA_SUPPORT_LINK),
                                    target: '_blank'
                                }
                            ]
                        });
                        break;
                    case (0, $7gA9Z.SlackErrorCodes).INVALID_STATE:
                        showFlag({
                            type: 'error',
                            title: (0, $6hZQA.default).slackNotConnectedTitleNonFinal,
                            description: (0, $6hZQA.default).slackConnectAgainDescriptionNonFinal
                        });
                        break;
                    case (0, $7gA9Z.SlackErrorCodes).LINK_EXPIRED:
                        showFlag({
                            type: 'error',
                            title: (0, $6hZQA.default).slackSessionExpiredTitleNonFinal,
                            description: (0, $6hZQA.default).slackConnectAgainDescriptionNonFinal
                        });
                        break;
                    case (0, $7gA9Z.SlackErrorCodes).STATE_DECRYPTION_FAILED:
                        showFlag({
                            type: 'error',
                            title: (0, $6hZQA.default).slackNotConnectedTitleNonFinal,
                            description: (0, $6hZQA.default).slackConnectAgainDescriptionNonFinal
                        });
                        break;
                    case (0, $7gA9Z.SlackErrorCodes).WORKSPACE_MISSMATCH:
                        showFlag({
                            type: 'error',
                            title: (0, $6hZQA.default).slackWorkspaceMismatchTitleNonFinal,
                            description: (0, $6hZQA.default).slackWorkSpaceMissmatchDescriptionNonFinal
                        });
                        break;
                    default:
                        showFlag({
                            type: 'error',
                            title: (0, $6hZQA.default).somethingWentWrongTitleNonFinal,
                            description: (0, $6hZQA.default).slackContactSupportDescriptionNonFinal,
                            actions: [
                                {
                                    content: (0, $6hZQA.default).slackSupportBtnLabelNonFinal,
                                    href: (0, $7gA9Z.JIRA_SUPPORT_LINK),
                                    target: '_blank'
                                }
                            ]
                        });
                        break;
                }
            }
        }), [
        onSuccess,
        showFlag
    ]);
    const slackUserLevelAuthoriseHandler = (0, $eUqFw.useCallback)((event)=>{
        (0, $4EZjF.chatOpsMessageHandler)({
            event: event,
            requiredEventId: (0, $7gA9Z.SLACK_USER_LEVEL_AUTH_EVENT_ID),
            onSuccessCallback: ()=>{
                onSuccess();
            }
        });
    }, [
        onSuccess
    ]);
    return {
        slackConnectHandler: slackConnectHandler,
        slackUserLevelAuthoriseHandler: slackUserLevelAuthoriseHandler
    };
};

});
parcelRegister("6hZQA", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc0f1389b6f97ca1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cc0f1389b6f97ca1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    getSlackConfigurationErrorTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.get-slack-configuration-error-title-non-final",
        "defaultMessage": "We couldn't connect the workspace"
    },
    getSlackConfigurationErrorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.get-slack-configuration-error-description-non-final",
        "defaultMessage": "Wait a moment or refresh the page before trying again."
    },
    slackNotConnectedTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-not-connected-title-non-final",
        "defaultMessage": "Couldn't connect your Slack workspace"
    },
    slackAuthoriseErrorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-authorise-error-description-non-final",
        "defaultMessage": "Your Slack workspace couldn't be authenticated. Please try again."
    },
    connectionAlreadyExistsDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.connection-already-exists-description-non-final",
        "defaultMessage": "Your Slack workspace is already connected to a different Jira Service Management site. Disconnect your workspace from the other site and try again."
    },
    connectionFailedDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.connection-failed-description-non-final",
        "defaultMessage": "Something went wrong. Please try connecting again or contact support for help."
    },
    slackSupportBtnLabelNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-support-btn-label-non-final",
        "defaultMessage": "Contact support"
    },
    somethingWentWrongTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.something-went-wrong-title-non-final",
        "defaultMessage": "Something went wrong"
    },
    slackContactSupportDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-contact-support-description-non-final",
        "defaultMessage": "Please try again or contact support for help."
    },
    slackConnectAgainDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-connect-again-description-non-final",
        "defaultMessage": "Please try connecting your workspace again."
    },
    slackSessionExpiredTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-session-expired-title-non-final",
        "defaultMessage": "Slack session expired"
    },
    slackWorkspaceMismatchTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-workspace-mismatch-title-non-final",
        "defaultMessage": "You aren't a member of the Slack workspace"
    },
    slackWorkSpaceMissmatchDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-work-space-missmatch-description-non-final",
        "defaultMessage": "Looks like you aren't part of the Slack workspace you're trying to connect with Jira. Join the Slack workspace and try again."
    }
});

});


parcelRegister("28tBY", function(module, exports) {

$parcel$export(module.exports, "actions", () => $3737b61fd16fde9d$export$e324594224ef24da);

var $7gA9Z = parcelRequire("7gA9Z");

var $g07uW = parcelRequire("g07uW");

var $dW1PF = parcelRequire("dW1PF");

var $8bxx7 = parcelRequire("8bxx7");

var $368EE = parcelRequire("368EE");
const $3737b61fd16fde9d$var$getChatToolsConnections = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            connections: {
                data: state.connections.data,
                error: null,
                loading: true
            }
        });
        return $8bxx7.getConnections(cloudId).then((res)=>setState({
                connections: (0, $g07uW.createDataResponse)(res)
            })).catch((err)=>{
            // TODO we might display toast
            setState({
                connections: (0, $g07uW.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $3737b61fd16fde9d$var$authorizeSlackConnection = (chatSpaceId)=>({ setState: setState }, { cloudId: cloudId })=>{
        setState({
            loadingConnectionId: chatSpaceId
        });
        $8bxx7.getAuthorizeSlackConnectionUrl({
            chatSpaceId: chatSpaceId,
            cloudId: cloudId
        }).then((res)=>{
            window.open(res.data.url, '_blank');
        })// TODO we might display toast
        .finally(()=>{
            setState({
                loadingConnectionId: ''
            });
        });
    };
const $3737b61fd16fde9d$var$delegateMSTConnection = (chatSpaceId)=>({ setState: setState }, { cloudId: cloudId })=>{
        setState({
            loadingConnectionId: chatSpaceId
        });
        $8bxx7.getDelegateMSTConnectionUrl({
            chatSpaceId: chatSpaceId,
            cloudId: cloudId
        }).then((res)=>{
            window.open(res.data.url, '_blank');
        })// TODO we might display toast
        .finally(()=>{
            setState({
                loadingConnectionId: ''
            });
        });
    };
const $3737b61fd16fde9d$var$getAuthorizeMSTConnectionUrl = (chatSpaceId)=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        if (state.mstConnectionUrls[chatSpaceId]) return Promise.resolve(state.mstConnectionUrls[chatSpaceId]);
        setState({
            loadingConnectionId: chatSpaceId
        });
        return $8bxx7.getaAuthorizeMSTConnectionUrl({
            chatSpaceId: chatSpaceId,
            cloudId: cloudId
        }).then((res)=>{
            state.mstConnectionUrls[chatSpaceId] = res.data.url;
            return res.data.url;
        })// TODO we might display toast
        .finally(()=>{
            setState({
                loadingConnectionId: ''
            });
        });
    };
const $3737b61fd16fde9d$var$authorizeMSTConnection = (chatSpaceId)=>({ dispatch: dispatch })=>{
        dispatch($3737b61fd16fde9d$var$getAuthorizeMSTConnectionUrl(chatSpaceId)).then((url)=>{
            window.open(url, '_blank');
        });
    };
const $3737b61fd16fde9d$var$copyMSTAuthorizationLink = (chatSpaceId)=>({ dispatch: dispatch }, { showFlag: showFlag })=>{
        dispatch($3737b61fd16fde9d$var$getAuthorizeMSTConnectionUrl(chatSpaceId)).then((url)=>{
            navigator.clipboard.writeText(url || '').then(()=>{
                showFlag?.({
                    type: 'success',
                    title: (0, $368EE.default).copiedConfirmationTitleNonFinal,
                    description: (0, $368EE.default).copiedSuccessNonFinal
                });
            }).catch(()=>{
                showFlag?.({
                    type: 'error',
                    title: (0, $368EE.default).copiedConfirmationTitleNonFinal,
                    description: (0, $368EE.default).copiedFailedNonFinal
                });
            });
        });
    };
const $3737b61fd16fde9d$var$getIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            integrations: {
                data: state.integrations.data,
                error: null,
                loading: true
            }
        });
        return $8bxx7.getOgIntegrations(cloudId).then((res)=>setState({
                integrations: (0, $g07uW.createDataResponse)(res)
            })).catch((err)=>{
            // TODO we might display toast
            setState({
                integrations: (0, $g07uW.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $3737b61fd16fde9d$var$givePermissionToUser = (integration)=>({ setState: setState }, { cloudId: cloudId })=>{
        setState({
            loadingIntegrationId: integration.id
        });
        $8bxx7.getUserAuthorizationUrl({
            cloudId: cloudId,
            chatSpaceType: integration.chatSpaceType,
            chatSpaceId: integration.chatSpaceId
        }).then((res)=>{
            window.open(res.data.url, '_blank');
        })// TODO we might display toast
        .finally(()=>{
            setState({
                loadingIntegrationId: ''
            });
        });
    };
const $3737b61fd16fde9d$var$duplicateIntegration = (integration)=>({ setState: setState, dispatch: dispatch }, { cloudId: cloudId, showFlag: showFlag })=>{
        setState({
            loadingIntegrationId: integration.id
        });
        $8bxx7.duplicateIntegration({
            cloudId: cloudId,
            id: integration.id,
            channelId: integration.channelId,
            connectionId: integration.connectionId,
            msTeamsId: integration.msTeamsId
        }).then(()=>{
            dispatch($3737b61fd16fde9d$var$getIntegrations());
        }).catch((error)=>{
            if (error.statusCode === 403) {
                showFlag?.({
                    type: 'error',
                    title: (0, $368EE.default).duplicateNotPartOfChannelTitleNonFinal,
                    description: (0, $368EE.default).duplicateNotPartOfChannelDescriptionNonFinal
                });
                return;
            }
            showFlag?.({
                type: 'error',
                title: (0, $368EE.default).duplicateGenericErrorTitleNonFinal,
                description: (0, $368EE.default).duplicateGenericErrorDescriptionNonFinal,
                actions: [
                    {
                        content: (0, $368EE.default).contactSupportBtnLabelNonFinal,
                        href: (0, $7gA9Z.JIRA_SUPPORT_LINK),
                        target: '_blank'
                    }
                ]
            });
        })// TODO we might display toast
        .finally(()=>{
            setState({
                loadingIntegrationId: ''
            });
        });
    };
const $3737b61fd16fde9d$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($3737b61fd16fde9d$var$getChatToolsConnections()),
            dispatch($3737b61fd16fde9d$var$getIntegrations())
        ]).then((0, $dW1PF.multiplePromiseSettler));
const $3737b61fd16fde9d$var$initializeForTeamAdmin = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($3737b61fd16fde9d$var$getIntegrations())
        ]).then((0, $dW1PF.multiplePromiseSettler));
const $3737b61fd16fde9d$export$e324594224ef24da = {
    getChatToolsConnections: $3737b61fd16fde9d$var$getChatToolsConnections,
    authorizeSlackConnection: $3737b61fd16fde9d$var$authorizeSlackConnection,
    delegateMSTConnection: $3737b61fd16fde9d$var$delegateMSTConnection,
    authorizeMSTConnection: $3737b61fd16fde9d$var$authorizeMSTConnection,
    copyMSTAuthorizationLink: $3737b61fd16fde9d$var$copyMSTAuthorizationLink,
    getIntegrations: $3737b61fd16fde9d$var$getIntegrations,
    givePermissionToUser: $3737b61fd16fde9d$var$givePermissionToUser,
    duplicateIntegration: $3737b61fd16fde9d$var$duplicateIntegration,
    initialize: $3737b61fd16fde9d$var$initialize,
    initializeForTeamAdmin: $3737b61fd16fde9d$var$initializeForTeamAdmin
};

});
parcelRegister("g07uW", function(module, exports) {

$parcel$export(module.exports, "createErrorResponse", () => $95cedbf68dc7910f$export$d27409b579447857);
$parcel$export(module.exports, "createDataResponse", () => $95cedbf68dc7910f$export$65a48814b87e4478);
const $95cedbf68dc7910f$export$d27409b579447857 = (error)=>({
        data: null,
        error: error,
        loading: false
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $95cedbf68dc7910f$export$65a48814b87e4478 = (data)=>({
        data: data,
        error: null,
        loading: false
    });

});

parcelRegister("dW1PF", function(module, exports) {

$parcel$export(module.exports, "multiplePromiseSettler", () => $b97a47020baf5570$export$be72b6e68f6d7c8f);
const $b97a47020baf5570$export$be72b6e68f6d7c8f = (results)=>{
    if (results.length > 0) {
        const error = results.find((result)=>result.status === 'rejected');
        if (error) throw 'reason' in error ? error.reason : new Error('Unknown error occurred during fetch resource');
        return results;
    }
    return results;
};

});

parcelRegister("8bxx7", function(module, exports) {

$parcel$export(module.exports, "getConnections", () => $20cadb65bdd9ad01$export$82b9f8f75cc709b4);
$parcel$export(module.exports, "getAuthorizeSlackConnectionUrl", () => $20cadb65bdd9ad01$export$2a70ab934b694f17);
$parcel$export(module.exports, "getOgIntegrations", () => $20cadb65bdd9ad01$export$f2efa3535e8bb631);
$parcel$export(module.exports, "getDelegateMSTConnectionUrl", () => $20cadb65bdd9ad01$export$58c33fd2c801ef0b);
$parcel$export(module.exports, "getaAuthorizeMSTConnectionUrl", () => $20cadb65bdd9ad01$export$d44eb3398b5db37);
$parcel$export(module.exports, "getUserAuthorizationUrl", () => $20cadb65bdd9ad01$export$4df1f26230bcb7c);
$parcel$export(module.exports, "duplicateIntegration", () => $20cadb65bdd9ad01$export$67ff1e867c2131aa);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $7gA9Z = parcelRequire("7gA9Z");
const $20cadb65bdd9ad01$export$82b9f8f75cc709b4 = (cloudId)=>{
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/transition/connections`;
    return (0, $lRmyA.performGetRequest)(url).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getConnectionsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $20cadb65bdd9ad01$export$2a70ab934b694f17 = ({ chatSpaceId: chatSpaceId, cloudId: cloudId })=>{
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorize/slack/connection/create?chatSpaceId=${chatSpaceId}&appType=jsm-it-service-desk&container=transition`;
    return (0, $lRmyA.performGetRequest)(url).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'authorizeSlackConnection',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $20cadb65bdd9ad01$export$f2efa3535e8bb631 = (cloudId)=>{
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/transition/integrations`;
    return (0, $lRmyA.performGetRequest)(url).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getOgIntegrationsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $20cadb65bdd9ad01$export$58c33fd2c801ef0b = ({ chatSpaceId: chatSpaceId, cloudId: cloudId })=>{
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorize/msteams/delegated?chatSpaceId=${chatSpaceId}&appType=jsm-msteams-app&container=transition&createConnection=true`;
    return (0, $lRmyA.performGetRequest)(url).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'delegateMSTConnection',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $20cadb65bdd9ad01$export$d44eb3398b5db37 = ({ chatSpaceId: chatSpaceId, cloudId: cloudId })=>{
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorize/msteams/admin?chatSpaceId=${chatSpaceId}&appType=jsm-msteams-app&container=transition`;
    return (0, $lRmyA.performGetRequest)(url).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'authorizeMSTConnection',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $20cadb65bdd9ad01$export$4df1f26230bcb7c = ({ cloudId: cloudId, chatSpaceType: chatSpaceType, chatSpaceId: chatSpaceId })=>{
    const appType = chatSpaceType === 'slack' ? (0, $7gA9Z.SLACK_APP_TYPE) : (0, $7gA9Z.MST_APP_TYPE);
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorise/user?chatSpaceId=${chatSpaceId}&appType=${appType}&source=transition`;
    return (0, $lRmyA.performGetRequest)(url).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getUserAuthorizationUrl',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $20cadb65bdd9ad01$export$67ff1e867c2131aa = (body)=>{
    const { cloudId: cloudId, id: id, ...restOfBody } = body;
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/transition/integration/duplicate/${id}`;
    return (0, $lRmyA.performPostRequest)(url, {
        body: JSON.stringify(restOfBody)
    }).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'duplicateIntegration',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};

});

parcelRegister("368EE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d639af20729f6ea$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3d639af20729f6ea$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    copiedConfirmationTitleNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.copied-confirmation-title-non-final",
        "defaultMessage": "Copied link"
    },
    copiedSuccessNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.copied-success-non-final",
        "defaultMessage": "Share it with your Teams Administrator to ask for their authorization to give permission."
    },
    copiedFailedNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.copied-failed-non-final",
        "defaultMessage": "Something went wrong, please try again? If you need help, contact support."
    },
    duplicateNotPartOfChannelTitleNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.duplicate-not-part-of-channel-title-non-final",
        "defaultMessage": "You aren't a member of the connected channel"
    },
    duplicateNotPartOfChannelDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.duplicate-not-part-of-channel-description-non-final",
        "defaultMessage": "This integration is connected to a chat channel or conversation that you aren't a member of. Join the channel and try again."
    },
    duplicateGenericErrorTitleNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.duplicate-generic-error-title-non-final",
        "defaultMessage": "Couldn't copy your integration"
    },
    duplicateGenericErrorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.duplicate-generic-error-description-non-final",
        "defaultMessage": "Something went wrong while copying your integration to Jira. Try again in some time. If you still need help, contact support."
    },
    contactSupportBtnLabelNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.contact-support-btn-label-non-final",
        "defaultMessage": "Contact support"
    }
});

});



parcelRegister("8OZdV", function(module, exports) {

$parcel$export(module.exports, "DeprecatedCountsContainer", () => $d30f8dd61b7d9c17$export$46cb9574b46bee08);
$parcel$export(module.exports, "useDeprecatedCountsStore", () => $d30f8dd61b7d9c17$export$7ccc6df7e431e9d5);
$parcel$export(module.exports, "useDeprecatedGroups", () => $d30f8dd61b7d9c17$export$a683813e834f13f1);
$parcel$export(module.exports, "useDeprecatedNotificationPolicies", () => $d30f8dd61b7d9c17$export$6dd4db40d5822337);
$parcel$export(module.exports, "useDeprecatedHeartbeats", () => $d30f8dd61b7d9c17$export$48cc63620d55f335);

var $fJD67 = parcelRequire("fJD67");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $k8Qyf = parcelRequire("k8Qyf");

var $gd0Sp = parcelRequire("gd0Sp");

var $7gA9Z = parcelRequire("7gA9Z");

var $j2xrH = parcelRequire("j2xrH");
const $d30f8dd61b7d9c17$export$d4c72bab9d6cc13a = {
    groups: (0, $7gA9Z.emptyResource),
    notificationPolicies: (0, $7gA9Z.emptyResource),
    heartbeats: (0, $7gA9Z.emptyResource)
};
const $d30f8dd61b7d9c17$var$Store = (0, $a61MH.createStore)({
    initialState: $d30f8dd61b7d9c17$export$d4c72bab9d6cc13a,
    actions: $j2xrH.actions,
    name: 'deprecated-counts'
});
const $d30f8dd61b7d9c17$export$46cb9574b46bee08 = (0, $fJD67.createContainer)($d30f8dd61b7d9c17$var$Store, {
    Wrapper: (0, $fJD67.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
            const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
            return {
                cloudId: cloudId,
                showFlag: showFlag
            };
        }
    })
});
const $d30f8dd61b7d9c17$export$7ccc6df7e431e9d5 = (0, $ggKAj.createHook)($d30f8dd61b7d9c17$var$Store);
const $d30f8dd61b7d9c17$export$a683813e834f13f1 = (0, $ggKAj.createHook)($d30f8dd61b7d9c17$var$Store, {
    selector: (state)=>({
            groups: state.groups,
            hasDeprecatedGroups: (state.groups.data?.count || 0) > 0
        })
});
const $d30f8dd61b7d9c17$export$6dd4db40d5822337 = (0, $ggKAj.createHook)($d30f8dd61b7d9c17$var$Store, {
    selector: (state)=>({
            notificationPolicies: state.notificationPolicies,
            hasDeprecatedNotificationPolicies: (state.notificationPolicies.data?.count || 0) > 0
        })
});
const $d30f8dd61b7d9c17$export$48cc63620d55f335 = (0, $ggKAj.createHook)($d30f8dd61b7d9c17$var$Store, {
    selector: (state)=>({
            heartbeats: state.heartbeats,
            hasDeprecatedGlobalHeartbeats: (state.heartbeats.data?.globalHeartbeatCount || 0) > 0,
            hasDeprecatedTotalHeartbeats: (state.heartbeats.data?.totalHeartbeatCount || 0) > 0,
            isExceedHeartbeatLimit: (state.heartbeats.data?.totalHeartbeatCount || 0) > 2000
        })
});

});
parcelRegister("j2xrH", function(module, exports) {

$parcel$export(module.exports, "actions", () => $c4c9f190d82e42ba$export$e324594224ef24da);

var $g07uW = parcelRequire("g07uW");

var $dW1PF = parcelRequire("dW1PF");

var $fbROV = parcelRequire("fbROV");
const $c4c9f190d82e42ba$var$getDeprecatedGroupsCount = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            groups: {
                data: state.groups.data,
                error: null,
                loading: true
            }
        });
        return $fbROV.getDeprecatedGroupsCount(cloudId).then((res)=>setState({
                groups: (0, $g07uW.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                groups: (0, $g07uW.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $c4c9f190d82e42ba$var$getDeprecatedHeartbeatsCount = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            heartbeats: {
                data: state.heartbeats.data,
                error: null,
                loading: true
            }
        });
        return $fbROV.getDeprecatedHeartbeatsCount(cloudId).then((res)=>setState({
                heartbeats: (0, $g07uW.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                heartbeats: (0, $g07uW.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $c4c9f190d82e42ba$var$getDeprecatedNotificationPoliciesCount = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            notificationPolicies: {
                data: state.notificationPolicies.data,
                error: null,
                loading: true
            }
        });
        return $fbROV.getDeprecatedNotificationPoliciesCount(cloudId).then((res)=>setState({
                notificationPolicies: (0, $g07uW.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                notificationPolicies: (0, $g07uW.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $c4c9f190d82e42ba$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($c4c9f190d82e42ba$var$getDeprecatedGroupsCount()),
            dispatch($c4c9f190d82e42ba$var$getDeprecatedHeartbeatsCount()),
            dispatch($c4c9f190d82e42ba$var$getDeprecatedNotificationPoliciesCount())
        ]).then((0, $dW1PF.multiplePromiseSettler));
const $c4c9f190d82e42ba$export$e324594224ef24da = {
    getDeprecatedGroupsCount: $c4c9f190d82e42ba$var$getDeprecatedGroupsCount,
    getDeprecatedHeartbeatsCount: $c4c9f190d82e42ba$var$getDeprecatedHeartbeatsCount,
    getDeprecatedNotificationPoliciesCount: $c4c9f190d82e42ba$var$getDeprecatedNotificationPoliciesCount,
    initialize: $c4c9f190d82e42ba$var$initialize
};

});
parcelRegister("fbROV", function(module, exports) {

$parcel$export(module.exports, "getDeprecatedGroupsCount", () => $0fca7f8dddff441a$export$67b822a517f03dfe);
$parcel$export(module.exports, "getDeprecatedNotificationPoliciesCount", () => $0fca7f8dddff441a$export$55e3f0e3955ec140);
$parcel$export(module.exports, "getDeprecatedHeartbeatsCount", () => $0fca7f8dddff441a$export$241c0dafce985f59);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $0fca7f8dddff441a$export$67b822a517f03dfe = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/changeboarding/groups`;
    return (0, $lRmyA.performGetRequest)(url).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getDeprecatedGroupsCountEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $0fca7f8dddff441a$export$55e3f0e3955ec140 = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/changeboarding/policies`;
    return (0, $lRmyA.performGetRequest)(url).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getDeprecatedNotificationPoliciesCountEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $0fca7f8dddff441a$export$241c0dafce985f59 = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/heartbeats/changeboarding`;
    return (0, $lRmyA.performGetRequest)(url).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getDeprecatedHeartbeatsCountEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};

});



parcelRegister("3CBya", function(module, exports) {

$parcel$export(module.exports, "IncidentsContainer", () => $832c5a7d878d7ec4$export$f504e9eea1c23a86);
$parcel$export(module.exports, "useIncidentsStore", () => $832c5a7d878d7ec4$export$7dfe7cf41f5c2f79);
$parcel$export(module.exports, "useIncidents", () => $832c5a7d878d7ec4$export$23e9cad190e56aee);

var $ggKAj = parcelRequire("ggKAj");
var $fJD67 = parcelRequire("fJD67");
var $a61MH = parcelRequire("a61MH");

var $gd0Sp = parcelRequire("gd0Sp");

var $7gA9Z = parcelRequire("7gA9Z");

var $5aFnD = parcelRequire("5aFnD");
const $832c5a7d878d7ec4$export$d4c72bab9d6cc13a = {
    incidentsCopyStatus: (0, $7gA9Z.emptyResource)
};
const $832c5a7d878d7ec4$var$Store = (0, $a61MH.createStore)({
    initialState: $832c5a7d878d7ec4$export$d4c72bab9d6cc13a,
    actions: $5aFnD.actions,
    name: 'incidents'
});
const $832c5a7d878d7ec4$export$f504e9eea1c23a86 = (0, $fJD67.createContainer)($832c5a7d878d7ec4$var$Store, {
    Wrapper: (0, $fJD67.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
            return {
                cloudId: cloudId
            };
        }
    })
});
const $832c5a7d878d7ec4$export$7dfe7cf41f5c2f79 = (0, $ggKAj.createHook)($832c5a7d878d7ec4$var$Store);
const $832c5a7d878d7ec4$export$43131cb4b87347a9 = (0, $ggKAj.createActionsHook)($832c5a7d878d7ec4$var$Store);
const $832c5a7d878d7ec4$export$23e9cad190e56aee = (0, $ggKAj.createHook)($832c5a7d878d7ec4$var$Store, {
    selector: (state)=>{
        const { incidentsCopyStatus: incidentsCopyStatus } = state;
        const projectKey = incidentsCopyStatus.data?.payload?.projectKey;
        const status = incidentsCopyStatus.data?.status;
        const errorLength = incidentsCopyStatus.data?.error?.length ?? 0;
        const hasCopyOperationError = errorLength > 0 || status === 'ERROR';
        const isCopied = status === 'SUCCESS' && !!projectKey && errorLength === 0;
        const isCopying = status === 'IN_PROGRESS';
        const canMigrateAgain = incidentsCopyStatus.data?.canMigrateAgain;
        const isEligibleForCopy = (status === 'SUCCESS' || hasCopyOperationError) && canMigrateAgain || status === 'NOT_STARTED';
        const shouldDisplaySuccessBanner = isCopied && canMigrateAgain === false;
        return {
            projectKey: projectKey,
            hasCopyOperationError: hasCopyOperationError,
            isCopied: isCopied,
            isCopying: isCopying,
            isEligibleForCopy: isEligibleForCopy,
            shouldDisplaySuccessBanner: shouldDisplaySuccessBanner
        };
    }
});

});
parcelRegister("5aFnD", function(module, exports) {

$parcel$export(module.exports, "actions", () => $2f95f328bd08c497$export$e324594224ef24da);

var $g07uW = parcelRequire("g07uW");

var $dW1PF = parcelRequire("dW1PF");

var $kP3n8 = parcelRequire("kP3n8");
const $2f95f328bd08c497$var$getIncidentsCopyStatus = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            incidentsCopyStatus: {
                ...state.incidentsCopyStatus,
                loading: true
            }
        });
        return $kP3n8.getIncidentsCopyStatus(cloudId).then((res)=>setState({
                incidentsCopyStatus: (0, $g07uW.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                incidentsCopyStatus: (0, $g07uW.createErrorResponse)(err)
            });
            throw err;
        });
    };
// Get status after copy is started and update the state
const $2f95f328bd08c497$var$copyIncidents = ()=>({ dispatch: dispatch }, { cloudId: cloudId })=>$kP3n8.copyIncidents(cloudId).then(()=>dispatch($2f95f328bd08c497$var$getIncidentsCopyStatus()));
const $2f95f328bd08c497$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($2f95f328bd08c497$var$getIncidentsCopyStatus())
        ]).then((0, $dW1PF.multiplePromiseSettler));
const $2f95f328bd08c497$export$e324594224ef24da = {
    getIncidentsCopyStatus: $2f95f328bd08c497$var$getIncidentsCopyStatus,
    copyIncidents: $2f95f328bd08c497$var$copyIncidents,
    initialize: $2f95f328bd08c497$var$initialize
};

});
parcelRegister("kP3n8", function(module, exports) {

$parcel$export(module.exports, "getIncidentsCopyStatus", () => $c8ecbff04d03567c$export$c027992a439e850d);
$parcel$export(module.exports, "copyIncidents", () => $c8ecbff04d03567c$export$583821603355a6e2);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $c8ecbff04d03567c$export$c027992a439e850d = (cloudId)=>{
    const url = `/gateway/api/jsd/escalator/${cloudId}/api/im-tooling/status`;
    return (0, $lRmyA.performGetRequest)(url).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getIncidentCopyStatusEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $c8ecbff04d03567c$export$583821603355a6e2 = (cloudId)=>{
    const url = `/gateway/api/jsd/escalator/${cloudId}/api/im-tooling/start`;
    return (0, $lRmyA.performPostRequest)(url).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'copyIncidentsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};

});



parcelRegister("2QBwV", function(module, exports) {

$parcel$export(module.exports, "IntegrationsContainer", () => $f9c26673f36902cd$export$a82408dc976aed12);
$parcel$export(module.exports, "useIntegrationsStore", () => $f9c26673f36902cd$export$20dfa6771a354e6b);
$parcel$export(module.exports, "useIntegrationCounts", () => $f9c26673f36902cd$export$d42a7d921bccf5ad);
$parcel$export(module.exports, "useSyncedIntegrations", () => $f9c26673f36902cd$export$f79da416c7d67657);
$parcel$export(module.exports, "useDiscontinuedIntegrations", () => $f9c26673f36902cd$export$7145e9baa0c24277);
$parcel$export(module.exports, "useDeprecatedIntegrations", () => $f9c26673f36902cd$export$1525890f71cafb3f);
$parcel$export(module.exports, "useIncomingCallIntegrations", () => $f9c26673f36902cd$export$f3c44b9fdca261f2);

var $ggKAj = parcelRequire("ggKAj");
var $fJD67 = parcelRequire("fJD67");
var $a61MH = parcelRequire("a61MH");

var $k8Qyf = parcelRequire("k8Qyf");

var $gd0Sp = parcelRequire("gd0Sp");

var $7gA9Z = parcelRequire("7gA9Z");

var $h8BF2 = parcelRequire("h8BF2");
const $f9c26673f36902cd$export$d4c72bab9d6cc13a = {
    counts: (0, $7gA9Z.emptyResource),
    syncedIntegrations: (0, $7gA9Z.emptyResource),
    discontinuedIntegrations: (0, $7gA9Z.emptyResource),
    deprecatedIntegrations: (0, $7gA9Z.emptyResource),
    incomingCallIntegrations: (0, $7gA9Z.emptyResource)
};
const $f9c26673f36902cd$var$Store = (0, $a61MH.createStore)({
    initialState: $f9c26673f36902cd$export$d4c72bab9d6cc13a,
    actions: $h8BF2.actions,
    name: 'integrations'
});
const $f9c26673f36902cd$export$a82408dc976aed12 = (0, $fJD67.createContainer)($f9c26673f36902cd$var$Store, {
    Wrapper: (0, $fJD67.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
            const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
            return {
                cloudId: cloudId,
                showFlag: showFlag
            };
        }
    })
});
const $f9c26673f36902cd$export$20dfa6771a354e6b = (0, $ggKAj.createHook)($f9c26673f36902cd$var$Store);
const $f9c26673f36902cd$export$eb083cb7fb078478 = (0, $ggKAj.createActionsHook)($f9c26673f36902cd$var$Store);
const $f9c26673f36902cd$export$d42a7d921bccf5ad = (0, $ggKAj.createHook)($f9c26673f36902cd$var$Store, {
    selector: (state)=>({
            counts: state.counts,
            hasIntegrations: (state.counts.data?.totalCount || 0) > 0
        })
});
const $f9c26673f36902cd$export$f79da416c7d67657 = (0, $ggKAj.createHook)($f9c26673f36902cd$var$Store, {
    selector: (state)=>({
            syncedIntegrations: state.syncedIntegrations,
            hasSyncedIntegration: (state.syncedIntegrations.data?.count || 0) > 0
        })
});
const $f9c26673f36902cd$export$7145e9baa0c24277 = (0, $ggKAj.createHook)($f9c26673f36902cd$var$Store, {
    selector: (state)=>({
            discontinuedIntegrations: state.discontinuedIntegrations,
            hasDiscontinuedIntegration: (state.discontinuedIntegrations.data?.count || 0) > 0
        })
});
const $f9c26673f36902cd$export$1525890f71cafb3f = (0, $ggKAj.createHook)($f9c26673f36902cd$var$Store, {
    selector: (state)=>({
            deprecatedIntegrations: state.deprecatedIntegrations,
            hasDeprecatedIntegration: (state.deprecatedIntegrations.data?.count || 0) > 0
        })
});
const $f9c26673f36902cd$export$f3c44b9fdca261f2 = (0, $ggKAj.createHook)($f9c26673f36902cd$var$Store, {
    selector: (state)=>({
            incomingCallIntegrations: state.incomingCallIntegrations,
            hasIncomingCallIntegration: (state.incomingCallIntegrations.data?.count || 0) > 0
        })
});

});
parcelRegister("h8BF2", function(module, exports) {

$parcel$export(module.exports, "actions", () => $d67f2a3505bc6a35$export$e324594224ef24da);

var $g07uW = parcelRequire("g07uW");

var $dW1PF = parcelRequire("dW1PF");

var $ihtu2 = parcelRequire("ihtu2");
const $d67f2a3505bc6a35$var$getIntegrationCounts = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            counts: {
                ...state.counts,
                loading: true
            }
        });
        return $ihtu2.getIntegrationCounts(cloudId).then((res)=>setState({
                counts: (0, $g07uW.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                counts: (0, $g07uW.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $d67f2a3505bc6a35$var$getSyncedIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            syncedIntegrations: {
                ...state.syncedIntegrations,
                loading: true
            }
        });
        return $ihtu2.getSyncedIntegrations(cloudId).then((res)=>setState({
                syncedIntegrations: (0, $g07uW.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                syncedIntegrations: (0, $g07uW.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $d67f2a3505bc6a35$var$getDiscontinuedIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            discontinuedIntegrations: {
                ...state.discontinuedIntegrations,
                loading: true
            }
        });
        return $ihtu2.getDiscontinuedIntegrations(cloudId).then((res)=>setState({
                discontinuedIntegrations: (0, $g07uW.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                discontinuedIntegrations: (0, $g07uW.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $d67f2a3505bc6a35$var$getDeprecatedIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            deprecatedIntegrations: {
                ...state.deprecatedIntegrations,
                loading: true
            }
        });
        return $ihtu2.getDeprecatedIntegrations(cloudId).then((res)=>setState({
                deprecatedIntegrations: (0, $g07uW.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                deprecatedIntegrations: (0, $g07uW.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $d67f2a3505bc6a35$var$getIncomingCallIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            incomingCallIntegrations: {
                ...state.incomingCallIntegrations,
                loading: true
            }
        });
        return $ihtu2.getIncomingCallIntegrations(cloudId).then((res)=>setState({
                incomingCallIntegrations: (0, $g07uW.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                incomingCallIntegrations: (0, $g07uW.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $d67f2a3505bc6a35$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($d67f2a3505bc6a35$var$getIntegrationCounts()),
            dispatch($d67f2a3505bc6a35$var$getSyncedIntegrations()),
            dispatch($d67f2a3505bc6a35$var$getDeprecatedIntegrations()),
            dispatch($d67f2a3505bc6a35$var$getDiscontinuedIntegrations()),
            dispatch($d67f2a3505bc6a35$var$getIncomingCallIntegrations())
        ]).then((0, $dW1PF.multiplePromiseSettler));
const $d67f2a3505bc6a35$export$e324594224ef24da = {
    initialize: $d67f2a3505bc6a35$var$initialize
};

});
parcelRegister("ihtu2", function(module, exports) {

$parcel$export(module.exports, "getIntegrationCounts", () => $8b6391841fb8530e$export$77778a0ed0c6fa6e);
$parcel$export(module.exports, "getSyncedIntegrations", () => $8b6391841fb8530e$export$832e854d2572cc2f);
$parcel$export(module.exports, "getDiscontinuedIntegrations", () => $8b6391841fb8530e$export$fd29039ae6c0f299);
$parcel$export(module.exports, "getDeprecatedIntegrations", () => $8b6391841fb8530e$export$37a9d02f12612e7c);
$parcel$export(module.exports, "getIncomingCallIntegrations", () => $8b6391841fb8530e$export$269a90dd370437b8);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $8b6391841fb8530e$export$77778a0ed0c6fa6e = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/count`;
    return (0, $lRmyA.performGetRequest)(url).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getIntegrationCountsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $8b6391841fb8530e$export$832e854d2572cc2f = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/sync`;
    return (0, $lRmyA.performGetRequest)(url).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getSyncedIntegrationsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $8b6391841fb8530e$export$fd29039ae6c0f299 = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/discontinued`;
    return (0, $lRmyA.performGetRequest)(url).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getDiscontinuedIntegrationsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $8b6391841fb8530e$export$37a9d02f12612e7c = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/deprecated`;
    return (0, $lRmyA.performGetRequest)(url).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getDeprecatedIntegrationsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $8b6391841fb8530e$export$269a90dd370437b8 = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/incoming-call`;
    return (0, $lRmyA.performGetRequest)(url).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getIncomingCallIntegrationsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};

});



parcelRegister("iIei2", function(module, exports) {

$parcel$export(module.exports, "JNAAppStatusContainer", () => $62e39e47205b9b8a$export$ea2d0ab423a74686);
$parcel$export(module.exports, "useJNAAppStatus", () => $62e39e47205b9b8a$export$5d602c3d2ce99e4d);

var $fJD67 = parcelRequire("fJD67");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $k8Qyf = parcelRequire("k8Qyf");

var $gd0Sp = parcelRequire("gd0Sp");

var $2OjEZ = parcelRequire("2OjEZ");
const $62e39e47205b9b8a$export$d4c72bab9d6cc13a = {
    loading: false,
    error: null
};
const $62e39e47205b9b8a$var$Store = (0, $a61MH.createStore)({
    initialState: $62e39e47205b9b8a$export$d4c72bab9d6cc13a,
    actions: $2OjEZ.actions,
    name: 'jna-app-status'
});
// We have a separate store for this b/c we need to fetch the data higher up in the tree
const $62e39e47205b9b8a$export$ea2d0ab423a74686 = (0, $fJD67.createContainer)($62e39e47205b9b8a$var$Store, {
    Wrapper: (0, $fJD67.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
            const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
            return {
                cloudId: cloudId,
                showFlag: showFlag
            };
        }
    })
});
const $62e39e47205b9b8a$export$5d602c3d2ce99e4d = (0, $ggKAj.createHook)($62e39e47205b9b8a$var$Store);

});
parcelRegister("2OjEZ", function(module, exports) {

$parcel$export(module.exports, "actions", () => $3e8363de586b063e$export$e324594224ef24da);

var $h6H3i = parcelRequire("h6H3i");
const $3e8363de586b063e$var$getData = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const { loading: loading } = getState();
        if (loading) // We are already fetching and will receive results, no need to start another request
        return;
        setState({
            loading: true
        });
        return (0, $h6H3i.listJNAAppsEndpoint)(cloudId)// Drop any unnecessary fields
        .then(({ values: values })=>({
                values: values
            })).then(setState).catch((error)=>{
            // TODO: we might display toast
            setState({
                error: error
            });
            throw error;
        }).finally(()=>{
            setState({
                loading: false
            });
        });
    };
const $3e8363de586b063e$var$initialize = $3e8363de586b063e$var$getData;
const $3e8363de586b063e$export$e324594224ef24da = {
    initialize: $3e8363de586b063e$var$initialize
};

});
parcelRegister("h6H3i", function(module, exports) {

$parcel$export(module.exports, "listJNAAppsEndpoint", () => $dee618a797e9b14a$export$89c8c108742e6641);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $dee618a797e9b14a$export$89c8c108742e6641 = (cloudId)=>(0, $lRmyA.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/onboarding/notification/devices`).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'listJNAAppsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });

});



parcelRegister("bkVBU", function(module, exports) {

$parcel$export(module.exports, "TeamAdminStatusContainer", () => $1f54706e18805055$export$1c30a658c5f5a989);
$parcel$export(module.exports, "useTeamAdminStatus", () => $1f54706e18805055$export$8e6e1b9570cbbe18);
$parcel$export(module.exports, "useIsTeamAdmin", () => $1f54706e18805055$export$1e85709af32c9e77);

var $fJD67 = parcelRequire("fJD67");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $gd0Sp = parcelRequire("gd0Sp");

var $7gA9Z = parcelRequire("7gA9Z");

var $4iFw8 = parcelRequire("4iFw8");
const $1f54706e18805055$export$d4c72bab9d6cc13a = {
    teamAdminStatus: (0, $7gA9Z.emptyResource)
};
const $1f54706e18805055$var$Store = (0, $a61MH.createStore)({
    initialState: $1f54706e18805055$export$d4c72bab9d6cc13a,
    actions: $4iFw8.actions,
    name: 'team-admin-status'
});
const $1f54706e18805055$export$1c30a658c5f5a989 = (0, $fJD67.createContainer)($1f54706e18805055$var$Store, {
    Wrapper: (0, $fJD67.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
            return {
                cloudId: cloudId
            };
        }
    })
});
const $1f54706e18805055$export$8e6e1b9570cbbe18 = (0, $ggKAj.createHook)($1f54706e18805055$var$Store);
const $1f54706e18805055$export$1e85709af32c9e77 = (0, $ggKAj.createHook)($1f54706e18805055$var$Store, {
    selector: (state)=>({
            isTeamAdmin: state.teamAdminStatus.data?.isTeamAdmin
        })
});

});
parcelRegister("4iFw8", function(module, exports) {

$parcel$export(module.exports, "actions", () => $89ab5bb4a0e4dc49$export$e324594224ef24da);

var $g07uW = parcelRequire("g07uW");

var $dW1PF = parcelRequire("dW1PF");

var $cF7D3 = parcelRequire("cF7D3");
const $89ab5bb4a0e4dc49$var$getTeamAdminStatus = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            teamAdminStatus: {
                data: state.teamAdminStatus.data,
                error: null,
                loading: true
            }
        });
        return $cF7D3.getTeamAdminStatus(cloudId).then((res)=>setState({
                teamAdminStatus: (0, $g07uW.createDataResponse)(res)
            })).catch((error)=>{
            setState({
                teamAdminStatus: (0, $g07uW.createErrorResponse)(error)
            });
            throw error;
        });
    };
const $89ab5bb4a0e4dc49$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($89ab5bb4a0e4dc49$var$getTeamAdminStatus())
        ]).then((0, $dW1PF.multiplePromiseSettler));
const $89ab5bb4a0e4dc49$export$e324594224ef24da = {
    getTeamAdminStatus: $89ab5bb4a0e4dc49$var$getTeamAdminStatus,
    initialize: $89ab5bb4a0e4dc49$var$initialize
};

});
parcelRegister("cF7D3", function(module, exports) {

$parcel$export(module.exports, "getTeamAdminStatus", () => $6e4186c1f482a042$export$454301be74c0d0f5);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $6e4186c1f482a042$export$454301be74c0d0f5 = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/teams/has-any-team-admin-role`;
    return (0, $lRmyA.performGetRequest)(url).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getTeamAdminStatusEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};

});



parcelRegister("hjidz", function(module, exports) {

$parcel$export(module.exports, "TeamsContainer", () => $f920567fff2ba828$export$1af14301d7a47977);
$parcel$export(module.exports, "useTeams", () => $f920567fff2ba828$export$6fe02dcc2001dcb0);

var $ggKAj = parcelRequire("ggKAj");
var $fJD67 = parcelRequire("fJD67");
var $a61MH = parcelRequire("a61MH");

var $k8Qyf = parcelRequire("k8Qyf");

var $jD3pk = parcelRequire("jD3pk");

var $gd0Sp = parcelRequire("gd0Sp");

var $7gA9Z = parcelRequire("7gA9Z");

var $9ykkm = parcelRequire("9ykkm");
const $f920567fff2ba828$export$d4c72bab9d6cc13a = {
    teams: (0, $7gA9Z.emptyResource),
    hasTeams: false
};
const $f920567fff2ba828$var$Store = (0, $a61MH.createStore)({
    initialState: $f920567fff2ba828$export$d4c72bab9d6cc13a,
    actions: $9ykkm.actions,
    name: 'teams-step'
});
const $f920567fff2ba828$export$1af14301d7a47977 = (0, $fJD67.createContainer)($f920567fff2ba828$var$Store, {
    Wrapper: (0, $fJD67.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { data: orgId } = (0, $jD3pk.useOrgId)();
            const { atlassianAccountId: atlassianAccountId, cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
            const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
            return {
                orgId: orgId,
                accountId: atlassianAccountId,
                siteId: cloudId,
                showFlag: showFlag
            };
        }
    })
});
const $f920567fff2ba828$export$381ea4f5dcfe14e8 = (0, $ggKAj.createHook)($f920567fff2ba828$var$Store);
const $f920567fff2ba828$export$61c2ead0c7de7c67 = (0, $ggKAj.createActionsHook)($f920567fff2ba828$var$Store);
const $f920567fff2ba828$export$6fe02dcc2001dcb0 = (0, $ggKAj.createHook)($f920567fff2ba828$var$Store, {
    selector: (state)=>({
            teams: state.teams,
            hasTeams: (state.teams.data?.entities.length || 0) > 0
        })
});

});
parcelRegister("9ykkm", function(module, exports) {

$parcel$export(module.exports, "actions", () => $3c8040b92d0d3139$export$e324594224ef24da);

var $g07uW = parcelRequire("g07uW");

var $dW1PF = parcelRequire("dW1PF");

var $adH9p = parcelRequire("adH9p");
const $3c8040b92d0d3139$var$getTeams = ()=>({ setState: setState, getState: getState }, { orgId: orgId, siteId: siteId, accountId: accountId })=>{
        if (!orgId) throw new Error('TeamsContainer-actions-getTeams-orgId must be defined to search teams');
        if (!accountId) {
            const error = new Error('TeamsContainer-useSyncContainerProps-atlassianAccountId must be defined to search teams');
            error.skipSentry = true;
            throw error;
        }
        const state = getState();
        setState({
            teams: {
                data: state.teams.data,
                error: null,
                loading: true
            }
        });
        return $adH9p.searchTeamsEndpoint({
            orgId: orgId,
            siteId: siteId,
            accountId: accountId
        }).then((res)=>setState({
                teams: (0, $g07uW.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                teams: (0, $g07uW.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $3c8040b92d0d3139$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($3c8040b92d0d3139$var$getTeams())
        ]).then((0, $dW1PF.multiplePromiseSettler));
const $3c8040b92d0d3139$export$e324594224ef24da = {
    getTeams: $3c8040b92d0d3139$var$getTeams,
    initialize: $3c8040b92d0d3139$var$initialize
};

});
parcelRegister("adH9p", function(module, exports) {

$parcel$export(module.exports, "searchTeamsEndpoint", () => $5ac9e5c94c3f6529$export$b6cad9b1c9a0c16e);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $5ac9e5c94c3f6529$export$b6cad9b1c9a0c16e = ({ orgId: orgId, siteId: siteId, accountId: accountId })=>{
    const url = '/gateway/api/v4/teams/search';
    return (0, $lRmyA.performPostRequest)(url, {
        method: 'POST',
        body: JSON.stringify({
            organizationId: orgId,
            siteId: siteId,
            membership: {
                memberAccountIds: [
                    accountId
                ]
            },
            sortBy: [
                {
                    field: 'displayName',
                    order: 'asc'
                }
            ],
            limit: 100
        })
    }).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'searchTeamsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};

});



parcelRegister("5e5rs", function(module, exports) {

$parcel$export(module.exports, "TransitioningStatusContainer", () => $10277dd8634dbe63$export$99720b5470b975d9);
$parcel$export(module.exports, "useTransitioningStatus", () => $10277dd8634dbe63$export$534e97dc293df05a);
$parcel$export(module.exports, "useTransitioningStatusActions", () => $10277dd8634dbe63$export$5097f959a9aa62ee);

var $ggKAj = parcelRequire("ggKAj");
var $fJD67 = parcelRequire("fJD67");
var $a61MH = parcelRequire("a61MH");

var $k8Qyf = parcelRequire("k8Qyf");

var $c7H0g = parcelRequire("c7H0g");
var $1R3n5 = parcelRequire("1R3n5");
var $gd0Sp = parcelRequire("gd0Sp");

var $lSr7u = parcelRequire("lSr7u");
const $10277dd8634dbe63$export$d4c72bab9d6cc13a = {
    loading: false,
    error: null,
    isJnaAppDownloaded: false,
    ogAppExistsAtTransitioningStart: false,
    isRBNEnabled: true,
    areOgRulesDuplicated: false,
    areOgAppsDeactivated: false,
    jnaAppDownloadedRatio: 0,
    jnaAppDownloadedUsersCount: 0
};
const $10277dd8634dbe63$var$Store = (0, $a61MH.createStore)({
    initialState: $10277dd8634dbe63$export$d4c72bab9d6cc13a,
    actions: $lSr7u.actions,
    name: 'transitioning-status'
});
const $10277dd8634dbe63$export$99720b5470b975d9 = (0, $fJD67.createContainer)($10277dd8634dbe63$var$Store, {
    Wrapper: (0, $fJD67.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
            const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
            const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
            const isPrimaryAdmin = (0, $c7H0g.useIsAdmin)();
            return {
                cloudId: cloudId,
                showFlag: showFlag,
                isAdmin: isSiteAdmin || isPrimaryAdmin
            };
        }
    })
});
const $10277dd8634dbe63$export$534e97dc293df05a = (0, $ggKAj.createHook)($10277dd8634dbe63$var$Store);
const $10277dd8634dbe63$export$5097f959a9aa62ee = (0, $ggKAj.createActionsHook)($10277dd8634dbe63$var$Store);

});
parcelRegister("lSr7u", function(module, exports) {

$parcel$export(module.exports, "actions", () => $100eedfdeab0745c$export$e324594224ef24da);

var $dW1PF = parcelRequire("dW1PF");

var $h0bmT = parcelRequire("h0bmT");
const $100eedfdeab0745c$var$getData = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId, isAdmin: isAdmin })=>{
        const { loading: loading } = getState();
        if (loading) // We are already fetching and receive results, no need to start another request
        return;
        setState({
            loading: true
        });
        return Promise.allSettled([
            (0, $h0bmT.getNotificationPreferences)(cloudId),
            (0, $h0bmT.getTransitioningStatus)(cloudId, isAdmin)
        ]).then((0, $dW1PF.multiplePromiseSettler)).then(([notificationPreferencesResult, transitioningStatusResult])=>{
            if (notificationPreferencesResult.status === 'rejected' || transitioningStatusResult.status === 'rejected') throw new Error('All promises should be fulfilled in then callback');
            return {
                ...notificationPreferencesResult.value,
                ...transitioningStatusResult.value
            };
        }).then(setState).catch((error)=>{
            // TODO: we might display toast
            setState({
                error: error
            });
            throw error;
        }).finally(()=>{
            setState({
                loading: false
            });
        });
    };
const $100eedfdeab0745c$var$initialize = $100eedfdeab0745c$var$getData;
const $100eedfdeab0745c$var$deactivateOgApps = ()=>async ({ setState: setState })=>{
        setState({
            areOgAppsDeactivated: true
        });
    };
const $100eedfdeab0745c$export$e324594224ef24da = {
    initialize: $100eedfdeab0745c$var$initialize,
    deactivateOgApps: $100eedfdeab0745c$var$deactivateOgApps
};

});
parcelRegister("h0bmT", function(module, exports) {

$parcel$export(module.exports, "getTransitioningStatus", () => $98423222b3c2421b$export$6b245964f40af86a);
$parcel$export(module.exports, "getNotificationPreferences", () => $98423222b3c2421b$export$60e139c3026f21bc);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $98423222b3c2421b$export$6b245964f40af86a = (cloudId, isAdmin)=>(0, $lRmyA.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/onboarding/transitioning?isAdmin=${isAdmin}`).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getTransitioningStatus',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
const $98423222b3c2421b$export$60e139c3026f21bc = (cloudId)=>(0, $lRmyA.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/notification-preferences`).then((res)=>// TODO: return name and role if it is necessary for the UI
        ({
            isRBNEnabled: !!res.roleBasedNotificationName
        })).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getNotificationPreferences',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });

});



parcelRegister("2Q2AK", function(module, exports) {

$parcel$export(module.exports, "UsersAndRolesContainer", () => $53addaaccbe63242$export$8641f4275dfb350f);
$parcel$export(module.exports, "useUsersAndRolesStore", () => $53addaaccbe63242$export$4c1f48a2f8c5d25);
$parcel$export(module.exports, "useUserAndRolesActions", () => $53addaaccbe63242$export$3a5577e95dd8ebcf);
$parcel$export(module.exports, "useGetUsersWithoutAdminRole", () => $53addaaccbe63242$export$208cf6e453d9959);
$parcel$export(module.exports, "useGetUsersWithoutCustomRole", () => $53addaaccbe63242$export$f97f67eb73b757d4);
$parcel$export(module.exports, "useStakeholders", () => $53addaaccbe63242$export$57e32456ebc09be3);

var $ggKAj = parcelRequire("ggKAj");
var $fJD67 = parcelRequire("fJD67");
var $a61MH = parcelRequire("a61MH");

var $gd0Sp = parcelRequire("gd0Sp");

var $7gA9Z = parcelRequire("7gA9Z");

var $6COoA = parcelRequire("6COoA");
const $53addaaccbe63242$var$initialState = {
    usersWithoutAdminRole: (0, $7gA9Z.emptyResource),
    usersWithoutCustomRole: (0, $7gA9Z.emptyResource),
    stakeholders: (0, $7gA9Z.emptyResource)
};
const $53addaaccbe63242$var$Store = (0, $a61MH.createStore)({
    initialState: $53addaaccbe63242$var$initialState,
    actions: $6COoA.actions,
    name: 'user-section'
});
const $53addaaccbe63242$export$8641f4275dfb350f = (0, $fJD67.createContainer)($53addaaccbe63242$var$Store, {
    Wrapper: (0, $fJD67.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
            return {
                cloudId: cloudId
            };
        }
    })
});
const $53addaaccbe63242$export$4c1f48a2f8c5d25 = (0, $ggKAj.createHook)($53addaaccbe63242$var$Store);
const $53addaaccbe63242$export$3a5577e95dd8ebcf = (0, $ggKAj.createActionsHook)($53addaaccbe63242$var$Store);
const $53addaaccbe63242$export$208cf6e453d9959 = (0, $ggKAj.createHook)($53addaaccbe63242$var$Store, {
    selector: (state)=>state.usersWithoutAdminRole
});
const $53addaaccbe63242$export$f97f67eb73b757d4 = (0, $ggKAj.createHook)($53addaaccbe63242$var$Store, {
    selector: (state)=>state.usersWithoutCustomRole
});
const $53addaaccbe63242$export$57e32456ebc09be3 = (0, $ggKAj.createHook)($53addaaccbe63242$var$Store, {
    selector: (state)=>state.stakeholders
});

});
parcelRegister("6COoA", function(module, exports) {

$parcel$export(module.exports, "actions", () => $c9d6025f0139ef97$export$e324594224ef24da);

var $1ybV0 = parcelRequire("1ybV0");

var $g07uW = parcelRequire("g07uW");

var $dW1PF = parcelRequire("dW1PF");

var $kwy8S = parcelRequire("kwy8S");
const $c9d6025f0139ef97$var$getUsersWithoutAdminRole = ()=>({ setState: setState }, { cloudId: cloudId })=>{
        setState({
            usersWithoutAdminRole: {
                data: null,
                error: null,
                loading: true
            }
        });
        return $kwy8S.getUsersWithoutAdminRole(cloudId).then((res)=>{
            setState({
                usersWithoutAdminRole: (0, $g07uW.createDataResponse)(res)
            });
        }).catch((err)=>{
            // TODO we might display toast
            setState({
                usersWithoutAdminRole: (0, $g07uW.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $c9d6025f0139ef97$var$getUsersWithoutCustomRole = ()=>({ setState: setState }, { cloudId: cloudId })=>{
        setState({
            usersWithoutCustomRole: {
                data: null,
                error: null,
                loading: true
            }
        });
        return $kwy8S.getUsersWithoutCustomRole(cloudId).then((res)=>{
            setState({
                usersWithoutCustomRole: (0, $g07uW.createDataResponse)(res)
            });
        }).catch((err)=>{
            // TODO we might display toast
            setState({
                usersWithoutCustomRole: (0, $g07uW.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $c9d6025f0139ef97$var$getStakeholders = ()=>({ setState: setState }, { cloudId: cloudId })=>{
        setState({
            stakeholders: {
                data: null,
                error: null,
                loading: true
            }
        });
        return $kwy8S.getStakeholders(cloudId).then((res)=>{
            setState({
                stakeholders: (0, $g07uW.createDataResponse)(res)
            });
        }).catch((err)=>{
            // TODO we might display toast
            setState({
                stakeholders: (0, $g07uW.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $c9d6025f0139ef97$var$initialize = (hasJsmAboveStandard)=>({ dispatch: dispatch })=>{
        const isOptimalTooling = (0, $1ybV0.ff)('platform.show-optimal-tooling_brgom');
        if (isOptimalTooling && hasJsmAboveStandard) return Promise.allSettled([
            dispatch($c9d6025f0139ef97$var$getUsersWithoutCustomRole()),
            dispatch($c9d6025f0139ef97$var$getUsersWithoutAdminRole()),
            dispatch($c9d6025f0139ef97$var$getStakeholders())
        ]).then((0, $dW1PF.multiplePromiseSettler));
        return Promise.allSettled([
            dispatch($c9d6025f0139ef97$var$getUsersWithoutCustomRole()),
            dispatch($c9d6025f0139ef97$var$getUsersWithoutAdminRole())
        ]).then((0, $dW1PF.multiplePromiseSettler));
    };
const $c9d6025f0139ef97$export$e324594224ef24da = {
    getUsersWithoutAdminRole: $c9d6025f0139ef97$var$getUsersWithoutAdminRole,
    getUsersWithoutCustomRole: $c9d6025f0139ef97$var$getUsersWithoutCustomRole,
    getStakeholders: $c9d6025f0139ef97$var$getStakeholders,
    initialize: $c9d6025f0139ef97$var$initialize
};

});
parcelRegister("kwy8S", function(module, exports) {

$parcel$export(module.exports, "getStakeholders", () => $5769a6b86cca7891$export$30370cfbc42a80a5);
$parcel$export(module.exports, "getUsersWithoutAdminRole", () => $5769a6b86cca7891$export$1ec19cfa7c383f0d);
$parcel$export(module.exports, "getUsersWithoutCustomRole", () => $5769a6b86cca7891$export$64f73bf174c9014a);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $5769a6b86cca7891$export$30370cfbc42a80a5 = (cloudId)=>(0, $lRmyA.performPostRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/roles/filter`, {
        body: JSON.stringify({
            limit: '10',
            offset: 0,
            roles: [
                'Stakeholder'
            ]
        })
    }).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getStakeholders',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
    // throw err;
    });
const $5769a6b86cca7891$export$1ec19cfa7c383f0d = (cloudId)=>(0, $lRmyA.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/permissionDifference/admin`).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getUsersWithoutAdminRole',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
const $5769a6b86cca7891$export$64f73bf174c9014a = (cloudId)=>(0, $lRmyA.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/permissionDifference/customRole`).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getUsersWithoutCustomRole',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });

});



const $672ccb48920b6462$export$203403aefc029c66 = 'ref';
const $672ccb48920b6462$export$8638ff77a0e20f0f = 'opsgenie';

parcelRegister("201R4", function(module, exports) {

$parcel$export(module.exports, "default", () => $acfb3b6dfdee18c9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $acfb3b6dfdee18c9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitleNonFinal: {
        "id": "eoc-changeboarding.controllers.store.global.error-title-non-final",
        "defaultMessage": "Couldn't open the guide"
    },
    errorDescriptionNonFinal: {
        "id": "eoc-changeboarding.controllers.store.global.error-description-non-final",
        "defaultMessage": "Something went wrong. Reload the page and try again."
    },
    errorActionNonFinal: {
        "id": "eoc-changeboarding.controllers.store.global.error-action-non-final",
        "defaultMessage": "Try again"
    }
});

});


const $c3a508c467a117cf$export$75f90732d1326d15 = 4;

parcelRegister("9piru", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dd9372ad3694e3cb$export$defe85febe8b728c);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $dd9372ad3694e3cb$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    stepLocator: {
        "id": "eoc-changeboarding.wizard.step-locator-no-translate",
        "defaultMessage": "{stepNumber} of {totalSteps}"
    },
    nextButton: {
        "id": "eoc-changeboarding.wizard.next-button-no-translate",
        "defaultMessage": "Next"
    },
    backButton: {
        "id": "eoc-changeboarding.wizard.back-button-no-translate",
        "defaultMessage": "Back"
    },
    closeButton: {
        "id": "eoc-changeboarding.wizard.close-button-no-translate",
        "defaultMessage": "Close"
    },
    unlockButton: {
        "id": "eoc-changeboarding.wizard.unlock-button-no-translate",
        "defaultMessage": "Let's start moving"
    },
    getStartedButton: {
        "id": "eoc-changeboarding.wizard.get-started-button-no-translate",
        "defaultMessage": "Open guide"
    },
    remindMeLaterButton: {
        "id": "eoc-changeboarding.wizard.remind-me-later-button-no-translate",
        "defaultMessage": "Remind me later"
    }
});

});

parcelRegister("gqg1q", function(module, exports) {

$parcel$export(module.exports, "StepFive", () => $30b1c63d29095682$export$782dfa47fc019134);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $d3vNK = parcelRequire("d3vNK");

var $a10lp = parcelRequire("a10lp");

var $iwsIy = parcelRequire("iwsIy");

var $cI9iM = parcelRequire("cI9iM");

var $jHMvH = parcelRequire("jHMvH");

var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $c7H0g = parcelRequire("c7H0g");
var $1R3n5 = parcelRequire("1R3n5");

var $1ZNqu = parcelRequire("1ZNqu");

var $dc8n7 = parcelRequire("dc8n7");

var $2Q2AK = parcelRequire("2Q2AK");

var $6HNET = parcelRequire("6HNET");

var $l6auV = parcelRequire("l6auV");
const $30b1c63d29095682$var$ListItem = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        justifyContent: "start",
        columnGap: "space.075",
        alignItems: "start",
        role: "listitem"
    }, children);
const $30b1c63d29095682$export$782dfa47fc019134 = ({ isFirstUnlocked: isFirstUnlocked = true })=>{
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isUser = !isAdmin && !isSiteAdmin;
    const [usersWithoutAdminRole] = (0, $2Q2AK.useGetUsersWithoutAdminRole)();
    const [usersWithoutCustomRole] = (0, $2Q2AK.useGetUsersWithoutCustomRole)();
    const [integrations] = (0, $dc8n7.useChatToolsIntegrations)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (isUser) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HNET.List), {
        heading: formatMessage((0, $l6auV.messages).titleByUser),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $l6auV.messages).listDescriptionForAnotherAdmin))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall",
        as: "h2"
    }, formatMessage((0, $l6auV.messages).listItemHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30b1c63d29095682$var$ListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a10lp))),
        color: (0, $1ZNqu.IconBoxColor).Orange
    }), formatMessage((0, $l6auV.messages).listItemOneUser)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30b1c63d29095682$var$ListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jHMvH))),
        color: (0, $1ZNqu.IconBoxColor).Green
    }), formatMessage((0, $l6auV.messages).listItemTwoUser)))));
    if (isFirstUnlocked) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HNET.List), {
        heading: formatMessage((0, $l6auV.messages).titleUnlockedBySameAdmin),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.250"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $l6auV.messages).listDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $l6auV.messages).listDescriptionTwo)))
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HNET.List), {
        heading: formatMessage((0, $l6auV.messages).titleUnlockedByAnotherAdmin),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $l6auV.messages).listDescriptionForAnotherAdmin))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall",
        as: "h2"
    }, formatMessage((0, $l6auV.messages).listItemHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, integrations.data?.count !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30b1c63d29095682$var$ListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))),
        color: (0, $1ZNqu.IconBoxColor).Teal
    }), formatMessage((0, $l6auV.messages).listItemOne)), usersWithoutAdminRole.data?.count !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30b1c63d29095682$var$ListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cI9iM))),
        color: (0, $1ZNqu.IconBoxColor).Orange
    }), formatMessage((0, $l6auV.messages).listItemTwo, {
        userAmount: usersWithoutAdminRole.data?.values.length ?? 0
    })), usersWithoutCustomRole.data?.count !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30b1c63d29095682$var$ListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))),
        color: (0, $1ZNqu.IconBoxColor).Purple
    }), formatMessage((0, $l6auV.messages).listItemThree, {
        userAmount: usersWithoutCustomRole.data?.values.length ?? 0
    })))));
};

});
parcelRegister("d3vNK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98143944cdbffe97$var$_react = $98143944cdbffe97$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $98143944cdbffe97$var$_comment = $98143944cdbffe97$var$_interopRequireDefault((parcelRequire("75UoT")));
function $98143944cdbffe97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $98143944cdbffe97$var$CommentIcon = (props)=>/*#__PURE__*/ $98143944cdbffe97$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props, {
        newIcon: $98143944cdbffe97$var$_comment.default
    }));
$98143944cdbffe97$var$CommentIcon.displayName = 'CommentIcon';
var $98143944cdbffe97$var$_default = module.exports.default = $98143944cdbffe97$var$CommentIcon;

});
parcelRegister("75UoT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52a4bffd3c43d738$var$_react = $52a4bffd3c43d738$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $52a4bffd3c43d738$var$_UNSAFE_baseNew = $52a4bffd3c43d738$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $52a4bffd3c43d738$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Comment".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $52a4bffd3c43d738$var$CommentIcon = (props)=>/*#__PURE__*/ $52a4bffd3c43d738$var$_react.default.createElement($52a4bffd3c43d738$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentColor" d="M6 12.25v-.75h-.221l-.186.12zM1.75 15H1a.75.75 0 0 0 1.157.63zM3 2.5h10V1H3zm10.5.5v8H15V3zm-.5 8.5H6V13h7zm-7.407.12-4.25 2.75.814 1.26 4.25-2.75zM2.5 15V3H1v12zM4 6h8V4.5H4zm0 3h5V7.5H4zm9.5 2a.5.5 0 0 1-.5.5V13a2 2 0 0 0 2-2zM13 2.5a.5.5 0 0 1 .5.5H15a2 2 0 0 0-2-2zM3 1a2 2 0 0 0-2 2h1.5a.5.5 0 0 1 .5-.5z"/>`
    }, props));
$52a4bffd3c43d738$var$CommentIcon.displayName = 'CommentIcon';
var $52a4bffd3c43d738$var$_default = module.exports.default = $52a4bffd3c43d738$var$CommentIcon;

});


parcelRegister("jHMvH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e587a998fd060edd$var$_react = $e587a998fd060edd$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $e587a998fd060edd$var$_eyeOpen = $e587a998fd060edd$var$_interopRequireDefault((parcelRequire("fMzEV")));
function $e587a998fd060edd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e587a998fd060edd$var$WatchIcon = (props)=>/*#__PURE__*/ $e587a998fd060edd$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M12 18c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6m0-14C6.48 4 2 8.841 2 12c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8"/><path d="M11.978 13.984c-1.104 0-2-.897-2-2s.896-2 2-2c1.103 0 2 .897 2 2s-.897 2-2 2m0-6c-2.206 0-4 1.794-4 4s1.793 4 4 4 4-1.794 4-4-1.794-4-4-4"/></g></svg>`
    }, props, {
        newIcon: $e587a998fd060edd$var$_eyeOpen.default
    }));
$e587a998fd060edd$var$WatchIcon.displayName = 'WatchIcon';
var $e587a998fd060edd$var$_default = module.exports.default = $e587a998fd060edd$var$WatchIcon;

});
parcelRegister("fMzEV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b7d6ffde6225a943$var$_react = $b7d6ffde6225a943$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b7d6ffde6225a943$var$_UNSAFE_baseNew = $b7d6ffde6225a943$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $b7d6ffde6225a943$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "EyeOpen".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b7d6ffde6225a943$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $b7d6ffde6225a943$var$_react.default.createElement($b7d6ffde6225a943$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentColor" d="M9.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/><path fill="currentColor" fill-rule="evenodd" d="M9.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" clip-rule="evenodd"/><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M.75 8A8.07 8.07 0 0 1 8 3.5 8.07 8.07 0 0 1 15.25 8 8.07 8.07 0 0 1 8 12.5 8.07 8.07 0 0 1 .75 8ZM9.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"/>`
    }, props));
$b7d6ffde6225a943$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $b7d6ffde6225a943$var$_default = module.exports.default = $b7d6ffde6225a943$var$EyeOpenIcon;

});


parcelRegister("6HNET", function(module, exports) {

$parcel$export(module.exports, "List", () => $b5c4dfa29d1c0552$export$54c2e3dc7acea9f5);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $c0jFd = parcelRequire("c0jFd");
const $b5c4dfa29d1c0552$export$54c2e3dc7acea9f5 = ({ heading: heading, description: description, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        rowGap: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        rowGap: "space.100",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xxlarge"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        role: "list",
        direction: "column",
        rowGap: "space.150"
    }, description, children));

});

parcelRegister("l6auV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3eea3f47a2531821$export$defe85febe8b728c);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $3eea3f47a2531821$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    titleUnlockedBySameAdmin: {
        "id": "eoc-changeboarding.wizard.steps.five.title-unlocked-by-same-admin.no-translate",
        "defaultMessage": "We're now moving you to Jira Service Management"
    },
    titleUnlockedByAnotherAdmin: {
        "id": "eoc-changeboarding.wizard.steps.five.title-unlocked-by-another-admin.no-translate",
        "defaultMessage": "Move your work from Opsgenie to Jira Service Management"
    },
    titleByUser: {
        "id": "eoc-changeboarding.wizard.steps.five.title-by-user.no-translate",
        "defaultMessage": "Move your work from Opsgenie to Jira Service Management"
    },
    listDescription: {
        "id": "eoc-changeboarding.wizard.steps.five.list-description.no-translate",
        "defaultMessage": "Almost all of your Opsgenie data and settings are now in Jira Service Management."
    },
    listDescriptionTwo: {
        "id": "eoc-changeboarding.wizard.steps.five.list-description-two.no-translate",
        "defaultMessage": "Let's go finish setting up some critical configurations, so your teams can start using operations in Jira Service Management."
    },
    listItemHeading: {
        "id": "eoc-changeboarding.wizard.steps.five.list-item-heading.no-translate",
        "defaultMessage": "Let's go set up a few things so your team can get started"
    },
    listDescriptionForAnotherAdmin: {
        "id": "eoc-changeboarding.wizard.steps.five.list-description-for-another-admin.no-translate",
        "defaultMessage": "Almost all of your Opsgenie data and settings are now in Jira Service Management, so you no longer need Opsgenie to do your alerting and on-call work."
    },
    listItemOne: {
        "id": "eoc-changeboarding.wizard.steps.five.list-item-one.no-translate",
        "defaultMessage": "Configure chat integrations in Jira Service Management"
    },
    listItemTwo: {
        "id": "eoc-changeboarding.wizard.steps.five.list-item-two.no-translate",
        "defaultMessage": "Give the product admin role to {userAmount, plural, one {{userAmount} Opsgenie admin} other {{userAmount} Opsgenie admins}}"
    },
    listItemThree: {
        "id": "eoc-changeboarding.wizard.steps.five.list-item-three.no-translate",
        "defaultMessage": "Give a product role to {userAmount, plural, one {{userAmount} Opsgenie user} other {{userAmount} Opsgenie users}} who no longer have a custom role"
    },
    listItemOneUser: {
        "id": "eoc-changeboarding.wizard.steps.five.list-item-one-user.no-translate",
        "defaultMessage": "Configure your notifications settings in Jira"
    },
    listItemTwoUser: {
        "id": "eoc-changeboarding.wizard.steps.five.list-item-two-user.no-translate",
        "defaultMessage": "Discover how operations works on Jira Service Management"
    },
    learnMore: {
        "id": "eoc-changeboarding.wizard.steps.five.learn-more.no-translate",
        "defaultMessage": "Don't feel ready yet? <link>Read more about operations</link>"
    }
});

});


parcelRegister("iJ4iV", function(module, exports) {

$parcel$export(module.exports, "StepFour", () => $db1bc6aaac1a8c27$export$b88edf692723a2ee);

var $eUqFw = parcelRequire("eUqFw");

var $bbmZl = parcelRequire("bbmZl");

var $EN9B6 = parcelRequire("EN9B6");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $dmCPj = parcelRequire("dmCPj");

var $k9Z3M = parcelRequire("k9Z3M");

var $ioiQ7 = parcelRequire("ioiQ7");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hqVLk = parcelRequire("hqVLk");

var $fH5cc = parcelRequire("fH5cc");

var $1ZNqu = parcelRequire("1ZNqu");

var $hCyRm = parcelRequire("hCyRm");

var $eZ4iK = parcelRequire("eZ4iK");
const $db1bc6aaac1a8c27$export$b88edf692723a2ee = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { timeZone: timeZone } = (0, $hCyRm.useUserTimezone)();
    const { data: transitioningData } = (0, $hqVLk.useResource)((0, $fH5cc.transitioningDetailsResource));
    if (!transitioningData) throw new Error('[StepFour] component should not be rendered before details resource fetched');
    const items = [
        {
            icon: {
                component: (0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))),
                color: (0, $1ZNqu.IconBoxColor).Magenta
            },
            text: formatMessage((0, $eZ4iK.messages).listItemOne)
        },
        {
            icon: {
                component: (0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))),
                color: (0, $1ZNqu.IconBoxColor).Green
            },
            text: formatMessage((0, $eZ4iK.messages).listItemTwo)
        },
        {
            icon: {
                component: (0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))),
                color: (0, $1ZNqu.IconBoxColor).Purple
            },
            text: formatMessage((0, $eZ4iK.messages).listItemThree, {
                unlockDate: (0, $EN9B6.default)((0, $bbmZl.default)(transitioningData?.autoOgTurnOffDate, timeZone), 'MMMM dd, yyyy'),
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, chunks)
            })
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        rowGap: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        rowGap: "space.100",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xlarge"
    }, formatMessage((0, $eZ4iK.messages).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        role: "list",
        direction: "column",
        rowGap: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $eZ4iK.messages).listDescription)), items.map((item, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            justifyContent: "start",
            columnGap: "space.075",
            alignItems: "start",
            role: "listitem",
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: item.icon.component,
            color: item.icon.color
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, item.text))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $eZ4iK.messages).learnMore, {
        link: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "link",
                spacing: "none",
                href: "https://support.atlassian.com/jira-service-management-cloud/docs/what-are-operations/",
                target: "_blank"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                as: "span",
                xcss: $db1bc6aaac1a8c27$var$buttonTextStyles
            }, str)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }))));
};
const $db1bc6aaac1a8c27$var$buttonTextStyles = (0, $1ZAYh.xcss)({
    textDecoration: 'underline',
    fontWeight: 400
});

});
parcelRegister("dmCPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bab72963b78cefe$var$_react = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9bab72963b78cefe$var$_copy = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("dBCpP")));
function $9bab72963b78cefe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9bab72963b78cefe$var$CopyIcon = (props)=>/*#__PURE__*/ $9bab72963b78cefe$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $9bab72963b78cefe$var$_copy.default
    }));
$9bab72963b78cefe$var$CopyIcon.displayName = 'CopyIcon';
var $9bab72963b78cefe$var$_default = module.exports.default = $9bab72963b78cefe$var$CopyIcon;

});
parcelRegister("dBCpP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e7c879c9eefdea2$var$_react = $9e7c879c9eefdea2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9e7c879c9eefdea2$var$_UNSAFE_baseNew = $9e7c879c9eefdea2$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $9e7c879c9eefdea2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Copy".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e7c879c9eefdea2$var$CopyIcon = (props)=>/*#__PURE__*/ $9e7c879c9eefdea2$var$_react.default.createElement($9e7c879c9eefdea2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentColor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$9e7c879c9eefdea2$var$CopyIcon.displayName = 'CopyIcon';
var $9e7c879c9eefdea2$var$_default = module.exports.default = $9e7c879c9eefdea2$var$CopyIcon;

});


parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ead4032469749d51$var$_checkMark = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("j52dF")));
function $ead4032469749d51$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $ead4032469749d51$var$_checkMark.default
    }));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = module.exports.default = $ead4032469749d51$var$EditorDoneIcon;

});
parcelRegister("j52dF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de4034a95f8a9e06$var$_react = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $de4034a95f8a9e06$var$_UNSAFE_baseNew = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $de4034a95f8a9e06$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "CheckMark".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de4034a95f8a9e06$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $de4034a95f8a9e06$var$_react.default.createElement($de4034a95f8a9e06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M1.5 8.966 5.4 13l9.1-9.75"/>`
    }, props));
$de4034a95f8a9e06$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $de4034a95f8a9e06$var$_default = module.exports.default = $de4034a95f8a9e06$var$CheckMarkIcon;

});


parcelRegister("hCyRm", function(module, exports) {

$parcel$export(module.exports, "useUserTimezone", () => $d13862eb65b8fbeb$export$a166f5a988ee846a);

var $cWiVr = parcelRequire("cWiVr");
const $d13862eb65b8fbeb$export$a166f5a988ee846a = ()=>{
    const { data: userData } = (0, $cWiVr.useCurrentUser)();
    const timeZone = 'timeZone' in userData.user ? userData.user.timeZone || 'UTC' : 'UTC';
    return {
        timeZone: timeZone
    };
};

});

parcelRegister("eZ4iK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0abe640585ec959a$export$defe85febe8b728c);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $0abe640585ec959a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "eoc-changeboarding.wizard.steps.four.title-no-translate",
        "defaultMessage": "Ready to move from Opsgenie?"
    },
    listDescription: {
        "id": "eoc-changeboarding.wizard.steps.four.list-description-no-translate",
        "defaultMessage": "Here's a summary of what happens once you move:"
    },
    listItemOne: {
        "id": "eoc-changeboarding.wizard.steps.four.list-item-one-no-translate",
        "defaultMessage": "Your Opsgenie data and settings will be synced with Jira Service Management, without any changes,"
    },
    listItemTwo: {
        "id": "eoc-changeboarding.wizard.steps.four.list-item-two-no-translate",
        "defaultMessage": "You'll get a guide to follow and complete your move from Opsgenie to Jira Service Management,"
    },
    listItemThree: {
        "id": "eoc-changeboarding.wizard.steps.four.list-item-three-no-translate",
        "defaultMessage": "Your Opsgenie account will continue to be accessible, until it's turned off on <b>{unlockDate}</b>."
    },
    learnMore: {
        "id": "eoc-changeboarding.wizard.steps.four.learn-more-no-translate",
        "defaultMessage": "Don't feel ready yet? <link>Read more about moving from Opsgenie</link>"
    }
});

});


parcelRegister("hu1EK", function(module, exports) {

$parcel$export(module.exports, "StepOne", () => $10d1c28a40a57177$export$d644924ea55d67c0);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $kgsNq = parcelRequire("kgsNq");

var $a10lp = parcelRequire("a10lp");

var $iw0Y6 = parcelRequire("iw0Y6");

var $c0jFd = parcelRequire("c0jFd");
var $1Yimi = parcelRequire("1Yimi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1ZNqu = parcelRequire("1ZNqu");

var $7PshF = parcelRequire("7PshF");
const $10d1c28a40a57177$export$d644924ea55d67c0 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const sections = [
        {
            icon: {
                component: (0, (/*@__PURE__*/$parcel$interopDefault($a10lp))),
                color: (0, $1ZNqu.IconBoxColor).Orange
            },
            title: formatMessage((0, $7PshF.messages).alertsTitle),
            description: formatMessage((0, $7PshF.messages).alertsDescription)
        },
        {
            icon: {
                component: (0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))),
                color: (0, $1ZNqu.IconBoxColor).Lime
            },
            title: formatMessage((0, $7PshF.messages).operationsTitle),
            description: formatMessage((0, $7PshF.messages).operationsDescription)
        },
        {
            icon: {
                component: (0, (/*@__PURE__*/$parcel$interopDefault($kgsNq))),
                color: (0, $1ZNqu.IconBoxColor).Teal
            },
            title: formatMessage((0, $7PshF.messages).mobileTitle),
            description: formatMessage((0, $7PshF.messages).mobileDescription)
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        rowGap: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        rowGap: "space.100",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xlarge"
    }, formatMessage((0, $7PshF.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $7PshF.messages).description))), sections.map((section, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            key: i,
            direction: "column",
            rowGap: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            columnGap: "space.075",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: section.icon.component,
            color: section.icon.color
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
            as: "h2",
            size: "xsmall"
        }, section.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, section.description))));
};

});
parcelRegister("kgsNq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03cea3abcae27ecc$var$_react = $03cea3abcae27ecc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $03cea3abcae27ecc$var$_deviceMobile = $03cea3abcae27ecc$var$_interopRequireDefault((parcelRequire("1N6bE")));
function $03cea3abcae27ecc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $03cea3abcae27ecc$var$MobileIcon = (props)=>/*#__PURE__*/ $03cea3abcae27ecc$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M7 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm10 2H7v13h10zm-3 15h-4v1h4z" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $03cea3abcae27ecc$var$_deviceMobile.default
    }));
$03cea3abcae27ecc$var$MobileIcon.displayName = 'MobileIcon';
var $03cea3abcae27ecc$var$_default = module.exports.default = $03cea3abcae27ecc$var$MobileIcon;

});
parcelRegister("1N6bE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14df2aa1f39eb3c5$var$_react = $14df2aa1f39eb3c5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $14df2aa1f39eb3c5$var$_UNSAFE_baseNew = $14df2aa1f39eb3c5$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $14df2aa1f39eb3c5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "DeviceMobile".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Known uses: call, contact us.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $14df2aa1f39eb3c5$var$DeviceMobileIcon = (props)=>/*#__PURE__*/ $14df2aa1f39eb3c5$var$_react.default.createElement($14df2aa1f39eb3c5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M6 12.25h4m-5.5 3h7c.69 0 1.25-.56 1.25-1.25V2c0-.69-.56-1.25-1.25-1.25h-7c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$14df2aa1f39eb3c5$var$DeviceMobileIcon.displayName = 'DeviceMobileIcon';
var $14df2aa1f39eb3c5$var$_default = module.exports.default = $14df2aa1f39eb3c5$var$DeviceMobileIcon;

});


parcelRegister("7PshF", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6a852f067422744f$export$defe85febe8b728c);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $6a852f067422744f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "eoc-changeboarding.wizard.steps.one.title-no-translate",
        "defaultMessage": "Move your work from Opsgenie to Jira Service Management"
    },
    description: {
        "id": "eoc-changeboarding.wizard.steps.one.description-no-translate",
        "defaultMessage": "Make Jira Service Management your team's central place to do all the operations work that they currently do with Opsgenie."
    },
    alertsTitle: {
        "id": "eoc-changeboarding.wizard.steps.one.alerts-title-no-translate",
        "defaultMessage": "Respond to alerts"
    },
    alertsDescription: {
        "id": "eoc-changeboarding.wizard.steps.one.alerts-description-no-translate",
        "defaultMessage": "Work on your alerts natively from Jira Service Management's Your work page."
    },
    operationsTitle: {
        "id": "eoc-changeboarding.wizard.steps.one.operations-title-no-translate",
        "defaultMessage": "Manage operations"
    },
    operationsDescription: {
        "id": "eoc-changeboarding.wizard.steps.one.operations-description-no-translate",
        "defaultMessage": "Find your integrations, custom roles, maintenance, notifications, policies, audit logs, and more in Jira settings."
    },
    mobileTitle: {
        "id": "eoc-changeboarding.wizard.steps.one.mobile-title-no-translate",
        "defaultMessage": "Get mobile notifications"
    },
    mobileDescription: {
        "id": "eoc-changeboarding.wizard.steps.one.mobile-description-no-translate",
        "defaultMessage": "Stay notified of alerts, check on-call schedules, and manage notification rules on the go with Jira Cloud mobile."
    }
});

});


parcelRegister("lkWvS", function(module, exports) {

$parcel$export(module.exports, "StepThree", () => $b3156ac8ab4bdbc2$export$98c7d7d0f8104aa7);

var $eUqFw = parcelRequire("eUqFw");

var $cGL6G = parcelRequire("cGL6G");

var $hI5oG = parcelRequire("hI5oG");

var $8tfNS = parcelRequire("8tfNS");

var $iFmgL = parcelRequire("iFmgL");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7gA9Z = parcelRequire("7gA9Z");

var $dc8n7 = parcelRequire("dc8n7");

var $gUnte = parcelRequire("gUnte");
const $b3156ac8ab4bdbc2$export$98c7d7d0f8104aa7 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [integrations] = (0, $dc8n7.useChatToolsIntegrations)();
    if (!integrations.data) throw new Error('StepThree should be rendered when chat tools integrations are loaded');
    const head = {
        cells: [
            {
                key: 'integration',
                content: formatMessage((0, $gUnte.messages).integration),
                width: 60
            },
            {
                key: 'team',
                content: formatMessage((0, $gUnte.messages).team),
                width: 40
            }
        ]
    };
    const rows = integrations.data.values.slice(0, 3).map(({ chatSpaceId: chatSpaceId, name: name, chatSpaceType: chatSpaceType, teamName: teamName })=>({
            key: chatSpaceId,
            cells: [
                {
                    key: `${chatSpaceId}-integration`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
                        alignItems: "center",
                        xcss: [
                            $b3156ac8ab4bdbc2$var$rowStyles,
                            $b3156ac8ab4bdbc2$var$linkStyles
                        ],
                        columnGap: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
                        width: "16",
                        height: "16",
                        src: chatSpaceType === 'slack' ? (0, $7gA9Z.SLACK_IMAGE_URL) : (0, $7gA9Z.MST_IMAGE_URL),
                        alt: chatSpaceType
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        xcss: $b3156ac8ab4bdbc2$var$integrationNameBoxStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "p",
                        maxLines: 1
                    }, name)))
                },
                {
                    key: `${chatSpaceId}-team`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
                        alignItems: "center",
                        columnGap: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tfNS))), {
                        size: "small",
                        label: ""
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "p",
                        maxLines: 1
                    }, teamName || formatMessage((0, $gUnte.messages).global)))
                }
            ]
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        rowGap: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        rowGap: "space.100",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xlarge"
    }, formatMessage((0, $gUnte.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $gUnte.messages).description))), integrations.data.count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        rowGap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall",
        as: "div"
    }, formatMessage((0, $gUnte.messages).chatIntegrationsFoundInOpsgenie, {
        amount: integrations.data.count
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b3156ac8ab4bdbc2$var$tableStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cGL6G.default), {
        isFixedSize: true,
        head: head,
        rows: rows,
        rowsPerPage: 3,
        defaultPage: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b3156ac8ab4bdbc2$var$blanketStyles
    }))));
};
const $b3156ac8ab4bdbc2$var$rowStyles = (0, $1ZAYh.xcss)({
    height: '36px'
});
const $b3156ac8ab4bdbc2$var$linkStyles = (0, $1ZAYh.xcss)({
    color: 'color.link'
});
const $b3156ac8ab4bdbc2$var$tableStyles = (0, $1ZAYh.xcss)({
    pointerEvents: 'none',
    userSelect: 'none',
    position: 'relative',
    marginBottom: '0'
});
const $b3156ac8ab4bdbc2$var$blanketStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: `linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, ${"var(--ds-surface-overlay, #282E33)"} 100%)`,
    // table adds margin-bottom: 24px by default. this is a hack to remove it.
    top: 'space.negative.300'
});
const $b3156ac8ab4bdbc2$var$integrationNameBoxStyles = (0, $1ZAYh.xcss)({
    width: '60%'
});

});
parcelRegister("cGL6G", function(module, exports) {

$parcel$export(module.exports, "default", () => $fee9e861fc13653b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $fVXMO = parcelRequire("fVXMO");

var $clqWl = parcelRequire("clqWl");
class $fee9e861fc13653b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            defaultPage: 1,
            isLoading: false,
            isFixedSize: false,
            isRankable: false,
            onSetPage: (0, $5Q9wj.default),
            onSort: (0, $5Q9wj.default),
            rowsPerPage: Infinity
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $clqWl.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        };
        this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        };
        this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        };
        this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        };
        this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $fVXMO.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});
parcelRegister("fVXMO", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $9778ffcbc0ef1196$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $9778ffcbc0ef1196$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $9778ffcbc0ef1196$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $9778ffcbc0ef1196$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $9778ffcbc0ef1196$export$c476bbe5da59992d);
const $9778ffcbc0ef1196$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $9778ffcbc0ef1196$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $9778ffcbc0ef1196$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $9778ffcbc0ef1196$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $9778ffcbc0ef1196$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $9778ffcbc0ef1196$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $9778ffcbc0ef1196$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $9778ffcbc0ef1196$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("clqWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cd2847e492d5dd4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5Q9wj = parcelRequire("5Q9wj");


var $fVXMO = parcelRequire("fVXMO");

var $3tjuM = parcelRequire("3tjuM");

var $iK2U9 = parcelRequire("iK2U9");

var $9t1Ml = parcelRequire("9t1Ml");

var $aLrpD = parcelRequire("aLrpD");

var $a96y2 = parcelRequire("a96y2");

var $DPlg5 = parcelRequire("DPlg5");

var $i9y06 = parcelRequire("i9y06");

var $cTO8p = parcelRequire("cTO8p");
const $7cd2847e492d5dd4$var$packageName = "platform-pkg";
const $7cd2847e492d5dd4$var$packageVersion = "0.0.0-use.local";
function $7cd2847e492d5dd4$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65:
            return 0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b;
        case 0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b:
            return 0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
class $7cd2847e492d5dd4$export$613134f68684a686 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isLoading: false,
            isFixedSize: false,
            rowsPerPage: Infinity,
            onSetPage: (0, $5Q9wj.default),
            onSort: (0, $5Q9wj.default),
            page: 1,
            isRankable: false,
            isRankingDisabled: false,
            onRankStart: (0, $5Q9wj.default),
            onRankEnd: (0, $5Q9wj.default),
            paginationi18n: {
                prev: 'Previous',
                next: 'Next',
                label: 'Pagination',
                pageLabel: 'Page'
            }
        };
    }
    UNSAFE_componentWillMount() {
        (0, $fVXMO.validateSortKey)(this.props.sortKey, this.props.head);
        (0, $fVXMO.assertIsSortable)(this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $fVXMO.validateSortKey)(nextProps.sortKey, nextProps.head);
        if (this.props.head !== nextProps.head) (0, $fVXMO.assertIsSortable)(nextProps.head);
    }
    render() {
        const { caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, isFixedSize: isFixedSize, page: page, rows: rows, rowsPerPage: rowsPerPage, sortKey: sortKey, sortOrder: sortOrder, isLoading: isLoading, loadingLabel: loadingLabel, isRankable: isRankable, isRankingDisabled: isRankingDisabled, paginationi18n: paginationi18n, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label } = this.props;
        const rowsLength = rows && rows.length;
        let totalPages;
        // set a flag to denote the dynamic table might get only one page of data
        // for paginated data
        let isTotalPagesControlledExternally = false;
        if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
            /**
       * If total number of rows / records have been passed down as prop
       * Then table is being fed paginated data from server or other sources
       * In this case, we want to respect information passed down by server or external source
       * Rather than relying on our computation based on number of rows
       */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
            isTotalPagesControlledExternally = true;
        } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
        totalPages = totalPages < 1 ? 1 : totalPages;
        const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
        const bodyProps = {
            highlightedRowIndex: highlightedRowIndex,
            rows: rows,
            head: head,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rowsPerPage: rowsPerPage,
            page: getPageNumber,
            isFixedSize: isFixedSize || false,
            onPageRowsUpdate: onPageRowsUpdate,
            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
            ref: this.tableBody,
            testId: testId
        };
        const rowsExist = !!rowsLength;
        const spinnerSize = this.getSpinnerSize();
        const emptyBody = this.renderEmptyBody();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $DPlg5.default), {
            isLoading: isLoading && rowsExist,
            spinnerSize: spinnerSize,
            targetRef: ()=>this.tableBody.current,
            testId: testId,
            loadingLabel: loadingLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.Table), {
            isFixedSize: isFixedSize,
            "aria-label": label,
            hasDataRow: rowsExist,
            testId: testId,
            isLoading: isLoading
        }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.Caption), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cTO8p.default), {
            head: head,
            onSort: this.onSortHandler,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRanking: this.state.isRanking,
            isRankable: isRankable,
            testId: testId
        }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd2847e492d5dd4$var$TableBody, {
            ...bodyProps,
            isRankable: this.props.isRankable,
            isRanking: this.state.isRanking,
            onRankStart: this.onRankStartHandler,
            onRankEnd: this.onRankEndHandler,
            isRankingDisabled: isRankingDisabled || isLoading || false
        }))), totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.PaginationWrapper), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i9y06.default), {
            value: getPageNumber,
            onChange: this.onSetPageHandler,
            total: totalPages,
            i18n: paginationi18n,
            isDisabled: isLoading,
            testId: testId
        })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a96y2.default), {
            isLoading: isLoading,
            spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
            testId: testId,
            loadingLabel: loadingLabel
        }, emptyBody));
    }
    constructor(...args){
        super(...args);
        this.tableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.state = {
            isRanking: false
        };
        this.onSortHandler = (item)=>()=>{
                const { sortKey: sortKey, sortOrder: sortOrder, onSort: onSort, isRankable: isRankable } = this.props;
                const { key: key } = item;
                if (!key) return;
                if (onSort && isRankable && key === sortKey && sortOrder === (0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65)) {
                    onSort({
                        key: null,
                        sortOrder: null,
                        item: item
                    });
                    return;
                }
                const sortOrderFormatted = key !== sortKey ? (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b) : $7cd2847e492d5dd4$var$toggleSortOrder(sortOrder);
                if (onSort) onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrderFormatted
                });
            };
        this.onSetPageHandler = (page, event)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) onSetPage(page, event);
        };
        this.onRankStartHandler = (params)=>{
            this.setState({
                isRanking: true
            });
            if (this.props.onRankStart) this.props.onRankStart(params);
        };
        this.onRankEndHandler = (params)=>{
            this.setState({
                isRanking: false
            });
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        };
        this.getSpinnerSize = ()=>{
            const { page: page, rows: rows, rowsPerPage: rowsPerPage, loadingSpinnerSize: loadingSpinnerSize } = this.props;
            if (loadingSpinnerSize) return loadingSpinnerSize;
            return (0, $fVXMO.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3) : (0, $9ad1be2eb14b8d3d$export$71dd4c8ecd45e95f);
        };
        this.renderEmptyBody = ()=>{
            const { emptyView: emptyView, isLoading: isLoading, testId: testId } = this.props;
            if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iK2U9.EmptyViewWithFixedHeight), {
                testId: testId
            });
            return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iK2U9.EmptyViewContainer), {
                testId: testId
            }, emptyView);
        };
    }
}

const $7cd2847e492d5dd4$var$RankableTableBody = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("ekXh3")));
const $7cd2847e492d5dd4$var$TableBody = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9t1Ml.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aLrpD.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd2847e492d5dd4$var$RankableTableBody, {
        ref: ref,
        ...bodyProps,
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    }))) : nonRankableBody;
});
const $7cd2847e492d5dd4$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
/**
 * __Dynamic table stateless__
 *
 * A stateless table that requires consumers to manage the sorting, drag and drop, and pagination.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/dynamic-table)
 * - [Code](https://bitbucket.org/atlassian/atlassian-frontend/packages/design-system/dynamic-table)
 */ const $7cd2847e492d5dd4$var$DynamicTableStateless = (0, $1ngde.default)({
    componentName: 'dynamicTable',
    packageName: $7cd2847e492d5dd4$var$packageName,
    packageVersion: $7cd2847e492d5dd4$var$packageVersion
})((0, $2jDha.default)({
    onSort: $7cd2847e492d5dd4$var$createAndFireEventOnAtlaskit({
        action: 'sorted',
        actionSubject: 'dynamicTable',
        attributes: {
            componentName: 'dynamicTable',
            packageName: $7cd2847e492d5dd4$var$packageName,
            packageVersion: $7cd2847e492d5dd4$var$packageVersion
        }
    }),
    onRankEnd: $7cd2847e492d5dd4$var$createAndFireEventOnAtlaskit({
        action: 'ranked',
        actionSubject: 'dynamicTable',
        attributes: {
            componentName: 'dynamicTable',
            packageName: $7cd2847e492d5dd4$var$packageName,
            packageVersion: $7cd2847e492d5dd4$var$packageVersion
        }
    })
})($7cd2847e492d5dd4$export$613134f68684a686));
var $7cd2847e492d5dd4$export$2e2bcd8739ae039 = $7cd2847e492d5dd4$var$DynamicTableStateless;

});
const $9ad1be2eb14b8d3d$export$1dee026a19752d6b = 'ASC';
const $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65 = 'DESC';
const $9ad1be2eb14b8d3d$export$71dd4c8ecd45e95f = 'small';
const $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3 = 'large';
const $9ad1be2eb14b8d3d$export$3843c586a90b9cbf = 0.22;

parcelRegister("3tjuM", function(module, exports) {

$parcel$export(module.exports, "tableRowCSSVars", () => $1430aaf59e7cbeab$export$3b9ea2c10c245fdb);
$parcel$export(module.exports, "Table", () => $1430aaf59e7cbeab$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $1430aaf59e7cbeab$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $1430aaf59e7cbeab$export$3e5e12dc01f20a43);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $g2Ovh = parcelRequire("g2Ovh");
function $1430aaf59e7cbeab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1430aaf59e7cbeab$export$3b9ea2c10c245fdb = {
    CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
    CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
    CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
    CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
};
const $1430aaf59e7cbeab$var$fixedSizeTableStyles = {
    name: "wgb42e",
    styles: "table-layout:fixed"
};
const $1430aaf59e7cbeab$var$tableStyles = {
    name: "mul4pg",
    styles: "width:100%;border-collapse:separate;border-spacing:0px"
};
const $1430aaf59e7cbeab$var$bodyBorder = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`
});
const $1430aaf59e7cbeab$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("table", {
        inert: isLoading ? '' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, $g2Ovh.row).hoverBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, $g2Ovh.row).highlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, $g2Ovh.row).hoverHighlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, $g2Ovh.row).focusOutline
        },
        css: [
            $1430aaf59e7cbeab$var$tableStyles,
            isFixedSize && $1430aaf59e7cbeab$var$fixedSizeTableStyles,
            hasDataRow && $1430aaf59e7cbeab$var$bodyBorder
        ],
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`
    }, children);
});
const $1430aaf59e7cbeab$var$captionStyles = {
    name: "125out0",
    styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);will-change:transform"
};
const $1430aaf59e7cbeab$var$oldCaptionStyles = {
    name: "4vsxw5",
    styles: "font-weight:var(--ds-font-weight-regular, 400);margin-block-start:28px"
};
const $1430aaf59e7cbeab$var$newCaptionStyles = {
    name: "1trrfbb",
    styles: "margin-block-start:var(--ds-space-300, 24px)"
};
const $1430aaf59e7cbeab$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("caption", {
        css: [
            $1430aaf59e7cbeab$var$captionStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.dynamic-table-typography_7zio6') ? $1430aaf59e7cbeab$var$newCaptionStyles : $1430aaf59e7cbeab$var$oldCaptionStyles
        ]
    }, children);
const $1430aaf59e7cbeab$var$paginationWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $1430aaf59e7cbeab$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1430aaf59e7cbeab$var$paginationWrapperStyles,
        "data-testid": testId && `${testId}--pagination--container`
    }, children);

});
parcelRegister("g2Ovh", function(module, exports) {

$parcel$export(module.exports, "MSThemeColors", () => $47d84a50d7c96182$export$34af08ce45c78352);
$parcel$export(module.exports, "arrow", () => $47d84a50d7c96182$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "row", () => $47d84a50d7c96182$export$120ff0929b202a6d);
$parcel$export(module.exports, "head", () => $47d84a50d7c96182$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tableBorder", () => $47d84a50d7c96182$export$38d703b73e2cf64d);

var $PdmhA = parcelRequire("PdmhA");
const $47d84a50d7c96182$export$34af08ce45c78352 = {
    Background: 'Canvas',
    Text: 'CanvasText',
    SelectedBackground: 'Highlight',
    SelectedText: 'HighlightText'
};
const $47d84a50d7c96182$export$f2120bbfa5450bd2 = {
    defaultColor: `var(--ds-icon-disabled, ${$PdmhA.N40})`,
    selectedColor: `var(--ds-icon-subtle, ${$PdmhA.N300})`
};
const $47d84a50d7c96182$export$120ff0929b202a6d = {
    focusOutline: `var(--ds-border-focused, ${$PdmhA.B100})`,
    highlightedBackground: `var(--ds-background-selected, ${$PdmhA.B50})`,
    hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$PdmhA.N10})`,
    hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$PdmhA.B75})`
};
const $47d84a50d7c96182$export$5fd5031fecdacec3 = {
    textColor: `var(--ds-text-subtlest, ${$PdmhA.N300})`
};
const $47d84a50d7c96182$export$38d703b73e2cf64d = {
    borderColor: `var(--ds-border, ${$PdmhA.N40})`
};

});


parcelRegister("iK2U9", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $1c04c67c6d2e01dc$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $1c04c67c6d2e01dc$export$381ea436de119582);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $byn9U = parcelRequire("byn9U");
function $1c04c67c6d2e01dc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1c04c67c6d2e01dc$var$fixedHeightStyles = {
    name: "50gc26",
    styles: "height:9rem"
};
const $1c04c67c6d2e01dc$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1c04c67c6d2e01dc$var$fixedHeightStyles,
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`
    }, children);
const $1c04c67c6d2e01dc$var$emptyViewContainerStyles = {
    name: "1yld51o",
    styles: "width:50%;margin:auto;padding:10px;text-align:center"
};
const $1c04c67c6d2e01dc$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1c04c67c6d2e01dc$var$emptyViewContainerStyles,
        "data-testid": testId && `${testId}--empty-view-container`
    }, children);
};

});

parcelRegister("9t1Ml", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdc1fe407cca2cd9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2c84N = parcelRequire("2c84N");

var $a8MUu = parcelRequire("a8MUu");
class $bdc1fe407cca2cd9$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef
        }, pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8MUu.default), {
                head: head,
                isFixedSize: isFixedSize,
                key: row.key || rowIndex,
                row: row,
                isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                testId: testId
            })));
    }
}
const $bdc1fe407cca2cd9$var$Body = (0, $2c84N.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdc1fe407cca2cd9$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bdc1fe407cca2cd9$export$2e2bcd8739ae039 = $bdc1fe407cca2cd9$var$Body;

});
parcelRegister("2c84N", function(module, exports) {

$parcel$export(module.exports, "default", () => $1514dd575e5332c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $fVXMO = parcelRequire("fVXMO");
const $1514dd575e5332c4$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $1514dd575e5332c4$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $1514dd575e5332c4$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $1514dd575e5332c4$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $1514dd575e5332c4$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $fVXMO.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $1514dd575e5332c4$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $fVXMO.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("a8MUu", function(module, exports) {

$parcel$export(module.exports, "default", () => $2038a3700f41e476$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4RemJ = parcelRequire("4RemJ");

var $iqL3E = parcelRequire("iqL3E");
const $2038a3700f41e476$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iqL3E.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
    }, cells.map((cell, cellIndex)=>{
        const { content: content, testId: cellTestId, ...restCellProps } = cell;
        const { shouldTruncate: shouldTruncate, width: width } = (head || {
            cells: []
        }).cells[cellIndex] || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RemJ.TableBodyCell), {
            "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
            ...restCellProps,
            isFixedSize: isFixedSize,
            key: cellIndex,
            shouldTruncate: shouldTruncate,
            width: width
        }, content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2038a3700f41e476$export$2e2bcd8739ae039 = $2038a3700f41e476$var$Row;

});
parcelRegister("4RemJ", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $5915d36ce36ccacb$export$948e91fcef170792);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $39mp0 = parcelRequire("39mp0");
const $5915d36ce36ccacb$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $39mp0.getTruncationStyleVars)({
            width: width
        }),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $39mp0.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $39mp0.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && (0, $39mp0.overflowTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $39mp0.cellStyles)
        ],
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        ...props
    });

});
parcelRegister("39mp0", function(module, exports) {

$parcel$export(module.exports, "truncationWidthStyles", () => $ad2974e69f235483$export$708a733455f59a29);
$parcel$export(module.exports, "fixedSizeTruncateStyles", () => $ad2974e69f235483$export$616c93ee022c8812);
$parcel$export(module.exports, "overflowTruncateStyles", () => $ad2974e69f235483$export$7f2cd17defa265d8);
$parcel$export(module.exports, "getTruncationStyleVars", () => $ad2974e69f235483$export$5e6497a652ae30b5);
$parcel$export(module.exports, "cellStyles", () => $ad2974e69f235483$export$f7913df521f684e2);

var $byn9U = parcelRequire("byn9U");
function $ad2974e69f235483$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ad2974e69f235483$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $ad2974e69f235483$export$708a733455f59a29 = /*#__PURE__*/ (0, $byn9U.css)({
    width: `var(${$ad2974e69f235483$var$CSS_VAR_WIDTH})`
});
const $ad2974e69f235483$export$616c93ee022c8812 = {
    name: "1s7jr4j",
    styles: "text-overflow:ellipsis;white-space:nowrap"
};
const $ad2974e69f235483$export$7f2cd17defa265d8 = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $ad2974e69f235483$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$ad2974e69f235483$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
const $ad2974e69f235483$export$f7913df521f684e2 = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
    border: 'none',
    textAlign: 'left',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        paddingInlineStart: "var(--ds-space-0, 0px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:last-child': {
        paddingInlineEnd: "var(--ds-space-0, 0px)"
    }
});

});


parcelRegister("iqL3E", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $6b389a48d047c2ef$export$45f39d9c38b886d5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $3tjuM = parcelRequire("3tjuM");
const $6b389a48d047c2ef$var$rowStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    '&:focus-visible': {
        outline: `2px solid ${`var(--ds-border-focused, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
        outlineOffset: `-2px`
    }
});
const $6b389a48d047c2ef$var$rowBackgroundStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
    }
});
const $6b389a48d047c2ef$var$rowHighlightedBackgroundStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: `var(--ds-background-selected, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
    }
});
const $6b389a48d047c2ef$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        css: [
            $6b389a48d047c2ef$var$rowStyles,
            isHighlighted ? $6b389a48d047c2ef$var$rowHighlightedBackgroundStyles : $6b389a48d047c2ef$var$rowBackgroundStyles
        ],
        ...rest,
        ref: ref,
        "data-testid": testId
    }, children);
});

});



parcelRegister("aLrpD", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $73b0e671a4d4f805$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");
class $73b0e671a4d4f805$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("a96y2", function(module, exports) {

$parcel$export(module.exports, "default", () => $feff75185b46f730$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");


var $a53tD = parcelRequire("a53tD");
class $feff75185b46f730$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $9ad1be2eb14b8d3d$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.Container), {
            testId: testId
        }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.ContentsContainer), {
            contentsOpacity: contentsOpacity,
            testId: testId
        }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.SpinnerContainer), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        })));
    }
}

});
parcelRegister("a53tD", function(module, exports) {

$parcel$export(module.exports, "Container", () => $aa6b103a00044c0b$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $aa6b103a00044c0b$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $aa6b103a00044c0b$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $byn9U = parcelRequire("byn9U");
function $aa6b103a00044c0b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aa6b103a00044c0b$export$c335a80381ec61f5 = '--contents-opacity';
const $aa6b103a00044c0b$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $aa6b103a00044c0b$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $aa6b103a00044c0b$var$containerStyles,
        "data-testid": testId && `${testId}--container`
    }, children);
const $aa6b103a00044c0b$var$contentsContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    opacity: `var(${$aa6b103a00044c0b$export$c335a80381ec61f5})`,
    pointerEvents: 'none'
});
const $aa6b103a00044c0b$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$aa6b103a00044c0b$export$c335a80381ec61f5]: contentsOpacity
        },
        css: [
            $aa6b103a00044c0b$var$contentsContainerStyles
        ],
        "data-testid": testId && `${testId}--contents--container`
    }, children);
const $aa6b103a00044c0b$var$spinnerContainerStyles = {
    name: "su4u96",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
};
const $aa6b103a00044c0b$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $aa6b103a00044c0b$var$spinnerContainerStyles,
        "data-testid": testId && `${testId}--spinner--container`
    }, children);

});


parcelRegister("DPlg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c0b56c99dd019f1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");


var $sM67g = parcelRequire("sM67g");
class $6c0b56c99dd019f1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $9ad1be2eb14b8d3d$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef
        }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.SpinnerBackdrop), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.SpinnerContainer), {
            ref: this.spinnerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        }))));
    }
    constructor(...args){
        super(...args);
        this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        };
        this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        };
        this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        };
        this.componentWillUnmount = ()=>{
            this.detachListeners();
        };
        this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        };
        this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps);
        this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        };
        this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        };
        this.handleResize = ()=>{
            this.updateSpinnerPosition();
        };
        this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        };
        this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        };
        this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("sM67g", function(module, exports) {

$parcel$export(module.exports, "Container", () => $e14096c71a70d04d$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $e14096c71a70d04d$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $e14096c71a70d04d$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $e14096c71a70d04d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e14096c71a70d04d$var$containerStyles = {
    name: "17fhw1k",
    styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
};
const $e14096c71a70d04d$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$containerStyles,
        ...rest,
        "data-testid": testId,
        ref: ref
    }, children));
});
const $e14096c71a70d04d$var$spinnerBackdropStyles = {
    name: "1yy6mjk",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
};
const $e14096c71a70d04d$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$spinnerBackdropStyles,
        "data-testid": testId && `${testId}--spinner-backdrop`
    }, children);
const $e14096c71a70d04d$var$spinnerContainerStyles = {
    name: "vi3nlf",
    styles: "position:relative;inset-block-start:0"
};
const $e14096c71a70d04d$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$spinnerContainerStyles,
        ref: ref
    }, children));

});


parcelRegister("i9y06", function(module, exports) {

$parcel$export(module.exports, "default", () => $59228fe552548a0a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3KPTt = parcelRequire("3KPTt");
class $59228fe552548a0a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KPTt.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args);
        this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("3KPTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $52d6d0a6ee26c024$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $dXKde = parcelRequire("dXKde");

var $dwj4T = parcelRequire("dwj4T");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $4DxcJ = parcelRequire("4DxcJ");

var $7X9O4 = parcelRequire("7X9O4");

var $eDUla = parcelRequire("eDUla");

var $1ssgv = parcelRequire("1ssgv");

var $bZ2kD = parcelRequire("bZ2kD");
const $52d6d0a6ee26c024$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $52d6d0a6ee26c024$var$paginationMenuStyles = (0, $1ZAYh.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});
const $52d6d0a6ee26c024$var$paginationMenuItemStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.0'
});
function $52d6d0a6ee26c024$var$InnerPagination({ components: components = (0, $1ssgv.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1ssgv.emptyObject), max: max = 7, onChange: onChange = (0, $5Q9wj.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $eDUla.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $2WwAS.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$52d6d0a6ee26c024$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            as: "li",
            xcss: $52d6d0a6ee26c024$var$paginationMenuItemStyles,
            key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7X9O4.default), {
            component: components.Page,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                }),
            "aria-current": isCurrentPage ? 'page' : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4DxcJ.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            }),
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dXKde))), {
            label: ""
        }),
        "aria-label": previousLabel,
        testId: testId && `${testId}--left-navigator`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $52d6d0a6ee26c024$var$paginationMenuStyles
    }, (0, $bZ2kD.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4DxcJ.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            }),
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
            label: ""
        }),
        "aria-label": nextLabel,
        testId: testId && `${testId}--right-navigator`
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $52d6d0a6ee26c024$var$Pagination = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)($52d6d0a6ee26c024$var$InnerPagination));
var $52d6d0a6ee26c024$export$2e2bcd8739ae039 = $52d6d0a6ee26c024$var$Pagination;

});
parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a2a4a1e4b9148f86$var$_chevronLeft = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $a2a4a1e4b9148f86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $a2a4a1e4b9148f86$var$_chevronLeft.default,
        iconType: "utility"
    }));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = module.exports.default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;

});
parcelRegister("a4cVy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75444e382f2d4220$var$_react = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75444e382f2d4220$var$_UNSAFE_baseNew = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75444e382f2d4220$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75444e382f2d4220$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $75444e382f2d4220$var$_react.default.createElement($75444e382f2d4220$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="m8 10.75-4.5-4.5L8 1.75"/>`,
        type: 'utility'
    }, props));
$75444e382f2d4220$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $75444e382f2d4220$var$_default = module.exports.default = $75444e382f2d4220$var$ChevronLeftIcon;

});


parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9d7d0ffff46f5f00$var$_chevronRight = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $9d7d0ffff46f5f00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9d7d0ffff46f5f00$var$_chevronRight.default,
        iconType: "utility"
    }));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = module.exports.default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;

});

parcelRegister("4DxcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4d3c7b4b153b94a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
function $a4d3c7b4b153b94a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("7X9O4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5f9797829cf4ad3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
function $e5f9797829cf4ad3$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("eDUla", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceba78dad21693c3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $lkPEe = parcelRequire("lkPEe");
const $ceba78dad21693c3$var$containerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    position: 'relative'
});
function $ceba78dad21693c3$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $ceba78dad21693c3$var$containerStyles,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        testId: testId && `${testId}-text`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});

parcelRegister("1ssgv", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $3850a464bb1795dd$export$3f860eba1218f8d3);
const $3850a464bb1795dd$export$3f860eba1218f8d3 = {};

});

parcelRegister("bZ2kD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a954a8bde9a3bed3$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $a954a8bde9a3bed3$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $5iWql.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $a954a8bde9a3bed3$export$2e2bcd8739ae039 = $a954a8bde9a3bed3$var$collapseRange;

});



parcelRegister("cTO8p", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1cf364925ee2f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVXMO = parcelRequire("fVXMO");

var $iLooJ = parcelRequire("iLooJ");

var $6Ztqc = parcelRequire("6Ztqc");

var $jRqbA = parcelRequire("jRqbA");
class $7e1cf364925ee2f7$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    UNSAFE_componentWillMount() {
        (0, $fVXMO.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $fVXMO.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $6Ztqc.default) : (0, $jRqbA.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLooJ.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, cells.map((cell, index)=>{
            const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
            // the API.
            ...restCellProps } = cell;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeadCellComponent, {
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                onClick: isSortable ? onSort(cell) : undefined,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width,
                ...restCellProps
            });
        })));
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7e1cf364925ee2f7$export$2e2bcd8739ae039 = $7e1cf364925ee2f7$var$TableHead;

});
parcelRegister("iLooJ", function(module, exports) {

$parcel$export(module.exports, "Head", () => $e23e257a0c447ed4$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $e23e257a0c447ed4$export$4e8024263ace498b);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");


var $g2Ovh = parcelRequire("g2Ovh");

var $39mp0 = parcelRequire("39mp0");
function $e23e257a0c447ed4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $e23e257a0c447ed4$var$rankingStyles = {
    name: "4zleql",
    styles: "display:block"
};
const $e23e257a0c447ed4$var$headStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderBlockEnd: `none`
});
const $e23e257a0c447ed4$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("thead", {
        css: [
            $e23e257a0c447ed4$var$headStyles,
            isRanking && $e23e257a0c447ed4$var$rankingStyles
        ],
        "data-testid": testId,
        ...props
    });
};
const $e23e257a0c447ed4$var$headCellBaseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`,
    color: `var(--ds-text-subtlest, ${`var(${$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR})`})`,
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $PdmhA.B100)})`}`
    }
});
const $e23e257a0c447ed4$var$headCellOldStyles = {
    name: "an5sdn",
    styles: "font-size:0.75rem;font-weight:var(--ds-font-weight-semibold, 600)"
};
const $e23e257a0c447ed4$var$headCellNewStyles = {
    name: "1xm9io",
    styles: "font:var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $e23e257a0c447ed4$var$onClickStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $PdmhA.N30A)})`,
        cursor: 'pointer'
    }
});
const $e23e257a0c447ed4$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        padding: "var(--ds-space-0, 0)",
        position: 'relative',
        appearance: 'none',
        background: 'none',
        border: 'none',
        color: 'inherit',
        cursor: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        '&::before, &::after': {
            display: 'block',
            width: 0,
            height: 0,
            position: 'absolute',
            border: '3px solid transparent',
            content: '""',
            insetInlineEnd: "var(--ds-space-negative-100, -8px)"
        },
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $g2Ovh.arrow).defaultColor}`,
            insetBlockEnd: "var(--ds-space-100, 8px)"
        },
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $g2Ovh.arrow).defaultColor}`,
            insetBlockEnd: 0
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before, &::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `3px solid ${(0, $g2Ovh.MSThemeColors).Background}`
            },
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $g2Ovh.MSThemeColors).Text}`
            },
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $g2Ovh.MSThemeColors).Text}`
            }
        }
    }
});
const $e23e257a0c447ed4$var$ascendingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $g2Ovh.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $g2Ovh.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e23e257a0c447ed4$var$descendingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $g2Ovh.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $g2Ovh.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e23e257a0c447ed4$export$4e8024263ace498b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $39mp0.getTruncationStyleVars)({
            width: width
        }),
        [$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR]: (0, $g2Ovh.head).textColor
    };
    const isASC = sortOrder === (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $39mp0.cellStyles),
            $e23e257a0c447ed4$var$headCellBaseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.dynamic-table-typography_7zio6') ? $e23e257a0c447ed4$var$headCellNewStyles : $e23e257a0c447ed4$var$headCellOldStyles,
            onClick && $e23e257a0c447ed4$var$onClickStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $39mp0.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $39mp0.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && (0, $39mp0.overflowTruncateStyles),
            isSortable && $e23e257a0c447ed4$var$baseStyles,
            isASC && $e23e257a0c447ed4$var$ascendingStyles,
            isDESC && $e23e257a0c447ed4$var$descendingStyles
        ],
        onClick: onClick,
        ref: ref,
        "data-testid": testId,
        ...rest
    }, children);
});

});

parcelRegister("6Ztqc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0043750917848b87$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hwoBY = parcelRequire("hwoBY");

var $fVXMO = parcelRequire("fVXMO");

var $jRqbA = parcelRequire("jRqbA");
class $0043750917848b87$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $fVXMO.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRqbA.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $0043750917848b87$var$RankableTableHeadCell = (0, $hwoBY.default)($0043750917848b87$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0043750917848b87$export$2e2bcd8739ae039 = $0043750917848b87$var$RankableTableHeadCell;

});
parcelRegister("hwoBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f810d119edc97937$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $f810d119edc97937$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                refWidth: 0,
                refHeight: 0
            };
            this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            };
            this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("jRqbA", function(module, exports) {

$parcel$export(module.exports, "default", () => $635bc03d85c6882e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iLooJ = parcelRequire("iLooJ");
const $635bc03d85c6882e$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLooJ.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable
    }, isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        type: "button",
        "aria-roledescription": "Sort button"
    }, content) : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$635bc03d85c6882e$export$2e2bcd8739ae039 = $635bc03d85c6882e$var$TableHeadCell;

});



parcelRegister("ekXh3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('aVYwg')
        ]);
        const value = parcelRequire('jlg4D');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("aVYwg")
    ]).then(()=>parcelRequire('jlg4D'));
}

});



parcelRegister("gUnte", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b6a3d82fe16b6d1c$export$defe85febe8b728c);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $b6a3d82fe16b6d1c$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "eoc-changeboarding.wizard.steps.three.title-no-translate",
        "defaultMessage": "What happens to chat tools"
    },
    description: {
        "id": "eoc-changeboarding.wizard.steps.three.description-no-translate",
        "defaultMessage": "Connect your chat tools and copy your Opsgenie chat integrations to Jira Service Management, as they won't be moved automatically."
    },
    chatIntegrationsFoundInOpsgenie: {
        "id": "eoc-changeboarding.wizard.steps.three.chat-integrations-found-in-opsgenie-no-translate",
        "defaultMessage": "{amount, plural, one {{amount} Opsgenie chat integration} other {{amount} Opsgenie chat integrations}} found"
    },
    integration: {
        "id": "eoc-changeboarding.wizard.steps.three.integration-no-translate",
        "defaultMessage": "Integration"
    },
    team: {
        "id": "eoc-changeboarding.wizard.steps.three.team-no-translate",
        "defaultMessage": "Team"
    },
    global: {
        "id": "eoc-changeboarding.wizard.steps.three.global-no-translate",
        "defaultMessage": "Global"
    }
});

});


parcelRegister("ktcUm", function(module, exports) {

$parcel$export(module.exports, "StepTwo", () => $cf8bf7b45754c27f$export$f7c6032816713bb9);

var $eUqFw = parcelRequire("eUqFw");

var $4XQdE = parcelRequire("4XQdE");

var $hI5oG = parcelRequire("hI5oG");

var $c0jFd = parcelRequire("c0jFd");
var $1Yimi = parcelRequire("1Yimi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2Q2AK = parcelRequire("2Q2AK");

var $3Jwoz = parcelRequire("3Jwoz");
const $cf8bf7b45754c27f$export$f7c6032816713bb9 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [usersWithoutCustomRole] = (0, $2Q2AK.useGetUsersWithoutCustomRole)();
    if (usersWithoutCustomRole.data === null) // Users should not see this screen if one of the requests is still loading or error
    throw new Error('StepTwo should not be rendered if users are still loading');
    const avatarGroupData = usersWithoutCustomRole.data.values.map((user)=>({
            key: user.id,
            name: user.name,
            src: user.avatarUrl
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        rowGap: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        rowGap: "space.100",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xlarge"
    }, formatMessage((0, $3Jwoz.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $3Jwoz.messages).description))), usersWithoutCustomRole.data.values.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        rowGap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall",
        as: "div"
    }, formatMessage((0, $3Jwoz.messages).usersNeedAdminRole, {
        userAmount: usersWithoutCustomRole.data.values.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XQdE.default), {
        appearance: "stack",
        data: avatarGroupData
    })));
};

});
parcelRegister("4XQdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6346b768779c72$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $iJlfe = parcelRequire("iJlfe");


var $5Q9wj = parcelRequire("5Q9wj");

var $7PTrT = parcelRequire("7PTrT");

var $8BKky = parcelRequire("8BKky");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $hCcWD = parcelRequire("hCcWD");

var $3Czko = parcelRequire("3Czko");

var $6cUPN = parcelRequire("6cUPN");

var $h5NqH = parcelRequire("h5NqH");

var $5TioN = parcelRequire("5TioN");

var $33ZPs = parcelRequire("33ZPs");

var $bLnyK = parcelRequire("bLnyK");
const $3b6346b768779c72$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $3b6346b768779c72$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $3b6346b768779c72$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $iJlfe.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eUqFw.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $5Q9wj.default;
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5TioN.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: (0, $lcnyw.layers).modal(),
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6cUPN.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $h5NqH.default), {
                    onClick: (e)=>e.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8BKky.default), null, data.slice(max).map((avatar, index)=>$3b6346b768779c72$var$getOverrides(overrides).AvatarGroupItem.render((0, $hCcWD.default), {
                        avatar: avatar,
                        onAvatarClick: onAvatarClick,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $3b6346b768779c72$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $33ZPs.default) : (0, $3Czko.default);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData, idx)=>{
        const callback = avatarData.onClick || onAvatarClick;
        const finalAvatar = $3b6346b768779c72$var$getOverrides(overrides).Avatar.render(avatar, {
            ...avatarData,
            size: size,
            borderColor: borderColor || avatarData.borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event, analyticsEvent)=>{
                callback(event, analyticsEvent, idx);
            } : undefined,
            stackIndex: max - idx
        }, idx);
        return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
            key: (0, $bLnyK.composeUniqueKey)(avatarData, idx),
            content: avatarData.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total));
};
var $3b6346b768779c72$export$2e2bcd8739ae039 = $3b6346b768779c72$var$AvatarGroup;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("hCcWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ec5414b121adc7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");
var $e7PSD = parcelRequire("e7PSD");
var $bo4OB = parcelRequire("bo4OB");

var $jXJS5 = parcelRequire("jXJS5");
const $19ec5414b121adc7$var$AvatarGroupItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { avatar: avatar, onAvatarClick: onAvatarClick, testId: testId, index: index } = props;
    const { href: href, onClick: onClick, ...rest } = avatar;
    const itemRef = (0, $jXJS5.default)();
    const CustomComponent = ({ children: children, ...props })=>{
        return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            type: "button",
            ...props
        }, children));
    };
    const AvatarIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        ...rest,
        testId: testId && `${testId}--avatar`,
        borderColor: "transparent",
        size: "small",
        name: ""
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: avatar.target,
        rel: avatar.target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, avatar.name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId
    }, avatar.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, avatar.name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$19ec5414b121adc7$export$2e2bcd8739ae039 = $19ec5414b121adc7$var$AvatarGroupItem;

});
parcelRegister("jXJS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a822a3bf76dc75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6cUPN = parcelRequire("6cUPN");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $47a822a3bf76dc75$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $47a822a3bf76dc75$export$2e2bcd8739ae039 = $47a822a3bf76dc75$var$useRegisterItemWithFocusManager;

});
parcelRegister("6cUPN", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $c9e49b704731182e$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $c9e49b704731182e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $HPlWp = parcelRequire("HPlWp");
const $c9e49b704731182e$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic
 */ const $c9e49b704731182e$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eUqFw.useEffect)(()=>{
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $HPlWp.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: (0, $HPlWp.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9e49b704731182e$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $c9e49b704731182e$export$2e2bcd8739ae039 = $c9e49b704731182e$var$FocusManager;

});
parcelRegister("HPlWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2eeb0b24006473e$export$2e2bcd8739ae039);

const $b2eeb0b24006473e$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $b2eeb0b24006473e$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $b2eeb0b24006473e$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement && nextFocusableElement.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement && prevFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, -1);
                nextFocusableElement && nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement && prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("3Czko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f319fa8ea8cddd21$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $f319fa8ea8cddd21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f319fa8ea8cddd21$var$gutter = "var(--ds-space-negative-050, -4px)";
const $f319fa8ea8cddd21$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    listStyleType: 'none !important',
    marginInlineEnd: $f319fa8ea8cddd21$var$gutter,
    marginInlineStart: $f319fa8ea8cddd21$var$gutter
});
const $f319fa8ea8cddd21$var$listItemStyles = {
    name: "3unxte",
    styles: "margin:var(--ds-space-0, 0px);margin-block-end:var(--ds-space-100, 8px);padding-inline-end:var(--ds-space-050, 4px);padding-inline-start:var(--ds-space-050, 4px)"
};
const $f319fa8ea8cddd21$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $f319fa8ea8cddd21$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $f319fa8ea8cddd21$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f319fa8ea8cddd21$export$2e2bcd8739ae039 = $f319fa8ea8cddd21$var$Grid;

});

parcelRegister("h5NqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ffca550571fe4d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $6cUPN = parcelRequire("6cUPN");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $4ffca550571fe4d8$var$PopupAvatarGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, setInitialFocusRef: setInitialFocusRef, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    (0, $eUqFw.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    }));
};
var $4ffca550571fe4d8$export$2e2bcd8739ae039 = $4ffca550571fe4d8$var$PopupAvatarGroup;

});

parcelRegister("5TioN", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bc7348cf05a7b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");
var $iJlfe = parcelRequire("iJlfe");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");
const $80bc7348cf05a7b7$var$buttonSizes = {
    xsmall: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xxlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $80bc7348cf05a7b7$var$buttonActiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-selected, ${(0, $PdmhA.B50)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 ${(0, $eri7S.BORDER_WIDTH)}px ${`var(--ds-border-selected, ${(0, $PdmhA.B300)})`}`,
        color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: `scale(${(0, $eri7S.ACTIVE_SCALE_FACTOR)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $PdmhA.N30)})`,
            color: `var(--ds-text-selected, ${(0, $PdmhA.N500)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $PdmhA.B50)})`,
            color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`
        }
    }
});
const $80bc7348cf05a7b7$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA.N20)})`,
        color: `var(--ds-text, ${(0, $PdmhA.N500)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $PdmhA.N30)})`,
            color: `var(--ds-text, ${(0, $PdmhA.N500)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $PdmhA.B50)})`,
            color: `var(--ds-text, ${(0, $PdmhA.B400)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::after': {
            display: 'none'
        }
    }
});
const $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT = 99;
const $80bc7348cf05a7b7$var$MoreIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : `var(--ds-border-inverse, ${0, $PdmhA.N0})`, size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iJlfe.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        ref: ref,
        onClick: onClickHander
    }, ({ testId: _, className: className, ref: ref, ...props })=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $byn9U.jsx)("button", {
            type: "submit",
            ...buttonProps,
            ...props,
            ref: ref,
            "data-testid": testId,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                font: $80bc7348cf05a7b7$var$buttonSizes[size]
            },
            css: [
                $80bc7348cf05a7b7$var$buttonStyles,
                isActive && $80bc7348cf05a7b7$var$buttonActiveStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className
        }, "+", count > $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT ? $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT : count));
});
$80bc7348cf05a7b7$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$80bc7348cf05a7b7$export$2e2bcd8739ae039 = $80bc7348cf05a7b7$var$MoreIndicator;

});

parcelRegister("33ZPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e31b31f1a588aba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $lcnyw = parcelRequire("lcnyw");
const $9e31b31f1a588aba$var$gutter = (0, $eri7S.BORDER_WIDTH) * 2 + (0, $lcnyw.gridSize)() / 2;
const $9e31b31f1a588aba$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    listStyleType: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: $9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$listItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: -$9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $9e31b31f1a588aba$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $9e31b31f1a588aba$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9e31b31f1a588aba$export$2e2bcd8739ae039 = $9e31b31f1a588aba$var$Stack;

});

parcelRegister("bLnyK", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $009108df95df64ca$export$b067756944994c79);
const $009108df95df64ca$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});


parcelRegister("3Jwoz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $30bcc3bc86088792$export$defe85febe8b728c);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $30bcc3bc86088792$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "eoc-changeboarding.wizard.steps.two.title-no-translate",
        "defaultMessage": "What happens to users and roles"
    },
    description: {
        "id": "eoc-changeboarding.wizard.steps.two.description-no-translate",
        "defaultMessage": "After users and roles are synced, you'll need to assign a product role to Opsgenie users who don't have the same role in Jira Service Management."
    },
    usersNeedAdminRole: {
        "id": "eoc-changeboarding.wizard.steps.two.users-need-admin-role-no-translate",
        "defaultMessage": "{userAmount, plural, one {{userAmount} Opsgenie user} other {{userAmount} Opsgenie users}} won't have the same role in Jira"
    }
});

});



parcelRegister("7eOF3", function(module, exports) {

$parcel$export(module.exports, "Wizard", () => $4b3d703e9055c1f4$export$c6a37f46d6629cf2);

var $eUqFw = parcelRequire("eUqFw");

var $aOw1G = parcelRequire("aOw1G");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");


var $dAipf = parcelRequire("dAipf");
var $lYBgG = parcelRequire("lYBgG");
var $6LJxb = parcelRequire("6LJxb");
var $iRJfw = parcelRequire("iRJfw");
var $h88BQ = parcelRequire("h88BQ");
const $4b3d703e9055c1f4$export$c6a37f46d6629cf2 = ({ isOpen: isOpen, onClose: onClose, defaultStep: defaultStep = 1, onUnlock: onUnlock })=>{
    const [currentStep, setCurrentStep] = (0, $eUqFw.useState)(defaultStep);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        height: 700,
        width: 1100,
        onClose: onClose,
        shouldCloseOnOverlayClick: false
    }, currentStep === 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6LJxb.StepOne), {
        onAction: setCurrentStep,
        onClose: onClose
    }), currentStep === 2 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h88BQ.StepTwo), {
        onAction: setCurrentStep,
        onClose: onClose
    }), currentStep === 3 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iRJfw.StepThree), {
        onAction: setCurrentStep,
        onClose: onClose
    }), currentStep === 4 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYBgG.StepFour), {
        onAction: setCurrentStep,
        onClose: onClose,
        onUnlock: onUnlock
    }), currentStep === 5 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dAipf.StepFive), {
        onClose: onClose,
        // If started from step 5, it means we weren't the one unlocking it
        isFirstUnlocked: defaultStep !== (0, $5a553e1dde064a50$export$75f90732d1326d15)
    }))));
};

});
const $5a553e1dde064a50$export$75f90732d1326d15 = 5;

parcelRegister("dAipf", function(module, exports) {

$parcel$export(module.exports, "StepFive", () => $72cd4af094fc231a$export$782dfa47fc019134);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $c7H0g = parcelRequire("c7H0g");
var $1R3n5 = parcelRequire("1R3n5");

var $h4zOy = parcelRequire("h4zOy");

var $2gqZT = parcelRequire("2gqZT");

var $j3FSb = parcelRequire("j3FSb");

var $8pS4q = parcelRequire("8pS4q");

var $lIeXV = parcelRequire("lIeXV");

var $lzGyk = parcelRequire("lzGyk");

var $hhjRL = parcelRequire("hhjRL");

var $aW54V = parcelRequire("aW54V");
const $72cd4af094fc231a$export$782dfa47fc019134 = ({ onClose: onClose, isFirstUnlocked: isFirstUnlocked = true })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { openTransitionHomeModal: openTransitionHomeModal, isTransitionHomeLoading: isTransitionHomeLoading, activateTransitionHome: activateTransitionHome } = (0, $lzGyk.useGlobalChangeboarding)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const { update: update } = (0, $hhjRL.useOgConsolidationUserState)();
    (0, $eUqFw.useEffect)(()=>{
        // Immediately update user state
        update({
            isWelcomeModalDisplayed: true
        }).catch(()=>{
            // If an error occurs, close the modal
            onClose();
        });
    // Here we don't include onClose as it is probably an inlined function
    // with a state update. It is totally fine to call the initial function
    // passed in when the update is first called even though it is now stale.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        update
    ]);
    const primaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        onClick: ()=>{
            openTransitionHomeModal().then(()=>{
                activateTransitionHome();
                onClose();
            });
        },
        appearance: "primary",
        isLoading: isTransitionHomeLoading
    }, formatMessage((0, $lIeXV.messages).openShiftingGuideButtonNonFinal));
    const secondaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: (e, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'closeTransitionWizardInUnlockStep');
            onClose();
            activateTransitionHome();
        },
        appearance: "subtle"
    }, formatMessage((0, $lIeXV.messages).remindMeLaterButtonNonFinal));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8pS4q.Layout), {
        vector: {
            light: isFirstUnlocked ? (0, (/*@__PURE__*/$parcel$interopDefault($h4zOy))) : (0, (/*@__PURE__*/$parcel$interopDefault($j3FSb))),
            dark: isFirstUnlocked ? (0, (/*@__PURE__*/$parcel$interopDefault($h4zOy))) : (0, (/*@__PURE__*/$parcel$interopDefault($2gqZT)))
        },
        currentStep: 5,
        actionButtons: {
            primary: primaryActionButton,
            secondary: secondaryActionButton
        },
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aW54V.Content), {
        isFirstUnlocked: isFirstUnlocked,
        isAdmin: isAdmin || isSiteAdmin
    }));
};

});
parcelRegister("2gqZT", function(module, exports) {
module.exports = new URL("step_five_vector_dark_optimal.d2b5a6c3.png", import.meta.url).toString();

});

parcelRegister("j3FSb", function(module, exports) {
module.exports = new URL("step_five_vector_light_optimal.1d639656.png", import.meta.url).toString();

});

parcelRegister("8pS4q", function(module, exports) {

$parcel$export(module.exports, "Layout", () => $6b7f16bd2622a5d1$export$c84671f46d6a1ca);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $jWuk1 = parcelRequire("jWuk1");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $4q38b = parcelRequire("4q38b");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fQpir = parcelRequire("fQpir");

var $3DX3T = parcelRequire("3DX3T");

var $lIeXV = parcelRequire("lIeXV");
const $6b7f16bd2622a5d1$export$c84671f46d6a1ca = ({ children: children, vector: vector, actionButtons: actionButtons, currentStep: currentStep, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const theme = (0, $4q38b.default)();
    const isDarkMode = theme.colorMode === 'dark';
    const shouldShowStep = currentStep !== 5;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $6b7f16bd2622a5d1$var$contentContainerStyles,
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        xcss: [
            $6b7f16bd2622a5d1$var$halfWidthStyles
        ],
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        rowGap: "space.100",
        xcss: [
            $6b7f16bd2622a5d1$var$contentStyles
        ]
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: [
            $6b7f16bd2622a5d1$var$actionStyles
        ],
        justifyContent: shouldShowStep ? 'space-between' : 'end',
        alignItems: "center"
    }, shouldShowStep && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $6b7f16bd2622a5d1$var$locatorStyles
    }, formatMessage((0, $lIeXV.messages).stepLocatorNonFinal, {
        currentStep: currentStep
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        columnGap: "space.100"
    }, actionButtons.secondary, actionButtons.primary))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: [
            $6b7f16bd2622a5d1$var$halfWidthStyles,
            $6b7f16bd2622a5d1$var$rightColumnStyles,
            isDarkMode ? $6b7f16bd2622a5d1$var$rightColumnDarkStyles : $6b7f16bd2622a5d1$var$rightColumnLightStyles
        ]
    }, vector.component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $6b7f16bd2622a5d1$var$vectorComponentProps
    }, vector.component) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        role: "presentation",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            backgroundImage: `url(${isDarkMode ? vector?.dark : vector?.light})`
        },
        xcss: $6b7f16bd2622a5d1$var$rightVectorStyles
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6b7f16bd2622a5d1$var$closeIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: ""
        }),
        "aria-label": formatMessage((0, $lIeXV.messages).closeButtonNonFinal),
        onClick: onClose
    })));
};
const $6b7f16bd2622a5d1$var$contentContainerStyles = (0, $1ZAYh.xcss)({
    height: '100%',
    position: 'relative'
});
const $6b7f16bd2622a5d1$var$vectorComponentProps = (0, $1ZAYh.xcss)({
    flex: '1'
});
const $6b7f16bd2622a5d1$var$halfWidthStyles = (0, $1ZAYh.xcss)({
    width: '50%',
    flexShrink: 0
});
const $6b7f16bd2622a5d1$var$contentStyles = (0, $1ZAYh.xcss)({
    margin: 'space.600',
    padding: 'space.200'
});
const $6b7f16bd2622a5d1$var$actionStyles = (0, $1ZAYh.xcss)({
    padding: 'space.200',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    borderLeft: 'none',
    borderRight: 'none',
    borderBottom: 'none'
});
const $6b7f16bd2622a5d1$var$locatorStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtlest'
});
const $6b7f16bd2622a5d1$var$rightColumnStyles = (0, $1ZAYh.xcss)({
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderTopRightRadius: 'border.radius.100',
    borderBottomRightRadius: 'border.radius.100',
    overflow: 'hidden'
});
const $6b7f16bd2622a5d1$var$rightVectorStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $6b7f16bd2622a5d1$var$rightColumnLightStyles = (0, $1ZAYh.xcss)({
    backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($3DX3T)))})`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $6b7f16bd2622a5d1$var$rightColumnDarkStyles = (0, $1ZAYh.xcss)({
    backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($fQpir)))})`
});
const $6b7f16bd2622a5d1$var$closeIconStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    right: 'space.200',
    top: 'space.200'
});

});
parcelRegister("lIeXV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e81579bf7f54e24d$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $e81579bf7f54e24d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    stepLocatorNonFinal: {
        "id": "eoc-changeboarding.common.wizard.layout.step-locator-non-final",
        "defaultMessage": "Step {currentStep} of 4"
    },
    nextButtonNonFinal: {
        "id": "eoc-changeboarding.common.wizard.layout.next-button-non-final",
        "defaultMessage": "Next"
    },
    backButtonNonFinal: {
        "id": "eoc-changeboarding.common.wizard.layout.back-button-non-final",
        "defaultMessage": "Back"
    },
    closeButtonNonFinal: {
        "id": "eoc-changeboarding.common.wizard.layout.close-button-non-final",
        "defaultMessage": "Close"
    },
    openShiftingGuideButtonNonFinal: {
        "id": "eoc-changeboarding.common.wizard.layout.open-shifting-guide-button-non-final",
        "defaultMessage": "Open guide"
    },
    remindMeLaterButtonNonFinal: {
        "id": "eoc-changeboarding.common.wizard.layout.remind-me-later-button-non-final",
        "defaultMessage": "Remind me later"
    }
});

});


parcelRegister("aW54V", function(module, exports) {

$parcel$export(module.exports, "Content", () => $d84ceaab3d75daa7$export$7c6e2c02157bb7d2);

var $eUqFw = parcelRequire("eUqFw");

var $2U51f = parcelRequire("2U51f");

var $4X41g = parcelRequire("4X41g");

var $k3QKS = parcelRequire("k3QKS");
const $d84ceaab3d75daa7$export$7c6e2c02157bb7d2 = ({ isFirstUnlocked: isFirstUnlocked, isAdmin: isAdmin })=>{
    if (isFirstUnlocked) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4X41g.UnlockedAdminContent), null);
    if (isAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2U51f.AdminContent), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k3QKS.UserContent), null);
};

});
parcelRegister("2U51f", function(module, exports) {

$parcel$export(module.exports, "AdminContent", () => $c16da9c6bc356ce2$export$55d2d5b64bfe8d2d);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $fwAIO = parcelRequire("fwAIO");

var $dmCPj = parcelRequire("dmCPj");

var $iwsIy = parcelRequire("iwsIy");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1ZNqu = parcelRequire("1ZNqu");

var $2DX8V = parcelRequire("2DX8V");

var $2Q2AK = parcelRequire("2Q2AK");

var $abPbL = parcelRequire("abPbL");
const $c16da9c6bc356ce2$export$55d2d5b64bfe8d2d = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ usersWithoutCustomRole: usersWithoutCustomRole, usersWithoutAdminRole: usersWithoutAdminRole }] = (0, $2Q2AK.useUsersAndRolesStore)();
    if (usersWithoutCustomRole.data === null || usersWithoutAdminRole.data === null) // Users should not see this screen if one of the requests is still loading or error
    throw new Error('[Optimal StepFive Admin Content] should not be rendered if users are still loading');
    const usersWithoutCustomRoleCount = usersWithoutCustomRole.data.count;
    const usersWithoutAdminRoleCount = usersWithoutAdminRole.data.count;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        rowGap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h800"
    }, formatMessage((0, $abPbL.messages).titleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $abPbL.messages).descriptionNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c16da9c6bc356ce2$var$listTitleWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $abPbL.messages).listTitleNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))),
            color: (0, $1ZNqu.IconBoxColor).Magenta,
            withCustomContainer: true
        }),
        description: formatMessage((0, $abPbL.messages).configureChatIntegrationsNonFinal)
    }), usersWithoutAdminRoleCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fwAIO))),
            color: (0, $1ZNqu.IconBoxColor).Purple,
            withCustomContainer: true
        }),
        description: formatMessage((0, $abPbL.messages).giveProductAdminRoleNonFinal, {
            adminCount: usersWithoutAdminRoleCount
        })
    }), usersWithoutCustomRoleCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))),
            color: (0, $1ZNqu.IconBoxColor).Orange,
            withCustomContainer: true
        }),
        description: formatMessage((0, $abPbL.messages).giveProductRoleNonFinal, {
            userCount: usersWithoutCustomRoleCount
        })
    })));
};
const $c16da9c6bc356ce2$var$listTitleWrapperStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});
parcelRegister("fwAIO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4d65456e92ed895$var$_react = $b4d65456e92ed895$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $b4d65456e92ed895$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b4d65456e92ed895$var$CheckCircleOutlineIcon = (props)=>/*#__PURE__*/ $b4d65456e92ed895$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/><path d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$b4d65456e92ed895$var$CheckCircleOutlineIcon.displayName = 'CheckCircleOutlineIcon';
var $b4d65456e92ed895$var$_default = module.exports.default = $b4d65456e92ed895$var$CheckCircleOutlineIcon;

});

parcelRegister("2DX8V", function(module, exports) {

$parcel$export(module.exports, "WizardInfoItem", () => $f82f44970e4e9dc5$export$b32afacf54b9b55f);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $c0jFd = parcelRequire("c0jFd");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");
const $f82f44970e4e9dc5$export$b32afacf54b9b55f = ({ iconBox: iconBox, title: title, description: description })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        columnGap: "space.100",
        alignItems: "start",
        xcss: $f82f44970e4e9dc5$var$containerStyles
    }, iconBox, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        rowGap: "space.025",
        direction: "column",
        xcss: $f82f44970e4e9dc5$var$contentWrapperStyles
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "xsmall"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, description)));
const $f82f44970e4e9dc5$var$containerStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $f82f44970e4e9dc5$var$contentWrapperStyles = (0, $1ZAYh.xcss)({
    alignSelf: 'center'
});

});

parcelRegister("abPbL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $77dad5aa5e4eca98$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $77dad5aa5e4eca98$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    titleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.admin.title-non-final",
        "defaultMessage": "Move your work from Opsgenie to Jira Service Management"
    },
    descriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.admin.description-non-final",
        "defaultMessage": "Almost all of your Opsgenie data and settings are now in Jira Service Management, so you no longer need Opsgenie to do your alerting and on-call work."
    },
    listTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.admin.list-title-non-final",
        "defaultMessage": "Let's go set up a few things so your team can get started"
    },
    configureChatIntegrationsNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.admin.configure-chat-integrations-non-final",
        "defaultMessage": "Configure chat integrations in Jira Service Management"
    },
    giveProductAdminRoleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.admin.give-product-admin-role-non-final",
        "defaultMessage": "Give the product admin role to {adminCount, plural, one {# Opsgenie admin} other {# Opsgenie admins}}"
    },
    giveProductRoleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.admin.give-product-role-non-final",
        "defaultMessage": "Give a product role to {userCount, plural, one {# Opsgenie user} other {# Opsgenie users}} who no longer have a custom role"
    }
});

});


parcelRegister("4X41g", function(module, exports) {

$parcel$export(module.exports, "UnlockedAdminContent", () => $e4f4391b73ab18ee$export$be18a8bc961d2bba);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2yReM = parcelRequire("2yReM");
const $e4f4391b73ab18ee$export$be18a8bc961d2bba = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        rowGap: "space.200",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h800"
    }, formatMessage((0, $2yReM.messages).titleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $2yReM.messages).description1NonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $2yReM.messages).description2NonFinal))));
};

});
parcelRegister("2yReM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $290284db7aa1ccdf$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $290284db7aa1ccdf$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    titleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.first-unlocked-admin.title-non-final",
        "defaultMessage": "We're now moving you to Jira Service Management"
    },
    description1NonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.first-unlocked-admin.description-1-non-final",
        "defaultMessage": "Almost all of your Opsgenie data and settings are now in Jira Service Management."
    },
    description2NonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.first-unlocked-admin.description-2-non-final",
        "defaultMessage": "Let's go finish setting up some critical configurations, so your teams can start using operations in Jira Service Management."
    }
});

});


parcelRegister("k3QKS", function(module, exports) {

$parcel$export(module.exports, "UserContent", () => $a53ef64b9e28d9f1$export$ef2ce2deea0ab0c1);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $3nnLQ = parcelRequire("3nnLQ");

var $aLjrh = parcelRequire("aLjrh");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1ZNqu = parcelRequire("1ZNqu");

var $2DX8V = parcelRequire("2DX8V");

var $lzUaz = parcelRequire("lzUaz");
const $a53ef64b9e28d9f1$export$ef2ce2deea0ab0c1 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        rowGap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h800"
    }, formatMessage((0, $lzUaz.messages).titleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $lzUaz.messages).descriptionNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a53ef64b9e28d9f1$var$listTitleWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $lzUaz.messages).listTitleNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aLjrh))),
            color: (0, $1ZNqu.IconBoxColor).Magenta,
            withCustomContainer: true
        }),
        description: formatMessage((0, $lzUaz.messages).configureNotificationSettingsNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3nnLQ))),
            color: (0, $1ZNqu.IconBoxColor).Purple,
            withCustomContainer: true
        }),
        description: formatMessage((0, $lzUaz.messages).learnHowToWorkNonFinal)
    })));
};
const $a53ef64b9e28d9f1$var$listTitleWrapperStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});
parcelRegister("3nnLQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2755f57284cb8101$var$_react = $2755f57284cb8101$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $2755f57284cb8101$var$_bookWithBookmark = $2755f57284cb8101$var$_interopRequireDefault((parcelRequire("aySPZ")));
function $2755f57284cb8101$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2755f57284cb8101$var$BookIcon = (props)=>/*#__PURE__*/ $2755f57284cb8101$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path fill-rule="nonzero" d="M7 6.002v9.996c0 .546.446 1.002.995 1.002h8.01c.54 0 .995-.449.995-1.002V6.002C17 5.456 16.554 5 16.005 5h-8.01C7.455 5 7 5.449 7 6.002m-2 0A3.005 3.005 0 0 1 7.995 3h8.01A3.003 3.003 0 0 1 19 6.002v9.996A3.005 3.005 0 0 1 16.005 19h-8.01A3.003 3.003 0 0 1 5 15.998z"/><path d="M9 7h6v4H9zm0 6h6v2H9zm1 7.86V20H7v.86L8.5 20zM7 18h3v2H7z"/></g></svg>`
    }, props, {
        newIcon: $2755f57284cb8101$var$_bookWithBookmark.default
    }));
$2755f57284cb8101$var$BookIcon.displayName = 'BookIcon';
var $2755f57284cb8101$var$_default = module.exports.default = $2755f57284cb8101$var$BookIcon;

});
parcelRegister("aySPZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b079df464c03232$var$_react = $7b079df464c03232$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7b079df464c03232$var$_UNSAFE_baseNew = $7b079df464c03232$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $7b079df464c03232$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "BookWithBookmark".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7b079df464c03232$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $7b079df464c03232$var$_react.default.createElement($7b079df464c03232$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M2.75 11.625c0 1.174.951 2.125 2.125 2.125H5.5m-2.75-2.125c0-1.174.951-2.125 2.125-2.125H12.5m-9.75 2.125v-8.75C2.75 1.701 3.701.75 4.875.75h8.375V9.5h-.75m1.5 4.25h-1.5m-2 0h2m0-4.25v4.25"/><path fill="currentColor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$7b079df464c03232$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $7b079df464c03232$var$_default = module.exports.default = $7b079df464c03232$var$BookWithBookmarkIcon;

});


parcelRegister("lzUaz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e017e58536150f8c$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $e017e58536150f8c$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    titleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.user.title-non-final",
        "defaultMessage": "Move your work from Opsgenie to Jira Service Management"
    },
    descriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.user.description-non-final",
        "defaultMessage": "Almost all of your Opsgenie data and settings are now in Jira Service Management, so you no longer need Opsgenie to do your alerting and on-call work."
    },
    listTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.user.list-title-non-final",
        "defaultMessage": "Let's go set up a few things so you can get started"
    },
    configureNotificationSettingsNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.user.configure-notification-settings-non-final",
        "defaultMessage": "Configure your notifications settings in Jira"
    },
    learnHowToWorkNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.user.learn-how-to-work-non-final",
        "defaultMessage": "Learn how operations works on Jira Service Management"
    }
});

});




parcelRegister("lYBgG", function(module, exports) {

$parcel$export(module.exports, "StepFour", () => $34fc3d136c58af77$export$b88edf692723a2ee);

var $eUqFw = parcelRequire("eUqFw");

var $bbmZl = parcelRequire("bbmZl");

var $EN9B6 = parcelRequire("EN9B6");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $hI5oG = parcelRequire("hI5oG");

var $3nnLQ = parcelRequire("3nnLQ");

var $dmCPj = parcelRequire("dmCPj");

var $5318D = parcelRequire("5318D");

var $23NQ5 = parcelRequire("23NQ5");

var $j76Bh = parcelRequire("j76Bh");

var $8tfNS = parcelRequire("8tfNS");

var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");

var $4kMup = parcelRequire("4kMup");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hqVLk = parcelRequire("hqVLk");

var $fH5cc = parcelRequire("fH5cc");

var $ikbtU = parcelRequire("ikbtU");

var $8QX8y = parcelRequire("8QX8y");

var $1ZNqu = parcelRequire("1ZNqu");

var $2DX8V = parcelRequire("2DX8V");

var $8pS4q = parcelRequire("8pS4q");

var $lIeXV = parcelRequire("lIeXV");

var $lzGyk = parcelRequire("lzGyk");

var $hCyRm = parcelRequire("hCyRm");

var $kyaLE = parcelRequire("kyaLE");
const $34fc3d136c58af77$export$b88edf692723a2ee = ({ onAction: onAction, onClose: onClose, onUnlock: onUnlock })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: transitioningData } = (0, $hqVLk.useResource)((0, $fH5cc.transitioningDetailsResource));
    const { timeZone: timeZone } = (0, $hCyRm.useUserTimezone)();
    const { activateWelcomeModal: activateWelcomeModal } = (0, $lzGyk.useGlobalChangeboarding)();
    if (!transitioningData) throw new Error('[Optimal StepFour] component should not be rendered before details resource fetched');
    const [isUnlocking, setIsUnlocking] = (0, $eUqFw.useState)(false);
    const handleNext = ()=>{
        activateWelcomeModal();
        setIsUnlocking(true);
        onUnlock?.().then(()=>{
            onAction((prevState)=>prevState + 1);
        }).finally(()=>{
            setIsUnlocking(false);
        });
    };
    const primaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        onClick: handleNext,
        appearance: "primary",
        isLoading: isUnlocking
    }, formatMessage((0, $kyaLE.messages).primaryButtonTextNonFinal));
    const secondaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: ()=>onAction((prevState)=>prevState - 1),
        appearance: "default"
    }, formatMessage((0, $lIeXV.messages).backButtonNonFinal));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8pS4q.Layout), {
        vector: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($8QX8y))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($ikbtU)))
        },
        currentStep: 4,
        actionButtons: {
            primary: primaryActionButton,
            secondary: secondaryActionButton
        },
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        rowGap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        rowGap: "space.100",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "large"
    }, formatMessage((0, $kyaLE.messages).titleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $kyaLE.messages).descriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))),
            color: (0, $1ZNqu.IconBoxColor).Magenta,
            withCustomContainer: true
        }),
        description: formatMessage((0, $kyaLE.messages).firstItemNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3nnLQ))),
            color: (0, $1ZNqu.IconBoxColor).Purple,
            withCustomContainer: true
        }),
        description: formatMessage((0, $kyaLE.messages).secondItemNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5318D))),
            color: (0, $1ZNqu.IconBoxColor).Teal,
            withCustomContainer: true
        }),
        description: formatMessage((0, $kyaLE.messages).thirdItemNonFinal, {
            unlockDate: (0, $EN9B6.default)((0, $bbmZl.default)(transitioningData?.autoOgTurnOffDate, timeZone), 'dd MMMM, yyyy')
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tfNS))),
            color: (0, $1ZNqu.IconBoxColor).Blue,
            withCustomContainer: true
        }),
        description: formatMessage((0, $kyaLE.messages).fourthItemNonFinal, {
            link: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
                    href: "https://support.atlassian.com/security-and-access-policies/docs/understand-data-residency/",
                    target: "_blank"
                }, str)
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($j76Bh))),
            color: (0, $1ZNqu.IconBoxColor).Orange,
            withCustomContainer: true
        }),
        description: formatMessage((0, $kyaLE.messages).fifthItemNonFinal)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $kyaLE.messages).dontReadyYetNonFinal, {
        link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
            href: "https://support.atlassian.com/jira-service-management-cloud/docs/start-shifting-from-opsgenie-to-jira-service-management/",
            target: "_blank"
        }, formatMessage((0, $kyaLE.messages).learnMoreNonFinal), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
            label: "",
            size: "small"
        }))
    }))));
};

});
parcelRegister("j76Bh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dea3ca78c255f4b6$var$_react = $dea3ca78c255f4b6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $dea3ca78c255f4b6$var$_teams = $dea3ca78c255f4b6$var$_interopRequireDefault((parcelRequire("gib2Q")));
function $dea3ca78c255f4b6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $dea3ca78c255f4b6$var$TeamsIcon = (props)=>/*#__PURE__*/ $dea3ca78c255f4b6$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M9 7.2a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m7.8 0a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m1.2 9.3a4.5 4.5 0 0 0-4.5-4.5h-1.378c-.484 0-1.275.127-1.875.41l.77 1.627c.14-.066.342-.129.566-.174s.421-.063.539-.063H17.1a2.7 2.7 0 0 1 2.7 2.7V18a.6.6 0 0 1-.6.6h-3.478a2.7 2.7 0 0 1-2.538-1.777l-.676-1.86A4.5 4.5 0 0 0 8.278 12H6.9a4.5 4.5 0 0 0-4.5 4.5V18a2.4 2.4 0 0 0 2.4 2.4h4.8v-1.8H4.8a.6.6 0 0 1-.6-.6v-1.5a2.7 2.7 0 0 1 2.7-2.7h1.378a2.7 2.7 0 0 1 2.538 1.777l.676 1.86a4.5 4.5 0 0 0 4.23 2.963H19.2a2.4 2.4 0 0 0 2.4-2.4z" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $dea3ca78c255f4b6$var$_teams.default
    }));
$dea3ca78c255f4b6$var$TeamsIcon.displayName = 'TeamsIcon';
var $dea3ca78c255f4b6$var$_default = module.exports.default = $dea3ca78c255f4b6$var$TeamsIcon;

});

parcelRegister("kyaLE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $21c2f1afaf85675c$export$defe85febe8b728c);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $21c2f1afaf85675c$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    titleNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.title-no-translate",
        "defaultMessage": "Ready to move from Opsgenie?"
    },
    descriptionNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.description-no-translate",
        "defaultMessage": "Here's a summary of what happens once you move:"
    },
    firstItemNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.first-item-no-translate",
        "defaultMessage": "Your Opsgenie data and settings will be copied to Jira Service Management, without any changes"
    },
    secondItemNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.second-item-no-translate",
        "defaultMessage": "You'll get a guide to finish setting up configurations that need your involvement"
    },
    thirdItemNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.third-item-no-translate",
        "defaultMessage": "Your Opsgenie site will continue to be accessible, until it's turned off on {unlockDate}"
    },
    fourthItemNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.fourth-item-no-translate",
        "defaultMessage": "Some of your data, including teams and team members, might change residency location from your selected server in Opsgenie. <link>Read more about data residency</link>"
    },
    fifthItemNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.fifth-item-no-translate",
        "defaultMessage": "Inform your organization admin about this change as after the move, your teams and team members will become visible across all sites within your Atlassian account."
    },
    learnMoreNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.learn-more-no-translate",
        "defaultMessage": "Read more about moving from Opsgenie"
    },
    dontReadyYetNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.dont-ready-yet-no-translate",
        "defaultMessage": "Don't feel ready yet? {link}"
    },
    primaryButtonTextNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.primary-button-text-no-translate",
        "defaultMessage": "Let's start moving"
    }
});

});


parcelRegister("6LJxb", function(module, exports) {

$parcel$export(module.exports, "StepOne", () => $31e4e9a0123cf07d$export$d644924ea55d67c0);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $bJZ7m = parcelRequire("bJZ7m");

var $kgsNq = parcelRequire("kgsNq");

var $a10lp = parcelRequire("a10lp");

var $iwsIy = parcelRequire("iwsIy");

var $iw0Y6 = parcelRequire("iw0Y6");

var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fk1Jw = parcelRequire("fk1Jw");

var $1SlSv = parcelRequire("1SlSv");

var $1ZNqu = parcelRequire("1ZNqu");

var $2DX8V = parcelRequire("2DX8V");

var $8pS4q = parcelRequire("8pS4q");

var $lIeXV = parcelRequire("lIeXV");

var $gwcS5 = parcelRequire("gwcS5");
const $31e4e9a0123cf07d$export$d644924ea55d67c0 = ({ onAction: onAction, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const primaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: ()=>onAction((prevState)=>prevState + 1),
        appearance: "primary"
    }, formatMessage((0, $lIeXV.messages).nextButtonNonFinal));
    const secondaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onClose,
        appearance: "default"
    }, formatMessage((0, $lIeXV.messages).closeButtonNonFinal));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8pS4q.Layout), {
        vector: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($1SlSv))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($fk1Jw)))
        },
        currentStep: 1,
        actionButtons: {
            primary: primaryActionButton,
            secondary: secondaryActionButton
        },
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        rowGap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        rowGap: "space.100",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "large"
    }, formatMessage((0, $gwcS5.messages).titleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $gwcS5.messages).descriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($a10lp))),
            color: (0, $1ZNqu.IconBoxColor).Orange,
            withCustomContainer: true
        }),
        title: formatMessage((0, $gwcS5.messages).alertsTitleNonFinal),
        description: formatMessage((0, $gwcS5.messages).alertsDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))),
            color: (0, $1ZNqu.IconBoxColor).Lime,
            withCustomContainer: true
        }),
        title: formatMessage((0, $gwcS5.messages).operationsTitleNonFinal),
        description: formatMessage((0, $gwcS5.messages).operationsDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kgsNq))),
            color: (0, $1ZNqu.IconBoxColor).Teal,
            withCustomContainer: true
        }),
        title: formatMessage((0, $gwcS5.messages).mobileTitleNonFinal),
        description: formatMessage((0, $gwcS5.messages).mobileDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))),
            color: (0, $1ZNqu.IconBoxColor).Blue,
            withCustomContainer: true
        }),
        title: formatMessage((0, $gwcS5.messages).teamsTitleNonFinal),
        description: formatMessage((0, $gwcS5.messages).teamsDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bJZ7m))),
            color: (0, $1ZNqu.IconBoxColor).Purple,
            withCustomContainer: true
        }),
        title: formatMessage((0, $gwcS5.messages).incidentsTitleNonFinal),
        description: formatMessage((0, $gwcS5.messages).incidentsDescriptionNonFinal)
    }))));
};

});
parcelRegister("bJZ7m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88c34e63e2df12b5$var$_react = $88c34e63e2df12b5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $88c34e63e2df12b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $88c34e63e2df12b5$var$Incident16Icon = (props)=>/*#__PURE__*/ $88c34e63e2df12b5$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M4.785 10h6.43L10.5 8H5.499l-.714 2zM4 11a1 1 0 00-1 1v1h10v-1a1 1 0 00-1-1H4zm1.856-4h4.288L8.942 3.632a1 1 0 00-1.884 0L5.856 7zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"/></svg>`
    }, props, {
        size: "small"
    }));
$88c34e63e2df12b5$var$Incident16Icon.displayName = 'Incident16Icon';
var $88c34e63e2df12b5$var$_default = $88c34e63e2df12b5$var$Incident16Icon;
module.exports.default = $88c34e63e2df12b5$var$_default;

});

parcelRegister("gwcS5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a311a4b60af70565$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a311a4b60af70565$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    titleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.title-non-final",
        "defaultMessage": "Move your work from Opsgenie to Jira Service Management"
    },
    descriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.description-non-final",
        "defaultMessage": "Make Jira Service Management your team's central place to do all the operations work that they do with Opsgenie."
    },
    alertsTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.alerts-title-non-final",
        "defaultMessage": "Respond to alerts"
    },
    alertsDescriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.alerts-description-non-final",
        "defaultMessage": "Access all your alerts natively from Jira Service Management's Your work page."
    },
    operationsTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.operations-title-non-final",
        "defaultMessage": "Manage operations"
    },
    operationsDescriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.operations-description-non-final",
        "defaultMessage": "Find your integrations, custom roles, maintenance, notifications, policies, audit logs, and more in Jira settings."
    },
    mobileTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.mobile-title-non-final",
        "defaultMessage": "Get mobile notifications"
    },
    mobileDescriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.mobile-description-non-final",
        "defaultMessage": "Stay notified of alerts, check on-call schedules, and manage notification rules on the go with Jira Cloud mobile."
    },
    teamsTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.teams-title-non-final",
        "defaultMessage": "Build efficient on-call teams"
    },
    teamsDescriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.teams-description-non-final",
        "defaultMessage": "Your Opsgenie teams will become Atlassian teams, so you can manage all your teams, including on-call, from Jira."
    },
    incidentsTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.incidents-title-non-final",
        "defaultMessage": "Streamlined incident management"
    },
    incidentsDescriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.incidents-description-non-final",
        "defaultMessage": "Detect and resolve incidents collaboratively in Jira Service Management."
    }
});

});


parcelRegister("iRJfw", function(module, exports) {

$parcel$export(module.exports, "StepThree", () => $f628e81f095c9772$export$98c7d7d0f8104aa7);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $iFXD5 = parcelRequire("iFXD5");

var $23NQ5 = parcelRequire("23NQ5");

var $iHib2 = parcelRequire("iHib2");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $4kMup = parcelRequire("4kMup");

var $2bbBk = parcelRequire("2bbBk");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1ZNqu = parcelRequire("1ZNqu");

var $2L6P0 = parcelRequire("2L6P0");

var $2DX8V = parcelRequire("2DX8V");

var $8pS4q = parcelRequire("8pS4q");

var $lIeXV = parcelRequire("lIeXV");

var $8OZdV = parcelRequire("8OZdV");

var $2QBwV = parcelRequire("2QBwV");

var $iwET7 = parcelRequire("iwET7");
const $f628e81f095c9772$export$98c7d7d0f8104aa7 = ({ onAction: onAction, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const primaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: ()=>onAction((prevState)=>prevState + 1),
        appearance: "primary"
    }, formatMessage((0, $lIeXV.messages).nextButtonNonFinal));
    const secondaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: ()=>onAction((prevState)=>prevState - 1),
        appearance: "default"
    }, formatMessage((0, $lIeXV.messages).backButtonNonFinal));
    const [{ counts: integrationCounts }] = (0, $2QBwV.useIntegrationCounts)();
    const [{ hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats, heartbeats: heartbeats }] = (0, $8OZdV.useDeprecatedHeartbeats)();
    const [{ hasDeprecatedNotificationPolicies: hasDeprecatedNotificationPolicies, notificationPolicies: notificationPolicies }] = (0, $8OZdV.useDeprecatedNotificationPolicies)();
    const [{ hasDeprecatedGroups: hasDeprecatedGroups, groups: groups }] = (0, $8OZdV.useDeprecatedGroups)();
    const [{ hasDeprecatedIntegration: hasDeprecatedIntegration, deprecatedIntegrations: deprecatedIntegrations }] = (0, $2QBwV.useDeprecatedIntegrations)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8pS4q.Layout), {
        vector: {
            light: '',
            dark: '',
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2bbBk.default), {
                alt: "",
                width: 355
            })
        },
        currentStep: 3,
        actionButtons: {
            primary: primaryActionButton,
            secondary: secondaryActionButton
        },
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        rowGap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        rowGap: "space.100",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "large"
    }, formatMessage((0, $iwET7.messages).titleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $iwET7.messages).descriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, hasDeprecatedIntegration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iFXD5))),
            color: (0, $1ZNqu.IconBoxColor).Teal,
            withCustomContainer: true
        }),
        title: formatMessage((0, $iwET7.messages).integrationsInfoTitleNonFinal, {
            count: deprecatedIntegrations.data?.count
        }),
        description: formatMessage((0, $iwET7.messages).integrationsInfoDescriptionNonFinal, {
            count: deprecatedIntegrations.data?.count,
            totalCount: integrationCounts.data?.totalCount
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iHib2))),
            color: (0, $1ZNqu.IconBoxColor).Purple,
            withCustomContainer: true
        }),
        title: formatMessage((0, $iwET7.messages).teamsApiInfoTitleNonFinal),
        description: formatMessage((0, $iwET7.messages).teamsApiInfoDescriptionNonFinal)
    })), (hasDeprecatedGroups || hasDeprecatedGlobalHeartbeats || hasDeprecatedNotificationPolicies) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h3",
        size: "xsmall"
    }, formatMessage((0, $iwET7.messages).moreConfigurationsNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        rowGap: "space.025",
        xcss: $f628e81f095c9772$var$configurationItemsWrapperStyles
    }, hasDeprecatedGroups && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2L6P0.ConfigurationItem), null, formatMessage((0, $iwET7.messages).groupNonFinal, {
        count: groups.data?.count
    })), hasDeprecatedGlobalHeartbeats && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2L6P0.ConfigurationItem), null, formatMessage((0, $iwET7.messages).heartbeatsNonFinal, {
        count: heartbeats.data?.globalHeartbeatCount
    })), hasDeprecatedNotificationPolicies && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2L6P0.ConfigurationItem), null, formatMessage((0, $iwET7.messages).notificationPoliciesNonFinal, {
        count: notificationPolicies.data?.count
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/start-shifting-from-opsgenie-to-jira-service-management/#What-happens-after-starting-your-shift-from-Opsgenie",
        target: "_blank"
    }, formatMessage((0, $iwET7.messages).learnMoreNonFinal), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
        label: "",
        size: "small"
    })))));
};
const $f628e81f095c9772$var$configurationItemsWrapperStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});
parcelRegister("iHib2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9ca57b7a20a40df$var$_react = $d9ca57b7a20a40df$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d9ca57b7a20a40df$var$_cloudArrowUp = $d9ca57b7a20a40df$var$_interopRequireDefault((parcelRequire("5Z1ia")));
function $d9ca57b7a20a40df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d9ca57b7a20a40df$var$UploadIcon = (props)=>/*#__PURE__*/ $d9ca57b7a20a40df$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
    }, props, {
        newIcon: $d9ca57b7a20a40df$var$_cloudArrowUp.default
    }));
$d9ca57b7a20a40df$var$UploadIcon.displayName = 'UploadIcon';
var $d9ca57b7a20a40df$var$_default = module.exports.default = $d9ca57b7a20a40df$var$UploadIcon;

});
parcelRegister("5Z1ia", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45b3a6cc7855c144$var$_react = $45b3a6cc7855c144$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $45b3a6cc7855c144$var$_UNSAFE_baseNew = $45b3a6cc7855c144$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $45b3a6cc7855c144$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "CloudArrowUp".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $45b3a6cc7855c144$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $45b3a6cc7855c144$var$_react.default.createElement($45b3a6cc7855c144$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-width="1.5" d="M4 8.75A2.25 2.25 0 0 1 1.75 6.5v-.482a2.73 2.73 0 0 1 1.94-2.614l.739-.223.157-.427a3.058 3.058 0 0 1 5.82.242l.273.995h1.191a2.38 2.38 0 0 1 2.38 2.38V6.5A2.25 2.25 0 0 1 12 8.75m-4 0V16"/><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="m5 11.75 3-3 3 3"/>`
    }, props));
$45b3a6cc7855c144$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $45b3a6cc7855c144$var$_default = module.exports.default = $45b3a6cc7855c144$var$CloudArrowUpIcon;

});


parcelRegister("2bbBk", function(module, exports) {

$parcel$export(module.exports, "default", () => $33650a243d0222fa$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = hj7z88nh8g2n4vfpm6mv889q
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/hj7z88nh8g2n4vfpm6mv889q

var $9TZf5 = parcelRequire("9TZf5");

var $eIP1v = parcelRequire("eIP1v");
const $33650a243d0222fa$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($eIP1v)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($eIP1v))
});
var $33650a243d0222fa$export$2e2bcd8739ae039 = $33650a243d0222fa$var$Illustration;
// for advanced use only
const $33650a243d0222fa$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    235
];

});
parcelRegister("eIP1v", function(module, exports) {
module.exports = new URL("crystal-ball.30a0dd2d.svg", import.meta.url).toString();

});


parcelRegister("2L6P0", function(module, exports) {

$parcel$export(module.exports, "ConfigurationItem", () => $24f28e0af531856f$export$201f11292a316609);

var $eUqFw = parcelRequire("eUqFw");

var $i6L17 = parcelRequire("i6L17");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $4lTFP = parcelRequire("4lTFP");
const $24f28e0af531856f$export$201f11292a316609 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        columnGap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i6L17))), {
        label: "",
        size: "small",
        primaryColor: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $24f28e0af531856f$var$textStyles,
        as: "span"
    }, children));
const $24f28e0af531856f$var$textStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtlest',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-body, ${(0, $4lTFP.fontFallback).body.medium})`
});

});
parcelRegister("i6L17", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2ed422678b90b4a$var$_react = $d2ed422678b90b4a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $d2ed422678b90b4a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d2ed422678b90b4a$var$HipchatMediaAttachmentCountIcon = (props)=>/*#__PURE__*/ $d2ed422678b90b4a$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="5" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$d2ed422678b90b4a$var$HipchatMediaAttachmentCountIcon.displayName = 'HipchatMediaAttachmentCountIcon';
var $d2ed422678b90b4a$var$_default = module.exports.default = $d2ed422678b90b4a$var$HipchatMediaAttachmentCountIcon;

});


parcelRegister("iwET7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $52e39ac8c69742a4$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $52e39ac8c69742a4$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    titleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.title-non-final",
        "defaultMessage": "What you'll leave behind in Opsgenie"
    },
    descriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.description-non-final",
        "defaultMessage": "A few legacy Opsgenie features that aren't supported by Jira Service Management will be left behind in Opsgenie. They'll keep working in Opsgenie until Opsgenie is turned off."
    },
    integrationsInfoTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.integrations-info-title-non-final",
        "defaultMessage": "{count, plural, one {{count} integration} other {{count} integrations}}"
    },
    integrationsInfoDescriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.integrations-info-description-non-final",
        "defaultMessage": "{count} of your {totalCount, plural, one {{totalCount} Opsgenie integration} other {{totalCount} Opsgenie integrations}} won't be available in Jira Service Management. They'll still work in Opsgenie."
    },
    teamsApiInfoTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.teams-api-info-title-non-final",
        "defaultMessage": "Teams API in Opsgenie"
    },
    teamsApiInfoDescriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.teams-api-info-description-non-final",
        "defaultMessage": "Opsgenie's API for team management won't work anymore. It will have to be done through the alternative Jira Cloud Platform API."
    },
    moreConfigurationsNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.more-configurations-non-final",
        "defaultMessage": "And a few more configurations:"
    },
    groupNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.group-non-final",
        "defaultMessage": "{count, plural, one {{count} group} other {{count} groups}}"
    },
    heartbeatsNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.heartbeats-non-final",
        "defaultMessage": "{count, plural, one {{count} global heartbeat} other {{count} global heartbeats}}"
    },
    notificationPoliciesNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.notification-policies-non-final",
        "defaultMessage": "{count, plural, one {{count} global notification policy} other {{count} global notification policies}}"
    },
    learnMoreNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.learn-more-non-final",
        "defaultMessage": "Read more about what you'll leave behind in Opsgenie"
    }
});

});


parcelRegister("h88BQ", function(module, exports) {

$parcel$export(module.exports, "StepTwo", () => $6abe1665c1811933$export$f7c6032816713bb9);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $d3vNK = parcelRequire("d3vNK");

var $4nce6 = parcelRequire("4nce6");

var $23NQ5 = parcelRequire("23NQ5");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $4kMup = parcelRequire("4kMup");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $050yH = parcelRequire("050yH");

var $1kItO = parcelRequire("1kItO");

var $1ZNqu = parcelRequire("1ZNqu");

var $2L6P0 = parcelRequire("2L6P0");

var $2DX8V = parcelRequire("2DX8V");

var $8pS4q = parcelRequire("8pS4q");

var $lIeXV = parcelRequire("lIeXV");

var $2QBwV = parcelRequire("2QBwV");

var $2Q2AK = parcelRequire("2Q2AK");

var $7A0X0 = parcelRequire("7A0X0");
const $6abe1665c1811933$export$f7c6032816713bb9 = ({ onAction: onAction, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ usersWithoutCustomRole: usersWithoutCustomRole, usersWithoutAdminRole: usersWithoutAdminRole }] = (0, $2Q2AK.useUsersAndRolesStore)();
    if (usersWithoutCustomRole.data === null || usersWithoutAdminRole.data === null) // Users should not see this screen if one of the requests is still loading or error
    throw new Error('[Optimal StepTwo] should not be rendered if users are still loading');
    const usersWithoutCustomRoleCount = usersWithoutCustomRole.data.count;
    const usersWithoutAdminRoleCount = usersWithoutAdminRole.data.count;
    const [{ counts: integrationCounts }] = (0, $2QBwV.useIntegrationCounts)();
    const chatCount = integrationCounts.data?.chatCount || 0;
    const primaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: ()=>onAction((prevState)=>prevState + 1),
        appearance: "primary"
    }, formatMessage((0, $lIeXV.messages).nextButtonNonFinal));
    const secondaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: ()=>onAction((prevState)=>prevState - 1),
        appearance: "default"
    }, formatMessage((0, $lIeXV.messages).backButtonNonFinal));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8pS4q.Layout), {
        vector: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($1kItO))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($050yH)))
        },
        currentStep: 2,
        actionButtons: {
            primary: primaryActionButton,
            secondary: secondaryActionButton
        },
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        rowGap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        rowGap: "space.100",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "large"
    }, formatMessage((0, $7A0X0.messages).titleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $7A0X0.messages).descriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, (usersWithoutCustomRoleCount > 0 || usersWithoutAdminRoleCount > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4nce6))),
            color: (0, $1ZNqu.IconBoxColor).Teal,
            withCustomContainer: true
        }),
        title: formatMessage((0, $7A0X0.messages).usersRoleTitleNonFinal),
        description: formatMessage((0, $7A0X0.messages).usersRoleDescriptionNonFinal, {
            adminCount: usersWithoutAdminRoleCount,
            userCount: usersWithoutCustomRoleCount
        })
    }), chatCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DX8V.WizardInfoItem), {
        iconBox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZNqu.IconBox), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))),
            color: (0, $1ZNqu.IconBoxColor).Lime,
            withCustomContainer: true
        }),
        title: formatMessage((0, $7A0X0.messages).chatIntegrationsTitleNonFinal),
        description: formatMessage((0, $7A0X0.messages).chatIntegrationsDescriptionNonFinal, {
            chatCount: chatCount
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall",
        as: "h2"
    }, formatMessage((0, $7A0X0.messages).configurationsTitleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "column",
        rowGap: "space.025",
        xcss: $6abe1665c1811933$var$configurationItemsWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2L6P0.ConfigurationItem), null, formatMessage((0, $7A0X0.messages).actionsAndIncidentRulesNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2L6P0.ConfigurationItem), null, formatMessage((0, $7A0X0.messages).heartbeatsNonFinal)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/start-shifting-from-opsgenie-to-jira-service-management",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $7A0X0.messages).readMoreAboutNonFinal), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
        label: "",
        size: "small"
    })))));
};
const $6abe1665c1811933$var$configurationItemsWrapperStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});
parcelRegister("4nce6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32f2cb577afb3a41$var$_react = $32f2cb577afb3a41$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $32f2cb577afb3a41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $32f2cb577afb3a41$var$PeopleIcon = (props)=>/*#__PURE__*/ $32f2cb577afb3a41$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props));
$32f2cb577afb3a41$var$PeopleIcon.displayName = 'PeopleIcon';
var $32f2cb577afb3a41$var$_default = module.exports.default = $32f2cb577afb3a41$var$PeopleIcon;

});

parcelRegister("050yH", function(module, exports) {
module.exports = new URL("step_two_vector_dark_optimal.34c23cb4.png", import.meta.url).toString();

});

parcelRegister("1kItO", function(module, exports) {
module.exports = new URL("step_two_vector_light_optimal.959d3c54.png", import.meta.url).toString();

});

parcelRegister("7A0X0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2b35ab6a4f1f3ba6$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $2b35ab6a4f1f3ba6$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    titleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.title-non-final",
        "defaultMessage": "What you'll need to set up"
    },
    descriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.description-non-final",
        "defaultMessage": "Almost all of your Opsgenie settings will be synced with Jira Service Management, only some configurations will need your involvement."
    },
    usersRoleTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.users-role-title-non-final",
        "defaultMessage": "Verify users' roles"
    },
    usersRoleDescriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.users-role-description-non-final",
        "defaultMessage": "{adminCount, plural,\n            =0 {{userCount, plural, =0 {} one {{userCount} Opsgenie user} other {{userCount} Opsgenie users}}}\n             one {{userCount, plural, =0 {{adminCount} Opsgenie admin} one {{adminCount} Opsgenie admin and {userCount} user} other {{adminCount} Opsgenie admin and {userCount} users}}}\n            other {{userCount, plural, =0 {{adminCount} Opsgenie admins} one {{adminCount} Opsgenie admins and {userCount} user} other {{adminCount} Opsgenie admins and {userCount} users}}}\n        } who don't have the same role in Jira Service Management."
    },
    chatIntegrationsTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.chat-integrations-title-non-final",
        "defaultMessage": "Copy chat integrations"
    },
    chatIntegrationsDescriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.chat-integrations-description-non-final",
        "defaultMessage": "Connect your chat tools and copy your {chatCount, plural, one {# Opsgenie chat integration} other {# Opsgenie chat integrations}} to Jira Service Management."
    },
    configurationsTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.configurations-title-non-final",
        "defaultMessage": "And a few more configurations:"
    },
    actionsAndIncidentRulesNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.actions-and-incident-rules-non-final",
        "defaultMessage": "Actions and incident rules"
    },
    heartbeatsNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.heartbeats-non-final",
        "defaultMessage": "Heartbeats"
    },
    readMoreAboutNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.read-more-about-non-final",
        "defaultMessage": "Read more about setting up operations"
    }
});

});



parcelRegister("91SM8", function(module, exports) {

$parcel$export(module.exports, "ChangeboardingProviders", () => $6244dc7a6b7d2d70$export$935fa8923574c4cf);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $dc8n7 = parcelRequire("dc8n7");

var $8OZdV = parcelRequire("8OZdV");

var $3CBya = parcelRequire("3CBya");

var $2QBwV = parcelRequire("2QBwV");

var $iIei2 = parcelRequire("iIei2");

var $bkVBU = parcelRequire("bkVBU");

var $hjidz = parcelRequire("hjidz");

var $5e5rs = parcelRequire("5e5rs");

var $2Q2AK = parcelRequire("2Q2AK");
const $6244dc7a6b7d2d70$var$MinimalToolingProviders = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Q2AK.UsersAndRolesContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dc8n7.ChatToolsContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iIei2.JNAAppStatusContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5e5rs.TransitioningStatusContainer), {
        isGlobal: true
    }, children))));
const $6244dc7a6b7d2d70$export$935fa8923574c4cf = ({ children: children })=>{
    const isOptimalTooling = (0, $1ybV0.ff)('platform.show-optimal-tooling_brgom');
    if (isOptimalTooling) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hjidz.TeamsContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bkVBU.TeamAdminStatusContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2QBwV.IntegrationsContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8OZdV.DeprecatedCountsContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3CBya.IncidentsContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6244dc7a6b7d2d70$var$MinimalToolingProviders, null, children))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6244dc7a6b7d2d70$var$MinimalToolingProviders, null, children);
};

});

parcelRegister("4pZOP", function(module, exports) {

$parcel$export(module.exports, "WelcomeModalRenderer", () => $ae2cdafdc6984a94$export$5d9e1395db999a45);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $lzGyk = parcelRequire("lzGyk");

var $91SM8 = parcelRequire("91SM8");


var $7eOF3 = parcelRequire("7eOF3");


var $7EfKv = parcelRequire("7EfKv");
const $ae2cdafdc6984a94$var$WelcomeModalRendererInner = ()=>{
    const { isWelcomeModalActivated: isWelcomeModalActivated, finalWelcomeModalIsOpen: finalWelcomeModalIsOpen, handleCloseWelcomeModal: handleCloseWelcomeModal } = (0, $lzGyk.useGlobalChangeboarding)();
    if (!isWelcomeModalActivated) return null;
    return (0, $1ybV0.ff)('platform.show-optimal-tooling_brgom') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eOF3.Wizard), {
        isOpen: Boolean(finalWelcomeModalIsOpen),
        onClose: handleCloseWelcomeModal,
        defaultStep: (0, $5a553e1dde064a50$export$75f90732d1326d15)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7EfKv.Wizard), {
        isOpen: Boolean(finalWelcomeModalIsOpen),
        onClose: handleCloseWelcomeModal,
        defaultStep: (0, $c3a508c467a117cf$export$75f90732d1326d15)
    });
};
const $ae2cdafdc6984a94$export$5d9e1395db999a45 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "flag",
        teamName: "alexstrasza",
        packageName: "jiraEocChangeboarding",
        id: "jiraEocChangeboarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $91SM8.ChangeboardingProviders), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ae2cdafdc6984a94$var$WelcomeModalRendererInner, null)));

});

parcelRegister("bZaKv", function(module, exports) {

$parcel$export(module.exports, "TransitionHomeRenderer", () => $9ab3691521dcaffa$export$e8934af6f19a3b7c);

var $eUqFw = parcelRequire("eUqFw");

var $55pTl = parcelRequire("55pTl");

var $h4Fhh = parcelRequire("h4Fhh");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $9pngN = parcelRequire("9pngN");

var $8WuJm = parcelRequire("8WuJm");

var $7gA9Z = parcelRequire("7gA9Z");

var $lzGyk = parcelRequire("lzGyk");

var $3IZ9E = parcelRequire("3IZ9E");

var $hhjRL = parcelRequire("hhjRL");

var $7lw2X = parcelRequire("7lw2X");

var $91SM8 = parcelRequire("91SM8");

var $pLZGf = parcelRequire("pLZGf");

var $kke6s = parcelRequire("kke6s");
const $9ab3691521dcaffa$var$TransitionHomeRendererInner = ()=>{
    const { isTransitionHomeModalOpen: isTransitionHomeModalOpen, openTransitionHomeModal: openTransitionHomeModal, closeTransitionHomeModal: closeTransitionHomeModal, isTransitionHomeLoading: isTransitionHomeLoading, isTransitionHomeActivated: isTransitionHomeActivated } = (0, $lzGyk.useGlobalChangeboarding)();
    const { isTransitioning: isTransitioning } = (0, $h4Fhh.useOgTenantInfo)();
    const { changeActiveContent: changeActiveContent } = (0, $3IZ9E.useProgressActions)();
    const { data: data } = (0, $hhjRL.useOgConsolidationUserState)();
    const isOptimalTooling = (0, $1ybV0.ff)('platform.show-optimal-tooling_brgom');
    const { clearQueryParams: clearQueryParams, queryParamsValid: queryParamsValid, activeTaskIndex: activeTaskIndex, activeContent: activeContent } = (0, $7lw2X.useTransitionHomeQueryParams)();
    (0, $eUqFw.useEffect)(()=>{
        const isTransitionHomeReady = !isTransitionHomeLoading && isTransitionHomeActivated && !isTransitionHomeModalOpen;
        const isTransitionHomeVisible = !data?.isTransitionHomeHidden;
        const isModalReady = isTransitionHomeReady && isTransitionHomeVisible;
        const shouldOpenAndActivateModal = isOptimalTooling && isTransitioning && queryParamsValid;
        if (isModalReady && shouldOpenAndActivateModal) openTransitionHomeModal().then(()=>{
            if (activeContent) {
                changeActiveContent(activeContent, activeTaskIndex);
                const nodes = document.querySelectorAll('.transition-home-content-box');
                const node = nodes[activeTaskIndex];
                if (node) node.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
                clearQueryParams();
            }
        });
    }, [
        activeContent,
        activeTaskIndex,
        changeActiveContent,
        clearQueryParams,
        data?.isTransitionHomeHidden,
        isOptimalTooling,
        isTransitionHomeActivated,
        isTransitionHomeLoading,
        isTransitionHomeModalOpen,
        isTransitioning,
        openTransitionHomeModal,
        queryParamsValid
    ]);
    if (!isTransitioning || !isTransitionHomeActivated) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "transitionHomeModal",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kke6s.TransitionHomeModal), {
        isOpen: isTransitionHomeModalOpen,
        onClose: closeTransitionHomeModal
    })), !data?.isTransitionHomeHidden && !isTransitionHomeModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9pngN.JiraBottomRightCornerOutlet), {
        orderFromRight: 5,
        id: "servicedesk-eoc-transition-home-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $pLZGf.TransitionHomeButton), {
        isLoading: isTransitionHomeLoading,
        onClick: openTransitionHomeModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55pTl.EngagementSpotlight), {
        engagementId: (0, $7gA9Z.HELP_PANEL_SPOTLIGHT_NAME)
    }));
};
const $9ab3691521dcaffa$export$e8934af6f19a3b7c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "eoc.changeboarding.transition.home",
        packageName: "jiraEocChangeboarding",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $91SM8.ChangeboardingProviders), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9ab3691521dcaffa$var$TransitionHomeRendererInner, null)));

});
parcelRegister("9pngN", function(module, exports) {

$parcel$export(module.exports, "JiraBottomRightCornerOutlet", () => $c006a225e0f72214$export$ee54e6ed235df65e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lEfVV = parcelRequire("lEfVV");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $71g00 = parcelRequire("71g00");
const $c006a225e0f72214$var$OutletWithPortal = ({ orderFromRight: orderFromRight, children: children, id: id })=>{
    const portalWrapper = (0, $eUqFw.useRef)(document.createElement('div'));
    const container = (0, $71g00.useBottomRightCornerContainer)();
    if (!container) throw new Error('GlobalBottomRightContainer could not be found. Please ensure that this container was rendered on the page.');
    const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, $71g00.useBottomRightCornerActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (container) {
            const indexToRender = insertBottomRightCornerPortal({
                orderFromRight: orderFromRight,
                id: id
            });
            // @ts-expect-error - TS2538 - Type 'Promise<void>' cannot be used as an index type. | TS2538 - Type 'void' cannot be used as an index type.
            container.insertBefore(portalWrapper.current, container.children[indexToRender]);
        }
        // required as eslint complains about the ref in cleanup function
        const portalCurrent = portalWrapper.current;
        return ()=>{
            container?.removeChild(portalCurrent);
            removeBottomRightCornerPortal(id);
        };
    }, [
        container,
        id,
        orderFromRight,
        insertBottomRightCornerPortal,
        removeBottomRightCornerPortal
    ]);
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c006a225e0f72214$var$StyledOutlet, null, children), portalWrapper.current);
};
const $c006a225e0f72214$export$ee54e6ed235df65e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "bottom-right-corner-outlet",
        packageName: "jira-bottom-right-corner-controller",
        extraEventData: {
            portalId: props.id
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c006a225e0f72214$var$OutletWithPortal, props));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c006a225e0f72214$var$StyledOutlet = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1vgl1wug _1ko9pxbi",
            __cmplp.className
        ])
    });
});

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("3IZ9E", function(module, exports) {

$parcel$export(module.exports, "useProgressStore", () => $05cdfa3490c319c7$export$312129c257c96af8);
$parcel$export(module.exports, "useProgressActions", () => $05cdfa3490c319c7$export$2c96689aa9dcabf8);

var $ggKAj = parcelRequire("ggKAj");
var $fJD67 = parcelRequire("fJD67");
var $a61MH = parcelRequire("a61MH");

var $c1CyL = parcelRequire("c1CyL");
const $05cdfa3490c319c7$var$initialState = {
    activeContent: (0, $c1CyL.ProgressContents).Home,
    activeTask: null,
    latestContent: (0, $c1CyL.ProgressContents).Home,
    isOpen: false
};
const $05cdfa3490c319c7$var$Store = (0, $a61MH.createStore)({
    initialState: $05cdfa3490c319c7$var$initialState,
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true,
                    activeContent: (0, $c1CyL.ProgressContents).Home
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            },
        changeActiveContent: (content, task)=>({ setState: setState })=>{
                setState({
                    activeContent: content,
                    activeTask: task || null
                });
            },
        backToHome: (latestContent)=>({ setState: setState })=>{
                setState({
                    activeContent: (0, $c1CyL.ProgressContents).Home,
                    latestContent: latestContent
                });
            }
    },
    name: 'progress'
});
const $05cdfa3490c319c7$export$312129c257c96af8 = (0, $ggKAj.createHook)($05cdfa3490c319c7$var$Store);
const $05cdfa3490c319c7$export$2c96689aa9dcabf8 = (0, $ggKAj.createActionsHook)($05cdfa3490c319c7$var$Store);
const $05cdfa3490c319c7$export$98485f76d889f48a = (0, $fJD67.createContainer)($05cdfa3490c319c7$var$Store, {
    Wrapper: (0, $fJD67.createDefaultEocWrapper)({})
});

});
parcelRegister("c1CyL", function(module, exports) {

$parcel$export(module.exports, "ProgressContents", () => $6605e422dab04105$export$470df1a589ec66d4);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $6605e422dab04105$export$470df1a589ec66d4;
(function(ProgressContents) {
    ProgressContents[ProgressContents["Home"] = 0] = "Home";
    ProgressContents[ProgressContents["UsersAndRoles"] = 1] = "UsersAndRoles";
    ProgressContents[ProgressContents["Alerts"] = 2] = "Alerts";
    ProgressContents[ProgressContents["Notifications"] = 3] = "Notifications";
    ProgressContents[ProgressContents["Teams"] = 4] = "Teams";
    ProgressContents[ProgressContents["ChatTools"] = 5] = "ChatTools";
    ProgressContents[ProgressContents["Integrations"] = 6] = "Integrations";
    ProgressContents[ProgressContents["AutomateAlertAndIncidentResponse"] = 7] = "AutomateAlertAndIncidentResponse";
    ProgressContents[ProgressContents["Incidents"] = 8] = "Incidents";
    ProgressContents[ProgressContents["Heartbeats"] = 9] = "Heartbeats";
    ProgressContents[ProgressContents["Find"] = 10] = "Find";
    ProgressContents[ProgressContents["DeprecatedOnes"] = 11] = "DeprecatedOnes";
})($6605e422dab04105$export$470df1a589ec66d4 || ($6605e422dab04105$export$470df1a589ec66d4 = {}));

});


parcelRegister("7lw2X", function(module, exports) {

$parcel$export(module.exports, "useTransitionHomeQueryParams", () => $e7963897b57e74af$export$d067561a2d981345);

var $5ua7k = parcelRequire("5ua7k");

var $c1CyL = parcelRequire("c1CyL");
function $e7963897b57e74af$var$isProgressContentsKey(key) {
    return key in (0, $c1CyL.ProgressContents);
}
function $e7963897b57e74af$var$getActiveContent(queryParamValue) {
    const activeContentValue = Number(queryParamValue);
    if (Number.isNaN(activeContentValue) && $e7963897b57e74af$var$isProgressContentsKey(queryParamValue)) return (0, $c1CyL.ProgressContents)[queryParamValue];
    return activeContentValue;
}
const $e7963897b57e74af$export$d067561a2d981345 = ()=>{
    const [transitionHomeContent, setTransitionHomeContent] = (0, $5ua7k.useQueryParam)('transitionHomeContent');
    const [transitionHomeActiveTask, setTransitionHomeActiveTask] = (0, $5ua7k.useQueryParam)('transitionHomeActiveTask');
    const clearQueryParams = ()=>{
        setTransitionHomeContent(undefined);
        // Workaround: A setTimeout is used to clear the transitionHomeActiveTask query parameter.
        // Without this delay, only the first query parameter gets cleared,
        // even though both setters are called within the same function.
        setTimeout(()=>{
            setTransitionHomeActiveTask(undefined);
        });
    };
    const activeTaskIndex = Number(transitionHomeActiveTask);
    const isTaskIndexValid = !Number.isNaN(activeTaskIndex) && activeTaskIndex >= 0;
    const isTransitionHomeContentValid = transitionHomeContent && $e7963897b57e74af$var$isProgressContentsKey(transitionHomeContent);
    const activeContent = isTransitionHomeContentValid ? $e7963897b57e74af$var$getActiveContent(transitionHomeContent) : undefined;
    const queryParamsValid = isTransitionHomeContentValid && isTaskIndexValid;
    return {
        clearQueryParams: clearQueryParams,
        activeTaskIndex: activeTaskIndex,
        activeContent: activeContent,
        queryParamsValid: queryParamsValid
    };
};

});

parcelRegister("pLZGf", function(module, exports) {

$parcel$export(module.exports, "TransitionHomeButton", () => $31a59024c3f45e6f$export$9f72b02411896f7a);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $55pTl = parcelRequire("55pTl");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $jWuk1 = parcelRequire("jWuk1");

var $iFmgL = parcelRequire("iFmgL");

var $ltfxy = parcelRequire("ltfxy");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $7gA9Z = parcelRequire("7gA9Z");

var $1askq = parcelRequire("1askq");

var $8KYeC = parcelRequire("8KYeC");

var $3RJ7R = parcelRequire("3RJ7R");

var $glNWE = parcelRequire("glNWE");

var $bMblX = parcelRequire("bMblX");

var $FQXY2 = parcelRequire("FQXY2");

var $23gLr = parcelRequire("23gLr");

var $lRLws = parcelRequire("lRLws");

var $chMCU = parcelRequire("chMCU");

var $9mhoi = parcelRequire("9mhoi");

var $emdrr = parcelRequire("emdrr");

var $5MGFf = parcelRequire("5MGFf");

var $3IZ9E = parcelRequire("3IZ9E");

var $c1CyL = parcelRequire("c1CyL");

var $hhjRL = parcelRequire("hhjRL");

var $hdeNY = parcelRequire("hdeNY");

var $fzouz = parcelRequire("fzouz");
const $31a59024c3f45e6f$export$9f72b02411896f7a = ({ onClick: onClick, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { update: update } = (0, $hhjRL.useOgConsolidationUserState)();
    const [{ activeContent: activeContent }] = (0, $3IZ9E.useProgressStore)();
    const isOptimalTooling = (0, $1ybV0.ff)('platform.show-optimal-tooling_brgom');
    const { src: floatingButtonSrc, xcssOverrides: xcssOverrides, stepDescription: stepDescription } = isOptimalTooling ? $31a59024c3f45e6f$var$floatingButtonAttributes[activeContent] : $31a59024c3f45e6f$var$floatingButtonAttributes[(0, $c1CyL.ProgressContents).Home];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: (0, $7gA9Z.TRANSITION_HOME_BUTTON_SPOTLIGHT_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        actionSubjectId: "eoc-changeboarding_transition_home_lozenge"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $31a59024c3f45e6f$var$buttonWrapperBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $31a59024c3f45e6f$var$outerBoxStyles,
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClick: !isLoading ? onClick : ()=>{},
        role: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        grow: "fill",
        alignInline: "start",
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: [
            $31a59024c3f45e6f$var$iconWrapperInlineStyles,
            ...xcssOverrides
        ],
        alignBlock: "center",
        alignInline: "center"
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
        src: floatingButtonSrc,
        width: 24,
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: stepDescription ? 'h200' : 'h400',
        as: "h2",
        color: "inverse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $fzouz.default).getStartedNonFinal)), stepDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.inverse",
        maxLines: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), stepDescription))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $31a59024c3f45e6f$var$closeButtonBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $fzouz.default).hideTransitionHomeNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": formatMessage((0, $fzouz.default).hideTransitionHomeNonFinal),
        spacing: "none",
        onClick: (e, analyticEvent)=>{
            e.stopPropagation();
            (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'dismissTransitionHomeButton');
            // If an error occurs, do nothing
            update({
                isTransitionHomeHidden: true
            }).catch((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))));
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: formatMessage((0, $fzouz.default).hideTransitionHomeNonFinal),
            primaryColor: "var(--ds-icon-inverse, white)",
            size: "small"
        }),
        appearance: "subtle"
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55pTl.EngagementSpotlight), {
        engagementId: (0, $7gA9Z.TRANSITION_HOME_BUTTON_SPOTLIGHT_NAME)
    }));
};
const $31a59024c3f45e6f$var$closeButtonBoxStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    right: 'space.250',
    top: 'space.250'
});
const $31a59024c3f45e6f$var$buttonWrapperBoxStyles = (0, $1ZAYh.xcss)({
    position: 'relative',
    width: '340px'
});
const $31a59024c3f45e6f$var$outerBoxStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.blue.bolder',
    padding: 'space.100',
    borderRadius: 'border.radius.circle',
    color: 'color.text.inverse',
    boxShadow: 'elevation.shadow.overlay',
    cursor: 'pointer',
    boxSizing: 'border-box',
    paddingRight: 'space.600',
    width: '100%'
});
const $31a59024c3f45e6f$var$iconWrapperInlineStyles = (0, $1ZAYh.xcss)({
    position: 'relative',
    flexShrink: 0,
    width: 'size.400',
    height: 'size.400',
    borderRadius: 'border.radius.circle',
    background: `${"var(--ds-background-accent-blue-subtlest, #E9F2FF)"}`,
    border: `2px solid ${`var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`}`,
    overflow: 'hidden'
});
const $31a59024c3f45e6f$var$orangeBackgroundStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.orange.subtler'
});
const $31a59024c3f45e6f$var$blueBackgroundStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.blue.subtler'
});
const $31a59024c3f45e6f$var$redSubtlerBackgroundStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.red.subtler'
});
const $31a59024c3f45e6f$var$redSubtlestBackgroundStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.red.subtlest'
});
const $31a59024c3f45e6f$var$yellowBackgroundStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.yellow.subtler'
});
const $31a59024c3f45e6f$var$yellowWarningBackgroundStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.warning'
});
const $31a59024c3f45e6f$var$blueSublestBackgroundStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.blue.subtlest'
});
const $31a59024c3f45e6f$var$opaqSublestBackgroundStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.gray.subtler'
});
const $31a59024c3f45e6f$var$floatingButtonAttributes = {
    [(0, $c1CyL.ProgressContents).Home]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hdeNY))),
        xcssOverrides: [],
        stepDescription: undefined
    },
    [(0, $c1CyL.ProgressContents).UsersAndRoles]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9mhoi))),
        xcssOverrides: [
            $31a59024c3f45e6f$var$blueBackgroundStyles
        ],
        stepDescription: (0, $5MGFf.messages).usersAndRolesTitleNonFinal
    },
    [(0, $c1CyL.ProgressContents).Alerts]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1askq))),
        xcssOverrides: [
            $31a59024c3f45e6f$var$orangeBackgroundStyles
        ],
        stepDescription: (0, $5MGFf.messages).alertsAndOnCallTitleNonFinal
    },
    [(0, $c1CyL.ProgressContents).Notifications]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($chMCU))),
        xcssOverrides: [
            $31a59024c3f45e6f$var$redSubtlerBackgroundStyles
        ],
        stepDescription: (0, $5MGFf.messages).notificationsTitleNonFinal
    },
    [(0, $c1CyL.ProgressContents).Teams]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($emdrr))),
        xcssOverrides: [
            $31a59024c3f45e6f$var$yellowBackgroundStyles
        ],
        stepDescription: (0, $5MGFf.messages).teamsTitleNonFinal
    },
    [(0, $c1CyL.ProgressContents).ChatTools]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3RJ7R))),
        xcssOverrides: [
            $31a59024c3f45e6f$var$blueSublestBackgroundStyles
        ],
        stepDescription: (0, $5MGFf.messages).chatToolsTitleNonFinal
    },
    [(0, $c1CyL.ProgressContents).AutomateAlertAndIncidentResponse]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8KYeC))),
        xcssOverrides: [
            $31a59024c3f45e6f$var$yellowWarningBackgroundStyles
        ],
        stepDescription: (0, $5MGFf.messages).automateAlertAndIncidentResponseTitleNonFinal
    },
    [(0, $c1CyL.ProgressContents).Integrations]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lRLws))),
        xcssOverrides: [
            $31a59024c3f45e6f$var$opaqSublestBackgroundStyles
        ],
        stepDescription: (0, $5MGFf.messages).integrationsTitleNonFinal
    },
    [(0, $c1CyL.ProgressContents).Find]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bMblX))),
        xcssOverrides: [
            $31a59024c3f45e6f$var$yellowBackgroundStyles
        ],
        stepDescription: (0, $5MGFf.messages).findWhatYouAreLookingForTitleNonFinal
    },
    [(0, $c1CyL.ProgressContents).DeprecatedOnes]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($glNWE))),
        xcssOverrides: [
            $31a59024c3f45e6f$var$redSubtlestBackgroundStyles
        ],
        stepDescription: (0, $5MGFf.messages).deprecatedOnesTitleNonFinal
    },
    [(0, $c1CyL.ProgressContents).Incidents]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($23gLr))),
        xcssOverrides: [
            $31a59024c3f45e6f$var$yellowBackgroundStyles
        ],
        stepDescription: (0, $5MGFf.messages).incidentsTitleNonFinal
    },
    [(0, $c1CyL.ProgressContents).Heartbeats]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($FQXY2))),
        xcssOverrides: [
            $31a59024c3f45e6f$var$blueSublestBackgroundStyles
        ],
        stepDescription: (0, $5MGFf.messages).heartbeatsTitleNonFinal
    }
};

});
parcelRegister("1askq", function(module, exports) {
module.exports = new URL("step-alerts.ab099e16.svg", import.meta.url).toString();

});

parcelRegister("8KYeC", function(module, exports) {
module.exports = new URL("step-automate-alert-and-incident-response.04583c29.svg", import.meta.url).toString();

});

parcelRegister("3RJ7R", function(module, exports) {
module.exports = new URL("step-chat-tools.459c0abf.svg", import.meta.url).toString();

});

parcelRegister("glNWE", function(module, exports) {
module.exports = new URL("step-deprecated-ones.cf47a65c.svg", import.meta.url).toString();

});

parcelRegister("bMblX", function(module, exports) {
module.exports = new URL("step-find-what-you-are-looking-for.38be2391.svg", import.meta.url).toString();

});

parcelRegister("FQXY2", function(module, exports) {
module.exports = new URL("step-heartbeats.5fa6a10d.svg", import.meta.url).toString();

});

parcelRegister("23gLr", function(module, exports) {
module.exports = new URL("step-incidents.bbada1c7.svg", import.meta.url).toString();

});

parcelRegister("lRLws", function(module, exports) {
module.exports = new URL("step-integrations.2c6dc384.svg", import.meta.url).toString();

});

parcelRegister("chMCU", function(module, exports) {
module.exports = new URL("step-notifications.0206673e.svg", import.meta.url).toString();

});

parcelRegister("9mhoi", function(module, exports) {
module.exports = new URL("step-permissions.1da1f2d5.svg", import.meta.url).toString();

});

parcelRegister("emdrr", function(module, exports) {
module.exports = new URL("step-teams-concept.3ee797f6.svg", import.meta.url).toString();

});

parcelRegister("5MGFf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3d4c5f16ad09ad4a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $3d4c5f16ad09ad4a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    notCompletedTaskCountNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.not-completed-task-count-non-final",
        "defaultMessage": "{count, plural, one {{count} task} other {{count} tasks}} left"
    },
    taskTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.task-title-non-final",
        "defaultMessage": "Things to do"
    },
    usersAndRolesTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.users-and-roles-title-non-final",
        "defaultMessage": "Users and roles"
    },
    usersAndRolesDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.users-and-roles-description-non-final",
        "defaultMessage": "Learn how to manage users and roles, and resolve any detected errors to ensure your team members have access to Jira Service Management."
    },
    alertsTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.alerts-title-non-final",
        "defaultMessage": "Alerts"
    },
    alertsAndOnCallTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.alerts-and-on-call-title-non-final",
        "defaultMessage": "Alerts and on-call"
    },
    alertsDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.alerts-description-non-final",
        "defaultMessage": "Check out what's new in the redesigned alerting experience in Jira Service Management."
    },
    notificationsTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.notifications-title-non-final",
        "defaultMessage": "Notifications"
    },
    notificationsDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.notifications-description-non-final",
        "defaultMessage": "Learn about the changes to your notifications, and set up Jira Cloud as your primary contact method for push notifications."
    },
    teamsTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.teams-title-non-final",
        "defaultMessage": "Launch operations for your team"
    },
    teamsDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.teams-description-non-final",
        "defaultMessage": "Discover how to launch and manage operations for your teams in Jira Service Management."
    },
    chatToolsTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.chat-tools-title-non-final",
        "defaultMessage": "Chat tools"
    },
    chatToolsDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.chat-tools-description-non-final",
        "defaultMessage": "Learn how chat tools help with alerting, and set up your Opsgenie chat integrations in Jira Service Management."
    },
    automateAlertAndIncidentResponseTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.automate-alert-and-incident-response-title-non-final",
        "defaultMessage": "Automate your alert and incident response"
    },
    automateAlertAndIncidentResponseDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.automate-alert-and-incident-response-description-non-final",
        "defaultMessage": "Learn how to set up automation for your alerts and incidents in Jira Service Management."
    },
    integrationsTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.integrations-title-non-final",
        "defaultMessage": "Integrations"
    },
    integrationsDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.integrations-description-non-final",
        "defaultMessage": "Learn where to find your alerting integrations and how to manage them in Jira Service Management."
    },
    deprecatedOnesTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.deprecated-ones-title-non-final",
        "defaultMessage": "What's left behind in Opsgenie"
    },
    deprecatedOnesDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.deprecated-ones-description-non-final",
        "defaultMessage": "Review which parts of Opsgenie aren't moving to Jira Service Management."
    },
    heartbeatsTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.heartbeats-title-non-final",
        "defaultMessage": "Heartbeats"
    },
    heartbeatsDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.heartbeats-description-non-final",
        "defaultMessage": "Learn how to manage your heartbeats in Jira Service Management."
    },
    findWhatYouAreLookingForTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.find-what-you-are-looking-for-title-non-final",
        "defaultMessage": "Find what you're looking for"
    },
    findWhatYouAreLookingForDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.find-what-you-are-looking-for-description-non-final",
        "defaultMessage": "View a list of shortcuts for you to quickly navigation between your operations work in Jira Service Management."
    },
    incidentsTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.incidents-title-non-final",
        "defaultMessage": "Incidents"
    },
    incidentsDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.incidents-description-non-final",
        "defaultMessage": "Check out how the incident management experience looks like in Jira Service Management."
    }
});

});

parcelRegister("hdeNY", function(module, exports) {
module.exports = new URL("left-icon.9d0fb470.svg", import.meta.url).toString();

});

parcelRegister("fzouz", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa5a0ec75776f50f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $aa5a0ec75776f50f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    getStartedNonFinal: {
        "id": "eoc-changeboarding.transition-home.transition-home-button.get-started-non-final",
        "defaultMessage": "Moving from Opsgenie"
    },
    hideTransitionHomeNonFinal: {
        "id": "eoc-changeboarding.transition-home.transition-home-button.hide-transition-home-non-final",
        "defaultMessage": "Hide guide"
    }
});

});


parcelRegister("kke6s", function(module, exports) {

$parcel$export(module.exports, "TransitionHomeModal", () => $ece27774e6d15709$export$164cefb24823017f);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $fyp42 = parcelRequire("fyp42");

var $l2ZYW = parcelRequire("l2ZYW");

var $dEoAQ = parcelRequire("dEoAQ");

var $aOw1G = parcelRequire("aOw1G");
var $dxopF = parcelRequire("dxopF");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $bm4CH = parcelRequire("bm4CH");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $5Etxm = parcelRequire("5Etxm");

var $3IZ9E = parcelRequire("3IZ9E");

var $c1CyL = parcelRequire("c1CyL");

var $59lwy = parcelRequire("59lwy");

var $hsqPc = parcelRequire("hsqPc");

var $4DyCL = parcelRequire("4DyCL");

var $42hEc = parcelRequire("42hEc");

var $1RgAi = parcelRequire("1RgAi");

var $gGnGU = parcelRequire("gGnGU");

var $585Wt = parcelRequire("585Wt");

var $68VJ0 = parcelRequire("68VJ0");

var $k1XvG = parcelRequire("k1XvG");

var $5owwq = parcelRequire("5owwq");

var $b0TOk = parcelRequire("b0TOk");

var $2TO9K = parcelRequire("2TO9K");

var $kG8k5 = parcelRequire("kG8k5");

var $hMEMz = parcelRequire("hMEMz");
const $ece27774e6d15709$var$GiveFeedbackButton = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { openEocFeedbackCollector: openEocFeedbackCollector } = (0, $bm4CH.useEocFeedbackCollector)();
    const onFeedbackButtonClick = (_, analyticEvent)=>{
        onClose();
        (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'eocGiveFeedbackButton');
        openEocFeedbackCollector({
            showTypeField: true,
            renderCustomContent: (0, $5Etxm.FeedbackCollectorDescription),
            feedbackTitle: formatMessage((0, $5owwq.default).giveFeedbackButtonNonFinal)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ece27774e6d15709$var$giveFeedbackBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l2ZYW))), {
            label: formatMessage((0, $5owwq.default).giveFeedbackButtonNonFinal),
            primaryColor: "var(--ds-icon-subtle, #626F86)"
        }),
        "aria-label": formatMessage((0, $5owwq.default).giveFeedbackButtonNonFinal),
        onClick: onFeedbackButtonClick
    }));
};
const $ece27774e6d15709$var$MinimizeButton = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ece27774e6d15709$var$closeFullScreenBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dEoAQ))), {
            label: formatMessage((0, $5owwq.default).minimizeNonFinal),
            primaryColor: "var(--ds-icon-subtle, #626F86)"
        }),
        "aria-label": formatMessage((0, $5owwq.default).closeButtonNonFinal),
        onClick: (_, analyticEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'closetransitionHome');
            onClose();
        }
    }));
};
const $ece27774e6d15709$export$164cefb24823017f = ({ isOpen: isOpen, onClose: onClose })=>{
    const [{ activeContent: activeContent, activeTask: activeTask }] = (0, $3IZ9E.useProgressStore)();
    const { backToHome: backToHome } = (0, $3IZ9E.useProgressActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (activeTask || activeTask === 0) {
            const nodes = document.querySelectorAll('.transition-home-content-box');
            const node = nodes[activeTask];
            if (node) node.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    }, [
        activeContent,
        activeTask
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: (e, analyticEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'transitionHome');
            onClose();
        },
        width: 1100,
        height: 700
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        grow: "fill",
        xcss: $ece27774e6d15709$var$inlineStyles
    }, activeContent === (0, $c1CyL.ProgressContents).Home ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k1XvG.TransitionHomeLeft), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2TO9K.TransitionHomeRight), null), (0, $1ybV0.ff)('enable-eoc-feedback-flow-for-cohort-3_3oqpa') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ece27774e6d15709$var$GiveFeedbackButton, {
        onClose: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ece27774e6d15709$var$MinimizeButton, {
        onClose: onClose
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ece27774e6d15709$var$stepLeftBoxStyles,
        padding: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fyp42))), {
            label: ""
        }),
        onClick: ()=>backToHome(activeContent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5owwq.default).backButtonNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        padding: "space.300",
        xcss: $ece27774e6d15709$var$stepsWrapperBoxStyles
    }, activeContent === (0, $c1CyL.ProgressContents).UsersAndRoles && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hMEMz.UsersAndRolesStep), null), activeContent === (0, $c1CyL.ProgressContents).Alerts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59lwy.AlertsStep), null), activeContent === (0, $c1CyL.ProgressContents).Notifications && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b0TOk.NotificationsStep), null), activeContent === (0, $c1CyL.ProgressContents).ChatTools && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4DyCL.ChatToolsStep), null), activeContent === (0, $c1CyL.ProgressContents).Teams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kG8k5.TeamsConceptStep), null), activeContent === (0, $c1CyL.ProgressContents).Integrations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $68VJ0.IntegrationsStep), null), activeContent === (0, $c1CyL.ProgressContents).AutomateAlertAndIncidentResponse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hsqPc.AutomateAlertAndIncidentResponseStep), null), activeContent === (0, $c1CyL.ProgressContents).Incidents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $585Wt.IncidentsStep), null), activeContent === (0, $c1CyL.ProgressContents).Heartbeats && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGnGU.HeartbeatsStep), null), activeContent === (0, $c1CyL.ProgressContents).Find && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1RgAi.FindStep), null), activeContent === (0, $c1CyL.ProgressContents).DeprecatedOnes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $42hEc.DeprecatedOnesStep), null), (0, $1ybV0.ff)('enable-eoc-feedback-flow-for-cohort-3_3oqpa') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ece27774e6d15709$var$GiveFeedbackButton, {
        onClose: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ece27774e6d15709$var$MinimizeButton, {
        onClose: onClose
    }))))));
};
const $ece27774e6d15709$var$stepLeftBoxStyles = (0, $1ZAYh.xcss)({
    width: '172px',
    flexShrink: 0
});
const $ece27774e6d15709$var$inlineStyles = (0, $1ZAYh.xcss)({
    height: '100%',
    position: 'relative'
});
const $ece27774e6d15709$var$closeFullScreenBoxStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    top: 'space.100',
    right: 'space.100'
});
const $ece27774e6d15709$var$giveFeedbackBoxStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    top: 'space.100',
    right: 'space.500'
});
const $ece27774e6d15709$var$stepsWrapperBoxStyles = (0, $1ZAYh.xcss)({
    position: 'relative',
    height: '100%',
    width: '100%',
    overflow: 'auto'
});

});
parcelRegister("l2ZYW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f529dd351378d429$var$_react = $f529dd351378d429$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $f529dd351378d429$var$_feedback = $f529dd351378d429$var$_interopRequireDefault((parcelRequire("3kIcQ")));
function $f529dd351378d429$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $f529dd351378d429$var$FeedbackIcon = (props)=>/*#__PURE__*/ $f529dd351378d429$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $f529dd351378d429$var$_feedback.default
    }));
$f529dd351378d429$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $f529dd351378d429$var$_default = module.exports.default = $f529dd351378d429$var$FeedbackIcon;

});
parcelRegister("3kIcQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26d587cb75b7e288$var$_react = $26d587cb75b7e288$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $26d587cb75b7e288$var$_UNSAFE_baseNew = $26d587cb75b7e288$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $26d587cb75b7e288$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Feedback".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $26d587cb75b7e288$var$FeedbackIcon = (props)=>/*#__PURE__*/ $26d587cb75b7e288$var$_react.default.createElement($26d587cb75b7e288$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 7H3c-.69 0-1.25-.56-1.25-1.25V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H6L1.75 15V9.5"/><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="m7.75 4.5 2.5 2.5-2.5 2.5"/>`
    }, props));
$26d587cb75b7e288$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $26d587cb75b7e288$var$_default = module.exports.default = $26d587cb75b7e288$var$FeedbackIcon;

});


parcelRegister("dEoAQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f02168594689cb7$var$_react = $9f02168594689cb7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9f02168594689cb7$var$_minimize = $9f02168594689cb7$var$_interopRequireDefault((parcelRequire("wWCFp")));
function $9f02168594689cb7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9f02168594689cb7$var$VidFullScreenOffIcon = (props)=>/*#__PURE__*/ $9f02168594689cb7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path fill-rule="nonzero" d="M9 15.003v2.995a1 1 0 1 0 2 0v-3.896C11 13.494 10.507 13 9.9 13H6a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M3.74 20.294a.997.997 0 0 0 1.407.005l5.152-5.152a1 1 0 0 0-.005-1.407l-.034-.034a.997.997 0 0 0-1.407-.005l-5.152 5.152a1 1 0 0 0 .005 1.407z"/><path d="M19.067 3.321 13.32 9.066a1.115 1.115 0 0 0 .005 1.57l.036.037a1.11 1.11 0 0 0 1.571.005l5.747-5.744a1.116 1.116 0 0 0-.006-1.57l-.037-.037a1.117 1.117 0 0 0-1.57-.006"/><path d="M13 6.002v3.896c0 .608.493 1.102 1.1 1.102H18a1 1 0 0 0 0-2.003h-3V6.002a1 1 0 1 0-2 0"/></g></svg>`
    }, props, {
        newIcon: $9f02168594689cb7$var$_minimize.default
    }));
$9f02168594689cb7$var$VidFullScreenOffIcon.displayName = 'VidFullScreenOffIcon';
var $9f02168594689cb7$var$_default = module.exports.default = $9f02168594689cb7$var$VidFullScreenOffIcon;

});
parcelRegister("wWCFp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0630768335388462$var$_react = $0630768335388462$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $0630768335388462$var$_UNSAFE_baseNew = $0630768335388462$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $0630768335388462$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Minimize".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Known uses: minimize modal window, minimize panel, minimize video screen.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0630768335388462$var$MinimizeIcon = (props)=>/*#__PURE__*/ $0630768335388462$var$_react.default.createElement($0630768335388462$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 14.5 5.25-5.25M14.5 1.5 9.25 6.75M6.75 14V9.25H2M9.25 2v4.75H14"/>`
    }, props));
$0630768335388462$var$MinimizeIcon.displayName = 'MinimizeIcon';
var $0630768335388462$var$_default = module.exports.default = $0630768335388462$var$MinimizeIcon;

});


parcelRegister("bm4CH", function(module, exports) {

$parcel$export(module.exports, "useEocFeedbackCollector", () => $a08f45b7114012c7$export$6c2ca7ac39b8ab80);

var $1c02D = parcelRequire("1c02D");
var $irg9D = parcelRequire("irg9D");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $5Yzlw = parcelRequire("5Yzlw");

var $gd0Sp = parcelRequire("gd0Sp");


var $cTHUM = parcelRequire("cTHUM");
const $a08f45b7114012c7$export$6c2ca7ac39b8ab80 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin, appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    const [{ route: { name: name, path: path } }] = (0, $5Yzlw.useRouter)();
    return {
        openEocFeedbackCollector: (options)=>{
            openFeedbackCollector({
                showTypeField: false,
                feedbackTitle: formatMessage((0, $cTHUM.messages).modalTitle),
                summaryPlaceholder: formatMessage((0, $cTHUM.messages).feedbackInputPlaceholder),
                // @ts-expect-error: Object literal may only specify known properties, and 'customTextAreaLabel' does not exist in type 'FeedbackCollectorProps'.ts(2345)
                customTextAreaLabel: formatMessage((0, $cTHUM.messages).feedbackInputLabel),
                ...options,
                entrypointId: (0, $b150ac4935ed554a$export$8c3fe078bd6c888e),
                onSubmit: ()=>{
                    // https://data-portal.internal.atlassian.com/analytics/registry/62661
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                        actionSubject: 'eocFeedbackCollectorModal',
                        action: 'submitted'
                    }));
                },
                feedbackContext: [
                    {
                        id: (0, $1c02D.EntryKeys).IS_ADMIN,
                        value: isAdmin
                    },
                    {
                        id: (0, $1c02D.EntryKeys).IS_SITE_ADMIN,
                        value: isSiteAdmin
                    },
                    {
                        id: (0, $1c02D.EntryKeys).EDITION,
                        value: appEditions.serviceDesk
                    },
                    {
                        id: (0, $1c02D.EntryKeys).ROUTE_NAME,
                        value: name
                    },
                    {
                        id: (0, $1c02D.EntryKeys).LOCATION,
                        value: path
                    }
                ]
            });
        }
    };
};

});
const $b150ac4935ed554a$export$8c3fe078bd6c888e = '07551bfc-5486-4265-b9fa-7e540430b3fd';

parcelRegister("cTHUM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a81eb417af11844d$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a81eb417af11844d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    modalTitle: {
        "id": "eoc-feedback-collector.modal-title",
        "defaultMessage": "Share your feedback with us"
    },
    feedbackInputPlaceholder: {
        "id": "eoc-feedback-collector.feedback-input-placeholder",
        "defaultMessage": "We'd love to know what you like, what you dislike, and what you want to change."
    },
    feedbackInputLabel: {
        "id": "eoc-feedback-collector.feedback-input-label",
        "defaultMessage": "Tell us what's on your mind"
    }
});

});


parcelRegister("5Etxm", function(module, exports) {

$parcel$export(module.exports, "FeedbackCollectorDescription", () => $761932a802be966f$export$5881447fa4ef232a);

var $eUqFw = parcelRequire("eUqFw");

var $5OdZ3 = parcelRequire("5OdZ3");

var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $joXuE = parcelRequire("joXuE");
const $761932a802be966f$export$5881447fa4ef232a = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        xcss: $761932a802be966f$var$feedbackCollectorDescriptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $joXuE.messages).descriptionNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $joXuE.messages).learnMoreNonFinal, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OdZ3.default), {
                href: "/"
            }, chunks)
    })));
};
const $761932a802be966f$var$feedbackCollectorDescriptionStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.300'
});

});
parcelRegister("joXuE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $660d541b98a493ae$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $660d541b98a493ae$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    descriptionNonFinal: {
        "id": "eoc-changeboarding.common.feedback-collector-description.description-non-final",
        "defaultMessage": "Your thoughts are valuable in helping improve our products."
    },
    learnMoreNonFinal: {
        "id": "eoc-changeboarding.common.feedback-collector-description.learn-more-non-final",
        "defaultMessage": "If you're looking to get help or want to report a bug, visit our <link>support site</link>."
    }
});

});


parcelRegister("59lwy", function(module, exports) {

$parcel$export(module.exports, "AlertsStep", () => $f7ae3520b5a2410e$export$d4500eed718a362b);

var $eUqFw = parcelRequire("eUqFw");

var $27B3S = parcelRequire("27B3S");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $jG1wZ = parcelRequire("jG1wZ");

var $iFmgL = parcelRequire("iFmgL");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jeqlo = parcelRequire("jeqlo");

var $220rR = parcelRequire("220rR");

var $5MGFf = parcelRequire("5MGFf");

var $gVzxN = parcelRequire("gVzxN");

var $kPl8l = parcelRequire("kPl8l");

var $icAmO = parcelRequire("icAmO");

var $dOFaH = parcelRequire("dOFaH");

var $fP12C = parcelRequire("fP12C");
const $f7ae3520b5a2410e$var$Bold = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "strong"
    }, children, " ", children?.[0] === 'More actions' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
        size: "small",
        label: ""
    }));
const $f7ae3520b5a2410e$export$d4500eed718a362b = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isOptimalTooling = (0, $1ybV0.ff)('platform.show-optimal-tooling_brgom');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220rR.TransitionHomeHeader), {
        title: isOptimalTooling ? formatMessage((0, $5MGFf.messages).alertsAndOnCallTitleNonFinal) : formatMessage((0, $5MGFf.messages).alertsTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).alertsDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).alertsTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $fP12C.messages).taskOneDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: "/jira/ops/alerts",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $fP12C.messages).taskOneButtonNonFinal))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dOFaH))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($icAmO))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).alertsTaskTwoNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), {
        options: {
            overrides: {
                strong: {
                    component: $f7ae3520b5a2410e$var$Bold
                }
            }
        }
    }, formatMessage((0, $fP12C.messages).taskTwoDescriptionNonFinal))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).alertsTaskThreeNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $fP12C.messages).taskThreeDescriptionNonFinal))))), isOptimalTooling && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            // todo: change the illustration when dark mode is ready
            src: (0, (/*@__PURE__*/$parcel$interopDefault($kPl8l))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($kPl8l))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $gVzxN.default).alertsTaskFourNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $fP12C.messages).taskFourDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: "/jira/ops/who-is-on-call",
        target: "_blank"
    }, formatMessage((0, $fP12C.messages).taskFourButtonNonFinal)))))));
};

});
parcelRegister("27B3S", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b8fbd7df5541f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $18b8fbd7df5541f7$var$n() {
    return $18b8fbd7df5541f7$var$n = Object.assign ? Object.assign.bind() : function(e) {
        for(var n = 1; n < arguments.length; n++){
            var t = arguments[n];
            for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
        return e;
    }, $18b8fbd7df5541f7$var$n.apply(this, arguments);
}
const $18b8fbd7df5541f7$var$t = [
    "children",
    "options"
];
var $18b8fbd7df5541f7$export$e0aa44767d8750d5, $18b8fbd7df5541f7$var$i;
!function(e) {
    e.blockQuote = "0", e.breakLine = "1", e.breakThematic = "2", e.codeBlock = "3", e.codeFenced = "4", e.codeInline = "5", e.footnote = "6", e.footnoteReference = "7", e.gfmTask = "8", e.heading = "9", e.headingSetext = "10", e.htmlBlock = "11", e.htmlComment = "12", e.htmlSelfClosing = "13", e.image = "14", e.link = "15", e.linkAngleBraceStyleDetector = "16", e.linkBareUrlDetector = "17", e.linkMailtoDetector = "18", e.newlineCoalescer = "19", e.orderedList = "20", e.paragraph = "21", e.ref = "22", e.refImage = "23", e.refLink = "24", e.table = "25", e.tableSeparator = "26", e.text = "27", e.textBolded = "28", e.textEmphasized = "29", e.textEscaped = "30", e.textMarked = "31", e.textStrikethroughed = "32", e.unorderedList = "33";
}($18b8fbd7df5541f7$export$e0aa44767d8750d5 || ($18b8fbd7df5541f7$export$e0aa44767d8750d5 = {})), function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($18b8fbd7df5541f7$var$i || ($18b8fbd7df5541f7$var$i = {}));
const $18b8fbd7df5541f7$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, n)=>(e[n.toLowerCase()] = n, e), {
    for: "htmlFor"
}), $18b8fbd7df5541f7$var$o = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $18b8fbd7df5541f7$var$c = [
    "style",
    "script"
], $18b8fbd7df5541f7$var$a = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $18b8fbd7df5541f7$var$s = /mailto:/i, $18b8fbd7df5541f7$var$d = /\n{2,}$/, $18b8fbd7df5541f7$var$u = /^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/, $18b8fbd7df5541f7$var$p = /^ *> ?/gm, $18b8fbd7df5541f7$var$f = /^ {2,}\n/, $18b8fbd7df5541f7$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $18b8fbd7df5541f7$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $18b8fbd7df5541f7$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $18b8fbd7df5541f7$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $18b8fbd7df5541f7$var$k = /^(?:\n *)*\n/, $18b8fbd7df5541f7$var$x = /\r\n?/g, $18b8fbd7df5541f7$var$v = /^\[\^([^\]]+)](:.*)\n/, $18b8fbd7df5541f7$var$b = /^\[\^([^\]]+)]/, $18b8fbd7df5541f7$var$$ = /\f/g, $18b8fbd7df5541f7$var$S = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $18b8fbd7df5541f7$var$w = /^\s*?\[(x|\s)\]/, $18b8fbd7df5541f7$var$C = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $18b8fbd7df5541f7$var$E = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $18b8fbd7df5541f7$var$A = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $18b8fbd7df5541f7$var$O = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i, $18b8fbd7df5541f7$var$T = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $18b8fbd7df5541f7$var$L = /^<!--[\s\S]*?(?:-->)/, $18b8fbd7df5541f7$var$z = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $18b8fbd7df5541f7$var$M = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $18b8fbd7df5541f7$var$I = /^\{.*\}$/, $18b8fbd7df5541f7$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $18b8fbd7df5541f7$var$U = /^<([^ >]+@[^ >]+)>/, $18b8fbd7df5541f7$var$j = /^<([^ >]+:\/[^ >]+)>/, $18b8fbd7df5541f7$var$B = /-([a-z])?/gi, $18b8fbd7df5541f7$var$N = /^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/, $18b8fbd7df5541f7$var$H = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $18b8fbd7df5541f7$var$D = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $18b8fbd7df5541f7$var$P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $18b8fbd7df5541f7$var$_ = /(\[|\])/g, $18b8fbd7df5541f7$var$F = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $18b8fbd7df5541f7$var$W = /\t/g, $18b8fbd7df5541f7$var$G = /^ *\| */, $18b8fbd7df5541f7$var$Z = /(^ *\||\| *$)/g, $18b8fbd7df5541f7$var$q = / *$/, $18b8fbd7df5541f7$var$V = /^ *:-+: *$/, $18b8fbd7df5541f7$var$X = /^ *:-+ *$/, $18b8fbd7df5541f7$var$Q = /^ *-+: *$/, $18b8fbd7df5541f7$var$J = /^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/, $18b8fbd7df5541f7$var$K = /^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1|\w)/, $18b8fbd7df5541f7$var$Y = /^==((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)==/, $18b8fbd7df5541f7$var$ee = /^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/, $18b8fbd7df5541f7$var$ne = /^\\([^0-9A-Za-z\s])/, $18b8fbd7df5541f7$var$te = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $18b8fbd7df5541f7$var$re = /^\n+/, $18b8fbd7df5541f7$var$ie = /^([ \t]*)/, $18b8fbd7df5541f7$var$le = /\\([^\\])/g, $18b8fbd7df5541f7$var$oe = / *\n+$/, $18b8fbd7df5541f7$var$ce = /(?:^|\n)( *)$/, $18b8fbd7df5541f7$var$ae = "(?:\\d+\\.)", $18b8fbd7df5541f7$var$se = "(?:[*+-])";
function $18b8fbd7df5541f7$var$de(e) {
    return "( *)(" + (1 === e ? $18b8fbd7df5541f7$var$ae : $18b8fbd7df5541f7$var$se) + ") +";
}
const $18b8fbd7df5541f7$var$ue = $18b8fbd7df5541f7$var$de(1), $18b8fbd7df5541f7$var$pe = $18b8fbd7df5541f7$var$de(2);
function $18b8fbd7df5541f7$var$fe(e) {
    return new RegExp("^" + (1 === e ? $18b8fbd7df5541f7$var$ue : $18b8fbd7df5541f7$var$pe));
}
const $18b8fbd7df5541f7$var$he = $18b8fbd7df5541f7$var$fe(1), $18b8fbd7df5541f7$var$me = $18b8fbd7df5541f7$var$fe(2);
function $18b8fbd7df5541f7$var$ge(e) {
    return new RegExp("^" + (1 === e ? $18b8fbd7df5541f7$var$ue : $18b8fbd7df5541f7$var$pe) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $18b8fbd7df5541f7$var$ae : $18b8fbd7df5541f7$var$se) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $18b8fbd7df5541f7$var$ye = $18b8fbd7df5541f7$var$ge(1), $18b8fbd7df5541f7$var$ke = $18b8fbd7df5541f7$var$ge(2);
function $18b8fbd7df5541f7$var$xe(e) {
    const n = 1 === e ? $18b8fbd7df5541f7$var$ae : $18b8fbd7df5541f7$var$se;
    return new RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
const $18b8fbd7df5541f7$var$ve = $18b8fbd7df5541f7$var$xe(1), $18b8fbd7df5541f7$var$be = $18b8fbd7df5541f7$var$xe(2);
function $18b8fbd7df5541f7$var$$e(e, n) {
    const t = 1 === n, r = t ? $18b8fbd7df5541f7$var$ve : $18b8fbd7df5541f7$var$be, i = t ? $18b8fbd7df5541f7$var$ye : $18b8fbd7df5541f7$var$ke, l = t ? $18b8fbd7df5541f7$var$he : $18b8fbd7df5541f7$var$me;
    return {
        match (e, n, t) {
            const i = $18b8fbd7df5541f7$var$ce.exec(t);
            return i && (n.list || !n.inline && !n.simple) ? r.exec(e = i[1] + e) : null;
        },
        order: 1,
        parse (e, n, r) {
            const o = t ? +e[2] : void 0, c = e[0].replace($18b8fbd7df5541f7$var$d, "\n").match(i);
            let a = !1;
            return {
                items: c.map(function(e, t) {
                    const i = l.exec(e)[0].length, o = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(o, "").replace(l, ""), d = t === c.length - 1, u = -1 !== s.indexOf("\n\n") || d && a;
                    a = u;
                    const p = r.inline, f = r.list;
                    let h;
                    r.list = !0, u ? (r.inline = !1, h = s.replace($18b8fbd7df5541f7$var$oe, "\n\n")) : (r.inline = !0, h = s.replace($18b8fbd7df5541f7$var$oe, ""));
                    const m = n(h, r);
                    return r.inline = p, r.list = f, m;
                }),
                ordered: t,
                start: o
            };
        },
        render: (n, t, r)=>e(n.ordered ? "ol" : "ul", {
                key: r.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, i) {
                return e("li", {
                    key: i
                }, t(n, r));
            }))
    };
}
const $18b8fbd7df5541f7$var$Se = /^\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $18b8fbd7df5541f7$var$we = /^!\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $18b8fbd7df5541f7$var$Ce = [
    $18b8fbd7df5541f7$var$u,
    $18b8fbd7df5541f7$var$m,
    $18b8fbd7df5541f7$var$g,
    $18b8fbd7df5541f7$var$C,
    $18b8fbd7df5541f7$var$A,
    $18b8fbd7df5541f7$var$E,
    $18b8fbd7df5541f7$var$L,
    $18b8fbd7df5541f7$var$N,
    $18b8fbd7df5541f7$var$ye,
    $18b8fbd7df5541f7$var$ve,
    $18b8fbd7df5541f7$var$ke,
    $18b8fbd7df5541f7$var$be
], $18b8fbd7df5541f7$var$Ee = [
    ...$18b8fbd7df5541f7$var$Ce,
    /^[^\n]+(?:  \n|\n{2,})/,
    $18b8fbd7df5541f7$var$O,
    $18b8fbd7df5541f7$var$M
];
function $18b8fbd7df5541f7$var$Ae(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $18b8fbd7df5541f7$var$Oe(e) {
    return $18b8fbd7df5541f7$var$Q.test(e) ? "right" : $18b8fbd7df5541f7$var$V.test(e) ? "center" : $18b8fbd7df5541f7$var$X.test(e) ? "left" : null;
}
function $18b8fbd7df5541f7$var$Te(e, n, t) {
    const r = t.inTable;
    t.inTable = !0;
    const i = n(e.trim(), t);
    t.inTable = r;
    let l = [
        []
    ];
    return i.forEach(function(e, n) {
        "26" === e.type ? 0 !== n && n !== i.length - 1 && l.push([]) : ("27" !== e.type || null != i[n + 1] && "26" !== i[n + 1].type || (e.text = e.text.replace($18b8fbd7df5541f7$var$q, "")), l[l.length - 1].push(e));
    }), l;
}
function $18b8fbd7df5541f7$var$Le(e, n, t) {
    t.inline = !0;
    const r = $18b8fbd7df5541f7$var$Te(e[1], n, t), i = e[2].replace($18b8fbd7df5541f7$var$Z, "").split("|").map($18b8fbd7df5541f7$var$Oe), l = function(e, n, t) {
        return e.trim().split("\n").map(function(e) {
            return $18b8fbd7df5541f7$var$Te(e, n, t);
        });
    }(e[3], n, t);
    return t.inline = !1, {
        align: i,
        cells: l,
        header: r,
        type: "25"
    };
}
function $18b8fbd7df5541f7$var$ze(e, n) {
    return null == e.align[n] ? {} : {
        textAlign: e.align[n]
    };
}
function $18b8fbd7df5541f7$var$Me(e) {
    return function(n, t) {
        return t.inline ? e.exec(n) : null;
    };
}
function $18b8fbd7df5541f7$var$Ie(e) {
    return function(n, t) {
        return t.inline || t.simple ? e.exec(n) : null;
    };
}
function $18b8fbd7df5541f7$var$Re(e) {
    return function(n, t) {
        return t.inline || t.simple ? null : e.exec(n);
    };
}
function $18b8fbd7df5541f7$var$Ue(e) {
    return function(n) {
        return e.exec(n);
    };
}
function $18b8fbd7df5541f7$var$je(e, n, t) {
    if (n.inline || n.simple) return null;
    if (t && !t.endsWith("\n")) return null;
    let r = "";
    e.split("\n").every((e)=>!$18b8fbd7df5541f7$var$Ce.some((n)=>n.test(e)) && (r += e + "\n", e.trim()));
    const i = r.trimEnd();
    return "" == i ? null : [
        r,
        i
    ];
}
function $18b8fbd7df5541f7$var$Be(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return;
    } catch (e) {
        return null;
    }
    return e;
}
function $18b8fbd7df5541f7$var$Ne(e) {
    return e.replace($18b8fbd7df5541f7$var$le, "$1");
}
function $18b8fbd7df5541f7$var$He(e, n, t) {
    const r = t.inline || !1, i = t.simple || !1;
    t.inline = !0, t.simple = !0;
    const l = e(n, t);
    return t.inline = r, t.simple = i, l;
}
function $18b8fbd7df5541f7$var$De(e, n, t) {
    const r = t.inline || !1, i = t.simple || !1;
    t.inline = !1, t.simple = !0;
    const l = e(n, t);
    return t.inline = r, t.simple = i, l;
}
function $18b8fbd7df5541f7$var$Pe(e, n, t) {
    return t.inline = !1, e(n, t);
}
const $18b8fbd7df5541f7$var$_e = (e, n, t)=>({
        children: $18b8fbd7df5541f7$var$He(n, e[1], t)
    });
function $18b8fbd7df5541f7$var$Fe() {
    return {};
}
function $18b8fbd7df5541f7$var$We() {
    return null;
}
function $18b8fbd7df5541f7$var$Ge(...e) {
    return e.filter(Boolean).join(" ");
}
function $18b8fbd7df5541f7$var$Ze(e, n, t) {
    let r = e;
    const i = n.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || t;
}
function $18b8fbd7df5541f7$export$69f434acfbdb0b32(t, r = {}) {
    r.overrides = r.overrides || {}, r.slugify = r.slugify || $18b8fbd7df5541f7$var$Ae, r.namedCodesToUnicode = r.namedCodesToUnicode ? $18b8fbd7df5541f7$var$n({}, $18b8fbd7df5541f7$var$o, r.namedCodesToUnicode) : $18b8fbd7df5541f7$var$o;
    const i = r.createElement || $eUqFw.createElement;
    function d(e, t, ...l) {
        const o = $18b8fbd7df5541f7$var$Ze(r.overrides, `${e}.props`, {});
        return i(function(e, n) {
            const t = $18b8fbd7df5541f7$var$Ze(n, e);
            return t ? "function" == typeof t || "object" == typeof t && "render" in t ? t : $18b8fbd7df5541f7$var$Ze(n, `${e}.component`, e) : e;
        }(e, r.overrides), $18b8fbd7df5541f7$var$n({}, t, o, {
            className: $18b8fbd7df5541f7$var$Ge(null == t ? void 0 : t.className, o.className) || void 0
        }), ...l);
    }
    function Z(n) {
        n = n.replace($18b8fbd7df5541f7$var$S, "");
        let t = !1;
        r.forceInline ? t = !0 : r.forceBlock || (t = !1 === $18b8fbd7df5541f7$var$F.test(n));
        const i = oe(le(t ? n : `${n.trimEnd().replace($18b8fbd7df5541f7$var$re, "")}\n\n`, {
            inline: t
        }));
        for(; "string" == typeof i[i.length - 1] && !i[i.length - 1].trim();)i.pop();
        if (null === r.wrapper) return i;
        const l = r.wrapper || (t ? "span" : "div");
        let o;
        if (i.length > 1 || r.forceWrapper) o = i;
        else {
            if (1 === i.length) return o = i[0], "string" == typeof o ? d("span", {
                key: "outer"
            }, o) : o;
            o = null;
        }
        return $eUqFw.createElement(l, {
            key: "outer"
        }, o);
    }
    function q(n) {
        const t = n.match($18b8fbd7df5541f7$var$a);
        return t ? t.reduce(function(n, t, r) {
            const i = t.indexOf("=");
            if (-1 !== i) {
                const o = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($18b8fbd7df5541f7$var$z) && (e = e.replace($18b8fbd7df5541f7$var$B, function(e, n) {
                        return n.toUpperCase();
                    })), e;
                })(t.slice(0, i)).trim(), c = function(e) {
                    const n = e[0];
                    return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
                }(t.slice(i + 1).trim()), a = $18b8fbd7df5541f7$var$l[o] || o, s = n[a] = function(e, n) {
                    return "style" === e ? n.split(/;\s?/).reduce(function(e, n) {
                        const t = n.slice(0, n.indexOf(":"));
                        return e[t.replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = n.slice(t.length + 1).trim(), e;
                    }, {}) : "href" === e || "src" === e ? $18b8fbd7df5541f7$var$Be(n) : (n.match($18b8fbd7df5541f7$var$I) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(o, c);
                "string" == typeof s && ($18b8fbd7df5541f7$var$O.test(s) || $18b8fbd7df5541f7$var$M.test(s)) && (n[a] = $eUqFw.cloneElement(Z(s.trim()), {
                    key: r
                }));
            } else "style" !== t && (n[$18b8fbd7df5541f7$var$l[t] || t] = !0);
            return n;
        }, {}) : null;
    }
    const V = [], X = {}, Q = {
        0: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$u),
            order: 1,
            parse: (e, n, t)=>({
                    children: n(e[0].replace($18b8fbd7df5541f7$var$p, ""), t)
                }),
            render: (e, n, t)=>d("blockquote", {
                    key: t.key
                }, n(e.children, t))
        },
        1: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$f),
            order: 1,
            parse: $18b8fbd7df5541f7$var$Fe,
            render: (e, n, t)=>d("br", {
                    key: t.key
                })
        },
        2: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$h),
            order: 1,
            parse: $18b8fbd7df5541f7$var$Fe,
            render: (e, n, t)=>d("hr", {
                    key: t.key
                })
        },
        3: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, t, r)=>d("pre", {
                    key: r.key
                }, d("code", $18b8fbd7df5541f7$var$n({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        4: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: q(e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: "3"
                })
        },
        5: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, n, t)=>d("code", {
                    key: t.key
                }, e.text)
        },
        6: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$v),
            order: 0,
            parse: (e)=>(V.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $18b8fbd7df5541f7$var$We
        },
        7: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$b),
            order: 1,
            parse: (e)=>({
                    target: `#${r.slugify(e[1])}`,
                    text: e[1]
                }),
            render: (e, n, t)=>d("a", {
                    key: t.key,
                    href: $18b8fbd7df5541f7$var$Be(e.target)
                }, d("sup", {
                    key: t.key
                }, e.text))
        },
        8: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$w),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, n, t)=>d("input", {
                    checked: e.completed,
                    key: t.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        9: {
            match: $18b8fbd7df5541f7$var$Re(r.enforceAtxHeadings ? $18b8fbd7df5541f7$var$E : $18b8fbd7df5541f7$var$C),
            order: 1,
            parse: (e, n, t)=>({
                    children: $18b8fbd7df5541f7$var$He(n, e[2], t),
                    id: r.slugify(e[2]),
                    level: e[1].length
                }),
            render: (e, n, t)=>d(`h${e.level}`, {
                    id: e.id,
                    key: t.key
                }, n(e.children, t))
        },
        10: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$A),
            order: 0,
            parse: (e, n, t)=>({
                    children: $18b8fbd7df5541f7$var$He(n, e[1], t),
                    level: "=" === e[2] ? 1 : 2,
                    type: "9"
                })
        },
        11: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$O),
            order: 1,
            parse (e, n, t) {
                const [, r] = e[3].match($18b8fbd7df5541f7$var$ie), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), o = (a = l, $18b8fbd7df5541f7$var$Ee.some((e)=>e.test(a)) ? $18b8fbd7df5541f7$var$Pe : $18b8fbd7df5541f7$var$He);
                var a;
                const s = e[1].toLowerCase(), d = -1 !== $18b8fbd7df5541f7$var$c.indexOf(s), u = {
                    attrs: q(e[2]),
                    noInnerParse: d,
                    tag: d ? s : e[1]
                };
                return t.inAnchor = t.inAnchor || "a" === s, d ? u.text = e[3] : u.children = o(n, l, t), t.inAnchor = !1, u;
            },
            render: (e, t, r)=>d(e.tag, $18b8fbd7df5541f7$var$n({
                    key: r.key
                }, e.attrs), e.text || t(e.children, r))
        },
        13: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$M),
            order: 1,
            parse: (e)=>({
                    attrs: q(e[2] || ""),
                    tag: e[1]
                }),
            render: (e, t, r)=>d(e.tag, $18b8fbd7df5541f7$var$n({}, e.attrs, {
                    key: r.key
                }))
        },
        12: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$L),
            order: 1,
            parse: ()=>({}),
            render: $18b8fbd7df5541f7$var$We
        },
        14: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$we),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $18b8fbd7df5541f7$var$Ne(e[2]),
                    title: e[3]
                }),
            render: (e, n, t)=>d("img", {
                    key: t.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: $18b8fbd7df5541f7$var$Be(e.target)
                })
        },
        15: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$Se),
            order: 3,
            parse: (e, n, t)=>({
                    children: $18b8fbd7df5541f7$var$De(n, e[1], t),
                    target: $18b8fbd7df5541f7$var$Ne(e[2]),
                    title: e[3]
                }),
            render: (e, n, t)=>d("a", {
                    key: t.key,
                    href: $18b8fbd7df5541f7$var$Be(e.target),
                    title: e.title
                }, n(e.children, t))
        },
        16: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$j),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: "27"
                        }
                    ],
                    target: e[1],
                    type: "15"
                })
        },
        17: {
            match: (e, n)=>n.inAnchor ? null : $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$R)(e, n),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: "27"
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: "15"
                })
        },
        18: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$U),
            order: 0,
            parse (e) {
                let n = e[1], t = e[1];
                return $18b8fbd7df5541f7$var$s.test(t) || (t = "mailto:" + t), {
                    children: [
                        {
                            text: n.replace("mailto:", ""),
                            type: "27"
                        }
                    ],
                    target: t,
                    type: "15"
                };
            }
        },
        20: $18b8fbd7df5541f7$var$$e(d, 1),
        33: $18b8fbd7df5541f7$var$$e(d, 2),
        19: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$k),
            order: 3,
            parse: $18b8fbd7df5541f7$var$Fe,
            render: ()=>"\n"
        },
        21: {
            match: $18b8fbd7df5541f7$var$je,
            order: 3,
            parse: $18b8fbd7df5541f7$var$_e,
            render: (e, n, t)=>d("p", {
                    key: t.key
                }, n(e.children, t))
        },
        22: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$H),
            order: 0,
            parse: (e)=>(X[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $18b8fbd7df5541f7$var$We
        },
        23: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$D),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, n, t)=>d("img", {
                    key: t.key,
                    alt: e.alt,
                    src: $18b8fbd7df5541f7$var$Be(X[e.ref].target),
                    title: X[e.ref].title
                })
        },
        24: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$P),
            order: 0,
            parse: (e, n, t)=>({
                    children: n(e[1], t),
                    fallbackChildren: n(e[0].replace($18b8fbd7df5541f7$var$_, "\\$1"), t),
                    ref: e[2]
                }),
            render: (e, n, t)=>X[e.ref] ? d("a", {
                    key: t.key,
                    href: $18b8fbd7df5541f7$var$Be(X[e.ref].target),
                    title: X[e.ref].title
                }, n(e.children, t)) : d("span", {
                    key: t.key
                }, n(e.fallbackChildren, t))
        },
        25: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$N),
            order: 1,
            parse: $18b8fbd7df5541f7$var$Le,
            render: (e, n, t)=>d("table", {
                    key: t.key
                }, d("thead", null, d("tr", null, e.header.map(function(r, i) {
                    return d("th", {
                        key: i,
                        style: $18b8fbd7df5541f7$var$ze(e, i)
                    }, n(r, t));
                }))), d("tbody", null, e.cells.map(function(r, i) {
                    return d("tr", {
                        key: i
                    }, r.map(function(r, i) {
                        return d("td", {
                            key: i,
                            style: $18b8fbd7df5541f7$var$ze(e, i)
                        }, n(r, t));
                    }));
                })))
        },
        26: {
            match: function(e, n) {
                return n.inTable ? (n.inline = !0, $18b8fbd7df5541f7$var$G.exec(e)) : null;
            },
            order: 1,
            parse: function() {
                return {
                    type: "26"
                };
            },
            render: ()=>" | "
        },
        27: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$te),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($18b8fbd7df5541f7$var$T, (e, n)=>r.namedCodesToUnicode[n] ? r.namedCodesToUnicode[n] : e)
                }),
            render: (e)=>e.text
        },
        28: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$J),
            order: 2,
            parse: (e, n, t)=>({
                    children: n(e[2], t)
                }),
            render: (e, n, t)=>d("strong", {
                    key: t.key
                }, n(e.children, t))
        },
        29: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$K),
            order: 3,
            parse: (e, n, t)=>({
                    children: n(e[2], t)
                }),
            render: (e, n, t)=>d("em", {
                    key: t.key
                }, n(e.children, t))
        },
        30: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$ne),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: "27"
                })
        },
        31: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$Y),
            order: 3,
            parse: $18b8fbd7df5541f7$var$_e,
            render: (e, n, t)=>d("mark", {
                    key: t.key
                }, n(e.children, t))
        },
        32: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$ee),
            order: 3,
            parse: $18b8fbd7df5541f7$var$_e,
            render: (e, n, t)=>d("del", {
                    key: t.key
                }, n(e.children, t))
        }
    };
    !0 === r.disableParsingRawHTML && (delete Q[11], delete Q[13]);
    const le = function(e) {
        let n = Object.keys(e);
        function t(r, i) {
            let l = [], o = "";
            for(; r;){
                let c = 0;
                for(; c < n.length;){
                    const a = n[c], s = e[a], d = s.match(r, i, o);
                    if (d) {
                        const e = d[0];
                        r = r.substring(e.length);
                        const n = s.parse(d, t, i);
                        null == n.type && (n.type = a), l.push(n), o = e;
                        break;
                    }
                    c++;
                }
            }
            return l;
        }
        return n.sort(function(n, t) {
            let r = e[n].order, i = e[t].order;
            return r !== i ? r - i : 1;
        }), function(e, n) {
            return t(function(e) {
                return e.replace($18b8fbd7df5541f7$var$x, "\n").replace($18b8fbd7df5541f7$var$$, "").replace($18b8fbd7df5541f7$var$W, "    ");
            }(e), n);
        };
    }(Q), oe = (ce = function(e, n) {
        return function(t, r, i) {
            const l = e[t.type].render;
            return n ? n(()=>l(t, r, i), t, r, i) : l(t, r, i);
        };
    }(Q, r.renderRule), function e(n, t = {}) {
        if (Array.isArray(n)) {
            const r = t.key, i = [];
            let l = !1;
            for(let r = 0; r < n.length; r++){
                t.key = r;
                const o = e(n[r], t), c = "string" == typeof o;
                c && l ? i[i.length - 1] += o : null !== o && i.push(o), l = c;
            }
            return t.key = r, i;
        }
        return ce(n, e, t);
    });
    var ce;
    const ae = Z(t);
    return V.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, V.map(function(e) {
        return d("div", {
            id: r.slugify(e.identifier),
            key: e.identifier
        }, e.identifier, oe(le(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $18b8fbd7df5541f7$export$2e2bcd8739ae039 = (n)=>{
    let { children: r, options: i } = n, l = function(e, n) {
        if (null == e) return {};
        var t, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)n.indexOf(t = l[r]) >= 0 || (i[t] = e[t]);
        return i;
    }(n, $18b8fbd7df5541f7$var$t);
    return $eUqFw.cloneElement($18b8fbd7df5541f7$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("jeqlo", function(module, exports) {

$parcel$export(module.exports, "TransitionHomeContentBox", () => $b2f5e64d6ebdf485$export$481db495d3b96c87);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");
const $b2f5e64d6ebdf485$export$481db495d3b96c87 = ({ children: children, footer: footer, illustration: illustration })=>{
    const isOptimalTooling = (0, $1ybV0.ff)('platform.show-optimal-tooling_brgom');
    if (isOptimalTooling) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: "transition-home-content-box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        xcss: $b2f5e64d6ebdf485$var$wrapperInlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        grow: "fill",
        alignInline: "center",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b2f5e64d6ebdf485$var$leftBoxStyles,
        padding: "space.300"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        padding: "space.300",
        xcss: $b2f5e64d6ebdf485$var$illustrationWrapperBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        alignItems: "center",
        justifyContent: "center"
    }, illustration))), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        padding: "space.300",
        paddingBlockStart: "space.0"
    }, footer))));
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: "transition-home-content-box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        grow: "fill",
        spread: "space-between",
        alignBlock: "center",
        xcss: $b2f5e64d6ebdf485$var$wrapperInlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b2f5e64d6ebdf485$var$leftBoxStyles,
        padding: "space.300"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        padding: "space.300",
        xcss: $b2f5e64d6ebdf485$var$illustrationWrapperBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        alignItems: "center",
        justifyContent: "center"
    }, illustration)))));
};
const $b2f5e64d6ebdf485$var$leftBoxStyles = (0, $1ZAYh.xcss)({
    width: '100%'
});
const $b2f5e64d6ebdf485$var$illustrationWrapperBoxStyles = (0, $1ZAYh.xcss)({
    width: '320px',
    flexShrink: 0
});
const $b2f5e64d6ebdf485$var$wrapperInlineStyles = (0, $1ZAYh.xcss)({
    boxShadow: 'elevation.shadow.raised',
    borderRadius: 'border.radius.200'
});

});

parcelRegister("220rR", function(module, exports) {

$parcel$export(module.exports, "TransitionHomeHeader", () => $2c9d1dbbd6399c6f$export$60dbab4e777fdf3e);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $1zbEq = parcelRequire("1zbEq");
const $2c9d1dbbd6399c6f$export$60dbab4e777fdf3e = ({ title: title, description: description })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h1",
        size: "large"
    }, title), description);

});

parcelRegister("gVzxN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d867fff9b17c2a7e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d867fff9b17c2a7e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    preventPushTitleNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.prevent-push-title-non-final",
        "defaultMessage": "Prevent push notifications from Opsgenie mobile app"
    },
    deleteOgContactMethodsTitleNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.delete-og-contact-methods-title-non-final",
        "defaultMessage": "Delete your Opsgenie contact methods"
    },
    contactMethodTitleNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.contact-method-title-non-final",
        "defaultMessage": "Keep your contact methods up to date"
    },
    usersAndRolesTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.users-and-roles-task-one-non-final",
        "defaultMessage": "How to manage users and roles"
    },
    usersAndRolesTaskTwoNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.users-and-roles-task-two-non-final",
        "defaultMessage": "{count, plural, =0 {All Opsgenie admins now have the product admin role} one {{count} Opsgenie admin doesn't have the product admin role} other {{count} Opsgenie admins don't have the product admin role}}"
    },
    usersAndRolesTaskThreeNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.users-and-roles-task-three-non-final",
        "defaultMessage": "{count, plural, =0 {All Opsgenie users now have a product role} one {{count} Opsgenie user no longer have custom roles} other {{count} Opsgenie users no longer have custom roles}}"
    },
    usersAndRolesTaskFourNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.users-and-roles-task-four-non-final",
        "defaultMessage": "Stakeholders are now in Jira Service Management"
    },
    alertsTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.alerts-task-one-non-final",
        "defaultMessage": "Meet the redesigned alerts on Jira"
    },
    alertsTaskTwoNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.alerts-task-two-non-final",
        "defaultMessage": "Where to find your alerts"
    },
    alertsTaskThreeNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.alerts-task-three-non-final",
        "defaultMessage": "What happens to Opsgenie alerts"
    },
    alertsTaskFourNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.alerts-task-four-non-final",
        "defaultMessage": "How to check and manage your on-call schedules"
    },
    notificationsTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.notifications-task-one-non-final",
        "defaultMessage": "How to manage your alert notifications"
    },
    notificationsTaskTwoNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.notifications-task-two-non-final",
        "defaultMessage": "Add Jira Cloud mobile app as your notification method"
    },
    notificationsTaskThreeNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.notifications-task-three-non-final",
        "defaultMessage": "Prevent duplicate notifications from Opsgenie mobile app"
    },
    teamsTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.teams-task-one-non-final",
        "defaultMessage": "Why launch operations for your team"
    },
    teamsTaskTwoNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.teams-task-two-non-final",
        "defaultMessage": "Opsgenie teams are now in Jira Service Management"
    },
    chatToolsTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.chat-tools-task-one-non-final",
        "defaultMessage": "How chat tools help with alerting"
    },
    chatToolsTaskTwoNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.chat-tools-task-two-non-final",
        "defaultMessage": "Connect your chat tools with Jira Service Management"
    },
    chatToolsTaskThreeNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.chat-tools-task-three-non-final",
        "defaultMessage": "Copy your Opsgenie chat integrations to Jira Service Management"
    },
    chatToolsTaskFourNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.chat-tools-task-four-non-final",
        "defaultMessage": "Prevent duplicate notifications from Opsgenie chat integrations"
    },
    automateAlertsAndIncidentResponseTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.automate-alerts-and-incident-response-task-one-non-final",
        "defaultMessage": "Recreate Opsgenie alert actions and incident rules in Jira"
    },
    automateAlertsAndIncidentResponseTaskTwoNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.automate-alerts-and-incident-response-task-two-non-final",
        "defaultMessage": "Delete your Opsgenie actions and incident rules"
    },
    integrationsTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.integrations-task-one-non-final",
        "defaultMessage": "Where to find your integrations"
    },
    integrationsTaskTwoNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.integrations-task-two-non-final",
        "defaultMessage": "Syncing your alerts with software and service projects"
    },
    integrationsTaskThreeNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.integrations-task-three-non-final",
        "defaultMessage": "Integrations unavailable for addition in Jira Service Management"
    },
    integrationsTaskFourNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.integrations-task-four-non-final",
        "defaultMessage": "Integrations left behind in Opsgenie"
    },
    integrationsTaskFiveNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.integrations-task-five-non-final",
        "defaultMessage": "Incoming call routing"
    },
    deprecatedOnesTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.deprecated-ones-task-one-non-final",
        "defaultMessage": "{deprecatedFeaturesCount, plural, one {{deprecatedFeaturesCount} feature is} other {{deprecatedFeaturesCount} features are}} left behind in Opsgenie"
    },
    heartbeatsTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.heartbeats-task-one-non-final",
        "defaultMessage": "Use the updated heartbeats' address in your systems"
    },
    heartbeatsTaskTwoNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.heartbeats-task-two-non-final",
        "defaultMessage": "Outdated heartbeats won't sync to Jira Service Management"
    },
    heartbeatsTaskThreeNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.heartbeats-task-three-non-final",
        "defaultMessage": "Remove excess heartbeats"
    },
    incidentsTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.incidents-task-one-non-final",
        "defaultMessage": "Find your Opsgenie incidents in Jira Service Management"
    },
    incidentsTaskTwoNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.incidents-task-two-non-final",
        "defaultMessage": "Incident status and priority in Jira Service Management"
    },
    incidentsTaskThreeNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.incidents-task-three-non-final",
        "defaultMessage": "4 incident features are left behind in Opsgenie"
    },
    incidentsTaskFourNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.incidents-task-four-non-final",
        "defaultMessage": "Copy new Opsgenie incidents to Jira Service Management"
    },
    incidentsTaskFourSuccessNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.incidents-task-four-success-non-final",
        "defaultMessage": "You've successfully copied your incidents to Jira"
    },
    findWhatYouAreLookingForTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.find-what-you-are-looking-for-task-one-non-final",
        "defaultMessage": "Navigate to your work quickly"
    }
});

});

parcelRegister("kPl8l", function(module, exports) {
module.exports = new URL("alerts-task-four-illustration.e6d37245.png", import.meta.url).toString();

});

parcelRegister("icAmO", function(module, exports) {
module.exports = new URL("alerts-task-two-illustration-dark.6f8e6f9c.png", import.meta.url).toString();

});

parcelRegister("dOFaH", function(module, exports) {
module.exports = new URL("alerts-task-two-illustration.11b778d2.png", import.meta.url).toString();

});

parcelRegister("fP12C", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fa116e7458f9c397$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $fa116e7458f9c397$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    taskOneDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.alerts-step.task-one-description-non-final",
        "defaultMessage": "\nWe've completely redesigned alerts to look and work like the way you'd like, so they're just as familiar as everything else on Jira.\n\nNow, Jira's robust design language powers the alert's layout, structure, actions, and details, making it more intuitive for you to work with alerts.\n\nTake a look at it yourself by viewing your alerts.\n        "
    },
    taskOneButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.alerts-step.task-one-button-non-final",
        "defaultMessage": "View your alerts"
    },
    taskTwoDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.alerts-step.task-two-description-non-final",
        "defaultMessage": "\nTo view your alerts, select **Your work** from Jira navigation and select **Alerts.**\nYou can also access your alerts from the **Alerts widget** on the **Your work** page.\n\nWant to create alerts yourself? Select **Create alert** from **More actions** on the **Alerts** page.\n        "
    },
    taskThreeDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.alerts-step.task-three-description-non-final",
        "defaultMessage": "While it's possible for you to work on your alerts on Opsgenie, it will support only critical actions. All of your alert, on-call, and incident response data from Opsgenie are now natively available on Jira Service Management, so you won't have to log in to Opsgenie."
    },
    taskFourDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.alerts-step.task-four-description-non-final",
        "defaultMessage": "\nYou can check your current on-call status and schedule times from the **On-call schedules** widget on the **Your work page**. Select **View all** to get a view of your on-call times and browse all the schedules.\n        "
    },
    taskFourButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.alerts-step.task-four-button-non-final",
        "defaultMessage": "View your on-call schedules"
    }
});

});


parcelRegister("hsqPc", function(module, exports) {

$parcel$export(module.exports, "AutomateAlertAndIncidentResponseStep", () => $046b39ed7a66d5ab$export$790d637e6bc9f322);

var $eUqFw = parcelRequire("eUqFw");

var $27B3S = parcelRequire("27B3S");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $iFmgL = parcelRequire("iFmgL");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");

var $ijwdS = parcelRequire("ijwdS");
parcelRequire("7rxh9");
var $cdOFH = parcelRequire("cdOFH");

var $5JgJ2 = parcelRequire("5JgJ2");

var $c7H0g = parcelRequire("c7H0g");
var $1R3n5 = parcelRequire("1R3n5");

var $iXxc0 = parcelRequire("iXxc0");

var $jeqlo = parcelRequire("jeqlo");

var $220rR = parcelRequire("220rR");

var $5MGFf = parcelRequire("5MGFf");

var $gVzxN = parcelRequire("gVzxN");

var $lzGyk = parcelRequire("lzGyk");

var $kiQ2t = parcelRequire("kiQ2t");
const $046b39ed7a66d5ab$export$790d637e6bc9f322 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isPrimaryAdmin = (0, $c7H0g.useIsAdmin)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const { opsgenieBaseUrl: opsgenieBaseUrl } = (0, $lzGyk.useGlobalChangeboarding)();
    const ogTeamsUrl = opsgenieBaseUrl ? `${opsgenieBaseUrl}/teams/list` : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220rR.TransitionHomeHeader), {
        title: formatMessage((0, $5MGFf.messages).automateAlertAndIncidentResponseTitleNonFinal),
        description: formatMessage((0, $5MGFf.messages).automateAlertAndIncidentResponseDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            width: "200px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($cdOFH))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($cdOFH))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $gVzxN.default).automateAlertsAndIncidentResponseTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $iXxc0.Anchor)
                }
            }
        }
    }, formatMessage((0, $kiQ2t.messages).taskOneDescriptionNonFinal))), (isPrimaryAdmin || isSiteAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: "/jira/settings/automation",
        target: "_blank"
    }, formatMessage((0, $kiQ2t.messages).taskOneButtonNonFinal))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            width: "163px",
            src: (0, $ijwdS.srcLight),
            srcDark: (0, $ijwdS.srcDark),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $gVzxN.default).automateAlertsAndIncidentResponseTaskTwoNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $iXxc0.Anchor)
                }
            }
        }
    }, formatMessage((0, $kiQ2t.messages).taskTwoDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: ogTeamsUrl,
        target: "_blank"
    }, formatMessage((0, $kiQ2t.messages).taskTwoButtonNonFinal))))));
};

});
parcelRegister("7rxh9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a54affc1cf626e3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("cdOFH")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("cdOFH")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 3p3pcq5wm596jjft2hqxn3jk
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/3p3pcq5wm596jjft2hqxn3jk

var $9TZf5 = parcelRequire("9TZf5");

var $cdOFH = parcelRequire("cdOFH");
const $3a54affc1cf626e3$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($cdOFH)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($cdOFH))
});
var $3a54affc1cf626e3$export$2e2bcd8739ae039 = $3a54affc1cf626e3$var$Illustration;
// for advanced use only
const $3a54affc1cf626e3$export$a179c88182cb9d56 = [
    0,
    0,
    264,
    212
];

});
parcelRegister("cdOFH", function(module, exports) {
module.exports = new URL("complex-window.3a2a7b13.svg", import.meta.url).toString();

});


parcelRegister("iXxc0", function(module, exports) {

$parcel$export(module.exports, "Anchor", () => $6a608086c4436df8$export$b688253958b8dfe7);

var $eUqFw = parcelRequire("eUqFw");

var $4kMup = parcelRequire("4kMup");
const $6a608086c4436df8$export$b688253958b8dfe7 = ({ children: children, href: href })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        href: href,
        target: "_blank"
    }, children);

});

parcelRegister("kiQ2t", function(module, exports) {

$parcel$export(module.exports, "messages", () => $03d95f6df9361acd$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $03d95f6df9361acd$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    taskOneDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.automate-alert-and-incident-response-step.task-one-description-non-final",
        "defaultMessage": "Your Opsgenie actions and incident rules aren't automatically moved to Jira Service Management.\n\nYou can easily recreate them using Jira Automation's vast library of rule templates and components. [Read how to recreate Opsgenie actions and rules with Jira automation](https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Automation)\n"
    },
    taskOneButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.automate-alert-and-incident-response-step.task-one-button-non-final",
        "defaultMessage": "Go to Jira automation"
    },
    taskTwoDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.automate-alert-and-incident-response-step.task-two-description-non-final",
        "defaultMessage": "To avoid conflict between Opsgenie and Jira, delete your teams' Opsgenie actions and incident rules in Opsgenie. It's recommended to do this after setting up your automation in Jira.\n\nIn your Opsgenie team, select **Actions** and **Incident rules** and delete all the action channels, actions, and incident rules permanently. [Read how to delete Opsgenie actions and incidents rules](https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Automation)\n"
    },
    taskTwoButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.automate-alert-and-incident-response-step.task-two-button-non-final",
        "defaultMessage": "Go to teams in Opsgenie"
    }
});

});


parcelRegister("4DyCL", function(module, exports) {

$parcel$export(module.exports, "ChatToolsStep", () => $09458a26cdc55f00$export$39c402b7954418b);

var $eUqFw = parcelRequire("eUqFw");

var $27B3S = parcelRequire("27B3S");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");

var $1ybV0 = parcelRequire("1ybV0");

var $02Brq = parcelRequire("02Brq");

var $8QJ51 = parcelRequire("8QJ51");

var $fJ8Lk = parcelRequire("fJ8Lk");

var $ljv8Z = parcelRequire("ljv8Z");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $c7H0g = parcelRequire("c7H0g");

var $iXxc0 = parcelRequire("iXxc0");

var $jeqlo = parcelRequire("jeqlo");

var $220rR = parcelRequire("220rR");

var $5MGFf = parcelRequire("5MGFf");

var $gVzxN = parcelRequire("gVzxN");

var $lzGyk = parcelRequire("lzGyk");

var $dc8n7 = parcelRequire("dc8n7");

var $bkVBU = parcelRequire("bkVBU");

var $8Gday = parcelRequire("8Gday");

var $52b7t = parcelRequire("52b7t");

var $l53yU = parcelRequire("l53yU");
const $09458a26cdc55f00$export$39c402b7954418b = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isPrimaryAdmin = (0, $c7H0g.useIsAdmin)();
    const [{ isTeamAdmin: isTeamAdmin }] = (0, $bkVBU.useIsTeamAdmin)();
    const [connections] = (0, $dc8n7.useChatToolsConnections)();
    const [integrations] = (0, $dc8n7.useChatToolsIntegrations)();
    if (!connections.data && !isTeamAdmin) throw new Error('ChatToolsStep should be rendered when chat tools connections are loaded');
    const isOptimalTooling = (0, $1ybV0.ff)('platform.show-optimal-tooling_brgom');
    const { opsgenieBaseUrl: opsgenieBaseUrl } = (0, $lzGyk.useGlobalChangeboarding)();
    const ogTeamsUrl = opsgenieBaseUrl ? `${opsgenieBaseUrl}/teams/list` : '';
    const ogIntegrationsUrl = opsgenieBaseUrl ? `${opsgenieBaseUrl}/settings/integrations/` : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220rR.TransitionHomeHeader), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).chatToolsTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).chatToolsDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8QJ51.default), {
            alt: "",
            width: 100
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).chatToolsTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $iXxc0.Anchor)
                }
            }
        }
    }, formatMessage((0, $l53yU.messages).taskOneDescriptionNonFinal))))), isPrimaryAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02Brq.default), {
            width: 100,
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).chatToolsTaskTwoNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $l53yU.messages).taskTwoDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: "/jira/settings/products/ops/jira-service-management-chatops-and-video-tools",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $l53yU.messages).taskTwoActionButtonNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Gday.ConnectChatToolsTable), {
        connections: connections
    })))), (integrations.data?.count || 0) > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fJ8Lk.default), {
            alt: "",
            width: 100
        }),
        footer: isOptimalTooling && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            paddingBlockStart: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $52b7t.CopyIntegrationsTable), {
            integrations: integrations
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).chatToolsTaskThreeNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $l53yU.messages).taskThreeDescriptionNonFinal))), isPrimaryAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: "/jira/settings/products/ops/integrations",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $l53yU.messages).taskThreeActionButtonNonFinal))), !isOptimalTooling && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $52b7t.CopyIntegrationsTable), {
        integrations: integrations
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ljv8Z.default), {
            width: 100,
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).chatToolsTaskFourNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage(isTeamAdmin ? (0, $l53yU.messages).taskFourTeamAdminDescriptionNonFinal : (0, $l53yU.messages).taskFourDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: isTeamAdmin ? ogTeamsUrl : ogIntegrationsUrl,
        target: "_blank"
    }, formatMessage(isTeamAdmin ? (0, $l53yU.messages).taskFourTeamAdminActionButtonNonFinal : (0, $l53yU.messages).taskFourActionButtonNonFinal))))));
};

});
parcelRegister("02Brq", function(module, exports) {

$parcel$export(module.exports, "default", () => $078460ec2710d3c8$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = mmwr66tqxzps49fhmn4694w
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/mmwr66tqxzps49fhmn4694w

var $9TZf5 = parcelRequire("9TZf5");

var $2ew7k = parcelRequire("2ew7k");

var $4CP48 = parcelRequire("4CP48");
const $078460ec2710d3c8$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4CP48)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2ew7k))
});
var $078460ec2710d3c8$export$2e2bcd8739ae039 = $078460ec2710d3c8$var$Illustration;
// for advanced use only
const $078460ec2710d3c8$export$a179c88182cb9d56 = [
    0,
    0,
    191,
    222
];

});
parcelRegister("2ew7k", function(module, exports) {
module.exports = new URL("lock-closed-darkmode.26d51607.svg", import.meta.url).toString();

});

parcelRegister("4CP48", function(module, exports) {
module.exports = new URL("lock-closed.22dbfd6e.svg", import.meta.url).toString();

});


parcelRegister("8QJ51", function(module, exports) {

$parcel$export(module.exports, "default", () => $972ce73d1ac639ce$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 5brnpzkmsmk379qcw4nzxktj
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/5brnpzkmsmk379qcw4nzxktj

var $9TZf5 = parcelRequire("9TZf5");

var $1trDy = parcelRequire("1trDy");

var $5jkCW = parcelRequire("5jkCW");
const $972ce73d1ac639ce$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5jkCW)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($1trDy))
});
var $972ce73d1ac639ce$export$2e2bcd8739ae039 = $972ce73d1ac639ce$var$Illustration;
// for advanced use only
const $972ce73d1ac639ce$export$a179c88182cb9d56 = [
    0,
    0,
    231,
    191
];

});
parcelRegister("1trDy", function(module, exports) {
module.exports = new URL("chat-darkmode.d567d134.svg", import.meta.url).toString();

});

parcelRegister("5jkCW", function(module, exports) {
module.exports = new URL("chat.06e18536.svg", import.meta.url).toString();

});


parcelRegister("fJ8Lk", function(module, exports) {

$parcel$export(module.exports, "default", () => $20a0bbd95b2732ed$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = q4j47tscp9jf77b93smc2h6r
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/q4j47tscp9jf77b93smc2h6r

var $9TZf5 = parcelRequire("9TZf5");

var $9C8mj = parcelRequire("9C8mj");
const $20a0bbd95b2732ed$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($9C8mj)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($9C8mj))
});
var $20a0bbd95b2732ed$export$2e2bcd8739ae039 = $20a0bbd95b2732ed$var$Illustration;
// for advanced use only
const $20a0bbd95b2732ed$export$a179c88182cb9d56 = [
    0,
    0,
    207,
    227
];

});
parcelRegister("9C8mj", function(module, exports) {
module.exports = new URL("download.61c2405e.svg", import.meta.url).toString();

});


parcelRegister("ljv8Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $927d75e1c9559a24$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 4gngnxb7cxjb44cjfmnzf923
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/4gngnxb7cxjb44cjfmnzf923

var $9TZf5 = parcelRequire("9TZf5");

var $4LNk6 = parcelRequire("4LNk6");
const $927d75e1c9559a24$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4LNk6)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($4LNk6))
});
var $927d75e1c9559a24$export$2e2bcd8739ae039 = $927d75e1c9559a24$var$Illustration;
// for advanced use only
const $927d75e1c9559a24$export$a179c88182cb9d56 = [
    0,
    0,
    220,
    192
];

});
parcelRegister("4LNk6", function(module, exports) {
module.exports = new URL("settings.9bfa4562.svg", import.meta.url).toString();

});


parcelRegister("8Gday", function(module, exports) {

$parcel$export(module.exports, "ConnectChatToolsTable", () => $431a25318bc61686$export$67c29319faef998a);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $cGL6G = parcelRequire("cGL6G");

var $aUqTb = parcelRequire("aUqTb");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");

var $8uD7Y = parcelRequire("8uD7Y");

var $7gA9Z = parcelRequire("7gA9Z");

var $7cUjN = parcelRequire("7cUjN");

var $iKNbb = parcelRequire("iKNbb");
const $431a25318bc61686$export$67c29319faef998a = ({ connections: connections })=>{
    if (!connections.data) throw new Error('ConnectChatToolsTable should be rendered when chat tools connections are loaded');
    const rows = connections.data.values.map((item, index)=>({
            key: `row-${index}`,
            cells: [
                {
                    key: `cell-${index}-workspace`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        paddingInlineStart: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "p",
                        maxLines: 1
                    }, item.chatSpaceName))
                },
                {
                    key: `cell-${index}-product`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                        space: "space.100",
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                        size: "xsmall",
                        src: item.chatSpaceType === 'slack' ? (0, $7gA9Z.SLACK_IMAGE_URL) : (0, $7gA9Z.MST_IMAGE_URL)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "p",
                        maxLines: 1
                    }, item.chatSpaceType === 'slack' ? (0, $7gA9Z.SLACK_TEXT) : (0, $7gA9Z.MST_TEXT)))
                },
                {
                    key: `cell-${index}-status`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                        space: "space.050",
                        alignBlock: "center",
                        alignInline: "center",
                        xcss: $431a25318bc61686$var$inlineStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cUjN.Action), {
                        item: item
                    }))
                }
            ]
        }));
    const head = {
        cells: [
            {
                key: 'workspace-or-tenant',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iKNbb.messages).chatToolsConnectTableWorkspaceHeadNonFinal)),
                isSortable: true
            },
            {
                key: 'product',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iKNbb.messages).chatToolsConnectTableProductHeadNonFinal)
            },
            {
                key: 'status',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                    space: "space.050",
                    alignInline: "center",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iKNbb.messages).chatToolsConnectTableStatusHeadNonFinal), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                    position: "top",
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iKNbb.messages).chatToolsConnectTableStatusHeadTooltipNonFinal)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    xcss: $431a25318bc61686$var$infoIconBoxStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
                    size: "small",
                    label: ""
                }))))
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cGL6G.default), {
        isLoading: connections.loading,
        isFixedSize: true,
        head: head,
        rows: rows,
        rowsPerPage: 5,
        defaultPage: 1
    });
};
const $431a25318bc61686$var$infoIconBoxStyles = (0, $1ZAYh.xcss)({
    height: 'size.100'
});
const $431a25318bc61686$var$inlineStyles = (0, $1ZAYh.xcss)({
    height: 'size.400',
    cursor: 'default'
});

});
parcelRegister("aUqTb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f13fdf9f823d771$var$_react = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $7f13fdf9f823d771$var$_information = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $7f13fdf9f823d771$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7f13fdf9f823d771$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $7f13fdf9f823d771$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $7f13fdf9f823d771$var$_information.default
    }));
$7f13fdf9f823d771$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $7f13fdf9f823d771$var$_default = module.exports.default = $7f13fdf9f823d771$var$EditorPanelIcon;

});
parcelRegister("h6FFs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c743518dce4b322a$var$_react = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c743518dce4b322a$var$_UNSAFE_baseNew = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c743518dce4b322a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Information".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Known uses: helper message under textfield, information state insection messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c743518dce4b322a$var$InformationIcon = (props)=>/*#__PURE__*/ $c743518dce4b322a$var$_react.default.createElement($c743518dce4b322a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentColor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$c743518dce4b322a$var$InformationIcon.displayName = 'InformationIcon';
var $c743518dce4b322a$var$_default = module.exports.default = $c743518dce4b322a$var$InformationIcon;

});


parcelRegister("7cUjN", function(module, exports) {

$parcel$export(module.exports, "Action", () => $f90eb4dcb4779b8b$export$e19cd5f9376f8cee);

var $eUqFw = parcelRequire("eUqFw");

var $7opLA = parcelRequire("7opLA");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $aWvIp = parcelRequire("aWvIp");

var $86Ndv = parcelRequire("86Ndv");

var $96IgR = parcelRequire("96IgR");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");

var $8uD7Y = parcelRequire("8uD7Y");

var $dc8n7 = parcelRequire("dc8n7");

var $aKWht = parcelRequire("aKWht");
const $f90eb4dcb4779b8b$export$e19cd5f9376f8cee = ({ item: item })=>{
    const { authorizeSlackConnection: authorizeSlackConnection, delegateMSTConnection: delegateMSTConnection, authorizeMSTConnection: authorizeMSTConnection, copyMSTAuthorizationLink: copyMSTAuthorizationLink } = (0, $dc8n7.useChatToolsActions)();
    const [{ loadingConnectionId: loadingConnectionId }] = (0, $dc8n7.useChatToolsStore)();
    const isLoading = loadingConnectionId === item.chatSpaceId;
    if (item.status === 'SITE_SETTING_CONFIGURED') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        size: "small",
        label: "",
        primaryColor: "var(--ds-icon-success, #22A06B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aKWht.messages).chatToolsConnectTableConnectedTextNonFinal));
    if (item.status === 'SITE_SETTING_NOT_PRESENT') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        onClick: ()=>{
            if (item.chatSpaceType === 'msteams') delegateMSTConnection(item.chatSpaceId);
            else if (item.chatSpaceType === 'slack') authorizeSlackConnection(item.chatSpaceId);
        },
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aKWht.messages).chatToolsConnectTableConnectButtonTextNonFinal));
    // msteams chat spaces
    if (item.status === 'REDUNDANT_TENANT' && item.chatSpaceType === 'msteams') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aKWht.messages).redundantTenantTooltipNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.050",
        alignBlock: "center",
        xcss: $f90eb4dcb4779b8b$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aKWht.messages).redundantTenantTextNonFinal)));
    if (item.status === 'ADMIN_CONSENT_NOT_GRANTED' && item.chatSpaceType === 'msteams') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
                ...props,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                    label: "Error",
                    size: "small"
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                    label: "chevron-down",
                    size: "small"
                }),
                isLoading: isLoading,
                ref: triggerRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aKWht.messages).givePermissionTextNonFinal))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aKWht.messages).givePermissionTooltipNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: ()=>authorizeMSTConnection(item.chatSpaceId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aKWht.messages).givePermissionTextNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aKWht.messages).copyLinkTooltipNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: ()=>copyMSTAuthorizationLink(item.chatSpaceId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aKWht.messages).copyLinkTextNonFinal)))));
    // It won't happen, there is a mistake on the BE side chatSpaceType is slack but status is not SITE_SETTING_NOT_PRESENT or SITE_SETTING_CONFIGURED
    return null;
};
const $f90eb4dcb4779b8b$var$inlineStyles = (0, $1ZAYh.xcss)({
    cursor: 'not-allowed'
});

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);
/* eslint-disable import/order */ 
var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) // Check if it is within dropdown and it is a trigger button
        // if it is a nested dropdown, clicking trigger won't close the dropdown
        // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
        return;
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    }));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);

const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if (isLayerDisabled()) {
            // if nested dropdown isOpen we need to close on Tab key press
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});


parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});

parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});


parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});

parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jFtVs = parcelRequire("jFtVs");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $jFtVs.useUID)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});
parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N300)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});


parcelRegister("aKWht", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e6f921f47a3cf3ab$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $e6f921f47a3cf3ab$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    chatToolsConnectTableConnectedTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.chat-tools-connect-table-connected-text-non-final",
        "defaultMessage": "Connected"
    },
    chatToolsConnectTableConnectButtonTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.chat-tools-connect-table-connect-button-text-non-final",
        "defaultMessage": "Connect"
    },
    redundantTenantTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.redundant-tenant-text-non-final",
        "defaultMessage": "Can't connect"
    },
    redundantTenantTooltipNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.redundant-tenant-tooltip-non-final",
        "defaultMessage": "You've already connected a Microsoft tenant with Jira Service Management."
    },
    givePermissionTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.give-permission-text-non-final",
        "defaultMessage": "Give permission"
    },
    givePermissionTooltipNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.give-permission-tooltip-non-final",
        "defaultMessage": "Microsoft Teams Administrator's permission is required to create chats, meetings, and post to channels in Microsoft Teams."
    },
    copyLinkTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.copy-link-text-non-final",
        "defaultMessage": "Copy link"
    },
    copyLinkTooltipNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.copy-link-tooltip-non-final",
        "defaultMessage": "Share the link with your Teams Administrator to give permission to Jira Service Management."
    }
});

});


parcelRegister("iKNbb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8b98fe229f8afb82$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $8b98fe229f8afb82$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    chatToolsConnectTableWorkspaceHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.chat-tools-connect-table-workspace-head-non-final",
        "defaultMessage": "Workspace or tenant"
    },
    chatToolsConnectTableProductHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.chat-tools-connect-table-product-head-non-final",
        "defaultMessage": "Product"
    },
    chatToolsConnectTableStatusHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.chat-tools-connect-table-status-head-non-final",
        "defaultMessage": "Status"
    },
    chatToolsConnectTableStatusHeadTooltipNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.chat-tools-connect-table-status-head-tooltip-non-final",
        "defaultMessage": "Make sure you're a member of the Slack workspace or Microsoft tenant."
    }
});

});


parcelRegister("52b7t", function(module, exports) {

$parcel$export(module.exports, "CopyIntegrationsTable", () => $ab717c3dbf9460e1$export$4d903b39a9b39b21);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $7u4fN = parcelRequire("7u4fN");

var $cGL6G = parcelRequire("cGL6G");

var $23NQ5 = parcelRequire("23NQ5");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7gA9Z = parcelRequire("7gA9Z");

var $kuyHX = parcelRequire("kuyHX");

var $c5LEw = parcelRequire("c5LEw");
const $ab717c3dbf9460e1$export$4d903b39a9b39b21 = ({ integrations: integrations })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!integrations.data) throw new Error('CopyIntegrationsTable should be rendered when chat tools integrations are loaded');
    const isOptimalTooling = (0, $1ybV0.ff)('platform.show-optimal-tooling_brgom');
    const rows = integrations.data.values.map((item, index)=>{
        const channelName = `${item.msTeamsName || item.channelName}, ${item.chatSpaceName}`;
        return {
            key: `row-${index}`,
            cells: [
                {
                    key: `cell-${index}-chat-integration`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                        position: "top",
                        content: item.name
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        xcss: isOptimalTooling && $ab717c3dbf9460e1$var$nameStyles,
                        paddingInlineStart: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                        space: "space.100",
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                        size: "xsmall",
                        src: item.chatSpaceType === 'slack' ? (0, $7gA9Z.SLACK_IMAGE_URL) : (0, $7gA9Z.MST_IMAGE_URL)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "p",
                        maxLines: 1
                    }, item.name))))
                },
                {
                    key: `cell-${index}-connected-to`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                        position: "top",
                        content: channelName
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "p",
                        maxLines: 1
                    }, channelName))
                },
                ...isOptimalTooling ? [
                    {
                        key: `cell-${index}-connected-to`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                            position: "top",
                            content: item.teamName
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                            as: "p",
                            maxLines: 1
                        }, item.teamName))
                    }
                ] : [
                    {}
                ],
                {
                    key: `cell-${index}-status`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                        space: "space.050",
                        alignBlock: "center",
                        alignInline: "center",
                        xcss: $ab717c3dbf9460e1$var$inlineStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kuyHX.Action), {
                        item: item
                    }))
                },
                ...isOptimalTooling ? [
                    {
                        key: `cell-${index}-actions`,
                        content: item.status === 'COPIED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                            appearance: "subtle",
                            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                                label: ""
                            }),
                            href: item.teamId ? `/jira/ops/teams/${item.teamId}/integrations/${item.chatSpaceType === 'slack' ? 'slack-plugin' : 'msteams-plugin'}/${item.jsmIntegrationId}` : `/jira/settings/products/ops/integrations/${item.chatSpaceType === 'slack' ? 'slack-plugin' : 'msteams-plugin'}/${item.jsmIntegrationId}`,
                            target: "_blank"
                        })
                    }
                ] : [
                    {}
                ]
            ]
        };
    });
    const head = {
        cells: [
            {
                key: 'chat-integration',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    paddingInlineStart: "space.100"
                }, formatMessage((0, $c5LEw.messages).chatIntegrationNonFinal)),
                isSortable: true
            },
            {
                key: 'connected-to',
                content: formatMessage((0, $c5LEw.messages).connectedToNonFinal)
            },
            ...isOptimalTooling ? [
                {
                    key: 'responder-team',
                    content: formatMessage((0, $c5LEw.messages).responderTeamNonFinal),
                    isSortable: true
                }
            ] : [
                {}
            ],
            {
                key: 'status',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                    alignInline: "center"
                }, formatMessage((0, $c5LEw.messages).statusNonFinal))
            },
            ...isOptimalTooling ? [
                {
                    key: 'actions',
                    content: null
                }
            ] : [
                {}
            ]
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cGL6G.default), {
        isLoading: integrations.loading,
        head: head,
        rows: rows,
        rowsPerPage: 5,
        defaultPage: 1
    });
};
const $ab717c3dbf9460e1$var$inlineStyles = (0, $1ZAYh.xcss)({
    height: 'size.400',
    cursor: 'default'
});
const $ab717c3dbf9460e1$var$nameStyles = (0, $1ZAYh.xcss)({
    maxWidth: '280px'
});

});
parcelRegister("kuyHX", function(module, exports) {

$parcel$export(module.exports, "Action", () => $39ef04f60674cc8d$export$e19cd5f9376f8cee);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $aWvIp = parcelRequire("aWvIp");

var $dmCPj = parcelRequire("dmCPj");

var $96IgR = parcelRequire("96IgR");

var $fXMW0 = parcelRequire("fXMW0");

var $8cU5f = parcelRequire("8cU5f");

var $8uD7Y = parcelRequire("8uD7Y");

var $dc8n7 = parcelRequire("dc8n7");

var $8QOqB = parcelRequire("8QOqB");
const $39ef04f60674cc8d$export$e19cd5f9376f8cee = ({ item: item })=>{
    const { givePermissionToUser: givePermissionToUser, duplicateIntegration: duplicateIntegration } = (0, $dc8n7.useChatToolsActions)();
    const [{ loadingIntegrationId: loadingIntegrationId }] = (0, $dc8n7.useChatToolsStore)();
    if (item.status === 'COPIED') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        size: "small",
        label: "",
        primaryColor: "var(--ds-icon-success, #22A06B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8QOqB.messages).copyIntegrationsTableCopiedTextNonFinal));
    if (item.status === 'UNCONNECTED') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), item.chatSpaceType === 'slack' ? (0, $8QOqB.messages).slackUnconnectedTooltipNonFinal : (0, $8QOqB.messages).mstUnconnectedTooltipNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        isDisabled: true,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fXMW0))), {
            size: "small",
            label: "",
            primaryColor: "var(--ds-icon-subtle, #626F86)"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8QOqB.messages).copyIntegrationsTableUnconnectedTextNonFinal)));
    if (item.status === 'AWAITED') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), item.chatSpaceType === 'slack' ? (0, $8QOqB.messages).slackGivePermissionTooltipNonFinal : (0, $8QOqB.messages).mstGivePermissionTooltipNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        isLoading: loadingIntegrationId === item.id,
        onClick: ()=>givePermissionToUser(item),
        appearance: "subtle-link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
            size: "small",
            label: "",
            primaryColor: "var(--ds-icon-subtle, #626F86)"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8QOqB.messages).givePermissionTextNonFinal)));
    if (item.status === 'GRANTED') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        onClick: ()=>duplicateIntegration(item),
        isLoading: loadingIntegrationId === item.id,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))), {
            label: "Copy",
            size: "small"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8QOqB.messages).copyToJiraNonFinal));
    // Only remaining case is FAILED and we users should be retry to copy again in this case
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        onClick: ()=>duplicateIntegration(item),
        isLoading: loadingIntegrationId === item.id,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))), {
            label: "Copy",
            size: "small"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8QOqB.messages).copyToJiraNonFinal));
};

});
parcelRegister("fXMW0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9f253171a9f20fe$var$_react = $b9f253171a9f20fe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $b9f253171a9f20fe$var$_lockLocked = $b9f253171a9f20fe$var$_interopRequireDefault((parcelRequire("gWhpp")));
function $b9f253171a9f20fe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b9f253171a9f20fe$var$LockIcon = (props)=>/*#__PURE__*/ $b9f253171a9f20fe$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $b9f253171a9f20fe$var$_lockLocked.default
    }));
$b9f253171a9f20fe$var$LockIcon.displayName = 'LockIcon';
var $b9f253171a9f20fe$var$_default = module.exports.default = $b9f253171a9f20fe$var$LockIcon;

});
parcelRegister("gWhpp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c54f9120ca8b9e22$var$_react = $c54f9120ca8b9e22$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c54f9120ca8b9e22$var$_UNSAFE_baseNew = $c54f9120ca8b9e22$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c54f9120ca8b9e22$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "LockLocked".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c54f9120ca8b9e22$var$LockLockedIcon = (props)=>/*#__PURE__*/ $c54f9120ca8b9e22$var$_react.default.createElement($c54f9120ca8b9e22$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 7.25H4c-.69 0-1.25.56-1.25 1.25V14c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V8.5c0-.69-.56-1.25-1.25-1.25h-.75m-6.5 0V4a3.25 3.25 0 1 1 6.5 0v3.25m-6.5 0h6.5"/>`
    }, props));
$c54f9120ca8b9e22$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $c54f9120ca8b9e22$var$_default = module.exports.default = $c54f9120ca8b9e22$var$LockLockedIcon;

});


parcelRegister("8QOqB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a9dc5fdb3e5b8893$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a9dc5fdb3e5b8893$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    copyIntegrationsTableCopiedTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.copy-integrations-table-copied-text-non-final",
        "defaultMessage": "Copied"
    },
    copyIntegrationsTableUnconnectedTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.copy-integrations-table-unconnected-text-non-final",
        "defaultMessage": "Unconnected"
    },
    givePermissionTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.give-permission-text-non-final",
        "defaultMessage": "Give permission"
    },
    copyToJiraNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.copy-to-jira-non-final",
        "defaultMessage": "Copy to Jira"
    },
    slackUnconnectedTooltipNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.slack-unconnected-tooltip-non-final",
        "defaultMessage": "Connect the Slack workspace to Jira Service Management and then copy the integration."
    },
    mstUnconnectedTooltipNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.mst-unconnected-tooltip-non-final",
        "defaultMessage": "Connect the Microsoft tenant to Jira Service Management and then copy the integration."
    },
    slackGivePermissionTooltipNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.slack-give-permission-tooltip-non-final",
        "defaultMessage": "Give permission to create channels and post to channels in Slack."
    },
    mstGivePermissionTooltipNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.mst-give-permission-tooltip-non-final",
        "defaultMessage": "Give permission to create chats, meetings, and post to channels in Microsoft Teams."
    }
});

});


parcelRegister("c5LEw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $eafd73bfcce3a869$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $eafd73bfcce3a869$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    chatIntegrationNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.chat-integration-non-final",
        "defaultMessage": "Chat integration"
    },
    connectedToNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.connected-to-non-final",
        "defaultMessage": "Connected to"
    },
    responderTeamNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.responder-team-non-final",
        "defaultMessage": "Responder team"
    },
    statusNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.status-non-final",
        "defaultMessage": "Status"
    }
});

});


parcelRegister("l53yU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1bb7b06ae5774d23$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1bb7b06ae5774d23$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    taskOneDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.task-one-description-non-final",
        "defaultMessage": "\nJira Service Management offers integrations with Slack and Microsoft Teams to help your on-call teams get alert notifications and manage alerts directly from chat channels.\n\n[Read more about chat tools for alerting](https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Chat-tools-for-alerting)"
    },
    taskTwoDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.task-two-description-non-final",
        "defaultMessage": "\nYour chat tools are currently connected with Opsgenie. Connect them with Jira Service Management to let your on-call teams work on alerts from their existing chat channels."
    },
    taskTwoActionButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.task-two-action-button-non-final",
        "defaultMessage": "Manage chat tools in Jira"
    },
    taskThreeDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.task-three-description-non-final",
        "defaultMessage": "\nSelect the Opsgenie chat integrations that you want to copy to Jira Service Management. The integration will be copied without any changes, but the status will be **OFF** by default. You can make any changes to the integration's settings and then turn it on.\n\nMake sure you're a member of the channel connected to the chat integration, else you won't be able to copy it to Jira Service Management."
    },
    taskThreeActionButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.task-three-action-button-non-final",
        "defaultMessage": "Manage chat integrations in Jira"
    },
    taskFourDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.task-four-description-non-final",
        "defaultMessage": "\nTo avoid duplicate notifications from Jira and Opsgenie's chat integrations, you can turn off the integrations in Opsgenie.\n\nThis will only turn off your Opsgenie chat integrations, the integrations won't be deleted. You can turn it on at any time."
    },
    taskFourTeamAdminDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.task-four-team-admin-description-non-final",
        "defaultMessage": "\nTo avoid duplicate notifications from Jira and Opsgenie's chat integrations, turn off your teams' integrations in Opsgenie.\n\nFind your Opsgenie integrations by navigating to a team and select **Integrations**. Select your chat integration from the list and select the **Turn off** button.\n\nThis will only turn off your Opsgenie chat integrations, the integrations won't be deleted. You can turn it on at any time."
    },
    taskFourActionButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.task-four-action-button-non-final",
        "defaultMessage": "Manage chat integrations in Opsgenie"
    },
    taskFourTeamAdminActionButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.task-four-team-admin-action-button-non-final",
        "defaultMessage": "Go to teams in Opsgenie"
    }
});

});


parcelRegister("42hEc", function(module, exports) {

$parcel$export(module.exports, "DeprecatedOnesStep", () => $b65560d8383e1c3c$export$ce0fe6d5fca0a967);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $8CfG4 = parcelRequire("8CfG4");

var $iFmgL = parcelRequire("iFmgL");

var $1zbEq = parcelRequire("1zbEq");

var $8cU5f = parcelRequire("8cU5f");
parcelRequire("9pFPL");
var $cPWxh = parcelRequire("cPWxh");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $c7H0g = parcelRequire("c7H0g");
var $1R3n5 = parcelRequire("1R3n5");

var $lYf25 = parcelRequire("lYf25");

var $jeqlo = parcelRequire("jeqlo");

var $220rR = parcelRequire("220rR");

var $5MGFf = parcelRequire("5MGFf");

var $a5i7W = parcelRequire("a5i7W");

var $8OZdV = parcelRequire("8OZdV");

var $2QBwV = parcelRequire("2QBwV");

var $19NeO = parcelRequire("19NeO");
const $b65560d8383e1c3c$export$ce0fe6d5fca0a967 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ deprecatedIntegrations: deprecatedIntegrations, hasDeprecatedIntegration: hasDeprecatedIntegration }] = (0, $2QBwV.useDeprecatedIntegrations)();
    const [{ groups: groups, hasDeprecatedGroups: hasDeprecatedGroups }] = (0, $8OZdV.useDeprecatedGroups)();
    const [{ heartbeats: heartbeats, hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats }] = (0, $8OZdV.useDeprecatedHeartbeats)();
    const [{ notificationPolicies: notificationPolicies, hasDeprecatedNotificationPolicies: hasDeprecatedNotificationPolicies }] = (0, $8OZdV.useDeprecatedNotificationPolicies)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isPrimaryAdmin = (0, $c7H0g.useIsAdmin)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220rR.TransitionHomeHeader), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).deprecatedOnesTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).deprecatedOnesDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($cPWxh))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($cPWxh))),
            alt: "",
            width: 130
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, (0, $a5i7W.getDeprecatedOnesTasks)({
        isAdmin: isSiteAdmin || isPrimaryAdmin,
        hasDeprecatedIntegration: hasDeprecatedIntegration,
        hasDeprecatedGroups: hasDeprecatedGroups,
        hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats,
        hasDeprecatedNotificationPolicies: hasDeprecatedNotificationPolicies
    })[0].description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardList), null, hasDeprecatedIntegration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $19NeO.messages).integrationsTitleNonFinal),
        description: formatMessage((0, $19NeO.messages).integrationsDescriptionNonFinal, {
            deprecatedIntegrationCount: deprecatedIntegrations.data?.count
        }),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $19NeO.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
                label: "",
                size: "small"
            }),
            "aria-label": formatMessage((0, $19NeO.messages).integrationsTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Integrations"
    }), hasDeprecatedGroups && (isSiteAdmin || isPrimaryAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $19NeO.messages).groupsTitleNonFinal),
        description: formatMessage((0, $19NeO.messages).groupsDescriptionNonFinal, {
            deprecatedGroupCount: groups.data?.count
        }),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $19NeO.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
                label: "",
                size: "small"
            }),
            "aria-label": formatMessage((0, $19NeO.messages).groupsTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Groups"
    }), hasDeprecatedGlobalHeartbeats && (isSiteAdmin || isPrimaryAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $19NeO.messages).heartbeatsTitleNonFinal),
        description: formatMessage((0, $19NeO.messages).heartbeatsDescriptionNonFinal, {
            deprecatedGlobalHeartbeatCount: heartbeats.data?.globalHeartbeatCount
        }),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $19NeO.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
                label: "",
                size: "small"
            }),
            "aria-label": formatMessage((0, $19NeO.messages).heartbeatsTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Heartbeats-V1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $19NeO.messages).teamsApiTitleNonFinal),
        description: formatMessage((0, $19NeO.messages).teamsApiDescriptionNonFinal),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $19NeO.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
                label: "",
                size: "small"
            }),
            "aria-label": formatMessage((0, $19NeO.messages).teamsApiTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Teams-API"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $19NeO.messages).incidentTemplatesTitleNonFinal),
        description: formatMessage((0, $19NeO.messages).incidentTemplatesDescriptionNonFinal),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $19NeO.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
                label: "",
                size: "small"
            }),
            "aria-label": formatMessage((0, $19NeO.messages).incidentTemplatesTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Incident-templates"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $19NeO.messages).iccAndBridgesTitleNonFinal),
        description: formatMessage((0, $19NeO.messages).iccAndBridgesDescriptionNonFinal),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $19NeO.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
                label: "",
                size: "small"
            }),
            "aria-label": formatMessage((0, $19NeO.messages).iccAndBridgesTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Incident-Command-Center-and-Conference-Bridges"
    }), hasDeprecatedNotificationPolicies && (isSiteAdmin || isPrimaryAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $19NeO.messages).notificationPoliciesTitleNonFinal),
        description: formatMessage((0, $19NeO.messages).notificationPoliciesDescriptionNonFinal, {
            deprecatedNotificationPolicyCount: notificationPolicies.data?.count
        }),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $19NeO.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
                label: "",
                size: "small"
            }),
            "aria-label": formatMessage((0, $19NeO.messages).notificationPoliciesTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Notification-policies-V1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $19NeO.messages).actionsAndIncidentRulesTitleNonFinal),
        description: formatMessage((0, $19NeO.messages).actionsAndIncidentRulesDescriptionNonFinal),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $19NeO.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
                label: "",
                size: "small"
            }),
            "aria-label": formatMessage((0, $19NeO.messages).actionsAndIncidentRulesTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Actions-and-incident-rules"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $19NeO.messages).reportsTitleNonFinal),
        description: formatMessage((0, $19NeO.messages).reportsDescriptionNonFinal),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $19NeO.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
                label: "",
                size: "small"
            }),
            "aria-label": formatMessage((0, $19NeO.messages).reportsTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Some-reports"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $19NeO.messages).oecTitleNonFinal),
        description: formatMessage((0, $19NeO.messages).oecDescriptionNonFinal),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $19NeO.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
                label: "",
                size: "small"
            }),
            "aria-label": formatMessage((0, $19NeO.messages).oecTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Opsgenie-Edge-Connector"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $19NeO.messages).servicesTitleNonFinal),
        description: formatMessage((0, $19NeO.messages).servicesDescriptionNonFinal),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $19NeO.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
                label: "",
                size: "small"
            }),
            "aria-label": formatMessage((0, $19NeO.messages).servicesTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#External-services"
    })))));
};

});
parcelRegister("8CfG4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $645e088e86b3f594$var$_react = $645e088e86b3f594$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $645e088e86b3f594$var$_page = $645e088e86b3f594$var$_interopRequireDefault((parcelRequire("20Mcc")));
function $645e088e86b3f594$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $645e088e86b3f594$var$PageIcon = (props)=>/*#__PURE__*/ $645e088e86b3f594$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
    }, props, {
        newIcon: $645e088e86b3f594$var$_page.default
    }));
$645e088e86b3f594$var$PageIcon.displayName = 'PageIcon';
var $645e088e86b3f594$var$_default = module.exports.default = $645e088e86b3f594$var$PageIcon;

});
parcelRegister("20Mcc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1770f78818431634$var$_react = $1770f78818431634$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1770f78818431634$var$_UNSAFE_baseNew = $1770f78818431634$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $1770f78818431634$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Page".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1770f78818431634$var$PageIcon = (props)=>/*#__PURE__*/ $1770f78818431634$var$_react.default.createElement($1770f78818431634$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$1770f78818431634$var$PageIcon.displayName = 'PageIcon';
var $1770f78818431634$var$_default = module.exports.default = $1770f78818431634$var$PageIcon;

});


parcelRegister("9pFPL", function(module, exports) {

$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("cPWxh")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("cPWxh")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 28g4fxvt8gs4swgsfwsrm85
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/28g4fxvt8gs4swgsfwsrm85

var $9TZf5 = parcelRequire("9TZf5");

var $cPWxh = parcelRequire("cPWxh");
const $744649ee89a95bf0$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($cPWxh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($cPWxh))
});
var $744649ee89a95bf0$export$2e2bcd8739ae039 = $744649ee89a95bf0$var$Illustration;
// for advanced use only
const $744649ee89a95bf0$export$a179c88182cb9d56 = [
    0,
    0,
    249,
    239
];

});
parcelRegister("cPWxh", function(module, exports) {
module.exports = new URL("trash.a4bf000c.svg", import.meta.url).toString();

});


parcelRegister("lYf25", function(module, exports) {

$parcel$export(module.exports, "CardList", () => $f74bef3124d987b2$export$bb29c16f5612603e);
$parcel$export(module.exports, "CardListItem", () => $f74bef3124d987b2$export$9156e7ca4e0589e5);

var $eUqFw = parcelRequire("eUqFw");

var $4kMup = parcelRequire("4kMup");
var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");
const $f74bef3124d987b2$export$bb29c16f5612603e = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        role: "list",
        xcss: $f74bef3124d987b2$var$wrapperStyles
    }, children);
const $f74bef3124d987b2$export$9156e7ca4e0589e5 = ({ title: title, description: description, href: href, afterIcon: afterIcon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        role: "listitem",
        xcss: $f74bef3124d987b2$var$listStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        href: href,
        target: "_blank",
        xcss: $f74bef3124d987b2$var$linkStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        size: "medium"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        size: "small",
        color: "color.text.subtlest"
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f74bef3124d987b2$var$afterIconStyles
    }, afterIcon))));
const $f74bef3124d987b2$var$afterIconStyles = (0, $1ZAYh.xcss)({
    flexShrink: 0
});
const $f74bef3124d987b2$var$wrapperStyles = (0, $1ZAYh.xcss)({
    border: '1px solid',
    borderColor: 'color.border',
    borderRadius: 'border.radius.200',
    overflow: 'hidden',
    width: '100%'
});
const $f74bef3124d987b2$var$listStyles = (0, $1ZAYh.xcss)({
    cursor: 'pointer',
    listStyleType: 'none',
    borderBottom: '1px solid',
    backgroundColor: 'elevation.surface',
    borderBottomColor: 'color.border',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-child': {
        borderBottom: '0'
    }
});
const $f74bef3124d987b2$var$linkStyles = (0, $1ZAYh.xcss)({
    display: 'block',
    padding: 'space.150',
    textDecoration: 'none',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        textDecoration: 'underline'
    },
    ':focus-within': {
        outline: 'none',
        backgroundColor: 'elevation.surface.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.pressed'
    }
});

});

parcelRegister("a5i7W", function(module, exports) {

$parcel$export(module.exports, "getUsersAndRolesTasks", () => $0fbf7b215f9ac72f$export$f657c0bf669f7c6f);
$parcel$export(module.exports, "getAlertsTasks", () => $0fbf7b215f9ac72f$export$c20dcc2e5bca31f);
$parcel$export(module.exports, "getNotificationsTasks", () => $0fbf7b215f9ac72f$export$965e2a52789d9ed1);
$parcel$export(module.exports, "getTeamsTasks", () => $0fbf7b215f9ac72f$export$1c78be8966011bdd);
$parcel$export(module.exports, "getChatToolsTasks", () => $0fbf7b215f9ac72f$export$fb7096e57ecb71c0);
$parcel$export(module.exports, "getAutomateAlertAndIncidentResponseTasks", () => $0fbf7b215f9ac72f$export$b7b04088d49bb385);
$parcel$export(module.exports, "getIntegrationsTasks", () => $0fbf7b215f9ac72f$export$fd18e60487f7976e);
$parcel$export(module.exports, "getDeprecatedOnesTasks", () => $0fbf7b215f9ac72f$export$3ac8fcaa0f45ffba);
$parcel$export(module.exports, "getHeartbeatsTasks", () => $0fbf7b215f9ac72f$export$3c15015776773877);
$parcel$export(module.exports, "getIncidentsTasks", () => $0fbf7b215f9ac72f$export$c8a56ca65a2b374f);
$parcel$export(module.exports, "getFindWhatYouAreLookingForTasks", () => $0fbf7b215f9ac72f$export$6faaa4c808c4f178);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $gVzxN = parcelRequire("gVzxN");
const $0fbf7b215f9ac72f$export$f657c0bf669f7c6f = ({ isOptimalTooling: isOptimalTooling, isSiteAdmin: isSiteAdmin, adminDifferenceCount: adminDifferenceCount, customRoleDifferenceCount: customRoleDifferenceCount, stakeholderCount: stakeholderCount })=>{
    const tasks = [
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).usersAndRolesTaskOneNonFinal)
        },
        {
            isCompleted: adminDifferenceCount === 0,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $gVzxN.default).usersAndRolesTaskTwoNonFinal,
                values: {
                    count: adminDifferenceCount
                }
            })
        },
        {
            isCompleted: customRoleDifferenceCount === 0,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $gVzxN.default).usersAndRolesTaskThreeNonFinal,
                values: {
                    count: customRoleDifferenceCount
                }
            })
        }
    ];
    if (isOptimalTooling && isSiteAdmin && stakeholderCount > 0) tasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).usersAndRolesTaskFourNonFinal)
    });
    return tasks;
};
const $0fbf7b215f9ac72f$export$c20dcc2e5bca31f = (isOptimalTooling)=>{
    const tasks = [
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).alertsTaskOneNonFinal)
        },
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).alertsTaskTwoNonFinal)
        },
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).alertsTaskThreeNonFinal)
        }
    ];
    if (isOptimalTooling) tasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).alertsTaskFourNonFinal)
    });
    return tasks;
};
const $0fbf7b215f9ac72f$var$getCardTwoTasks = ({ areOgAppsDeactivated: areOgAppsDeactivated, ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart, isRBNEnabled: isRBNEnabled })=>{
    // No second card
    if (!ogAppExistsAtTransitioningStart && !isRBNEnabled) return [];
    // 2D
    if (!ogAppExistsAtTransitioningStart && isRBNEnabled) return [
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).contactMethodTitleNonFinal)
        }
    ];
    // 2C
    if (ogAppExistsAtTransitioningStart && isRBNEnabled && areOgAppsDeactivated) return [
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).preventPushTitleNonFinal)
        },
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).deleteOgContactMethodsTitleNonFinal)
        }
    ];
    // 2A & 2B & 2E
    return [
        {
            isCompleted: areOgAppsDeactivated,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).notificationsTaskThreeNonFinal)
        }
    ];
};
const $0fbf7b215f9ac72f$export$965e2a52789d9ed1 = ({ isJnaAppDownloaded: isJnaAppDownloaded, areOgAppsDeactivated: areOgAppsDeactivated, ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart, isRBNEnabled: isRBNEnabled, areOgRulesDuplicated: areOgRulesDuplicated })=>[
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).notificationsTaskOneNonFinal)
        },
        {
            isCompleted: isJnaAppDownloaded,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).notificationsTaskTwoNonFinal)
        },
        ...$0fbf7b215f9ac72f$var$getCardTwoTasks({
            isJnaAppDownloaded: isJnaAppDownloaded,
            areOgAppsDeactivated: areOgAppsDeactivated,
            ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart,
            isRBNEnabled: isRBNEnabled,
            areOgRulesDuplicated: areOgRulesDuplicated
        })
    ];
const $0fbf7b215f9ac72f$export$1c78be8966011bdd = (isOptimalTooling, hasItem)=>{
    const tasks = [
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).teamsTaskOneNonFinal)
        }
    ];
    if (isOptimalTooling && hasItem) tasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).teamsTaskTwoNonFinal)
    });
    return tasks;
};
const $0fbf7b215f9ac72f$export$fb7096e57ecb71c0 = ({ isChatToolsConnectedToJSM: isChatToolsConnectedToJSM, isOgIntegrationsCopiedToJSM: isOgIntegrationsCopiedToJSM, isDuplicateNotificationsPrevented: isDuplicateNotificationsPrevented, isPrimaryAdmin: isPrimaryAdmin, hasIntegration: hasIntegration })=>{
    const tasks = [
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).chatToolsTaskOneNonFinal)
        },
        {
            isCompleted: isDuplicateNotificationsPrevented,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).chatToolsTaskFourNonFinal)
        }
    ];
    const integrationTasks = [
        {
            isCompleted: isOgIntegrationsCopiedToJSM,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).chatToolsTaskThreeNonFinal)
        }
    ];
    const primaryAdminTasks = [
        {
            isCompleted: isChatToolsConnectedToJSM,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).chatToolsTaskTwoNonFinal)
        }
    ];
    if (hasIntegration) tasks.splice(1, 0, ...integrationTasks);
    if (isPrimaryAdmin) tasks.splice(1, 0, ...primaryAdminTasks);
    return tasks;
};
const $0fbf7b215f9ac72f$export$b7b04088d49bb385 = ()=>[
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).automateAlertsAndIncidentResponseTaskOneNonFinal)
        },
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).automateAlertsAndIncidentResponseTaskTwoNonFinal)
        }
    ];
const $0fbf7b215f9ac72f$export$fd18e60487f7976e = ({ hasSyncedIntegration: hasSyncedIntegration, hasDiscontinuedIntegration: hasDiscontinuedIntegration, hasDeprecatedIntegration: hasDeprecatedIntegration, hasIncomingCallIntegration: hasIncomingCallIntegration, shouldHaveIncomingCallPermission: shouldHaveIncomingCallPermission })=>{
    const integrationTasks = [
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).integrationsTaskOneNonFinal)
        }
    ];
    if (hasSyncedIntegration) integrationTasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).integrationsTaskTwoNonFinal)
    });
    if (hasDiscontinuedIntegration) integrationTasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).integrationsTaskThreeNonFinal)
    });
    if (hasDeprecatedIntegration) integrationTasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).integrationsTaskFourNonFinal)
    });
    if (hasIncomingCallIntegration && shouldHaveIncomingCallPermission) integrationTasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).integrationsTaskFiveNonFinal)
    });
    return integrationTasks;
};
const $0fbf7b215f9ac72f$export$3ac8fcaa0f45ffba = ({ isAdmin: isAdmin, hasDeprecatedIntegration: hasDeprecatedIntegration, hasDeprecatedGroups: hasDeprecatedGroups, hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats, hasDeprecatedNotificationPolicies: hasDeprecatedNotificationPolicies })=>{
    // We have 7 static tasks which is displayed no matter what
    let totalCount = 7;
    // Deprecated integrations is dispplayed for admins and team admins
    if (hasDeprecatedIntegration) totalCount += 1;
    if (isAdmin) {
        if (hasDeprecatedGroups) totalCount += 1;
        if (hasDeprecatedGlobalHeartbeats) totalCount += 1;
        if (hasDeprecatedNotificationPolicies) totalCount += 1;
    }
    return [
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $gVzxN.default).deprecatedOnesTaskOneNonFinal,
                values: {
                    deprecatedFeaturesCount: totalCount
                }
            })
        }
    ];
};
const $0fbf7b215f9ac72f$export$3c15015776773877 = ({ hasDeprecatedTotalHeartbeats: hasDeprecatedTotalHeartbeats, hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats, isExceedHeartbeatLimit: isExceedHeartbeatLimit })=>{
    const tasks = [];
    if (hasDeprecatedTotalHeartbeats) tasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).heartbeatsTaskOneNonFinal)
    });
    if (hasDeprecatedGlobalHeartbeats) tasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).heartbeatsTaskTwoNonFinal)
    });
    if (isExceedHeartbeatLimit) tasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).heartbeatsTaskThreeNonFinal)
    });
    return tasks;
};
const $0fbf7b215f9ac72f$export$c8a56ca65a2b374f = ({ isCopied: isCopied, shouldDisplaySuccessBanner: shouldDisplaySuccessBanner, isEligibleForCopy: isEligibleForCopy })=>{
    const tasks = [
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).incidentsTaskTwoNonFinal)
        },
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).incidentsTaskThreeNonFinal)
        }
    ];
    if (isCopied) tasks.unshift({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).incidentsTaskOneNonFinal)
    });
    if (isEligibleForCopy) tasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).incidentsTaskFourNonFinal)
    });
    if (shouldDisplaySuccessBanner) tasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).incidentsTaskFourSuccessNonFinal)
    });
    return tasks;
};
const $0fbf7b215f9ac72f$export$6faaa4c808c4f178 = ()=>[
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).findWhatYouAreLookingForTaskOneNonFinal)
        }
    ];

});

parcelRegister("19NeO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $69cb1686924a501e$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $69cb1686924a501e$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    integrationsTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.integrations-title-non-final",
        "defaultMessage": "Integrations"
    },
    integrationsDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.integrations-description-non-final",
        "defaultMessage": "{deprecatedIntegrationCount, plural, one {{deprecatedIntegrationCount} integration} other {{deprecatedIntegrationCount} integrations}} weren't moved as they're not supported by Jira Service Management."
    },
    groupsTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.groups-title-non-final",
        "defaultMessage": "Groups"
    },
    groupsDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.groups-description-non-final",
        "defaultMessage": "{deprecatedGroupCount, plural, one {{deprecatedGroupCount} group} other {{deprecatedGroupCount} groups}} in Opsgenie weren't moved as they're now deprecated. You can recreate these groups as teams in Jira Service Management instead."
    },
    heartbeatsTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.heartbeats-title-non-final",
        "defaultMessage": "Heartbeats (V1)"
    },
    heartbeatsDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.heartbeats-description-non-final",
        "defaultMessage": "{deprecatedGlobalHeartbeatCount, plural, one {{deprecatedGlobalHeartbeatCount} heartbeat} other {{deprecatedGlobalHeartbeatCount} heartbeats}} in Opsgenie weren't moved as they're now deprecated. To move them to Jira Service Management, update to the latest version."
    },
    teamsApiTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.teams-api-title-non-final",
        "defaultMessage": "Teams API"
    },
    teamsApiDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.teams-api-description-non-final",
        "defaultMessage": "The Teams Opsgenie API doesn't work with Jira Service Management. You can use the alternative Jira Cloud Platform API."
    },
    incidentTemplatesTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.incident-templates-title-non-final",
        "defaultMessage": "Incident templates"
    },
    incidentTemplatesDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.incident-templates-description-non-final",
        "defaultMessage": "Incident templates aren't supported by Jira Service Management, so they weren't moved. You can use incident request types instead."
    },
    iccAndBridgesTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.icc-and-bridges-title-non-final",
        "defaultMessage": "Incident Command Center and Conference Bridges"
    },
    iccAndBridgesDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.icc-and-bridges-description-non-final",
        "defaultMessage": "The Incident Command Center and Conference Bridges aren't supported by Jira Service Management. You can use the Slack, Microsoft Teams, and Zoom apps instead."
    },
    notificationPoliciesTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.notification-policies-title-non-final",
        "defaultMessage": "Notification policies (V1)"
    },
    notificationPoliciesDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.notification-policies-description-non-final",
        "defaultMessage": "{deprecatedNotificationPolicyCount, plural, one {{deprecatedNotificationPolicyCount} notification policy wasn't} other {{deprecatedNotificationPolicyCount} notification policies weren't}} moved as they're now deprecated. To move them to Jira Service Management, update to the latest version."
    },
    actionsAndIncidentRulesTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.actions-and-incident-rules-title-non-final",
        "defaultMessage": "Actions and incident rules"
    },
    actionsAndIncidentRulesDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.actions-and-incident-rules-description-non-final",
        "defaultMessage": "Opsgenie actions and incident rules weren't moved. You can recreate actions and rules using Jira automation."
    },
    reportsTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.reports-title-non-final",
        "defaultMessage": "Some reports"
    },
    reportsDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.reports-description-non-final",
        "defaultMessage": "A few reports are not available in Jira Service Management as there are either not supported or are replaced by new reports."
    },
    oecTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.oec-title-non-final",
        "defaultMessage": "Opsgenie Edge Connector"
    },
    oecDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.oec-description-non-final",
        "defaultMessage": "Your existing OEC integrations will continue to work in Jira. You can create new integrations and actions with the new Jira Edge Connector."
    },
    servicesTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.services-title-non-final",
        "defaultMessage": "External services"
    },
    servicesDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.services-description-non-final",
        "defaultMessage": "It's not possible to create an external service in Jira. You can simply add stakeholders to your services or incidents instead."
    },
    tooltipTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.tooltip-text-non-final",
        "defaultMessage": "Go to documentation"
    }
});

});


parcelRegister("1RgAi", function(module, exports) {

$parcel$export(module.exports, "FindStep", () => $51eb85ea8552548c$export$612db864546c088e);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $23NQ5 = parcelRequire("23NQ5");

var $iFmgL = parcelRequire("iFmgL");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");
parcelRequire("17zNW");
var $fFQjm = parcelRequire("fFQjm");

var $5JgJ2 = parcelRequire("5JgJ2");

var $c7H0g = parcelRequire("c7H0g");
var $1R3n5 = parcelRequire("1R3n5");

var $lYf25 = parcelRequire("lYf25");

var $jeqlo = parcelRequire("jeqlo");

var $220rR = parcelRequire("220rR");

var $5MGFf = parcelRequire("5MGFf");

var $gVzxN = parcelRequire("gVzxN");

var $bkVBU = parcelRequire("bkVBU");

var $fBtfy = parcelRequire("fBtfy");
const $51eb85ea8552548c$export$612db864546c088e = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ isTeamAdmin: isTeamAdmin }] = (0, $bkVBU.useIsTeamAdmin)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isPrimaryAdmin = (0, $c7H0g.useIsAdmin)();
    const showAllAdmins = isSiteAdmin || isPrimaryAdmin || isTeamAdmin;
    const showRealAdmins = isSiteAdmin || isPrimaryAdmin;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220rR.TransitionHomeHeader), {
        title: formatMessage((0, $5MGFf.messages).findWhatYouAreLookingForTitleNonFinal),
        description: formatMessage((0, $5MGFf.messages).findWhatYouAreLookingForDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($fFQjm))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($fFQjm))),
            width: 200,
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        spread: "space-between",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $gVzxN.default).findWhatYouAreLookingForTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $51eb85ea8552548c$var$fullWidthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $fBtfy.messages).yourTeamsTitleNonFinal),
        description: formatMessage((0, $fBtfy.messages).yourTeamsDescriptionNonFinal),
        href: "/jira/people/search/teams",
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $fBtfy.messages).openTeamsNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                size: "small",
                label: ""
            }),
            "aria-label": formatMessage((0, $fBtfy.messages).openTeamsNonFinal)
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $fBtfy.messages).schedulesTitleNonFinal),
        description: formatMessage((0, $fBtfy.messages).schedulesDescriptionNonFinal),
        href: "/jira/ops/who-is-on-call",
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $fBtfy.messages).openSchedulesNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                size: "small",
                label: ""
            }),
            "aria-label": formatMessage((0, $fBtfy.messages).openSchedulesNonFinal)
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $fBtfy.messages).alertsTitleNonFinal),
        description: formatMessage((0, $fBtfy.messages).alertsDescriptionNonFinal),
        href: "/jira/ops/alerts",
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $fBtfy.messages).openAlertsNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                size: "small",
                label: ""
            }),
            "aria-label": formatMessage((0, $fBtfy.messages).openAlertsNonFinal)
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $fBtfy.messages).notificationSettingsTitleNonFinal),
        description: formatMessage((0, $fBtfy.messages).notificationSettingsDescriptionNonFinal),
        href: "/jira/settings/personal/alert-notifications",
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $fBtfy.messages).openNotificationsNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                size: "small",
                label: ""
            }),
            "aria-label": formatMessage((0, $fBtfy.messages).openNotificationsNonFinal)
        }))
    }), showAllAdmins && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $fBtfy.messages).reportsTitleNonFinal),
        description: formatMessage(isTeamAdmin ? (0, $fBtfy.messages).reportsTeamAdminDescriptionNonFinal : (0, $fBtfy.messages).reportsDescriptionNonFinal),
        href: isTeamAdmin ? '/jira/people/search/teams' : '/jira/settings/products/ops/reports',
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage(isTeamAdmin ? (0, $fBtfy.messages).openTeamsNonFinal : (0, $fBtfy.messages).viewReportsNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                size: "small",
                label: ""
            }),
            "aria-label": formatMessage(isTeamAdmin ? (0, $fBtfy.messages).openTeamsNonFinal : (0, $fBtfy.messages).viewReportsNonFinal)
        }))
    }), showRealAdmins && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $fBtfy.messages).auditTitleNonFinal),
        description: formatMessage((0, $fBtfy.messages).auditDescriptionNonFinal),
        href: "/jira/settings/products/ops/jira-service-management-audit-logs",
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $fBtfy.messages).openAuditLogsNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                size: "small",
                label: ""
            }),
            "aria-label": formatMessage((0, $fBtfy.messages).openAuditLogsNonFinal)
        }))
    }), showRealAdmins && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $fBtfy.messages).rbnTitleNonFinal),
        description: formatMessage((0, $fBtfy.messages).rbnDescriptionNonFinal),
        href: "/jira/settings/products/ops/role-based-notifications",
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $fBtfy.messages).openRbnNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                size: "small",
                label: ""
            }),
            "aria-label": formatMessage((0, $fBtfy.messages).openRbnNonFinal)
        }))
    }), showAllAdmins && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage(isTeamAdmin ? (0, $fBtfy.messages).customTeamRolesTitleNonFinal : (0, $fBtfy.messages).customRolesTitleNonFinal),
        description: formatMessage(isTeamAdmin ? (0, $fBtfy.messages).customRolesTeamAdminDescriptionNonFinal : (0, $fBtfy.messages).customRolesDescriptionNonFinal),
        href: isTeamAdmin ? '/jira/people/search/teams' : '/jira/settings/products/ops/roles',
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage(isTeamAdmin ? (0, $fBtfy.messages).openTeamsNonFinal : (0, $fBtfy.messages).openCustomRolesNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                size: "small",
                label: ""
            }),
            "aria-label": formatMessage(isTeamAdmin ? (0, $fBtfy.messages).openTeamsNonFinal : (0, $fBtfy.messages).openCustomRolesNonFinal)
        }))
    }), showAllAdmins && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $fBtfy.messages).automationTitleNonFinal),
        description: formatMessage(isTeamAdmin ? (0, $fBtfy.messages).automationTeamAdminDescriptionNonFinal : (0, $fBtfy.messages).automationDescriptionNonFinal),
        href: isTeamAdmin ? '/jira/people/search/teams' : '/jira/settings/automation',
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage(isTeamAdmin ? (0, $fBtfy.messages).openTeamsNonFinal : (0, $fBtfy.messages).openAutomationNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                size: "small",
                label: ""
            }),
            "aria-label": formatMessage(isTeamAdmin ? (0, $fBtfy.messages).openTeamsNonFinal : (0, $fBtfy.messages).openAutomationNonFinal)
        }))
    }), showAllAdmins && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYf25.CardListItem), {
        title: formatMessage((0, $fBtfy.messages).syncTitleNonFinal),
        description: formatMessage(isTeamAdmin ? (0, $fBtfy.messages).syncTeamAdminDescriptionNonFinal : (0, $fBtfy.messages).syncDescriptionNonFinal),
        href: isTeamAdmin ? '/jira/people/search/teams' : '/jira/settings/products/ops/syncs',
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage(isTeamAdmin ? (0, $fBtfy.messages).openTeamsNonFinal : (0, $fBtfy.messages).openSyncNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                size: "small",
                label: ""
            }),
            "aria-label": formatMessage(isTeamAdmin ? (0, $fBtfy.messages).openTeamsNonFinal : (0, $fBtfy.messages).openSyncNonFinal)
        }))
    }))))));
};
const $51eb85ea8552548c$var$fullWidthStyles = (0, $1ZAYh.xcss)({
    width: '100%'
});

});
parcelRegister("17zNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5db74c20798b6f43$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("fFQjm")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("fFQjm")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = nj3nrg7zrmxwrhh9fn9ftw5m
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/nj3nrg7zrmxwrhh9fn9ftw5m

var $9TZf5 = parcelRequire("9TZf5");

var $fFQjm = parcelRequire("fFQjm");
const $5db74c20798b6f43$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($fFQjm)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fFQjm))
});
var $5db74c20798b6f43$export$2e2bcd8739ae039 = $5db74c20798b6f43$var$Illustration;
// for advanced use only
const $5db74c20798b6f43$export$a179c88182cb9d56 = [
    0,
    0,
    95,
    89
];

});
parcelRegister("fFQjm", function(module, exports) {
module.exports = new URL("magic-search.dbdce574.svg", import.meta.url).toString();

});


parcelRegister("fBtfy", function(module, exports) {

$parcel$export(module.exports, "messages", () => $caf4159dd792110c$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $caf4159dd792110c$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    yourTeamsTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.your-teams-title-non-final",
        "defaultMessage": "Your teams from Opsgenie"
    },
    yourTeamsDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.your-teams-description-non-final",
        "defaultMessage": "Where to find it: Jira navigation > Teams > Go to operations"
    },
    schedulesTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.schedules-title-non-final",
        "defaultMessage": "On-call schedules"
    },
    schedulesDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.schedules-description-non-final",
        "defaultMessage": "Where to find it: Your work > On-call"
    },
    alertsTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.alerts-title-non-final",
        "defaultMessage": "Alerts"
    },
    alertsDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.alerts-description-non-final",
        "defaultMessage": "Where to find it: Your work > Alerts"
    },
    notificationSettingsTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.notification-settings-title-non-final",
        "defaultMessage": "Personal notification settings"
    },
    notificationSettingsDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.notification-settings-description-non-final",
        "defaultMessage": "Where to find it: Your profile and settings > Personal settings > Alerts"
    },
    reportsTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.reports-title-non-final",
        "defaultMessage": "Reports"
    },
    reportsDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.reports-description-non-final",
        "defaultMessage": "Where to find it: Settings > Products > Reports"
    },
    reportsTeamAdminDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.reports-team-admin-description-non-final",
        "defaultMessage": "Where to find it: Teams > Go to operations > Reports"
    },
    auditTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.audit-title-non-final",
        "defaultMessage": "Audit logs"
    },
    auditDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.audit-description-non-final",
        "defaultMessage": "Where to find it: Settings > Products > Audit logs"
    },
    rbnTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.rbn-title-non-final",
        "defaultMessage": "Role-based notifications"
    },
    rbnDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.rbn-description-non-final",
        "defaultMessage": "Where to find it: Settings > Products > Role-based notifications"
    },
    customRolesTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.custom-roles-title-non-final",
        "defaultMessage": "Custom roles"
    },
    customTeamRolesTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.custom-team-roles-title-non-final",
        "defaultMessage": "Custom team roles"
    },
    customRolesDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.custom-roles-description-non-final",
        "defaultMessage": "Where to find it: Settings > Products > Custom roles"
    },
    customRolesTeamAdminDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.custom-roles-team-admin-description-non-final",
        "defaultMessage": "Where to find it: Teams > Go to operations > Member roles"
    },
    automationTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.automation-title-non-final",
        "defaultMessage": "Automation"
    },
    automationDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.automation-description-non-final",
        "defaultMessage": "Where to find it: Settings > System > Automation"
    },
    automationTeamAdminDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.automation-team-admin-description-non-final",
        "defaultMessage": "Where to find it: Teams > Go to operations > Automation"
    },
    syncTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.sync-title-non-final",
        "defaultMessage": "Sync"
    },
    syncDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.sync-description-non-final",
        "defaultMessage": "Where to find it: Settings > System > Sync"
    },
    syncTeamAdminDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.sync-team-admin-description-non-final",
        "defaultMessage": "Where to find it: Teams > Go to operations > Sync"
    },
    openTeamsNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.open-teams-non-final",
        "defaultMessage": "Open teams"
    },
    openAlertsNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.open-alerts-non-final",
        "defaultMessage": "Open alerts"
    },
    openSchedulesNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.open-schedules-non-final",
        "defaultMessage": "Open on-call schedules"
    },
    openNotificationsNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.open-notifications-non-final",
        "defaultMessage": "Open personal notification settings"
    },
    viewReportsNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.view-reports-non-final",
        "defaultMessage": "View documentation"
    },
    openAuditLogsNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.open-audit-logs-non-final",
        "defaultMessage": "Open audit logs"
    },
    openRbnNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.open-rbn-non-final",
        "defaultMessage": "Open role-based notifications"
    },
    openCustomRolesNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.open-custom-roles-non-final",
        "defaultMessage": "Open custom roles"
    },
    openAutomationNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.open-automation-non-final",
        "defaultMessage": "Open automation"
    },
    openSyncNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.open-sync-non-final",
        "defaultMessage": "Open sync"
    }
});

});


parcelRegister("gGnGU", function(module, exports) {

$parcel$export(module.exports, "HeartbeatsStep", () => $6815b09f2efa74d1$export$7d42d8486f0042ef);

var $eUqFw = parcelRequire("eUqFw");

var $27B3S = parcelRequire("27B3S");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $iFmgL = parcelRequire("iFmgL");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");

var $ijwdS = parcelRequire("ijwdS");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iXxc0 = parcelRequire("iXxc0");

var $jeqlo = parcelRequire("jeqlo");

var $220rR = parcelRequire("220rR");

var $5MGFf = parcelRequire("5MGFf");

var $gVzxN = parcelRequire("gVzxN");

var $lzGyk = parcelRequire("lzGyk");

var $8OZdV = parcelRequire("8OZdV");

var $ehhLy = parcelRequire("ehhLy");
const $6815b09f2efa74d1$export$7d42d8486f0042ef = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { opsgenieBaseUrl: opsgenieBaseUrl } = (0, $lzGyk.useGlobalChangeboarding)();
    const [{ hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats, hasDeprecatedTotalHeartbeats: hasDeprecatedTotalHeartbeats, isExceedHeartbeatLimit: isExceedHeartbeatLimit, heartbeats: heartbeats }] = (0, $8OZdV.useDeprecatedHeartbeats)();
    if (!heartbeats.data) throw new Error('Heartbeats step - heartbeat counts data should be loaded at this point');
    const { globalHeartbeatCount: globalHeartbeatCount, totalHeartbeatCount: totalHeartbeatCount } = heartbeats.data;
    const ogHeartbeatsUrl = opsgenieBaseUrl ? `${opsgenieBaseUrl}/settings/heartbeat` : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220rR.TransitionHomeHeader), {
        title: formatMessage((0, $5MGFf.messages).heartbeatsTitleNonFinal),
        description: formatMessage((0, $5MGFf.messages).heartbeatsDescriptionNonFinal)
    }), hasDeprecatedTotalHeartbeats && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $gVzxN.default).heartbeatsTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $iXxc0.Anchor)
                }
            }
        }
    }, formatMessage((0, $ehhLy.messages).taskOneDescriptionNonFinal, {
        totalHeartbeatCount: totalHeartbeatCount
    }))))), hasDeprecatedGlobalHeartbeats && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            width: "163px",
            src: (0, $ijwdS.srcLight),
            srcDark: (0, $ijwdS.srcDark),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $gVzxN.default).heartbeatsTaskTwoNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $iXxc0.Anchor)
                }
            }
        }
    }, formatMessage((0, $ehhLy.messages).taskTwoDescriptionNonFinal, {
        globalHeartbeatCount: globalHeartbeatCount
    }))))), isExceedHeartbeatLimit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $gVzxN.default).heartbeatsTaskThreeNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $iXxc0.Anchor)
                }
            }
        }
    }, formatMessage((0, $ehhLy.messages).taskThreeDescriptionNonFinal, {
        heartbeatToBeRemovedCount: totalHeartbeatCount - 2000
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: ogHeartbeatsUrl,
        target: "_blank"
    }, formatMessage((0, $ehhLy.messages).taskThreeButtonNonFinal))))));
};

});
parcelRegister("ehhLy", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6fd847f8763c6fb3$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $6fd847f8763c6fb3$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    taskOneDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.heartbeats-step.task-one-description-non-final",
        "defaultMessage": "We've moved {totalHeartbeatCount, plural, one {{totalHeartbeatCount} heartbeat} other {{totalHeartbeatCount} heartbeats}} from Opsgenie to Jira Service Management. They've now moved from Opsgenie address to a new Jira Service Management-based address.\n\nYou'll need to update the address of the heartbeats wherever they're used in your systems, to ensure the heartbeats work as expected.\n\n[Read more about the updated heartbeats](https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Heartbeats)\n"
    },
    taskTwoDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.heartbeats-step.task-two-description-non-final",
        "defaultMessage": "Looks like {globalHeartbeatCount, plural, one {{globalHeartbeatCount} heartbeat} other {{globalHeartbeatCount} heartbeats}} in Opsgenie aren't assigned to any team. So they weren't synced with Jira Service Management. [Read more about heartbeats without an assigned team](https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Heartbeats)\n"
    },
    taskThreeDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.heartbeats-step.task-three-description-non-final",
        "defaultMessage": "Looks like you've got more than 2,000 heartbeats in your Jira Service Management site, which are more than the allowed limit. You'll need to remove {heartbeatToBeRemovedCount} so you can add more heartbeats. [Read how to remove excess heartbeats](https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Heartbeats)\n"
    },
    taskThreeButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.heartbeats-step.task-three-button-non-final",
        "defaultMessage": "Go to heartbeats in Opsgenie"
    }
});

});


parcelRegister("585Wt", function(module, exports) {

$parcel$export(module.exports, "IncidentsStep", () => $51c2ef42e8fa73cf$export$7da1951768bbe34c);

var $eUqFw = parcelRequire("eUqFw");

var $27B3S = parcelRequire("27B3S");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $bT7k5 = parcelRequire("bT7k5");

var $hI5oG = parcelRequire("hI5oG");

var $iFmgL = parcelRequire("iFmgL");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");

var $1BxcC = parcelRequire("1BxcC");
parcelRequire("f6nFT");
var $82KlD = parcelRequire("82KlD");
parcelRequire("lQXqy");
var $6bGvz = parcelRequire("6bGvz");
var $jhcOe = parcelRequire("jhcOe");

var $ijwdS = parcelRequire("ijwdS");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7gA9Z = parcelRequire("7gA9Z");

var $iXxc0 = parcelRequire("iXxc0");

var $jeqlo = parcelRequire("jeqlo");

var $220rR = parcelRequire("220rR");

var $5MGFf = parcelRequire("5MGFf");

var $jxABB = parcelRequire("jxABB");

var $gVzxN = parcelRequire("gVzxN");

var $3CBya = parcelRequire("3CBya");

var $bZcoj = parcelRequire("bZcoj");

var $dPaxG = parcelRequire("dPaxG");

var $lbvpY = parcelRequire("lbvpY");

var $hliOZ = parcelRequire("hliOZ");

var $7O856 = parcelRequire("7O856");

var $lzdnQ = parcelRequire("lzdnQ");

var $2dlWw = parcelRequire("2dlWw");

var $bLjxY = parcelRequire("bLjxY");
const $51c2ef42e8fa73cf$export$7da1951768bbe34c = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isChecked, setIsChecked] = (0, $eUqFw.useState)(false);
    const [isCopyManuallyInitiated, setIsCopyManuallyInitiated] = (0, $eUqFw.useState)(false);
    const [{ projectKey: projectKey, hasCopyOperationError: hasCopyOperationError, isCopied: isCopied, isCopying: isCopying, isEligibleForCopy: isEligibleForCopy, shouldDisplaySuccessBanner: shouldDisplaySuccessBanner }, { copyIncidents: copyIncidents, getIncidentsCopyStatus: getIncidentsCopyStatus }] = (0, $3CBya.useIncidents)();
    // If the copy operation is in progress, we need to keep checking the status in the interval
    (0, $1BxcC.useInterval)(getIncidentsCopyStatus, (isCopying || isCopyManuallyInitiated) && !isCopied ? 3000 : null);
    const incidentsJiraWebUrl = `/jira/servicedesk/projects/${projectKey}/section/incidents`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220rR.TransitionHomeHeader), {
        title: formatMessage((0, $5MGFf.messages).incidentsTitleNonFinal),
        description: formatMessage((0, $5MGFf.messages).incidentsDescriptionNonFinal)
    }), isCopying && !isCopyManuallyInitiated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            width: "262px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($82KlD))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($82KlD))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        level: "h500"
    }, formatMessage((0, $lzdnQ.messages).loadingTitleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, " ", formatMessage((0, $lzdnQ.messages).loadingDescriptionNonFinal)))), hasCopyOperationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            width: "80px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($jhcOe))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($6bGvz))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $lzdnQ.messages).errorDescriptionNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: (0, $7gA9Z.JIRA_SUPPORT_LINK),
        target: "_blank",
        appearance: "warning"
    }, formatMessage((0, $lzdnQ.messages).contactAtlassianSupportButtonNonFinal))))), isCopied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            width: "249px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($lbvpY))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($dPaxG))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        level: "h500"
    }, formatMessage((0, $gVzxN.default).incidentsTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $lzdnQ.messages).taskOneDescriptionNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: incidentsJiraWebUrl,
        target: "_blank"
    }, formatMessage((0, $lzdnQ.messages).taskOneButtonNonFinal)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            width: "293px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($7O856))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($hliOZ))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        level: "h500"
    }, formatMessage((0, $gVzxN.default).incidentsTaskTwoNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $lzdnQ.messages).taskTwoDescriptionNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2dlWw.PriorityTable), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLjxY.StatusTable), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            width: "118px",
            src: (0, $ijwdS.srcLight),
            srcDark: (0, $ijwdS.srcDark),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        level: "h500"
    }, formatMessage((0, $gVzxN.default).incidentsTaskThreeNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), {
        options: {
            overrides: {
                ul: {
                    component: (0, $jxABB.UnorderedList)
                },
                li: {
                    component: (0, $jxABB.UnorderedListItem)
                }
            }
        }
    }, formatMessage((0, $lzdnQ.messages).taskThreeDescriptionNonFinal)))), (isEligibleForCopy || isCopying && isCopyManuallyInitiated) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            width: "240px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($bZcoj))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        level: "h500"
    }, formatMessage((0, $gVzxN.default).incidentsTaskFourNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $lzdnQ.messages).taskFourDescriptionNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        isChecked: isChecked,
        onChange: ()=>setIsChecked((current)=>!current),
        label: formatMessage((0, $lzdnQ.messages).taskFourConfirmationNonFinal),
        isDisabled: isCopying && isCopyManuallyInitiated,
        isRequired: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        onClick: ()=>{
            setIsCopyManuallyInitiated(true);
            if (!isCopying) copyIncidents();
        },
        isLoading: isCopying && isCopyManuallyInitiated,
        isDisabled: !isChecked || isCopying && isCopyManuallyInitiated
    }, formatMessage((0, $lzdnQ.messages).taskFourCopyButtonNonFinal)))))), shouldDisplaySuccessBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            width: "240px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($bZcoj))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        level: "h500"
    }, formatMessage((0, $gVzxN.default).incidentsTaskFourSuccessNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $iXxc0.Anchor)
                }
            }
        }
    }, formatMessage((0, $lzdnQ.messages).taskFourDescriptionSuccessNonFinal)))));
};

});
parcelRegister("bT7k5", function(module, exports) {

$parcel$export(module.exports, "default", () => $562b222d8d94ede5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");

var $PdmhA = parcelRequire("PdmhA");

var $eYWZs = parcelRequire("eYWZs");
var $kzlpH = parcelRequire("kzlpH");
var $kbQR9 = parcelRequire("kbQR9");
var $1BPvG = parcelRequire("1BPvG");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $562b222d8d94ede5$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $562b222d8d94ede5$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $1lQG9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eUqFw.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kzlpH.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $562b222d8d94ede5$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eYWZs.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbQR9.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1BPvG.default), null)));
}));
$562b222d8d94ede5$var$Checkbox.displayName = 'Checkbox';
var $562b222d8d94ede5$export$2e2bcd8739ae039 = $562b222d8d94ede5$var$Checkbox;

});
parcelRegister("eYWZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da93fd40e0e88a3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");
function $3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $3da93fd40e0e88a3$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $3da93fd40e0e88a3$export$2e2bcd8739ae039 = $3da93fd40e0e88a3$var$CheckboxIcon;

});

parcelRegister("kzlpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f9422953e9457b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $f4f9422953e9457b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $PdmhA.N900)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $f4f9422953e9457b$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $f4f9422953e9457b$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $PdmhA.N80)})`,
    cursor: 'not-allowed'
});
const $f4f9422953e9457b$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $PdmhA.B50)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    '--local-border-active': `var(--ds-border, ${(0, $PdmhA.B50)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $PdmhA.R300)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $PdmhA.R300)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $PdmhA.B400)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $PdmhA.N10)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $PdmhA.N70)})`,
    '--local-tick-rest': 'transparent'
});
function $f4f9422953e9457b$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $f4f9422953e9457b$var$baseStyles,
            label && $f4f9422953e9457b$var$textLabelLayoutStyles,
            isDisabled && $f4f9422953e9457b$var$disabledStyles,
            $f4f9422953e9457b$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("kbQR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $582b6523b23912df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $582b6523b23912df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $582b6523b23912df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $582b6523b23912df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $582b6523b23912df$var$labelTextStyles
    }, children);
}

});

parcelRegister("1BPvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac167f9dd7ee34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $87ac167f9dd7ee34$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $PdmhA.R500)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $87ac167f9dd7ee34$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $87ac167f9dd7ee34$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("1BxcC", function(module, exports) {

$parcel$export(module.exports, "useInterval", () => $b083f9ec537b3759$export$f4b266cd2aae9cb1);

var $eUqFw = parcelRequire("eUqFw");
const $b083f9ec537b3759$export$f4b266cd2aae9cb1 = (callback, delay)=>{
    const savedCallbackRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        savedCallbackRef.current = callback;
    }, [
        callback
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const handler = (...args)=>savedCallbackRef.current(...args);
        if (delay !== null) {
            const intervalId = setInterval(handler, delay);
            return ()=>clearInterval(intervalId);
        }
    }, [
        delay
    ]);
};

});

parcelRegister("f6nFT", function(module, exports) {

$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("82KlD")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("82KlD")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = f3wqzmppnmtv35kjw7795k
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/f3wqzmppnmtv35kjw7795k

var $9TZf5 = parcelRequire("9TZf5");

var $82KlD = parcelRequire("82KlD");
const $1aa305e93f2b9dbd$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($82KlD)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($82KlD))
});
var $1aa305e93f2b9dbd$export$2e2bcd8739ae039 = $1aa305e93f2b9dbd$var$Illustration;
// for advanced use only
const $1aa305e93f2b9dbd$export$a179c88182cb9d56 = [
    0,
    0,
    583,
    280
];

});
parcelRegister("82KlD", function(module, exports) {
module.exports = new URL("moving.ac8b8afe.svg", import.meta.url).toString();

});


parcelRegister("lQXqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $30559913302f86cb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $30559913302f86cb$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("jhcOe")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6bGvz")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $9TZf5 = parcelRequire("9TZf5");

var $6bGvz = parcelRequire("6bGvz");

var $jhcOe = parcelRequire("jhcOe");
const $30559913302f86cb$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($jhcOe)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6bGvz))
});
var $30559913302f86cb$export$2e2bcd8739ae039 = $30559913302f86cb$var$Illustration;
// for advanced use only
const $30559913302f86cb$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("6bGvz", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("jhcOe", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("jxABB", function(module, exports) {

$parcel$export(module.exports, "UnorderedList", () => $3112d3b756250328$export$30b2abb1ad323770);
$parcel$export(module.exports, "UnorderedListItem", () => $3112d3b756250328$export$4418ead52cf036a8);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $3112d3b756250328$export$30b2abb1ad323770 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "ul",
        xcss: $3112d3b756250328$var$unorderedListBoxStyles
    }, children);
const $3112d3b756250328$export$4418ead52cf036a8 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "li",
        xcss: $3112d3b756250328$var$listItemBoxStyles
    }, children);
const $3112d3b756250328$var$unorderedListBoxStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.100',
    listStyle: 'none'
});
const $3112d3b756250328$var$listItemBoxStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':before': {
        content: '"\u2022"',
        fontSize: '10pt',
        paddingRight: 'space.100'
    }
});

});

parcelRegister("bZcoj", function(module, exports) {
module.exports = new URL("incidents-task-four-illustration.d40fac76.png", import.meta.url).toString();

});

parcelRegister("dPaxG", function(module, exports) {
module.exports = new URL("incidents-task-one-illustration-dark.ac414e13.png", import.meta.url).toString();

});

parcelRegister("lbvpY", function(module, exports) {
module.exports = new URL("incidents-task-one-illustration.6d9c99f6.png", import.meta.url).toString();

});

parcelRegister("hliOZ", function(module, exports) {
module.exports = new URL("incidents-task-two-illustration-dark.2cc09514.png", import.meta.url).toString();

});

parcelRegister("7O856", function(module, exports) {
module.exports = new URL("incidents-task-two-illustration.d4c7054b.png", import.meta.url).toString();

});

parcelRegister("lzdnQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3f14b9bc594579b0$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $3f14b9bc594579b0$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    errorDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.error-description-non-final",
        "defaultMessage": "We've bumped into an issue while copying incidents. Please get in touch with the Atlassian support team for help."
    },
    contactAtlassianSupportButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.contact-atlassian-support-button-non-final",
        "defaultMessage": "Contact Atlassian support"
    },
    loadingTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.loading-title-non-final",
        "defaultMessage": "We're copying your Opsgenie incidents to Jira Service Management"
    },
    loadingDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.loading-description-non-final",
        "defaultMessage": "Your Opsgenie incidents, linked alerts, and relevant data like PIRs are being copied to a new service project in Jira Service Management. Once it's complete, you'll be able to manage your incidents directly in Jira Service Management."
    },
    taskOneDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.task-one-description-non-final",
        "defaultMessage": "We've copied your Opsgenie incidents, linked alerts, and relevant data like PIRs to a new service project named **Opsgenie Migrated Incidents** in Jira Service Management, using the Incidents issue type. They'll now look and work the same way other issues do in Jira, with a more tailored experience for incident management.\n\nGo on, take a look."
    },
    taskOneButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.task-one-button-non-final",
        "defaultMessage": "View your incidents in Jira"
    },
    taskTwoDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.task-two-description-non-final",
        "defaultMessage": "We've made incident statuses and priorities simpler in Jira Service Management. Here's the mapping between Opsgenie and Jira's statuses and priorities:"
    },
    taskThreeDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.task-three-description-non-final",
        "defaultMessage": "These incident fields aren't copied from Opsgenie to Jira Service Management:\n\n- Actions\n- Responder roles\n- Stakeholder filters\n- Stakeholder templates\n"
    },
    taskFourDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.task-four-description-non-final",
        "defaultMessage": "We've copied your existing Opsgenie incidents and PIRs to Jira Service Management. It's recommend that you create and manage your incidents and PIRs directly in Jira Service Management from now on, as it's easier and more efficient.\n\nIf you create new incidents and PIRs in Opsgenie, you'll get only one chance to copy them to Jira Service Management."
    },
    taskFourConfirmationNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.task-four-confirmation-non-final",
        "defaultMessage": "I understand I can copy Opsgenie incidents only once"
    },
    taskFourCopyButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.task-four-copy-button-non-final",
        "defaultMessage": "Copy Opsgenie incidents to Jira"
    },
    taskFourDescriptionSuccessNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.task-four-description-success-non-final",
        "defaultMessage": "You successfully copied all your incidents to Jira Service Management.\n\nIf you need to copy any new incidents and PIRs again, get in touch with Atlassian Support team. [Contact Atlassian support](https://support.atlassian.com/contact/#/)"
    }
});

});

parcelRegister("2dlWw", function(module, exports) {

$parcel$export(module.exports, "PriorityTable", () => $57b3938e4c9fdccb$export$67ef5b89c4a3c145);

var $eUqFw = parcelRequire("eUqFw");

var $cGL6G = parcelRequire("cGL6G");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $luVFI = parcelRequire("luVFI");

var $1P9Xz = parcelRequire("1P9Xz");
const $57b3938e4c9fdccb$export$67ef5b89c4a3c145 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const Priorities = (0, $1P9Xz.getPriorities)(formatMessage);
    const rows = Object.values(Priorities).map((priority, index)=>({
            key: `row-${index}`,
            cells: [
                {
                    key: `cell-${index}-priority-in-Opsgenie`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.150"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                        // eslint-disable-next-line jira/react/no-style-attribute
                        style: {
                            backgroundColor: priority.bgColor,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`
                        }
                    }, priority.ogPriority))
                },
                {
                    key: `cell-${index}-priority-in-Jira`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
                        justifyContent: "end"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
                        columnGap: "space.050",
                        alignItems: "center",
                        xcss: $57b3938e4c9fdccb$var$priorityInJiraCellStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
                        xcss: $57b3938e4c9fdccb$var$IconContainer,
                        alignItems: "center",
                        justifyContent: "center"
                    }, priority.Icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "p"
                    }, priority.jiraPriority)))
                }
            ]
        }));
    const head = {
        cells: [
            {
                key: 'priority-in-Opsgenie',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    paddingInlineStart: "space.100"
                }, formatMessage((0, $luVFI.messages).priortiyInOpsgenieNonFinal))
            },
            {
                key: 'priority-in-Jira',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
                    justifyContent: "end"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    xcss: $57b3938e4c9fdccb$var$priorityInJiraHeadStyles
                }, formatMessage((0, $luVFI.messages).priortiyInJiraNonFinal)))
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cGL6G.default), {
        head: head,
        rows: rows,
        isFixedSize: true
    });
};
// In order to place priority in Jira column to the right, we need to set the width of the column.
const $57b3938e4c9fdccb$var$priorityInJiraHeadStyles = (0, $1ZAYh.xcss)({
    width: '127px'
});
const $57b3938e4c9fdccb$var$priorityInJiraCellStyles = (0, $1ZAYh.xcss)({
    width: '127px',
    paddingInlineStart: 'space.100'
});
const $57b3938e4c9fdccb$var$IconContainer = (0, $1ZAYh.xcss)({
    width: '20px',
    height: '20px'
});

});
parcelRegister("luVFI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b16809d42746cdb9$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $b16809d42746cdb9$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    priortiyInOpsgenieNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.priority-table.priortiy-in-opsgenie-non-final",
        "defaultMessage": "Priority in Opsgenie"
    },
    priortiyInJiraNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.priority-table.priortiy-in-jira-non-final",
        "defaultMessage": "Priority in Jira"
    },
    highestPriorityNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.priority-table.highest-priority-non-final",
        "defaultMessage": "Highest"
    },
    highPriorityNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.priority-table.high-priority-non-final",
        "defaultMessage": "High"
    },
    mediumPriorityNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.priority-table.medium-priority-non-final",
        "defaultMessage": "Medium"
    },
    lowPriorityNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.priority-table.low-priority-non-final",
        "defaultMessage": "Low"
    },
    lowestPriorityNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.priority-table.lowest-priority-non-final",
        "defaultMessage": "Lowest"
    }
});

});

parcelRegister("1P9Xz", function(module, exports) {

$parcel$export(module.exports, "getPriorities", () => $0420c23579ae9b8a$export$489e9c0d7da0a5e2);

var $eUqFw = parcelRequire("eUqFw");

var $iFmgL = parcelRequire("iFmgL");

var $PdmhA = parcelRequire("PdmhA");

var $2UDx5 = parcelRequire("2UDx5");

var $kZt08 = parcelRequire("kZt08");

var $jbaEz = parcelRequire("jbaEz");

var $kc2ce = parcelRequire("kc2ce");

var $g3FdF = parcelRequire("g3FdF");

var $luVFI = parcelRequire("luVFI");
const $0420c23579ae9b8a$export$489e9c0d7da0a5e2 = (formatMessage)=>({
        P1: {
            ogPriority: 'P1',
            bgColor: `var(--ds-icon-danger, ${0, $PdmhA.R500})`,
            jiraPriority: formatMessage((0, $luVFI.messages).highestPriorityNonFinal),
            Icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($kZt08))),
                alt: ""
            })
        },
        P2: {
            ogPriority: 'P2',
            bgColor: `var(--ds-background-accent-red-subtle, ${0, $PdmhA.R200})`,
            jiraPriority: formatMessage((0, $luVFI.messages).highPriorityNonFinal),
            Icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($2UDx5))),
                alt: ""
            })
        },
        P3: {
            ogPriority: 'P3',
            bgColor: `var(--ds-background-accent-orange-subtle, ${0, $PdmhA.Y400})`,
            jiraPriority: formatMessage((0, $luVFI.messages).mediumPriorityNonFinal),
            Icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($g3FdF))),
                alt: ""
            })
        },
        P4: {
            ogPriority: 'P4',
            bgColor: "var(--ds-background-accent-green-subtle, #22A06B)",
            jiraPriority: formatMessage((0, $luVFI.messages).lowPriorityNonFinal),
            Icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($jbaEz))),
                alt: ""
            })
        },
        P5: {
            ogPriority: 'P5',
            bgColor: "var(--ds-background-accent-green-bolder, #1F845A)",
            jiraPriority: formatMessage((0, $luVFI.messages).lowestPriorityNonFinal),
            Icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($kc2ce))),
                alt: ""
            })
        }
    });

});
parcelRegister("2UDx5", function(module, exports) {
module.exports = new URL("high-priority.427a170e.svg", import.meta.url).toString();

});

parcelRegister("kZt08", function(module, exports) {
module.exports = new URL("highest-priority.32f80175.svg", import.meta.url).toString();

});

parcelRegister("jbaEz", function(module, exports) {
module.exports = new URL("low-priority.2e35e1bc.svg", import.meta.url).toString();

});

parcelRegister("kc2ce", function(module, exports) {
module.exports = new URL("lowest-priority.c391bcb1.svg", import.meta.url).toString();

});

parcelRegister("g3FdF", function(module, exports) {
module.exports = new URL("medium-priority.e0880a26.svg", import.meta.url).toString();

});



parcelRegister("bLjxY", function(module, exports) {

$parcel$export(module.exports, "StatusTable", () => $ab59b6c27485a0bf$export$c849b5d47a9c2fe0);

var $eUqFw = parcelRequire("eUqFw");

var $cGL6G = parcelRequire("cGL6G");

var $cSu9v = parcelRequire("cSu9v");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1Yimi = parcelRequire("1Yimi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5d231 = parcelRequire("5d231");

var $ehhWF = parcelRequire("ehhWF");
const $ab59b6c27485a0bf$export$c849b5d47a9c2fe0 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const Status = (0, $ehhWF.getStatus)(formatMessage);
    const rows = Object.values(Status).map((status, index)=>({
            key: `row-${index}`,
            cells: [
                {
                    key: `cell-${index}-status-in-Opsgenie`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.150"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "p"
                    }, status.ogStatus))
                },
                {
                    key: `cell-${index}-status-in-Jira`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.150"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
                        alignItems: "center",
                        justifyContent: "space-between"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "p"
                    }, status.jiraStatus), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
                        columnGap: "space.025"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
                        label: "",
                        size: "small"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                        appearance: status.appearance
                    }, status.lozengeContent))))
                }
            ]
        }));
    const head = {
        cells: [
            {
                key: 'priority-in-Opsgenie',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    paddingInlineStart: "space.100"
                }, formatMessage((0, $5d231.messages).statusInOpsgenieNonFinal))
            },
            {
                key: 'priority-in-Jira',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    paddingInlineStart: "space.100"
                }, formatMessage((0, $5d231.messages).statusInJiraNonFinal))
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cGL6G.default), {
        head: head,
        rows: rows,
        isFixedSize: true
    });
};

});
parcelRegister("5d231", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e7c6af85f006b0f4$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $e7c6af85f006b0f4$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    statusInOpsgenieNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.status-in-opsgenie-non-final",
        "defaultMessage": "Status in Opsgenie"
    },
    statusInJiraNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.status-in-jira-non-final",
        "defaultMessage": "Status in Jira"
    },
    openNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.open-non-final",
        "defaultMessage": "Open"
    },
    resolveNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.resolve-non-final",
        "defaultMessage": "Resolve"
    },
    closeNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.close-non-final",
        "defaultMessage": "Close"
    },
    deleteNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.delete-non-final",
        "defaultMessage": "Delete"
    },
    pendingNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.pending-non-final",
        "defaultMessage": "Pending"
    },
    investigateNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.investigate-non-final",
        "defaultMessage": "Investigate"
    },
    cancelNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.cancel-non-final",
        "defaultMessage": "Cancel"
    },
    workInProgressNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.work-in-progress-non-final",
        "defaultMessage": "Work In Progress"
    },
    canceledNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.canceled-non-final",
        "defaultMessage": "Canceled"
    },
    completedNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.completed-non-final",
        "defaultMessage": "Completed"
    }
});

});

parcelRegister("ehhWF", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $ca5aa3800c78c5e7$export$b70265791d2079d4);

var $5d231 = parcelRequire("5d231");
const $ca5aa3800c78c5e7$export$b70265791d2079d4 = (formatMessage)=>({
        Open: {
            ogStatus: formatMessage((0, $5d231.messages).openNonFinal),
            jiraStatus: formatMessage((0, $5d231.messages).pendingNonFinal),
            lozengeContent: formatMessage((0, $5d231.messages).pendingNonFinal),
            appearance: 'inprogress'
        },
        Resolve: {
            ogStatus: formatMessage((0, $5d231.messages).resolveNonFinal),
            jiraStatus: formatMessage((0, $5d231.messages).investigateNonFinal),
            lozengeContent: formatMessage((0, $5d231.messages).workInProgressNonFinal),
            appearance: 'inprogress'
        },
        Close: {
            ogStatus: formatMessage((0, $5d231.messages).closeNonFinal),
            jiraStatus: formatMessage((0, $5d231.messages).cancelNonFinal),
            lozengeContent: formatMessage((0, $5d231.messages).canceledNonFinal),
            appearance: 'success'
        },
        Delete: {
            ogStatus: formatMessage((0, $5d231.messages).deleteNonFinal),
            jiraStatus: formatMessage((0, $5d231.messages).resolveNonFinal),
            lozengeContent: formatMessage((0, $5d231.messages).completedNonFinal),
            appearance: 'success'
        }
    });

});



parcelRegister("68VJ0", function(module, exports) {

$parcel$export(module.exports, "IntegrationsStep", () => $84054426601bde9b$export$d87d670a1449abbf);

var $eUqFw = parcelRequire("eUqFw");

var $27B3S = parcelRequire("27B3S");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $iFmgL = parcelRequire("iFmgL");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
parcelRequire("4MHAP");
var $eIOEP = parcelRequire("eIOEP");
parcelRequire("fsvBj");
var $6njbi = parcelRequire("6njbi");
var $hV43Y = parcelRequire("hV43Y");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $c7H0g = parcelRequire("c7H0g");
var $1R3n5 = parcelRequire("1R3n5");

var $iXxc0 = parcelRequire("iXxc0");

var $jeqlo = parcelRequire("jeqlo");

var $220rR = parcelRequire("220rR");

var $5MGFf = parcelRequire("5MGFf");

var $gVzxN = parcelRequire("gVzxN");

var $2QBwV = parcelRequire("2QBwV");

var $7X8R1 = parcelRequire("7X8R1");

var $31ogk = parcelRequire("31ogk");

var $l1wSv = parcelRequire("l1wSv");

var $c8m9N = parcelRequire("c8m9N");

var $i3BZW = parcelRequire("i3BZW");
const $84054426601bde9b$export$d87d670a1449abbf = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ counts: counts }] = (0, $2QBwV.useIntegrationCounts)();
    const [{ syncedIntegrations: syncedIntegrations, hasSyncedIntegration: hasSyncedIntegration }] = (0, $2QBwV.useSyncedIntegrations)();
    const [{ deprecatedIntegrations: deprecatedIntegrations, hasDeprecatedIntegration: hasDeprecatedIntegration }] = (0, $2QBwV.useDeprecatedIntegrations)();
    const [{ discontinuedIntegrations: discontinuedIntegrations, hasDiscontinuedIntegration: hasDiscontinuedIntegration }] = (0, $2QBwV.useDiscontinuedIntegrations)();
    const [{ incomingCallIntegrations: incomingCallIntegrations, hasIncomingCallIntegration: hasIncomingCallIntegration }] = (0, $2QBwV.useIncomingCallIntegrations)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isPrimaryAdmin = (0, $c7H0g.useIsAdmin)();
    if (!counts.data || !deprecatedIntegrations.data || !incomingCallIntegrations.data || !syncedIntegrations.data || !discontinuedIntegrations.data) throw new Error('IntegrationsStep - integrations data should be loaded at this point');
    const totalCount = counts.data.totalCount;
    const notSyncedIntegrationCount = counts.data.chatCount + deprecatedIntegrations.data?.count;
    const syncedIntegrationCount = counts.data.totalCount - notSyncedIntegrationCount;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220rR.TransitionHomeHeader), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).integrationsTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).integrationsDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($hV43Y))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($6njbi))),
            alt: "",
            width: 130
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).integrationsTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $c8m9N.messages).taskOneDescriptionNonFinal, {
        totalCount: totalCount,
        syncedIntegrationCount: syncedIntegrationCount,
        notSyncedIntegrationCount: notSyncedIntegrationCount
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: "/jira/settings/products/ops/integrations",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $c8m9N.messages).taskOneActionButtonNonFinal))))), hasSyncedIntegration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($7X8R1))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).integrationsTaskTwoNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $iXxc0.Anchor)
                }
            }
        }
    }, formatMessage((0, $c8m9N.messages).taskTwoDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i3BZW.SyncedIntegrationsTable), {
        syncedIntegrations: syncedIntegrations
    }))), hasDiscontinuedIntegration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).integrationsTaskThreeNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $c8m9N.messages).taskThreeDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l1wSv.DiscontinuedIntegrationsTable), {
        discontinuedIntegrations: discontinuedIntegrations
    }))), hasDeprecatedIntegration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).integrationsTaskFourNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $c8m9N.messages).taskFourDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $31ogk.DeprecatedIntegrationsTable), {
        deprecatedIntegrations: deprecatedIntegrations
    }))), hasIncomingCallIntegration && (isSiteAdmin || isPrimaryAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($eIOEP))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($eIOEP))),
            alt: "",
            width: 139
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).integrationsTaskFiveNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $c8m9N.messages).taskFiveDescriptionNonFinal, {
        incomingCallIntegrations: incomingCallIntegrations.data.count
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: "/jira/settings/products/ops/incoming-call",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $c8m9N.messages).taskFiveActionButtonNonFinal))))));
};

});
parcelRegister("4MHAP", function(module, exports) {

$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("eIOEP")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("eIOEP")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = fn5hfx2htbhq8ggtqmfxfk7
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/fn5hfx2htbhq8ggtqmfxfk7

var $9TZf5 = parcelRequire("9TZf5");

var $eIOEP = parcelRequire("eIOEP");
const $974b20a960910471$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($eIOEP)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($eIOEP))
});
var $974b20a960910471$export$2e2bcd8739ae039 = $974b20a960910471$var$Illustration;
// for advanced use only
const $974b20a960910471$export$a179c88182cb9d56 = [
    0,
    0,
    191,
    239
];

});
parcelRegister("eIOEP", function(module, exports) {
module.exports = new URL("android-black-chat.8170c98f.svg", import.meta.url).toString();

});


parcelRegister("fsvBj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2629be9c3e70a33d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("hV43Y")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6njbi")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tkm7rmprbgw57n9vt8r59gw
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tkm7rmprbgw57n9vt8r59gw

var $9TZf5 = parcelRequire("9TZf5");

var $6njbi = parcelRequire("6njbi");

var $hV43Y = parcelRequire("hV43Y");
const $2629be9c3e70a33d$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($hV43Y)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6njbi))
});
var $2629be9c3e70a33d$export$2e2bcd8739ae039 = $2629be9c3e70a33d$var$Illustration;
// for advanced use only
const $2629be9c3e70a33d$export$a179c88182cb9d56 = [
    0,
    0,
    221,
    207
];

});
parcelRegister("6njbi", function(module, exports) {
module.exports = new URL("integrations-darkmode.c1854228.svg", import.meta.url).toString();

});

parcelRegister("hV43Y", function(module, exports) {
module.exports = new URL("integrations.a739abe5.svg", import.meta.url).toString();

});


parcelRegister("7X8R1", function(module, exports) {
module.exports = new URL("integrations-task-two-illustration.1ec667da.svg", import.meta.url).toString();

});

parcelRegister("31ogk", function(module, exports) {

$parcel$export(module.exports, "DeprecatedIntegrationsTable", () => $d1b4ea42749ff3dd$export$69e4937f38d9a6ae);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $cGL6G = parcelRequire("cGL6G");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");

var $8cU5f = parcelRequire("8cU5f");

var $8uD7Y = parcelRequire("8uD7Y");

var $1v6uX = parcelRequire("1v6uX");
const $d1b4ea42749ff3dd$export$69e4937f38d9a6ae = ({ deprecatedIntegrations: deprecatedIntegrations })=>{
    if (!deprecatedIntegrations.data) throw new Error('DeprecatedIntegrationsTable should be rendered when synced integrations are loaded');
    const rows = deprecatedIntegrations.data.values.map((item, index)=>({
            key: `row-${index}`,
            cells: [
                {
                    key: `cell-${index}-deprecated-integration`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                        space: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                        size: "xsmall",
                        src: item.logoUrl
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                        position: "top",
                        content: item.integrationName
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "p",
                        maxLines: 1
                    }, item.integrationName))))
                },
                {
                    key: `cell-${index}-product-name`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "p",
                        maxLines: 1
                    }, item.integrationTypeName))
                },
                {
                    key: `cell-${index}-team-name`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "p",
                        maxLines: 1
                    }, item.teamName))
                }
            ]
        }));
    const head = {
        cells: [
            {
                key: 'deprecated-integration',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $1v6uX.messages).deprecatedIntegrationsTableIntegrationNameHeadNonFinal)),
                isSortable: true
            },
            {
                key: 'product-name',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $1v6uX.messages).deprecatedIntegrationsProductNameHeadNonFinal))
            },
            {
                key: 'team-name',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $1v6uX.messages).deprecatedIntegrationsTeamNameHeadNonFinal))
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $1v6uX.messages).deprecatedIntegrationCountNonFinal,
        values: {
            count: deprecatedIntegrations.data.count
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cGL6G.default), {
        isLoading: deprecatedIntegrations.loading,
        isFixedSize: true,
        head: head,
        rows: rows,
        rowsPerPage: 5,
        defaultPage: 1
    }));
};

});
parcelRegister("1v6uX", function(module, exports) {

$parcel$export(module.exports, "messages", () => $16e91a7deb72156b$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $16e91a7deb72156b$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    deprecatedIntegrationsTableIntegrationNameHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.deprecated-integrations-table.deprecated-integrations-table-integration-name-head-non-final",
        "defaultMessage": "Integration"
    },
    deprecatedIntegrationsProductNameHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.deprecated-integrations-table.deprecated-integrations-product-name-head-non-final",
        "defaultMessage": "Product"
    },
    deprecatedIntegrationsTeamNameHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.deprecated-integrations-table.deprecated-integrations-team-name-head-non-final",
        "defaultMessage": "Team"
    },
    deprecatedIntegrationCountNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.deprecated-integrations-table.deprecated-integration-count-non-final",
        "defaultMessage": "{count, plural, one {{count} integration} other {{count} integrations}} were left behind in Opsgenie:"
    }
});

});


parcelRegister("l1wSv", function(module, exports) {

$parcel$export(module.exports, "DiscontinuedIntegrationsTable", () => $70cc3d696b98a39c$export$3b69d6ab3073278b);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $cGL6G = parcelRequire("cGL6G");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");

var $8cU5f = parcelRequire("8cU5f");

var $8uD7Y = parcelRequire("8uD7Y");

var $3qtEi = parcelRequire("3qtEi");
const $70cc3d696b98a39c$export$3b69d6ab3073278b = ({ discontinuedIntegrations: discontinuedIntegrations })=>{
    if (!discontinuedIntegrations.data) throw new Error('DiscontinuedIntegrationsTable should be rendered when synced integrations are loaded');
    const rows = discontinuedIntegrations.data.values.map((item, index)=>({
            key: `row-${index}`,
            cells: [
                {
                    key: `cell-${index}-discontinued-integration`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                        space: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                        size: "xsmall",
                        src: item.logoUrl
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                        position: "top",
                        content: item.integrationName
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "p",
                        maxLines: 1
                    }, item.integrationName))))
                },
                {
                    key: `cell-${index}-product-name`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "p",
                        maxLines: 1
                    }, item.integrationTypeName))
                },
                {
                    key: `cell-${index}-team-name`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "p",
                        maxLines: 1
                    }, item.teamName))
                }
            ]
        }));
    const head = {
        cells: [
            {
                key: 'discontinued-integration',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3qtEi.messages).discontinuedIntegrationsTableIntegrationNameHeadNonFinal)),
                isSortable: true
            },
            {
                key: 'product-name',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3qtEi.messages).discontinuedIntegrationsProductNameHeadNonFinal))
            },
            {
                key: 'team-name',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3qtEi.messages).discontinuedIntegrationsTeamNameHeadNonFinal))
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $3qtEi.messages).discontinuedIntegrationCountNonFinal,
        values: {
            count: discontinuedIntegrations.data.count
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cGL6G.default), {
        isLoading: discontinuedIntegrations.loading,
        isFixedSize: true,
        head: head,
        rows: rows,
        rowsPerPage: 5,
        defaultPage: 1
    }));
};

});
parcelRegister("3qtEi", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3234a9988c0b83e1$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $3234a9988c0b83e1$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    discontinuedIntegrationsTableIntegrationNameHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.discontinued-integrations-table.discontinued-integrations-table-integration-name-head-non-final",
        "defaultMessage": "Integration"
    },
    discontinuedIntegrationsProductNameHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.discontinued-integrations-table.discontinued-integrations-product-name-head-non-final",
        "defaultMessage": "Product"
    },
    discontinuedIntegrationsTeamNameHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.discontinued-integrations-table.discontinued-integrations-team-name-head-non-final",
        "defaultMessage": "Team"
    },
    discontinuedIntegrationCountNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.discontinued-integrations-table.discontinued-integration-count-non-final",
        "defaultMessage": "{count, plural, one {{count} integration} other {{count} integrations}} that are unavailable in Jira:"
    }
});

});


parcelRegister("c8m9N", function(module, exports) {

$parcel$export(module.exports, "messages", () => $624fcd7e82077832$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $624fcd7e82077832$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    taskOneDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.task-one-description-non-final",
        "defaultMessage": "\nOut of {totalCount, plural, one {{totalCount} Opsgenie integration} other {{totalCount} Opsgenie integrations}}, {syncedIntegrationCount, plural, one {{syncedIntegrationCount} integration is} other {{syncedIntegrationCount} integrations are}}  fully synced with Jira Service Management.\n{notSyncedIntegrationCount, plural, =0 {} one {{notSyncedIntegrationCount} integration wasn't synced either because it isn't supported in Jira Service Management or is a chat integration that you'll need to configure manually.} other {{notSyncedIntegrationCount} integrations weren't synced either because they aren't supported in Jira Service Management or are chat integrations that you'll need to configure manually.}} \n\nTo manage your integrations, go to **Settings > Products > Integrations**.\n        "
    },
    taskOneActionButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.task-one-action-button-non-final",
        "defaultMessage": "View your integrations"
    },
    taskTwoDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.task-two-description-non-final",
        "defaultMessage": "\nYour Opsgenie's integrations with Jira and Jira Service Management are now available as Sync in **Settings > Products > Syncs**.\n\nYou can set up more syncs with your service and software projects on the same site, or a different site. [Read more about sync](https://support.atlassian.com/jira-service-management-cloud/docs/what-is-sync/).\n        "
    },
    taskThreeDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.task-three-description-non-final",
        "defaultMessage": "These are Opsgenie integrations with products that are unavailable for addition in Jira Service Management. You can edit existing instances that are synced with Jira Service Management but can't add new ones."
    },
    taskFourDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.task-four-description-non-final",
        "defaultMessage": "\nThese integrations weren't moved to Jira Service Management as we're ending support for some of them. They'll continue to work in Opsgenie until you turn off Opsgenie."
    },
    taskFiveDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.task-five-description-non-final",
        "defaultMessage": "\nAll {incomingCallIntegrations, plural, one {{incomingCallIntegrations} incoming call integration} other {{incomingCallIntegrations} incoming call integrations}} incoming call integrations in Opsgenie are now available in Jira Service Management as a native feature, not integrations. You'll find it in **Settings > Products > Incoming call routing**."
    },
    taskFiveActionButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.task-five-action-button-non-final",
        "defaultMessage": "Go to incoming call routing"
    }
});

});

parcelRegister("i3BZW", function(module, exports) {

$parcel$export(module.exports, "SyncedIntegrationsTable", () => $febd0dc04598f66a$export$4e5f47ba6988d9d2);

var $eUqFw = parcelRequire("eUqFw");

var $cGL6G = parcelRequire("cGL6G");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");

var $8uD7Y = parcelRequire("8uD7Y");

var $gJoz5 = parcelRequire("gJoz5");
const $febd0dc04598f66a$export$4e5f47ba6988d9d2 = ({ syncedIntegrations: syncedIntegrations })=>{
    if (!syncedIntegrations.data) throw new Error('SyncedIntegrationsTable should be rendered when synced integrations are loaded');
    const rows = syncedIntegrations.data.values.map((item, index)=>({
            key: `row-${index}`,
            cells: [
                {
                    key: `cell-${index}-sync-integration`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "p",
                        maxLines: 1
                    }, item.integrationName))
                },
                {
                    key: `cell-${index}-team-name`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "p",
                        maxLines: 1
                    }, item.teamName))
                }
            ]
        }));
    const head = {
        cells: [
            {
                key: 'sync-integration',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gJoz5.messages).syncedIntegrationsTableIntegrationNameHeadNonFinal)),
                isSortable: true
            },
            {
                key: 'team-name',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gJoz5.messages).syncedIntegrationsTableTeamNameHeadNonFinal))
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $gJoz5.messages).syncedIntegrationCountNonFinal,
        values: {
            count: syncedIntegrations.data.count
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cGL6G.default), {
        isLoading: syncedIntegrations.loading,
        isFixedSize: true,
        head: head,
        rows: rows,
        rowsPerPage: 5,
        defaultPage: 1
    }));
};

});
parcelRegister("gJoz5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e2026c516b8975e8$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $e2026c516b8975e8$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    syncedIntegrationsTableIntegrationNameHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.synced-integrations-table.synced-integrations-table-integration-name-head-non-final",
        "defaultMessage": "Sync"
    },
    syncedIntegrationsTableTeamNameHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.synced-integrations-table.synced-integrations-table-team-name-head-non-final",
        "defaultMessage": "Team name"
    },
    syncedIntegrationCountNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.synced-integrations-table.synced-integration-count-non-final",
        "defaultMessage": "{count, plural, one {{count} Opsgenie integration} other {{count} Opsgenie integrations}} are now syncs:"
    }
});

});



parcelRegister("k1XvG", function(module, exports) {

$parcel$export(module.exports, "TransitionHomeLeft", () => $f55b9a629836d0ea$export$2e4f33c9d0d1e59b);

var $eUqFw = parcelRequire("eUqFw");

var $iFmgL = parcelRequire("iFmgL");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $4kMup = parcelRequire("4kMup");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $c7H0g = parcelRequire("c7H0g");
var $1R3n5 = parcelRequire("1R3n5");

var $1askq = parcelRequire("1askq");

var $8KYeC = parcelRequire("8KYeC");

var $3RJ7R = parcelRequire("3RJ7R");

var $glNWE = parcelRequire("glNWE");

var $bMblX = parcelRequire("bMblX");

var $FQXY2 = parcelRequire("FQXY2");

var $23gLr = parcelRequire("23gLr");

var $lRLws = parcelRequire("lRLws");

var $chMCU = parcelRequire("chMCU");

var $9mhoi = parcelRequire("9mhoi");

var $emdrr = parcelRequire("emdrr");

var $220rR = parcelRequire("220rR");

var $2GL1T = parcelRequire("2GL1T");

var $5MGFf = parcelRequire("5MGFf");

var $a5i7W = parcelRequire("a5i7W");

var $3IZ9E = parcelRequire("3IZ9E");

var $c1CyL = parcelRequire("c1CyL");

var $dc8n7 = parcelRequire("dc8n7");

var $8OZdV = parcelRequire("8OZdV");

var $3CBya = parcelRequire("3CBya");

var $2QBwV = parcelRequire("2QBwV");

var $bkVBU = parcelRequire("bkVBU");

var $hjidz = parcelRequire("hjidz");

var $5e5rs = parcelRequire("5e5rs");

var $2Q2AK = parcelRequire("2Q2AK");

var $fQGVM = parcelRequire("fQGVM");
const $f55b9a629836d0ea$export$2e4f33c9d0d1e59b = ()=>{
    const { changeActiveContent: changeActiveContent } = (0, $3IZ9E.useProgressActions)();
    const [{ latestContent: latestContent }] = (0, $3IZ9E.useProgressStore)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const stepsRef = (0, $eUqFw.useRef)({
        [(0, $c1CyL.ProgressContents).Home]: null,
        [(0, $c1CyL.ProgressContents).UsersAndRoles]: null,
        [(0, $c1CyL.ProgressContents).Alerts]: null,
        [(0, $c1CyL.ProgressContents).Notifications]: null,
        [(0, $c1CyL.ProgressContents).Teams]: null,
        [(0, $c1CyL.ProgressContents).ChatTools]: null,
        [(0, $c1CyL.ProgressContents).AutomateAlertAndIncidentResponse]: null,
        [(0, $c1CyL.ProgressContents).Integrations]: null,
        [(0, $c1CyL.ProgressContents).Heartbeats]: null,
        [(0, $c1CyL.ProgressContents).Find]: null,
        [(0, $c1CyL.ProgressContents).DeprecatedOnes]: null,
        [(0, $c1CyL.ProgressContents).Incidents]: null
    });
    (0, $eUqFw.useEffect)(()=>{
        stepsRef.current[latestContent]?.focus();
    }, [
        latestContent
    ]);
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isPrimaryAdmin = (0, $c7H0g.useIsAdmin)();
    const [{ isTeamAdmin: isTeamAdmin }] = (0, $bkVBU.useIsTeamAdmin)();
    const [usersWithoutAdminRole] = (0, $2Q2AK.useGetUsersWithoutAdminRole)();
    const [usersWithoutCustomRole] = (0, $2Q2AK.useGetUsersWithoutCustomRole)();
    const [stakeholders] = (0, $2Q2AK.useStakeholders)();
    const [connections] = (0, $dc8n7.useChatToolsConnections)();
    const [{ hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats, hasDeprecatedTotalHeartbeats: hasDeprecatedTotalHeartbeats, isExceedHeartbeatLimit: isExceedHeartbeatLimit }] = (0, $8OZdV.useDeprecatedHeartbeats)();
    const [{ hasIntegrations: hasIntegrations }] = (0, $2QBwV.useIntegrationCounts)();
    const [{ hasTeams: hasTeams }] = (0, $hjidz.useTeams)();
    const [{ hasSyncedIntegration: hasSyncedIntegration }] = (0, $2QBwV.useSyncedIntegrations)();
    const [{ hasDeprecatedIntegration: hasDeprecatedIntegration }] = (0, $2QBwV.useDeprecatedIntegrations)();
    const [{ hasDiscontinuedIntegration: hasDiscontinuedIntegration }] = (0, $2QBwV.useDiscontinuedIntegrations)();
    const [{ hasIncomingCallIntegration: hasIncomingCallIntegration }] = (0, $2QBwV.useIncomingCallIntegrations)();
    const [{ hasDeprecatedGroups: hasDeprecatedGroups }] = (0, $8OZdV.useDeprecatedGroups)();
    const [{ hasDeprecatedNotificationPolicies: hasDeprecatedNotificationPolicies }] = (0, $8OZdV.useDeprecatedNotificationPolicies)();
    const [{ isCopied: isCopied, shouldDisplaySuccessBanner: shouldDisplaySuccessBanner, isEligibleForCopy: isEligibleForCopy }] = (0, $3CBya.useIncidents)();
    const [integrations] = (0, $dc8n7.useChatToolsIntegrations)();
    const [{ isRBNEnabled: isRBNEnabled, ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart, areOgAppsDeactivated: areOgAppsDeactivated, isJnaAppDownloaded: isJnaAppDownloaded, areOgRulesDuplicated: areOgRulesDuplicated, error: error, loading: loading }] = (0, $5e5rs.useTransitioningStatus)();
    if (error || loading) // Users should not see this screen if one of the requests is still loading or error
    throw new Error('TransitionHomeLeft should not be rendered if transitioning status is still loading or errored');
    const isOptimalTooling = (0, $1ybV0.ff)('platform.show-optimal-tooling_brgom');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingInline: "space.400",
        paddingBlock: "space.300",
        xcss: $f55b9a629836d0ea$var$wrapperBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220rR.TransitionHomeHeader), {
        title: formatMessage((0, $fQGVM.messages).titleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $fQGVM.messages).descriptionNonFinal, {
            link: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
                    href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/",
                    target: "_blank"
                }, text)
        }))
    }), (isSiteAdmin || isPrimaryAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GL1T.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $c1CyL.ProgressContents).UsersAndRoles] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $c1CyL.ProgressContents).UsersAndRoles, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: [
                $f55b9a629836d0ea$var$iconBoxStyles,
                $f55b9a629836d0ea$var$blueBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($9mhoi))),
            alt: ""
        })),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).usersAndRolesTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).usersAndRolesDescriptionNonFinal),
        // content will changeActiveContent when count is 0
        tasks: (0, $a5i7W.getUsersAndRolesTasks)({
            isOptimalTooling: isOptimalTooling,
            isSiteAdmin: isSiteAdmin,
            adminDifferenceCount: usersWithoutAdminRole?.data?.count || 0,
            customRoleDifferenceCount: usersWithoutCustomRole?.data?.count || 0,
            stakeholderCount: stakeholders?.data?.userCount || 0
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GL1T.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $c1CyL.ProgressContents).Alerts] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $c1CyL.ProgressContents).Alerts, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: [
                $f55b9a629836d0ea$var$iconBoxStyles,
                $f55b9a629836d0ea$var$orangeBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($1askq))),
            alt: ""
        })),
        title: isOptimalTooling ? formatMessage((0, $5MGFf.messages).alertsAndOnCallTitleNonFinal) : formatMessage((0, $5MGFf.messages).alertsTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).alertsDescriptionNonFinal),
        tasks: (0, $a5i7W.getAlertsTasks)(isOptimalTooling)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GL1T.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $c1CyL.ProgressContents).Notifications] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $c1CyL.ProgressContents).Notifications, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: [
                $f55b9a629836d0ea$var$iconBoxStyles,
                $f55b9a629836d0ea$var$redSubtlerBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($chMCU))),
            alt: ""
        })),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).notificationsTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).notificationsDescriptionNonFinal),
        tasks: (0, $a5i7W.getNotificationsTasks)({
            isRBNEnabled: isRBNEnabled,
            ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart,
            areOgAppsDeactivated: areOgAppsDeactivated,
            isJnaAppDownloaded: isJnaAppDownloaded,
            areOgRulesDuplicated: areOgRulesDuplicated
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GL1T.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $c1CyL.ProgressContents).Teams] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $c1CyL.ProgressContents).Teams, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: [
                $f55b9a629836d0ea$var$iconBoxStyles,
                $f55b9a629836d0ea$var$yellowBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($emdrr))),
            alt: ""
        })),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).teamsTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).teamsDescriptionNonFinal),
        tasks: (0, $a5i7W.getTeamsTasks)(isOptimalTooling, hasTeams)
    }), (isPrimaryAdmin || isTeamAdmin) && connections?.data?.count !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GL1T.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $c1CyL.ProgressContents).ChatTools] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $c1CyL.ProgressContents).ChatTools, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: [
                $f55b9a629836d0ea$var$iconBoxStyles,
                $f55b9a629836d0ea$var$blueSublestBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($3RJ7R))),
            alt: ""
        })),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).chatToolsTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).chatToolsDescriptionNonFinal),
        tasks: (0, $a5i7W.getChatToolsTasks)({
            isChatToolsConnectedToJSM: false,
            isOgIntegrationsCopiedToJSM: false,
            isDuplicateNotificationsPrevented: false,
            isPrimaryAdmin: isPrimaryAdmin,
            hasIntegration: (integrations?.data?.count || 0) > 0
        })
    }), (isPrimaryAdmin || isSiteAdmin || isTeamAdmin) && isOptimalTooling && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GL1T.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $c1CyL.ProgressContents).AutomateAlertAndIncidentResponse] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $c1CyL.ProgressContents).AutomateAlertAndIncidentResponse, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: [
                $f55b9a629836d0ea$var$iconBoxStyles,
                $f55b9a629836d0ea$var$yellowWarningBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8KYeC))),
            alt: ""
        })),
        title: formatMessage((0, $5MGFf.messages).automateAlertAndIncidentResponseTitleNonFinal),
        description: formatMessage((0, $5MGFf.messages).automateAlertAndIncidentResponseDescriptionNonFinal),
        tasks: (0, $a5i7W.getAutomateAlertAndIncidentResponseTasks)()
    }), (isPrimaryAdmin || isSiteAdmin || isTeamAdmin) && isOptimalTooling && hasIntegrations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GL1T.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $c1CyL.ProgressContents).Integrations] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $c1CyL.ProgressContents).Integrations, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: [
                $f55b9a629836d0ea$var$iconBoxStyles,
                $f55b9a629836d0ea$var$opaqSublestBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($lRLws))),
            alt: ""
        })),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).integrationsTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).integrationsDescriptionNonFinal),
        tasks: (0, $a5i7W.getIntegrationsTasks)({
            hasSyncedIntegration: hasSyncedIntegration,
            hasDiscontinuedIntegration: hasDiscontinuedIntegration,
            hasDeprecatedIntegration: hasDeprecatedIntegration,
            hasIncomingCallIntegration: hasIncomingCallIntegration,
            shouldHaveIncomingCallPermission: isSiteAdmin || isPrimaryAdmin
        })
    }), isOptimalTooling && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GL1T.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $c1CyL.ProgressContents).Incidents] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $c1CyL.ProgressContents).Incidents, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: [
                $f55b9a629836d0ea$var$iconBoxStyles,
                $f55b9a629836d0ea$var$yellowBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($23gLr))),
            width: 40,
            alt: ""
        })),
        title: formatMessage((0, $5MGFf.messages).incidentsTitleNonFinal),
        description: formatMessage((0, $5MGFf.messages).incidentsDescriptionNonFinal),
        tasks: (0, $a5i7W.getIncidentsTasks)({
            isCopied: isCopied,
            shouldDisplaySuccessBanner: shouldDisplaySuccessBanner,
            isEligibleForCopy: isEligibleForCopy
        })
    }), isOptimalTooling && (hasDeprecatedGlobalHeartbeats || hasDeprecatedTotalHeartbeats) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GL1T.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $c1CyL.ProgressContents).Heartbeats] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $c1CyL.ProgressContents).Heartbeats, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: [
                $f55b9a629836d0ea$var$iconBoxStyles,
                $f55b9a629836d0ea$var$blueBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($FQXY2))),
            width: 40,
            alt: ""
        })),
        title: formatMessage((0, $5MGFf.messages).heartbeatsTitleNonFinal),
        description: formatMessage((0, $5MGFf.messages).heartbeatsDescriptionNonFinal),
        tasks: (0, $a5i7W.getHeartbeatsTasks)({
            hasDeprecatedTotalHeartbeats: hasDeprecatedTotalHeartbeats,
            hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats,
            isExceedHeartbeatLimit: isExceedHeartbeatLimit
        })
    }), isOptimalTooling && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GL1T.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $c1CyL.ProgressContents).Find] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $c1CyL.ProgressContents).Find, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: [
                $f55b9a629836d0ea$var$iconBoxStyles,
                $f55b9a629836d0ea$var$yellowBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($bMblX))),
            width: 40,
            alt: ""
        })),
        title: formatMessage((0, $5MGFf.messages).findWhatYouAreLookingForTitleNonFinal),
        description: formatMessage((0, $5MGFf.messages).findWhatYouAreLookingForDescriptionNonFinal),
        tasks: (0, $a5i7W.getFindWhatYouAreLookingForTasks)()
    }), (isPrimaryAdmin || isSiteAdmin || isTeamAdmin) && isOptimalTooling && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GL1T.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $c1CyL.ProgressContents).DeprecatedOnes] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $c1CyL.ProgressContents).DeprecatedOnes, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: [
                $f55b9a629836d0ea$var$iconBoxStyles,
                $f55b9a629836d0ea$var$redSubtlestBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($glNWE))),
            alt: ""
        })),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).deprecatedOnesTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).deprecatedOnesDescriptionNonFinal),
        tasks: (0, $a5i7W.getDeprecatedOnesTasks)({
            isAdmin: isSiteAdmin || isPrimaryAdmin,
            hasDeprecatedIntegration: hasDeprecatedIntegration,
            hasDeprecatedGroups: hasDeprecatedGroups,
            hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats,
            hasDeprecatedNotificationPolicies: hasDeprecatedNotificationPolicies
        })
    })));
};
const $f55b9a629836d0ea$var$iconBoxStyles = (0, $1ZAYh.xcss)({
    flexShrink: 0,
    borderRadius: 'border.radius.200',
    width: '56px',
    height: '56px'
});
const $f55b9a629836d0ea$var$orangeBackgroundStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.orange.subtler'
});
const $f55b9a629836d0ea$var$blueBackgroundStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.blue.subtler'
});
const $f55b9a629836d0ea$var$redSubtlerBackgroundStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.red.subtler'
});
const $f55b9a629836d0ea$var$redSubtlestBackgroundStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.red.subtlest'
});
const $f55b9a629836d0ea$var$yellowBackgroundStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.yellow.subtler'
});
const $f55b9a629836d0ea$var$yellowWarningBackgroundStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.warning'
});
const $f55b9a629836d0ea$var$blueSublestBackgroundStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.blue.subtlest'
});
const $f55b9a629836d0ea$var$opaqSublestBackgroundStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.gray.subtler'
});
const $f55b9a629836d0ea$var$wrapperBoxStyles = (0, $1ZAYh.xcss)({
    height: '100%',
    overflow: 'auto'
});

});
parcelRegister("2GL1T", function(module, exports) {

$parcel$export(module.exports, "TransitionHomeStep", () => $44eaa19a407d298c$export$14cf80e1c8ab4f8);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $iFmgL = parcelRequire("iFmgL");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");

var $5tIf1 = parcelRequire("5tIf1");

var $i8hLm = parcelRequire("i8hLm");

var $7upPz = parcelRequire("7upPz");

var $5MGFf = parcelRequire("5MGFf");
const $44eaa19a407d298c$export$14cf80e1c8ab4f8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ icon: icon, title: title, description: description, tasks: tasks, onClick: onClick }, ref)=>{
    const notCompletedTaskCount = tasks.filter((task)=>!task.isCompleted).length;
    const onKeyDown = (0, $eUqFw.useCallback)((e, taskIndex)=>{
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick(taskIndex);
        }
    }, [
        onClick
    ]);
    const isOptimalTooling = (0, $1ybV0.ff)('platform.show-optimal-tooling_brgom');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ref: ref,
        xcss: $44eaa19a407d298c$var$wrapperBoxStyles,
        padding: "space.250",
        onClick: ()=>onClick(),
        onKeyDown: onKeyDown,
        role: "button",
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.150"
    }, notCompletedTaskCount !== 0 && !isOptimalTooling && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "new"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $5MGFf.messages).notCompletedTaskCountNonFinal,
        values: {
            count: notCompletedTaskCount
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.200"
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, title), description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.050"
    }, !isOptimalTooling && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h3",
        level: "h200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).taskTitleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), null, tasks.map((task, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            role: "button",
            xcss: $44eaa19a407d298c$var$taskBoxStyles,
            padding: "space.100",
            key: index,
            tabIndex: 0,
            onClick: (e)=>{
                e.stopPropagation();
                onClick(index);
            },
            onKeyDown: (e)=>{
                e.stopPropagation();
                onKeyDown(e, index);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            space: "space.050"
        }, isOptimalTooling ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5tIf1.ArrowRightCircleOutline), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: task.isCompleted ? (0, (/*@__PURE__*/$parcel$interopDefault($i8hLm))) : (0, (/*@__PURE__*/$parcel$interopDefault($7upPz))),
            alt: ""
        }), task.description)))))));
});
const $44eaa19a407d298c$var$wrapperBoxStyles = (0, $1ZAYh.xcss)({
    boxShadow: 'elevation.shadow.raised',
    borderRadius: 'border.radius.200',
    cursor: 'pointer'
});
const $44eaa19a407d298c$var$taskBoxStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.raised',
    borderRadius: 'border.radius.100',
    transition: '0.2s ease all',
    ':hover': {
        backgroundColor: 'elevation.surface.overlay.hovered'
    },
    ':focus': {
        backgroundColor: 'elevation.surface.overlay.hovered'
    }
});

});
parcelRegister("5tIf1", function(module, exports) {

$parcel$export(module.exports, "ArrowRightCircleOutline", () => $e8d6e71bbe5299f5$export$bcf2c0707dacd14a);

var $eUqFw = parcelRequire("eUqFw");
const $e8d6e71bbe5299f5$export$bcf2c0707dacd14a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        role: "presentation",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        width: "20",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "var(--ds-chart-gray-bold, #8590A2)",
        d: "M17.5 10c0 4.1421-3.3579 7.5-7.5 7.5S2.5 14.1421 2.5 10 5.8579 2.5 10 2.5s7.5 3.3579 7.5 7.5Zm-1.6667 0c0-3.2217-2.6116-5.8333-5.8333-5.8333-3.2217 0-5.8333 2.6116-5.8333 5.8333 0 3.2217 2.6116 5.8333 5.8333 5.8333 3.2217 0 5.8333-2.6116 5.8333-5.8333Zm-2.6773-.514-.0668-.0753a.8359.8359 0 0 1 .1848.2798.767.767 0 0 1 .0295.0878.776.776 0 0 1 .0206.098.8203.8203 0 0 1 .0092.1237l-.0001.0161a.896.896 0 0 1-.0032.0591L13.3333 10a.8482.8482 0 0 1-.0287.2178.9379.9379 0 0 1-.0315.0939.8159.8159 0 0 1-.1145.199.8807.8807 0 0 1-.0412.049l-.0282.0296-2.5 2.5a.8333.8333 0 0 1-1.2478-1.1l.0694-.0786 1.0767-1.0774H7.5a.8333.8333 0 0 1-.1045-1.6601L7.5 9.1667h2.9891L9.4108 8.0893a.8335.8335 0 0 1-.0694-1.1l.0694-.0786a.8335.8335 0 0 1 1.1-.0693l.0784.0693 2.5024 2.5024a.8205.8205 0 0 1 .0644.073Z"
    }));

});

parcelRegister("i8hLm", function(module, exports) {
module.exports = new URL("coin-blue.78b4366c.svg", import.meta.url).toString();

});

parcelRegister("7upPz", function(module, exports) {
module.exports = new URL("coin-purple.19ad91e6.svg", import.meta.url).toString();

});


parcelRegister("fQGVM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0b0ac73731ec911d$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $0b0ac73731ec911d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    titleNonFinal: {
        "id": "eoc-changeboarding.transition-home.left.title-non-final",
        "defaultMessage": "Moving from Opsgenie to Jira Service Management"
    },
    descriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.left.description-non-final",
        "defaultMessage": "Here's a guide with everything that you must know and do to complete your move from Opsgenie to Jira Service Management. <link>Get more help with the move</link>"
    }
});

});


parcelRegister("5owwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc730a12a8efa771$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dc730a12a8efa771$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    backButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.back-button-non-final",
        "defaultMessage": "Back"
    },
    closeButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.close-button-non-final",
        "defaultMessage": "Close"
    },
    minimizeNonFinal: {
        "id": "eoc-changeboarding.transition-home.minimize-non-final",
        "defaultMessage": "Minimize"
    },
    giveFeedbackButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.give-feedback-button-non-final",
        "defaultMessage": "Give feedback"
    }
});

});

parcelRegister("b0TOk", function(module, exports) {

$parcel$export(module.exports, "NotificationsStep", () => $40be58c65bcf047a$export$1318b037d331dd3a);

var $eUqFw = parcelRequire("eUqFw");

var $1zbEq = parcelRequire("1zbEq");

var $8uD7Y = parcelRequire("8uD7Y");

var $220rR = parcelRequire("220rR");

var $5MGFf = parcelRequire("5MGFf");

var $5e5rs = parcelRequire("5e5rs");

var $kGOYm = parcelRequire("kGOYm");

var $21ymY = parcelRequire("21ymY");

var $d37Bw = parcelRequire("d37Bw");
const $40be58c65bcf047a$export$1318b037d331dd3a = ()=>{
    const [{ isRBNEnabled: isRBNEnabled, ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart, loading: loading }] = (0, $5e5rs.useTransitioningStatus)();
    if (loading) throw new Error('NotificationsStep - Data should be loaded at this point.');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220rR.TransitionHomeHeader), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).notificationsTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).notificationsDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d37Bw.CardZero), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGOYm.CardOne), null), (ogAppExistsAtTransitioningStart || isRBNEnabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $21ymY.CardTwo), null));
};

});
parcelRegister("kGOYm", function(module, exports) {

$parcel$export(module.exports, "CardOne", () => $818b23fb2f08727d$export$d129961cedc364a0);

var $eUqFw = parcelRequire("eUqFw");

var $27B3S = parcelRequire("27B3S");

var $hI5oG = parcelRequire("hI5oG");

var $aWvIp = parcelRequire("aWvIp");

var $jgrQL = parcelRequire("jgrQL");

var $iFmgL = parcelRequire("iFmgL");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jeqlo = parcelRequire("jeqlo");

var $gVzxN = parcelRequire("gVzxN");

var $5e5rs = parcelRequire("5e5rs");

var $cPcIS = parcelRequire("cPcIS");

var $9kcbS = parcelRequire("9kcbS");

var $k3Ih7 = parcelRequire("k3Ih7");
const $818b23fb2f08727d$var$Layout = ({ children: children, isRBNEnabled: isRBNEnabled, isJnaAppDownloaded: isJnaAppDownloaded, ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            alignInline: "center",
            space: "space.300"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($cPcIS))),
            alt: "https://atlassian.app.link/jswc-mobile-app-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: [
                $818b23fb2f08727d$var$inlineStyles,
                $818b23fb2f08727d$var$qrTextStyles
            ]
        }, formatMessage((0, $9kcbS.default).downloadJna)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).notificationsTaskTwoNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $9kcbS.default).descriptionNonFinal, {
        hideMiddleParagraph: isJnaAppDownloaded && !isRBNEnabled && !ogAppExistsAtTransitioningStart,
        isRBNEnabled: isRBNEnabled
    }))), children));
};
const $818b23fb2f08727d$export$d129961cedc364a0 = ()=>{
    const [{ isJnaAppDownloaded: isJnaAppDownloaded, isRBNEnabled: isRBNEnabled, ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart }] = (0, $5e5rs.useTransitioningStatus)();
    if (/* 1A & 1B */ !isJnaAppDownloaded || /* 1G */ isJnaAppDownloaded && isRBNEnabled || /* 1F */ isJnaAppDownloaded && !isRBNEnabled && !ogAppExistsAtTransitioningStart) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($818b23fb2f08727d$var$Layout, {
        isJnaAppDownloaded: isJnaAppDownloaded,
        isRBNEnabled: isRBNEnabled,
        ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $818b23fb2f08727d$var$inlineStyles,
        alignBlock: "baseline",
        space: "space.050"
    }, isJnaAppDownloaded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        label: "",
        primaryColor: `var(--ds-icon, ${(0, $PdmhA).N500})`,
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jgrQL))), {
        label: "",
        primaryColor: `var(--ds-icon, ${(0, $PdmhA).N500})`,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), isJnaAppDownloaded ? (0, $9kcbS.default).addedJnaNonFinal : (0, $9kcbS.default).couldntDetectJnaNonFinal)));
    // 1E & 1D
    if (isJnaAppDownloaded && !isRBNEnabled && ogAppExistsAtTransitioningStart) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($818b23fb2f08727d$var$Layout, {
        isJnaAppDownloaded: isJnaAppDownloaded,
        isRBNEnabled: isRBNEnabled,
        ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k3Ih7.MobileDeviceList), null));
    throw new Error('CardOne - unexpected state');
};
const $818b23fb2f08727d$var$inlineStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtlest'
});
const $818b23fb2f08727d$var$qrTextStyles = (0, $1ZAYh.xcss)({
    textAlign: 'center',
    width: '148px'
});

});
parcelRegister("jgrQL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0651d627acb5549$var$_react = $e0651d627acb5549$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $e0651d627acb5549$var$_information = $e0651d627acb5549$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $e0651d627acb5549$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e0651d627acb5549$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $e0651d627acb5549$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
    }, props, {
        newIcon: $e0651d627acb5549$var$_information.default
    }));
$e0651d627acb5549$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $e0651d627acb5549$var$_default = module.exports.default = $e0651d627acb5549$var$EditorInfoIcon;

});

parcelRegister("cPcIS", function(module, exports) {
module.exports = new URL("qr.39fb77b5.png", import.meta.url).toString();

});

parcelRegister("9kcbS", function(module, exports) {

$parcel$export(module.exports, "default", () => $45eb6898d166b4e6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $45eb6898d166b4e6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    descriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.description-non-final",
        "defaultMessage": "Get notified of alerts, check on-call schedules, and manage your notifications on the go, with the Jira Cloud mobile app.\n\n{hideMiddleParagraph, select,\n    true {}\n    other {{isRBNEnabled, select,\n        true {A central notification template applies to you, so you need the Jira Cloud mobile app to receive push notifications for alerts and on-call. Central notification templates are called role-based notifications in Jira Service Management.}\n        other {Once you've installed it, you can add it as a notification method to start receiving push notifications for alerts and on-call. Your notification rules from Opsgenie will be copied to your Jira Cloud mobile app, without any changes.}\n    }}\n}\n\nMake sure your Jira Cloud mobile app is up-to-date and that you allow it to send you push notifications in your mobile settings."
    },
    couldntDetectJnaNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.couldnt-detect-jna-non-final",
        "defaultMessage": "Couldn't detect any mobile device with Jira Cloud app installed"
    },
    addedJnaNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.added-jna-non-final",
        "defaultMessage": "Added. You'll now get push notifications from the Jira Cloud mobile app."
    },
    downloadJna: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.download-jna",
        "defaultMessage": "Scan to download the Jira Cloud mobile app"
    }
});

});

parcelRegister("k3Ih7", function(module, exports) {

$parcel$export(module.exports, "MobileDeviceList", () => $45a46c32a7d4d99b$export$c47ee992c358ec22);

var $eUqFw = parcelRequire("eUqFw");

var $7opLA = parcelRequire("7opLA");

var $bT7k5 = parcelRequire("bT7k5");

var $cGL6G = parcelRequire("cGL6G");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iIei2 = parcelRequire("iIei2");

var $5e5rs = parcelRequire("5e5rs");

var $ajHC5 = parcelRequire("ajHC5");

var $f1RNe = parcelRequire("f1RNe");
const $45a46c32a7d4d99b$var$ROWS_PER_PAGE = 5;
const $45a46c32a7d4d99b$export$c47ee992c358ec22 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ values: values }] = (0, $iIei2.useJNAAppStatus)();
    const [{ areOgRulesDuplicated: areOgRulesDuplicated }] = (0, $5e5rs.useTransitioningStatus)();
    const { sync: sync, loading: syncLoading, syncStarted: syncStarted } = (0, $ajHC5.useSyncDevices)();
    if (!values) throw new Error('MobileDeviceList - data should be loaded when you render this component');
    const [ids, setIds] = (0, $eUqFw.useState)(new Set());
    const lastCheckbox = (0, $eUqFw.useRef)();
    const handleCopy = ()=>{
        const items = [
            ...ids.values()
        ];
        const isValid = items.length > 0;
        if (!isValid) {
            lastCheckbox.current?.setCustomValidity(formatMessage((0, $f1RNe.default).noSelectionNonFinal));
            lastCheckbox.current?.reportValidity();
            return;
        }
        sync(items);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $45a46c32a7d4d99b$var$fullWidthWrapperStyles,
            ...values.length > $45a46c32a7d4d99b$var$ROWS_PER_PAGE ? [] : [
                $45a46c32a7d4d99b$var$fixBottomMarginStyles
            ]
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cGL6G.default), {
        head: {
            cells: [
                // Without a space in content, the styles break visually
                ...!areOgRulesDuplicated ? [
                    {
                        content: ' '
                    }
                ] : [],
                {
                    content: formatMessage((0, $f1RNe.default).mobileDeviceNonFinal),
                    isSortable: true,
                    key: 'string'
                },
                {
                    content: formatMessage((0, $f1RNe.default).appVersionNonFinal)
                },
                ...areOgRulesDuplicated ? [
                    {
                        content: formatMessage((0, $f1RNe.default).statusNonFinal)
                    }
                ] : []
            ]
        },
        rows: values.filter((device)=>!areOgRulesDuplicated || device.synced).map((value)=>({
                key: value.name + value.id,
                cells: [
                    ...!areOgRulesDuplicated ? [
                        {
                            content: !areOgRulesDuplicated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
                                onChange: (e)=>{
                                    if (e.target.checked) {
                                        e.target?.setCustomValidity('');
                                        setIds((prev)=>new Set(prev).add(value.id));
                                    } else setIds((prev)=>{
                                        const newSet = new Set(prev);
                                        newSet.delete(value.id);
                                        return newSet;
                                    });
                                },
                                ref: (r)=>{
                                    if (r && !r.checked) lastCheckbox.current = r;
                                },
                                value: value.id,
                                isDisabled: syncStarted || syncLoading,
                                isChecked: ids.has(value.id)
                            })
                        }
                    ] : [],
                    {
                        content: value.name
                    },
                    {
                        content: value.appVersion
                    },
                    ...areOgRulesDuplicated ? [
                        {
                            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                                appearance: value.synced ? 'success' : 'removed'
                            }, formatMessage(value.synced ? (0, $f1RNe.default).statusOnNonFinal : (0, $f1RNe.default).statusOffNonFinal))
                        }
                    ] : []
                ]
            })),
        rowsPerPage: $45a46c32a7d4d99b$var$ROWS_PER_PAGE,
        defaultPage: 1,
        defaultSortKey: "string",
        defaultSortOrder: "ASC"
    })), !areOgRulesDuplicated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        onClick: handleCopy,
        isLoading: syncLoading,
        isDisabled: syncStarted
    }, formatMessage((0, $f1RNe.default).duplicateButtonNonFinal)));
};
const $45a46c32a7d4d99b$var$fullWidthWrapperStyles = (0, $1ZAYh.xcss)({
    width: '100%'
});
const $45a46c32a7d4d99b$var$fixBottomMarginStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.negative.200'
});

});
parcelRegister("ajHC5", function(module, exports) {

$parcel$export(module.exports, "useSyncDevices", () => $43dbf528ebbdc651$export$53be5cda9a22cfe3);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $dWLk9 = parcelRequire("dWLk9");

var $nZEiD = parcelRequire("nZEiD");

var $kiZx2 = parcelRequire("kiZx2");
const $43dbf528ebbdc651$export$53be5cda9a22cfe3 = ()=>{
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [syncStarted, setSyncStarted] = (0, $eUqFw.useState)(false);
    const cloudId = (0, $dWLk9.useCloudId)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    return {
        sync: (items)=>{
            if (loading) return;
            setLoading(true);
            (0, $nZEiD.syncDevicesEndpoint)(cloudId, items).then(()=>{
                setSyncStarted(true);
            }).catch(()=>{
                showFlag({
                    type: 'error',
                    title: (0, $kiZx2.default).errorTitleNonFinal,
                    description: (0, $kiZx2.default).errorDescriptionNonFinal
                });
            }).finally(()=>setLoading(false));
        },
        loading: loading,
        syncStarted: syncStarted
    };
};

});
parcelRegister("nZEiD", function(module, exports) {

$parcel$export(module.exports, "syncDevicesEndpoint", () => $8ab4020028221bbc$export$7ae6daa69946ab0c);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $8ab4020028221bbc$export$7ae6daa69946ab0c = (cloudId, values)=>(0, $lRmyA.performPostRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/notification-preferences/sync-devices`, {
        body: JSON.stringify({
            values: values
        })
    }).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'syncDevicesEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });

});

parcelRegister("kiZx2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2556c4128cbb56e0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2556c4128cbb56e0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-sync-devices.error-title-non-final",
        "defaultMessage": "Couldn't update notification methods"
    },
    errorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-sync-devices.error-description-non-final",
        "defaultMessage": "Make sure your Jira Cloud mobile app is up-to-date, and try again."
    }
});

});


parcelRegister("f1RNe", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea1f1759db5befe6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ea1f1759db5befe6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    mobileDeviceNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.mobile-device-non-final",
        "defaultMessage": "Mobile device"
    },
    appVersionNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.app-version-non-final",
        "defaultMessage": "App version"
    },
    statusNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.status-non-final",
        "defaultMessage": "Status"
    },
    statusOnNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.status-on-non-final",
        "defaultMessage": "ON"
    },
    statusOffNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.status-off-non-final",
        "defaultMessage": "OFF"
    },
    duplicateButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.duplicate-button-non-final",
        "defaultMessage": "Add Jira Cloud app as notification method"
    },
    noSelectionNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.no-selection-non-final",
        "defaultMessage": "No mobile devices selected. Select mobile devices to add Jira Cloud as the notification method."
    }
});

});



parcelRegister("21ymY", function(module, exports) {

$parcel$export(module.exports, "CardTwo", () => $55b06cb9b835e9f5$export$59c392903286a545);

var $eUqFw = parcelRequire("eUqFw");

var $27B3S = parcelRequire("27B3S");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $bT7k5 = parcelRequire("bT7k5");

var $hI5oG = parcelRequire("hI5oG");

var $aWvIp = parcelRequire("aWvIp");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jeqlo = parcelRequire("jeqlo");

var $gVzxN = parcelRequire("gVzxN");

var $5e5rs = parcelRequire("5e5rs");

var $glUDm = parcelRequire("glUDm");

var $4XJ0T = parcelRequire("4XJ0T");
const $55b06cb9b835e9f5$var$Layout = ({ children: children, heading: heading })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, heading ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).notificationsTaskThreeNonFinal)), children));
const $55b06cb9b835e9f5$export$59c392903286a545 = ()=>{
    const [{ isRBNEnabled: isRBNEnabled, ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart, areOgAppsDeactivated: areOgAppsDeactivated }] = (0, $5e5rs.useTransitioningStatus)();
    const { deactivate: deactivate, loading: loading } = (0, $glUDm.useDeactivateOG)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const checkbox = (0, $eUqFw.useRef)(null);
    const handleDeactivate = ()=>{
        checkbox.current?.reportValidity();
        if (!checkbox.current?.validity.valid) return;
        deactivate();
    };
    // #region ogAppExistsAtTransitioningStart === false
    if (!ogAppExistsAtTransitioningStart && !isRBNEnabled) throw new Error('CardTwo - unexpected state');
    // 2D
    if (!ogAppExistsAtTransitioningStart && isRBNEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55b06cb9b835e9f5$var$Layout, {
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).contactMethodTitleNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $4XJ0T.default).contactMethodDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: "/jira/settings/personal/alert-notifications",
        target: "_blank"
    }, formatMessage((0, $4XJ0T.default).manageContactMethodsNonFinal)));
    // #endregion
    // #region ogAppExistsAtTransitioningStart === true
    // 2A & 2B
    if (ogAppExistsAtTransitioningStart && !isRBNEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55b06cb9b835e9f5$var$Layout, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $4XJ0T.default).avoidDuplicateNotificationsNonFinal))), !areOgAppsDeactivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        ref: checkbox,
        isRequired: true,
        label: formatMessage((0, $4XJ0T.default).acknowledgeTurnOffOgNonFinal)
    }), !areOgAppsDeactivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        onClick: handleDeactivate,
        isLoading: loading
    }, formatMessage((0, $4XJ0T.default).turnOffOgCtaNonFinal)), areOgAppsDeactivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $55b06cb9b835e9f5$var$inlineStyles,
        alignBlock: "baseline",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        label: "",
        primaryColor: `var(--ds-icon, ${(0, $PdmhA).N500})`,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4XJ0T.default).ogTurnedOffNonFinal)));
    // 2C
    if (ogAppExistsAtTransitioningStart && isRBNEnabled && areOgAppsDeactivated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55b06cb9b835e9f5$var$Layout, {
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).preventPushTitleNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $4XJ0T.default).preventPushDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $55b06cb9b835e9f5$var$inlineStyles,
        alignBlock: "baseline",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        label: "",
        primaryColor: `var(--ds-icon, ${(0, $PdmhA).N500})`,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4XJ0T.default).ogTurnedOffNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55b06cb9b835e9f5$var$Layout, {
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).deleteOgContactMethodsTitleNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $4XJ0T.default).deleteOgCantactMethodsDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: "/jira/settings/personal/alert-notifications",
        target: "_blank"
    }, formatMessage((0, $4XJ0T.default).manageContactMethodsNonFinal))));
    // 2E
    if (ogAppExistsAtTransitioningStart && isRBNEnabled && !areOgAppsDeactivated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55b06cb9b835e9f5$var$Layout, {
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).preventPushTitleNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $4XJ0T.default).preventPushDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        ref: checkbox,
        isRequired: true,
        label: formatMessage((0, $4XJ0T.default).acknowledgeTurnOffOgNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        onClick: handleDeactivate,
        isLoading: loading
    }, formatMessage((0, $4XJ0T.default).turnOffOgCtaNonFinal)));
    // #endregion
    throw new Error('CardOne - unexpected state');
};
const $55b06cb9b835e9f5$var$inlineStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtlest'
});

});
parcelRegister("glUDm", function(module, exports) {

$parcel$export(module.exports, "useDeactivateOG", () => $14e20cb78febc82d$export$17946bfaf216a108);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $dWLk9 = parcelRequire("dWLk9");

var $1Ah8o = parcelRequire("1Ah8o");

var $5e5rs = parcelRequire("5e5rs");

var $3Pyev = parcelRequire("3Pyev");
const $14e20cb78febc82d$export$17946bfaf216a108 = ()=>{
    const { deactivateOgApps: deactivateOgApps } = (0, $5e5rs.useTransitioningStatusActions)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    return {
        deactivate: ()=>{
            if (loading) return;
            setLoading(true);
            (0, $1Ah8o.deactivateOGEndpoint)(cloudId).then(deactivateOgApps).catch(()=>{
                showFlag({
                    type: 'error',
                    title: (0, $3Pyev.default).errorTitleNonFinal,
                    description: (0, $3Pyev.default).errorDescriptionNonFinal,
                    actions: [
                        {
                            content: (0, $3Pyev.default).errorActionNonFinal,
                            href: '/jira/settings/personal/alert-notifications',
                            target: '_blank'
                        }
                    ]
                });
            }).finally(()=>setLoading(false));
        },
        loading: loading
    };
};

});
parcelRegister("1Ah8o", function(module, exports) {

$parcel$export(module.exports, "deactivateOGEndpoint", () => $d586128129cfb9dd$export$4f3458f9d2959064);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $d586128129cfb9dd$export$4f3458f9d2959064 = (cloudId)=>(0, $lRmyA.performPostRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/contact/og-devices/deactivate`, {
        method: 'POST'
    }).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'deactivateOGEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });

});

parcelRegister("3Pyev", function(module, exports) {

$parcel$export(module.exports, "default", () => $b61ad20df099d4aa$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b61ad20df099d4aa$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-deactivate-og.error-title-non-final",
        "defaultMessage": "Couldn't turn off Opsgenie contact methods"
    },
    errorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-deactivate-og.error-description-non-final",
        "defaultMessage": "Please try again. If that doesn't work, you can manually turn off your Opsgenie mobile app in contact methods."
    },
    errorActionNonFinal: {
        "id": "eoc-changeboarding.services.use-deactivate-og.error-action-non-final",
        "defaultMessage": "Manage contact methods"
    }
});

});


parcelRegister("4XJ0T", function(module, exports) {

$parcel$export(module.exports, "default", () => $d118f9316932790e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d118f9316932790e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    preventPushDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-two.prevent-push-description-non-final",
        "defaultMessage": "To receive all your notifications from the Jira Cloud mobile app instead of Opsgenie, you can turn off the Opsgenie mobile app in your contact methods."
    },
    ogTurnedOffNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-two.og-turned-off-non-final",
        "defaultMessage": "Turned off. You'll no longer get push notifications from the Opsgenie mobile app."
    },
    contactMethodDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-two.contact-method-description-non-final",
        "defaultMessage": "Check and update any missing contact methods, so that you get all the alert notifications as configured in the central notification template that's applied to you."
    },
    manageContactMethodsNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-two.manage-contact-methods-non-final",
        "defaultMessage": "Manage contact methods"
    },
    deleteOgCantactMethodsDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-two.delete-og-cantact-methods-description-non-final",
        "defaultMessage": "To ensure your notifications aren't pushed to your Opsgenie mobile app (which is now turned off), delete your Opsgenie contact method.\n\nThis makes Jira Mobile Cloud mobile app your primary contact method in central-notification templates."
    },
    turnOffOgCtaNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-two.turn-off-og-cta-non-final",
        "defaultMessage": "Turn off Opsgenie mobile app contact method"
    },
    acknowledgeTurnOffOgNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-two.acknowledge-turn-off-og-non-final",
        "defaultMessage": "I understand I'll stop getting alert notifications from Opsgenie mobile app"
    },
    avoidDuplicateNotificationsNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-two.avoid-duplicate-notifications-non-final",
        "defaultMessage": "To avoid duplicate notifications from Jira and Opsgenie mobile apps, you can turn off the Opsgenie mobile app in your contact methods. This will only turn off your Opsgenie mobile app as a contact method, so your notification rules and preferences will not be affected."
    }
});

});


parcelRegister("d37Bw", function(module, exports) {

$parcel$export(module.exports, "CardZero", () => $7a0a904dc44d3166$export$2fa4bd80d48310be);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $27B3S = parcelRequire("27B3S");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $2n1pR = parcelRequire("2n1pR");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $gVzxN = parcelRequire("gVzxN");

var $4cnpV = parcelRequire("4cnpV");
const $7a0a904dc44d3166$var$BlueText = ({ children: children })=>/*#__PURE__*/ $eUqFw.createElement((0, $1Yimi.default), {
        color: "color.link"
    }, children);
const $7a0a904dc44d3166$export$2fa4bd80d48310be = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ $eUqFw.createElement((0, $9Amv1.default), {
        grow: "fill",
        alignInline: "center",
        alignBlock: "center",
        xcss: $7a0a904dc44d3166$var$wrapperInlineStyles
    }, /*#__PURE__*/ $eUqFw.createElement((0, $b5IAe.default), {
        padding: "space.300"
    }, /*#__PURE__*/ $eUqFw.createElement((0, $1zbEq.default), {
        space: "space.200",
        alignInline: "start"
    }, /*#__PURE__*/ $eUqFw.createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ $eUqFw.createElement((0, $8uD7Y.default), (0, $gVzxN.default).notificationsTaskOneNonFinal)), /*#__PURE__*/ $eUqFw.createElement((0, $b5IAe.default), null, /*#__PURE__*/ $eUqFw.createElement((0, $27B3S.default), {
        options: {
            overrides: {
                BlueText: {
                    component: $7a0a904dc44d3166$var$BlueText
                }
            }
        }
    }, formatMessage((0, $4cnpV.default).descriptionNonFinal))), /*#__PURE__*/ $eUqFw.createElement((0, $7u4fN.default), {
        href: "/jira/settings/personal/alert-notifications",
        target: "_blank"
    }, formatMessage((0, $4cnpV.default).manageYourAlertNotificationsNonFinal)))), /*#__PURE__*/ $eUqFw.createElement((0, $b5IAe.default), {
        xcss: $7a0a904dc44d3166$var$illustrationWrapperBoxStyles
    }, /*#__PURE__*/ $eUqFw.createElement((0, $c0jFd.default), {
        xcss: $7a0a904dc44d3166$var$iphoneContainerStyles,
        alignItems: "center",
        justifyContent: "end"
    }, /*#__PURE__*/ $eUqFw.createElement("div", {
        className: (0, $7JEyt.default)([
            "_t9ecrz87 _ca0q9qu9 _19bv9qu9"
        ])
    }, /*#__PURE__*/ $eUqFw.createElement((0, $2n1pR.default), {
        width: 154,
        alt: ""
    })))));
};
const $7a0a904dc44d3166$var$iphoneContainerStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden'
});
const $7a0a904dc44d3166$var$iphoneStyles = null;
const $7a0a904dc44d3166$var$illustrationWrapperBoxStyles = (0, $1ZAYh.xcss)({
    alignSelf: 'end',
    width: '320px',
    flexShrink: 0
});
const $7a0a904dc44d3166$var$wrapperInlineStyles = (0, $1ZAYh.xcss)({
    boxShadow: 'elevation.shadow.raised',
    borderRadius: 'border.radius.200'
});

});
parcelRegister("2n1pR", function(module, exports) {

$parcel$export(module.exports, "default", () => $66e1b5abf26c433a$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = nx9r83bw45698nschcs6kxsg
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/nx9r83bw45698nschcs6kxsg

var $9TZf5 = parcelRequire("9TZf5");

var $ldY7X = parcelRequire("ldY7X");
const $66e1b5abf26c433a$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($ldY7X)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($ldY7X))
});
var $66e1b5abf26c433a$export$2e2bcd8739ae039 = $66e1b5abf26c433a$var$Illustration;
// for advanced use only
const $66e1b5abf26c433a$export$a179c88182cb9d56 = [
    0,
    0,
    155,
    230
];

});
parcelRegister("ldY7X", function(module, exports) {
module.exports = new URL("iphone-black-delete.6b26517f.svg", import.meta.url).toString();

});


parcelRegister("4cnpV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4205c89f33764445$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4205c89f33764445$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    descriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-zero.description-non-final",
        "defaultMessage": "Your contact methods, notification and forwarding rules from Opsgenie are now synced with Jira Service Management, without any changes.\n\nYou'll continue to get your alert and on-call notifications as usual, but they will now be sent by Jira Service Management and not Opsgenie. Update your filters and blocklist in your email client to ensure that you have access to email notifications from '<BlueText>'no-reply@jsm-notifications.atlassian.net'</BlueText>'.\n\nTo manage your alert notification settings, go to **Personal settings** and select Alerts in **Notification settings**."
    },
    manageYourAlertNotificationsNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-zero.manage-your-alert-notifications-non-final",
        "defaultMessage": "Manage your alert notifications"
    }
});

});



parcelRegister("2TO9K", function(module, exports) {

$parcel$export(module.exports, "TransitionHomeRight", () => $4b5329e4695a88fa$export$cd93c3d31025c7e8);

var $eUqFw = parcelRequire("eUqFw");

var $3nnLQ = parcelRequire("3nnLQ");

var $aWvIp = parcelRequire("aWvIp");

var $fD6AU = parcelRequire("fD6AU");

var $lUBoX = parcelRequire("lUBoX");

var $23NQ5 = parcelRequire("23NQ5");

var $ffiyv = parcelRequire("ffiyv");

var $4kMup = parcelRequire("4kMup");
var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $c7H0g = parcelRequire("c7H0g");
var $1R3n5 = parcelRequire("1R3n5");

var $5e5rs = parcelRequire("5e5rs");

var $2wAUb = parcelRequire("2wAUb");

var $1YtWU = parcelRequire("1YtWU");

var $2ftT6 = parcelRequire("2ftT6");
const $4b5329e4695a88fa$export$cd93c3d31025c7e8 = ()=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $5JgJ2.default)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isPrimaryAdmin = (0, $c7H0g.useIsAdmin)();
    const [{ isJnaAppDownloaded: isJnaAppDownloaded, areOgRulesDuplicated: areOgRulesDuplicated, areOgAppsDeactivated: areOgAppsDeactivated, jnaAppDownloadedRatio: jnaAppDownloadedRatio, jnaAppDownloadedUsersCount: jnaAppDownloadedUsersCount, ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart }] = (0, $5e5rs.useTransitioningStatus)();
    const isOptimalTooling = (0, $1ybV0.ff)('platform.show-optimal-tooling_brgom');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: isOptimalTooling ? 'space.600' : 'space.800',
        paddingBlockEnd: "space.300",
        paddingInline: isOptimalTooling ? 'space.500' : 'space.400',
        xcss: $4b5329e4695a88fa$var$rightSideWrapperBoxStyles
    }, !isOptimalTooling && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "h2",
        xcss: $4b5329e4695a88fa$var$titleHeadingBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $1YtWU.messages).titleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        alignBlock: "center"
    }, isJnaAppDownloaded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        label: formatMessage((0, $1YtWU.messages).doneNonFinal),
        primaryColor: "var(--ds-icon-subtle, #626F86)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lUBoX))), {
        label: formatMessage((0, $1YtWU.messages).todoNonFinal),
        primaryColor: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $1YtWU.messages).appDownloadNonFinal)), ogAppExistsAtTransitioningStart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        alignBlock: "center"
    }, areOgRulesDuplicated ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        label: formatMessage((0, $1YtWU.messages).doneNonFinal),
        primaryColor: "var(--ds-icon-subtle, #626F86)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lUBoX))), {
        label: formatMessage((0, $1YtWU.messages).todoNonFinal),
        primaryColor: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $1YtWU.messages).jiraCloudContactMethodNonFinal)), ogAppExistsAtTransitioningStart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        alignBlock: "center"
    }, areOgAppsDeactivated ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        label: formatMessage((0, $1YtWU.messages).doneNonFinal),
        primaryColor: "var(--ds-icon-subtle, #626F86)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lUBoX))), {
        label: formatMessage((0, $1YtWU.messages).todoNonFinal),
        primaryColor: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $1YtWU.messages).turnOffOgNonFinal))), (isPrimaryAdmin || isSiteAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b5329e4695a88fa$var$jnaAppDownloadPercentBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90IgZ.FormattedNumber), {
        ...(0, $1YtWU.messages).jnaAppDownloadPercentNonFinal,
        value: jnaAppDownloadedRatio,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: "percent",
        maximumFractionDigits: 0
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $1YtWU.messages).numberOfUsersJnaDownloadedNonFinal,
        values: {
            numberOfUsers: jnaAppDownloadedUsersCount
        }
    }))), isOptimalTooling && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "h2",
        xcss: $4b5329e4695a88fa$var$titleHeadingBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $1YtWU.messages).titleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ftT6.TodoItem), {
        description: formatMessage((0, $1YtWU.messages).appDownloadNonFinal),
        isChecked: isJnaAppDownloaded
    }), ogAppExistsAtTransitioningStart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ftT6.TodoItem), {
        description: formatMessage((0, $1YtWU.messages).jiraCloudContactMethodNonFinal),
        isChecked: areOgRulesDuplicated
    }), ogAppExistsAtTransitioningStart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ftT6.TodoItem), {
        description: formatMessage((0, $1YtWU.messages).turnOffOgNonFinal),
        isChecked: areOgAppsDeactivated
    }), jnaAppDownloadedUsersCount > 0 && (isPrimaryAdmin || isSiteAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.075",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fD6AU))), {
        label: formatMessage((0, $1YtWU.messages).doneNonFinal),
        primaryColor: `var(--ds-link, ${(0, $PdmhA).B400})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtlest"
    }, formatMessage((0, $1YtWU.messages).numberOfUsersJnaDownloadedWithLozengeNonFinal, {
        numberOfUsers: jnaAppDownloadedUsersCount,
        allUsers: formatNumber(jnaAppDownloadedRatio, {
            style: 'percent',
            maximumFractionDigits: 0
        }),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        lozenge: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, str)
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "hr",
        xcss: $4b5329e4695a88fa$var$dividerStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "h2",
        xcss: $4b5329e4695a88fa$var$titleHeadingBoxStyles
    }, formatMessage((0, $1YtWU.messages).documentationNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        xcss: $4b5329e4695a88fa$var$linkStyles,
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/",
        target: "_blank",
        rel: "noopener noreferrer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b5329e4695a88fa$var$iconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3nnLQ))), {
        label: ""
    })), formatMessage((0, $1YtWU.messages).unlockOperationsInJsmNonFinal), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
        label: "",
        size: "small"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4b5329e4695a88fa$var$cloudStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2wAUb.Clouds), null))));
};
const $4b5329e4695a88fa$var$cloudStyles = (0, $1ZAYh.xcss)({
    width: '85px',
    position: 'absolute',
    bottom: 'space.0',
    right: 'space.0'
});
const $4b5329e4695a88fa$var$rightSideWrapperBoxStyles = (0, $1ZAYh.xcss)({
    position: 'relative',
    width: '340px',
    height: '100%',
    flexShrink: 0,
    backgroundColor: 'color.background.accent.blue.subtlest',
    borderBottomRightRadius: 'border.radius',
    borderTopRightRadius: 'border.radius'
});
const $4b5329e4695a88fa$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexShrink: 0,
    height: '20px',
    width: '24px',
    justifyContent: 'center',
    alignItems: 'center'
});
const $4b5329e4695a88fa$var$titleHeadingBoxStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtlest',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-heading-xxsmall, ${(0, $4lTFP.fontFallback).heading.xxsmall})`,
    textTransform: 'uppercase'
});
const $4b5329e4695a88fa$var$jnaAppDownloadPercentBoxStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.accent.blue',
    fontWeight: 700
});
const $4b5329e4695a88fa$var$linkStyles = (0, $1ZAYh.xcss)({
    textDecoration: 'none',
    display: 'flex',
    columnGap: 'space.075',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.subtle',
        textDecoration: 'underline'
    }
});
const $4b5329e4695a88fa$var$dividerStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    border: '1px solid',
    borderColor: 'color.border'
});

});
parcelRegister("fD6AU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b60f9d0621ab0edb$var$_react = $b60f9d0621ab0edb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $b60f9d0621ab0edb$var$_lightbulb = $b60f9d0621ab0edb$var$_interopRequireDefault((parcelRequire("aUmij")));
function $b60f9d0621ab0edb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b60f9d0621ab0edb$var$LightbulbIcon = (props)=>/*#__PURE__*/ $b60f9d0621ab0edb$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M11.998 4A5.997 5.997 0 0 0 6 9.998c0 2.218 2.288 4.484 2.288 4.484.39.387.71 1.112.71 1.611s.45.907 1 .907h4c.55 0 1-.408 1-.907s.32-1.224.71-1.611c0 0 2.288-2.266 2.288-4.484A5.997 5.997 0 0 0 11.998 4m0 2a4.003 4.003 0 0 1 3.998 3.998c0 1.029-1.145 2.511-1.695 3.064-.507.501-.912 1.216-1.13 1.938h-2.346c-.217-.722-.622-1.435-1.125-1.934-.555-.557-1.7-2.039-1.7-3.068A4.003 4.003 0 0 1 11.998 6m2.965 13c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v.003c0 .55.45 1 1 1h4c.55 0 1-.45 1-1z"/></svg>`
    }, props, {
        newIcon: $b60f9d0621ab0edb$var$_lightbulb.default
    }));
$b60f9d0621ab0edb$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $b60f9d0621ab0edb$var$_default = module.exports.default = $b60f9d0621ab0edb$var$LightbulbIcon;

});
parcelRegister("aUmij", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f106d874eab35ef$var$_react = $7f106d874eab35ef$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7f106d874eab35ef$var$_UNSAFE_baseNew = $7f106d874eab35ef$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $7f106d874eab35ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Lightbulb".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Known uses: learnings in Atlas, initiatives in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f106d874eab35ef$var$LightbulbIcon = (props)=>/*#__PURE__*/ $7f106d874eab35ef$var$_react.default.createElement($7f106d874eab35ef$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M5.75 12.25V14c0 .69.56 1.25 1.25 1.25h2c.69 0 1.25-.56 1.25-1.25v-1.75m-4.5 0v-.715c0-.483-.286-.912-.685-1.182a5.25 5.25 0 1 1 5.871 0c-.4.27-.686.7-.686 1.182v.715m-4.5 0h4.5"/>`
    }, props));
$7f106d874eab35ef$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $7f106d874eab35ef$var$_default = module.exports.default = $7f106d874eab35ef$var$LightbulbIcon;

});


parcelRegister("lUBoX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff3bd719ada455a7$var$_react = $ff3bd719ada455a7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $ff3bd719ada455a7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ff3bd719ada455a7$var$MediaServicesPreselectedIcon = (props)=>/*#__PURE__*/ $ff3bd719ada455a7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" d="M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14m0 2a9 9 0 1 1 0-18 9 9 0 0 1 0 18"/></svg>`
    }, props));
$ff3bd719ada455a7$var$MediaServicesPreselectedIcon.displayName = 'MediaServicesPreselectedIcon';
var $ff3bd719ada455a7$var$_default = module.exports.default = $ff3bd719ada455a7$var$MediaServicesPreselectedIcon;

});

parcelRegister("2wAUb", function(module, exports) {

$parcel$export(module.exports, "Clouds", () => $60c93c01eb244a23$export$517de9992f3047ca);
/* eslint-disable jira/react/no-style-attribute */ 
var $eUqFw = parcelRequire("eUqFw");
const $60c93c01eb244a23$export$517de9992f3047ca = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        role: "presentation",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 85 200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        style: {
            mixBlendMode: 'screen'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        d: "M205.165 216c-12.255 0-22.195-9.637-22.212-21.537v-.01c-.004-11.91-9.954-21.561-22.219-21.558h-23.86c-12.265-.003-22.205-9.665-22.201-21.575v-.01c-.004-11.91-9.954-21.561-22.2191-21.558H22.1622C9.8969 129.728-.0248 120.049 0 108.14v-.297c0-11.9097 9.943-21.5644 22.2084-21.5644h5.5254c12.2654 0 22.2084-9.6547 22.2084-21.5645v-.0103c0-11.9098 9.943-21.5645 22.2083-21.5645h13.7817c12.2654 0 22.2088-9.6547 22.2088-21.5645C108.141 9.6582 118.087 0 130.36 0H373.69c6.627 0 12 5.3726 12 12v192c0 6.627-5.373 12-12 12H205.161h.004Z",
        opacity: ".35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)",
        d: "M230.473 216c-12.255 0-22.194-9.637-22.212-21.537v-.01c-.003-11.91-9.953-21.561-22.219-21.558h-23.859c-12.266-.003-22.205-9.665-22.202-21.575v-.01c-.003-11.91-9.953-21.561-22.219-21.558H47.4708c-12.2653-.024-22.187-9.703-22.1622-21.612v-.297c0-11.9097 9.943-21.5644 22.2084-21.5644h5.5254c12.2654 0 22.2084-9.6547 22.2084-21.5645v-.0103c0-11.9098 9.943-21.5645 22.2083-21.5645h13.7819c12.265 0 22.208-9.6547 22.208-21.5645C133.449 9.6582 143.396 0 155.668 0h243.331c6.627 0 12 5.3726 12 12v192c0 6.627-5.373 12-12 12H230.47h.003Z",
        opacity: ".45"
    })));

});

parcelRegister("1YtWU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2081228bf0067d4a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $2081228bf0067d4a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    titleNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.title-non-final",
        "defaultMessage": "Get alerts on Jira Cloud mobile"
    },
    appDownloadNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.app-download-non-final",
        "defaultMessage": "Get the Jira Cloud mobile app"
    },
    jiraCloudContactMethodNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.jira-cloud-contact-method-non-final",
        "defaultMessage": "Add Jira Cloud mobile app as your notification method"
    },
    turnOffOgNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.turn-off-og-non-final",
        "defaultMessage": "Turn off Opsgenie mobile app in your contact methods"
    },
    numberOfUsersJnaDownloadedNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.number-of-users-jna-downloaded-non-final",
        "defaultMessage": "{numberOfUsers, plural, one {{numberOfUsers} team member} other {{numberOfUsers} team members}} already have the Jira Cloud mobile app."
    },
    jnaAppDownloadPercentNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.jna-app-download-percent-non-final",
        "defaultMessage": "{percent}%"
    },
    doneNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.done-non-final",
        "defaultMessage": "Done"
    },
    todoNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.todo-non-final",
        "defaultMessage": "To do"
    },
    documentationNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.documentation-non-final",
        "defaultMessage": "Get help with the move"
    },
    unlockOperationsInJsmNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.unlock-operations-in-jsm-non-final",
        "defaultMessage": "Set up operations and complete your move to Jira Service Management"
    },
    numberOfUsersJnaDownloadedWithLozengeNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.number-of-users-jna-downloaded-with-lozenge-non-final",
        "defaultMessage": "<lozenge>{numberOfUsers}</lozenge> {numberOfUsers, plural, one {team member} other {team members}} already have the Jira Cloud mobile app, <lozenge>{allUsers}</lozenge> of all users"
    }
});

});

parcelRegister("2ftT6", function(module, exports) {

$parcel$export(module.exports, "TodoItem", () => $d1f7224d690fd970$export$de515f7f7fedd6e3);

var $eUqFw = parcelRequire("eUqFw");

var $aWvIp = parcelRequire("aWvIp");

var $lUBoX = parcelRequire("lUBoX");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bDwCZ = parcelRequire("bDwCZ");
const $d1f7224d690fd970$export$de515f7f7fedd6e3 = ({ isChecked: isChecked, description: description })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.075",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d1f7224d690fd970$var$iconWrapperStyles
    }, isChecked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        label: formatMessage((0, $bDwCZ.messages).doneNonFinal),
        primaryColor: `var(--ds-icon-success, ${(0, $PdmhA).G300})`,
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lUBoX))), {
        label: formatMessage((0, $bDwCZ.messages).todoNonFinal),
        primaryColor: `var(--ds-background-accent-gray-subtler-hovered, ${(0, $PdmhA).N40})`,
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $d1f7224d690fd970$var$descriptionStyles
    }, description));
};
const $d1f7224d690fd970$var$descriptionStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtlest',
    lineHeight: '24px'
});
const $d1f7224d690fd970$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexShrink: 0,
    height: '24px',
    width: '24px',
    justifyContent: 'center',
    alignItems: 'center'
});

});
parcelRegister("bDwCZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8c987aca9ebdd1b3$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $8c987aca9ebdd1b3$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    doneNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.todo-item.done-non-final",
        "defaultMessage": "Done"
    },
    todoNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.todo-item.todo-non-final",
        "defaultMessage": "To do"
    }
});

});



parcelRegister("kG8k5", function(module, exports) {

$parcel$export(module.exports, "TeamsConceptStep", () => $ce7de21f6d7134f6$export$75bf0627b755c06d);

var $eUqFw = parcelRequire("eUqFw");

var $27B3S = parcelRequire("27B3S");

var $hI5oG = parcelRequire("hI5oG");

var $iFmgL = parcelRequire("iFmgL");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");

var $4kMup = parcelRequire("4kMup");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jeqlo = parcelRequire("jeqlo");

var $220rR = parcelRequire("220rR");

var $5MGFf = parcelRequire("5MGFf");

var $jxABB = parcelRequire("jxABB");

var $gVzxN = parcelRequire("gVzxN");

var $hjidz = parcelRequire("hjidz");

var $g4A4b = parcelRequire("g4A4b");

var $8R7P0 = parcelRequire("8R7P0");

var $3l4MF = parcelRequire("3l4MF");

var $9Ty43 = parcelRequire("9Ty43");
const $ce7de21f6d7134f6$export$75bf0627b755c06d = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ hasTeams: hasTeams, teams: teams }] = (0, $hjidz.useTeams)();
    const isOptimalTooling = (0, $1ybV0.ff)('platform.show-optimal-tooling_brgom');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220rR.TransitionHomeHeader), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).teamsTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).teamsDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8R7P0))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($g4A4b))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).teamsTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), {
        options: {
            overrides: {
                ul: {
                    component: (0, $jxABB.UnorderedList)
                },
                li: {
                    component: (0, $jxABB.UnorderedListItem)
                }
            }
        }
    }, formatMessage((0, $3l4MF.messages).taskOneDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/launch-your-team-operations/",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3l4MF.messages).taskOneCtaNonFinal))))), isOptimalTooling && hasTeams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).teamsTaskTwoNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $3l4MF.messages).taskTwoDescriptionNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p",
        color: "color.text.subtlest"
    }, formatMessage((0, $3l4MF.messages).tableDescriptionTextNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Ty43.TeamsTable), {
        teams: teams
    }))))));
};

});
parcelRegister("g4A4b", function(module, exports) {
module.exports = new URL("task-one-illustration-dark.8a85ce87.png", import.meta.url).toString();

});

parcelRegister("8R7P0", function(module, exports) {
module.exports = new URL("task-one-illustration.d1a41afc.png", import.meta.url).toString();

});

parcelRegister("3l4MF", function(module, exports) {

$parcel$export(module.exports, "messages", () => $11b5c2cc467d6991$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $11b5c2cc467d6991$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    taskOneDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.teams-concept-step.task-one-description-non-final",
        "defaultMessage": "You can build your own on-call teams and optimize alerting and on-call settings for your team's purpose and way of working.\n\nWhat you can do with on-call teams:\n\n- assign teams as a responder to alerts\n- create on-call schedules for teams\n- build team-based policies, integrations, automation, maintenance, and more.\n\nThe team admins can manage operations for the team while others can only respond to alerts.\n"
    },
    taskOneCtaNonFinal: {
        "id": "eoc-changeboarding.transition-home.teams-concept-step.task-one-cta-non-final",
        "defaultMessage": "Read how to launch operations for your team"
    },
    taskTwoDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.teams-concept-step.task-two-description-non-final",
        "defaultMessage": "All the teams from Opsgenie have been synced as Atlassian teams, so they'll now be visible on all products on your Atlassian site.\n\nJust so you know, only team members with a Jira Service Management license can use alerting and on-call.\n\nTo browse your teams, select **Teams > Search people and teams** from Jira navigation. On the team's profile page, select **Go to operations** to access alerting and on-call features.\n"
    },
    tableDescriptionTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.teams-concept-step.table-description-text-non-final",
        "defaultMessage": "Here are some of the teams you're a member of:"
    }
});

});

parcelRegister("9Ty43", function(module, exports) {

$parcel$export(module.exports, "TeamsTable", () => $90dcf5db6253d2d1$export$8e18da410be5e057);

var $eUqFw = parcelRequire("eUqFw");

var $6R0C9 = parcelRequire("6R0C9");
var $iJlfe = parcelRequire("iJlfe");

var $7u4fN = parcelRequire("7u4fN");

var $cGL6G = parcelRequire("cGL6G");

var $23NQ5 = parcelRequire("23NQ5");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fpfuU = parcelRequire("fpfuU");
const $90dcf5db6253d2d1$export$8e18da410be5e057 = ({ teams: teams })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!teams.data) return null;
    const rows = teams.data.entities.map((item, index)=>({
            key: `row-${index}`,
            cells: [
                {
                    key: `cell-${index}-name`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6R0C9.default), {
                        avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                            name: item.displayName,
                            src: item.smallAvatarImageUrl
                        }),
                        primaryText: item.displayName,
                        secondaryText: formatMessage((0, $fpfuU.messages).memberCountNonFinal, {
                            count: item.memberCount
                        })
                    })
                },
                {
                    key: `cell-${index}-name`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
                        justifyContent: "end"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                        appearance: "subtle-link",
                        href: `/jira/people/team/${item.id}`,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                            label: ""
                        })
                    }, formatMessage((0, $fpfuU.messages).viewNonFinal)))
                }
            ]
        }));
    const head = {
        cells: [
            {
                key: 'name',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    paddingInlineStart: "space.100"
                }, formatMessage((0, $fpfuU.messages).teamNonFinal)),
                isSortable: true
            },
            {
                key: 'type',
                content: null
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cGL6G.default), {
        isLoading: teams.loading,
        head: head,
        rows: rows,
        rowsPerPage: 5,
        defaultPage: 1
    });
};

});
parcelRegister("6R0C9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d303d2caa12f1c14$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $1Yimi = parcelRequire("1Yimi");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $eri7S = parcelRequire("eri7S");

var $6ecEX = parcelRequire("6ecEX");
function $d303d2caa12f1c14$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d303d2caa12f1c14$var$avatarItemStyles = {
    name: "1dq1lfl",
    styles: "min-width:0;max-width:100%;flex:1 1 100%;line-height:1.4;padding-inline-start:var(--ds-space-100, 8px)"
};
const $d303d2caa12f1c14$var$secondaryTextOldStyles = {
    name: "1udad45",
    styles: "color:var(--ds-text-subtlest, #626F86);font-size:0.85em"
};
const $d303d2caa12f1c14$var$baseTextStyles = {
    name: "1sodx6b",
    styles: "display:block;color:var(--ds-text, #172B4D)"
};
const $d303d2caa12f1c14$var$truncationStyles = {
    name: "n3ut7m",
    styles: "overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $d303d2caa12f1c14$var$getStyles = (css, { backgroundColor: backgroundColor, isInteractive: isInteractive, isDisabled: isDisabled })=>// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @repo/internal/react/no-css-string-literals
    css`
		align-items: center;
		background-color: ${backgroundColor};
		border-radius: ${(0, $lcnyw.borderRadius)()}px;
		border: ${0, $eri7S.BORDER_WIDTH}px solid transparent;
		box-sizing: border-box;
		color: inherit;
		display: flex;
		font-size: inherit;
		font-style: normal;
		font-weight: normal;
		line-height: 1;
		outline: none;
		margin: ${"var(--ds-space-0, 0px)"};
		padding: ${"var(--ds-space-050, 4px)"};
		text-align: left;
		text-decoration: none;
		width: 100%;

		${isInteractive && `
        :hover {
          background-color: ${`var(--ds-background-neutral-subtle-hovered, ${0, $PdmhA.N30})`};
          cursor: pointer;
          text-decoration: none;
        }

        :focus {
          outline: none;
          border-color: ${`var(--ds-border-focused, ${0, $PdmhA.B200})`};
        }

        :active {
          background-color: ${`var(--ds-background-neutral-subtle-pressed, ${0, $PdmhA.B50})`};
        }
      `}

		${isDisabled && `
        cursor: not-allowed;
        opacity: ${"var(--ds-opacity-disabled, 0.5)"};
        pointer-events: none;
      `}
	`;
/**
 * __Avatar item__
 *
 * An avatar item is a wrapper that goes around an avatar when it's displayed alongside text, such as a name or status.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-item/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-item/code)
 */ const $d303d2caa12f1c14$var$AvatarItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ avatar: avatar, backgroundColor: backgroundColor = 'transparent', children: children, isTruncationDisabled: isTruncationDisabled, href: href, isDisabled: isDisabled, onClick: onClick, primaryText: primaryText, secondaryText: secondaryText, target: target, testId: testId, label: label }, ref)=>{
    const getTestId = (testId, children)=>!children ? {
            'data-testid': `${testId}--itemInner`
        } : {
            testId: `${testId}--itemInner`
        };
    const componentProps = ()=>{
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return {
            ...href && (0, $6ecEX.getLinkProps)(href, target),
            ...onClick && !href ? (0, $6ecEX.getButtonProps)(onClick) : {
                onClick: onClick
            }
        };
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css })=>{
        const props = {
            ref: ref,
            className: $d303d2caa12f1c14$var$getStyles(css, {
                backgroundColor: backgroundColor,
                isInteractive: Boolean(onClick || href),
                isDisabled: isDisabled
            }),
            ...componentProps(),
            ...testId && getTestId(testId, children),
            ...(onClick || href) && {
                'aria-label': label
            },
            children: /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, avatar, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: $d303d2caa12f1c14$var$avatarItemStyles
            }, (0, $XHGTv.getBooleanFF)('platform.design-system-team.avatar-item-font-size_830x6') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
                maxLines: isTruncationDisabled ? undefined : 1
            }, primaryText), /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
                color: "color.text.subtlest",
                maxLines: isTruncationDisabled ? undefined : 1,
                size: "UNSAFE_small"
            }, secondaryText)) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                css: [
                    $d303d2caa12f1c14$var$baseTextStyles,
                    !isTruncationDisabled && $d303d2caa12f1c14$var$truncationStyles
                ]
            }, primaryText), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                css: [
                    $d303d2caa12f1c14$var$baseTextStyles,
                    $d303d2caa12f1c14$var$secondaryTextOldStyles,
                    !isTruncationDisabled && $d303d2caa12f1c14$var$truncationStyles
                ]
            }, secondaryText))))
        };
        return children ? children(props) : /*#__PURE__*/ (0, $eUqFw.createElement)((0, $6ecEX.getCustomElement)(isDisabled, href, onClick), props);
    });
});
$d303d2caa12f1c14$var$AvatarItem.displayName = 'AvatarItem';
var $d303d2caa12f1c14$export$2e2bcd8739ae039 = $d303d2caa12f1c14$var$AvatarItem;

});

parcelRegister("fpfuU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $aa9ee6d7b4e1934d$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $aa9ee6d7b4e1934d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    teamNonFinal: {
        "id": "eoc-changeboarding.transition-home.teams-concept-step.teams-table.team-non-final",
        "defaultMessage": "Team"
    },
    viewNonFinal: {
        "id": "eoc-changeboarding.transition-home.teams-concept-step.teams-table.view-non-final",
        "defaultMessage": "View team"
    },
    memberCountNonFinal: {
        "id": "eoc-changeboarding.transition-home.teams-concept-step.teams-table.member-count-non-final",
        "defaultMessage": "{count, plural, one {{count} member} other {{count} members}}"
    }
});

});



parcelRegister("hMEMz", function(module, exports) {

$parcel$export(module.exports, "UsersAndRolesStep", () => $77a68b5f9dad4dbd$export$26e472ebfeed082e);

var $eUqFw = parcelRequire("eUqFw");

var $1zbEq = parcelRequire("1zbEq");

var $8uD7Y = parcelRequire("8uD7Y");

var $c7H0g = parcelRequire("c7H0g");
var $1R3n5 = parcelRequire("1R3n5");

var $220rR = parcelRequire("220rR");

var $5MGFf = parcelRequire("5MGFf");

var $RxS31 = parcelRequire("RxS31");

var $fCYS5 = parcelRequire("fCYS5");
const $77a68b5f9dad4dbd$export$26e472ebfeed082e = ()=>{
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isPrimaryAdmin = (0, $c7H0g.useIsAdmin)();
    if (!isSiteAdmin && !isPrimaryAdmin) throw new Error('UsersAndRolesStep should be rendered only for primary or site admin');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220rR.TransitionHomeHeader), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).usersAndRolesTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5MGFf.messages).usersAndRolesDescriptionNonFinal)
    }), isSiteAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fCYS5.UsersAndRolesStepSiteAdmin), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RxS31.UsersAndRolesStepPrimaryAdmin), null));
};

});
parcelRegister("RxS31", function(module, exports) {

$parcel$export(module.exports, "UsersAndRolesStepPrimaryAdmin", () => $d2517b618771bef0$export$91726114d3504de7);

var $eUqFw = parcelRequire("eUqFw");

var $27B3S = parcelRequire("27B3S");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");

var $02Brq = parcelRequire("02Brq");

var $1SeLe = parcelRequire("1SeLe");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $iXxc0 = parcelRequire("iXxc0");

var $jeqlo = parcelRequire("jeqlo");

var $gVzxN = parcelRequire("gVzxN");

var $2Q2AK = parcelRequire("2Q2AK");

var $dW8ui = parcelRequire("dW8ui");
const $d2517b618771bef0$export$91726114d3504de7 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [usersWithoutAdminRole] = (0, $2Q2AK.useGetUsersWithoutAdminRole)();
    const [usersWithoutCustomRole] = (0, $2Q2AK.useGetUsersWithoutCustomRole)();
    if (usersWithoutAdminRole.data === null || usersWithoutCustomRole.data === null) // Users should not see this screen if one of the requests is still loading or error
    throw new Error('UsersAndRolesStepPrimaryAdmin should not be rendered if users are still loading');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1SeLe.default), {
            width: 168,
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).usersAndRolesTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $dW8ui.messages).taskOneDescriptionPrimaryAdminNonFinal))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02Brq.default), {
            width: 100,
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $gVzxN.default).usersAndRolesTaskTwoNonFinal,
        values: {
            count: usersWithoutAdminRole.data.count
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $iXxc0.Anchor)
                }
            }
        }
    }, usersWithoutAdminRole.data.count > 0 ? formatMessage((0, $dW8ui.messages).taskTwoDescriptionPrimaryAdminNonFinal) : formatMessage((0, $dW8ui.messages).taskTwoEmptyDescriptionPrimaryAdminNonFinal))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02Brq.default), {
            width: 100,
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $gVzxN.default).usersAndRolesTaskThreeNonFinal,
        values: {
            count: usersWithoutCustomRole.data.count
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $iXxc0.Anchor)
                }
            }
        }
    }, usersWithoutCustomRole.data.count > 0 ? formatMessage((0, $dW8ui.messages).taskThreeDescriptionPrimaryAdminNonFinal) : formatMessage((0, $dW8ui.messages).taskThreeEmptyDescriptionPrimaryAdminNonFinal))))));
};

});
parcelRegister("1SeLe", function(module, exports) {

$parcel$export(module.exports, "default", () => $348a63b930427542$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = gb2mq7c36fg799bs6rmv7tbm
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/gb2mq7c36fg799bs6rmv7tbm

var $9TZf5 = parcelRequire("9TZf5");

var $7Pcpv = parcelRequire("7Pcpv");
const $348a63b930427542$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($7Pcpv)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($7Pcpv))
});
var $348a63b930427542$export$2e2bcd8739ae039 = $348a63b930427542$var$Illustration;
// for advanced use only
const $348a63b930427542$export$a179c88182cb9d56 = [
    0,
    0,
    275,
    254
];

});
parcelRegister("7Pcpv", function(module, exports) {
module.exports = new URL("rope-stanchion.597fab6c.svg", import.meta.url).toString();

});


parcelRegister("dW8ui", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4e1a5678574a845b$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $4e1a5678574a845b$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    taskOneDescriptionPrimaryAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.primary-admin.task-one-description-primary-admin-non-final",
        "defaultMessage": "\nYou can manage users' access to operations by giving them an **Admin**, **User**, or a **custom role**.\n**Admins** can create and manage on-call teams, while **Users** can use their team's operations without any admin permissions.\n\nTo manage users and roles, go to **Jira settings > Products > Role assignment** or **Custom roles**.\n        "
    },
    taskTwoDescriptionPrimaryAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.primary-admin.task-two-description-primary-admin-non-final",
        "defaultMessage": "\nThey are an admin in Opsgenie but aren't a product admin in Jira Service Management.\n\nContact your organization admin to give them the **product admin** role in Jira Service Management so they can continue to have the access to configure operations.\n[Read how to make someone a product admin](https://support.atlassian.com/user-management/docs/give-users-admin-permissions/#Make-someone-a-product-admin)\n"
    },
    taskTwoEmptyDescriptionPrimaryAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.primary-admin.task-two-empty-description-primary-admin-non-final",
        "defaultMessage": "Users who were an Opsgenie admin are now a product admin in Jira Service Management. They have the access to configure operations."
    },
    taskThreeDescriptionPrimaryAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.primary-admin.task-three-description-primary-admin-non-final",
        "defaultMessage": "\nThey have a custom role in Opsgenie that isn't supported by Jira Service Management, so they currently have a User role.\n\nContact your organization admin to give them the **product admin** role in Jira Service Management so they can continue to have the access to configure operations.\n[Read how to make someone a product admin](https://support.atlassian.com/user-management/docs/give-users-admin-permissions/#Make-someone-a-product-admin)\n"
    },
    taskThreeEmptyDescriptionPrimaryAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.primary-admin.task-three-empty-description-primary-admin-non-final",
        "defaultMessage": "Users who had a custom role in Opsgenie that isn't supported by Jira Service Management are now given a different role."
    }
});

});


parcelRegister("fCYS5", function(module, exports) {

$parcel$export(module.exports, "UsersAndRolesStepSiteAdmin", () => $e879b1744f59d718$export$e2f0ae870b18b439);

var $eUqFw = parcelRequire("eUqFw");

var $27B3S = parcelRequire("27B3S");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $cSu9v = parcelRequire("cSu9v");

var $iFmgL = parcelRequire("iFmgL");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");

var $1ybV0 = parcelRequire("1ybV0");

var $02Brq = parcelRequire("02Brq");

var $1SeLe = parcelRequire("1SeLe");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $iXxc0 = parcelRequire("iXxc0");

var $jeqlo = parcelRequire("jeqlo");

var $9mUME = parcelRequire("9mUME");

var $cOTlH = parcelRequire("cOTlH");

var $gVzxN = parcelRequire("gVzxN");

var $2Q2AK = parcelRequire("2Q2AK");

var $hug4W = parcelRequire("hug4W");
const $e879b1744f59d718$export$e2f0ae870b18b439 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [usersWithoutAdminRole] = (0, $2Q2AK.useGetUsersWithoutAdminRole)();
    const [usersWithoutCustomRole] = (0, $2Q2AK.useGetUsersWithoutCustomRole)();
    const [stakeholders] = (0, $2Q2AK.useStakeholders)();
    const isOptimalTooling = (0, $1ybV0.ff)('platform.show-optimal-tooling_brgom');
    if (usersWithoutAdminRole.data === null || usersWithoutCustomRole.data === null) // Users should not see this screen if one of the requests is still loading or error
    throw new Error('UsersAndRolesStepSiteAdmin should not be rendered if users are still loading');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1SeLe.default), {
            width: 168,
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gVzxN.default).usersAndRolesTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), null, formatMessage((0, $hug4W.messages).taskOneDescriptionSiteAdminNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: "https://admin.atlassian.com/",
        target: "_blank",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hug4W.messages).goToAtlassianAdministrationButtonNonFinal))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02Brq.default), {
            width: 100,
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $gVzxN.default).usersAndRolesTaskTwoNonFinal,
        values: {
            count: usersWithoutAdminRole.data.count
        }
    })), usersWithoutAdminRole.data.count > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $iXxc0.Anchor)
                }
            }
        }
    }, formatMessage((0, $hug4W.messages).taskTwoDescriptionSiteAdminNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: "https://admin.atlassian.com/",
        target: "_blank",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hug4W.messages).goToAtlassianAdministrationButtonNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOTlH.UsersAndRolesStepTable), {
        data: usersWithoutAdminRole.data,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hug4W.messages).taskTwoTableDescriptionSiteAdminNonFinal)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hug4W.messages).taskTwoEmptyStateSiteAdminNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: "https://admin.atlassian.com/",
        target: "_blank",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hug4W.messages).goToAtlassianAdministrationButtonNonFinal)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02Brq.default), {
            width: 100,
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $gVzxN.default).usersAndRolesTaskThreeNonFinal,
        values: {
            count: usersWithoutCustomRole.data.count
        }
    })), usersWithoutCustomRole.data.count > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $iXxc0.Anchor)
                }
            }
        }
    }, formatMessage((0, $hug4W.messages).taskThreeDescriptionSiteAdminNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: "https://admin.atlassian.com/",
        target: "_blank",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hug4W.messages).goToAtlassianAdministrationButtonNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOTlH.UsersAndRolesStepTable), {
        data: usersWithoutCustomRole.data,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hug4W.messages).taskThreeTableDescriptionSiteAdminNonFinal)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hug4W.messages).taskThreeEmptyStateSiteAdminNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: "https://admin.atlassian.com/",
        target: "_blank",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hug4W.messages).goToAtlassianAdministrationButtonNonFinal)))))), isOptimalTooling && (stakeholders.data?.userCount || 0) > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeqlo.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($9mUME))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $gVzxN.default).usersAndRolesTaskFourNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27B3S.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $iXxc0.Anchor)
                }
            }
        }
    }, formatMessage((0, $hug4W.messages).taskFourDescriptionSiteAdminNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: "https://admin.atlassian.com/",
        target: "_blank"
    }, formatMessage((0, $hug4W.messages).goToAtlassianAdministrationButtonNonFinal))))));
};

});
parcelRegister("9mUME", function(module, exports) {
module.exports = new URL("users-and-roles-task-four-illustration.5598079a.svg", import.meta.url).toString();

});

parcelRegister("cOTlH", function(module, exports) {

$parcel$export(module.exports, "UsersAndRolesStepTable", () => $93bcc1a4e7e0299a$export$b79ee632f1e89073);

var $eUqFw = parcelRequire("eUqFw");

var $6R0C9 = parcelRequire("6R0C9");
var $iJlfe = parcelRequire("iJlfe");

var $7u4fN = parcelRequire("7u4fN");

var $cGL6G = parcelRequire("cGL6G");

var $23NQ5 = parcelRequire("23NQ5");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $8uD7Y = parcelRequire("8uD7Y");

var $8NRWM = parcelRequire("8NRWM");
const $93bcc1a4e7e0299a$export$b79ee632f1e89073 = ({ description: description, data: data })=>{
    const rows = data.values.map((item, index)=>({
            key: `row-${index}`,
            cells: [
                {
                    key: `cell-${index}-user`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        paddingInlineStart: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                        grow: "fill",
                        spread: "space-between",
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6R0C9.default), {
                        avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                            src: item.avatarUrl
                        }),
                        primaryText: item.name,
                        secondaryText: item.role
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        xcss: $93bcc1a4e7e0299a$var$viewProfileButtonBoxStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                        href: `/jira/people/${item.id}`,
                        target: "_blank",
                        appearance: "subtle-link",
                        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                            label: "",
                            primaryColor: "var(--ds-icon-subtle, #626F86)"
                        })
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8NRWM.messages).tableUserCellActionNonFinal)))))
                }
            ]
        }));
    const head = {
        cells: [
            {
                key: 'user',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8NRWM.messages).tableUserCellNonFinal)),
                isSortable: true
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p",
        color: "color.text.subtlest"
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cGL6G.default), {
        head: head,
        rows: rows,
        rowsPerPage: 5,
        defaultPage: 1
    }));
};
const $93bcc1a4e7e0299a$var$viewProfileButtonBoxStyles = (0, $1ZAYh.xcss)({
    flexShrink: 0
});

});
parcelRegister("8NRWM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $55aaafa00f8943af$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $55aaafa00f8943af$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    tableUserCellNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.users-and-roles.table.table-user-cell-non-final",
        "defaultMessage": "User"
    },
    tableUserCellActionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.users-and-roles.table.table-user-cell-action-non-final",
        "defaultMessage": "View profile"
    }
});

});


parcelRegister("hug4W", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1e59251a910b0cfe$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1e59251a910b0cfe$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    taskOneDescriptionSiteAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-one-description-site-admin-non-final",
        "defaultMessage": "\nUse **Atlassian Administration** to manage your teams' access to Jira Service Management and other cloud products.\n\nUsers with the **product admin** role in Jira Service Management can manage the product's settings, including operations, while Users can use the product without any admin permissions.\n        "
    },
    goToAtlassianAdministrationButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.go-to-atlassian-administration-button-non-final",
        "defaultMessage": "Go to Atlassian Administration"
    },
    taskTwoDescriptionSiteAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-two-description-site-admin-non-final",
        "defaultMessage": "\nThey are an admin in Opsgenie but aren't a product admin in Jira Service Management.\n\nYou can give them the **product admin** role in Jira Service Management so they can continue to have the access to configure operations.\n[Read how to make someone a product admin](https://support.atlassian.com/user-management/docs/give-users-admin-permissions/#Make-someone-a-product-admin)\n"
    },
    taskTwoTableDescriptionSiteAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-two-table-description-site-admin-non-final",
        "defaultMessage": "Opsgenie admins who don't have the product admin role:"
    },
    taskTwoEmptyStateSiteAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-two-empty-state-site-admin-non-final",
        "defaultMessage": "Users who were an Opsgenie admin are now a product admin in Jira Service Management. They have the access to configure operations."
    },
    taskThreeDescriptionSiteAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-three-description-site-admin-non-final",
        "defaultMessage": "\nThey have a custom role in Opsgenie that isn't supported by Jira Service Management, so they currently have a User role.\n\nYou can give them the **product admin** role in Jira Service Management so they can continue to have the access to configure operations.\n[Read how to make someone a product admin](https://support.atlassian.com/user-management/docs/give-users-admin-permissions/#Make-someone-a-product-admin)\n"
    },
    taskThreeTableDescriptionSiteAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-three-table-description-site-admin-non-final",
        "defaultMessage": "Opsgenie users who no longer have custom roles:"
    },
    taskThreeEmptyStateSiteAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-three-empty-state-site-admin-non-final",
        "defaultMessage": "Users who had a custom role in Opsgenie that isn't supported by Jira Service Management are now given a different role."
    },
    taskFourDescriptionSiteAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-four-description-site-admin-non-final",
        "defaultMessage": "All the stakeholders from Opsgenie were synced with Jira Service Management as agents, so they'll continue to have product access.\n\nYou can invite more stakeholders to Jira Service Management via Atlassian Administration. They don't need an agent license to join Jira Service Management, if you're on the Premium or Enterprise plan. [Read how to invite stakeholders](https://support.atlassian.com/jira-service-management-cloud/docs/how-can-i-add-and-manage-internal-stakeholders/#Invite-stakeholders-to-Jira-Service-Management)"
    }
});

});





parcelRegister("hO8H1", function(module, exports) {

$parcel$export(module.exports, "useChangeboardingBroadcastWidget", () => $1652a5c028ac88c9$export$bc42a1c2f5132de5);

var $eUqFw = parcelRequire("eUqFw");

var $h4Fhh = parcelRequire("h4Fhh");

var $c7H0g = parcelRequire("c7H0g");
var $1R3n5 = parcelRequire("1R3n5");

var $hhjRL = parcelRequire("hhjRL");
const $1652a5c028ac88c9$export$bc42a1c2f5132de5 = ()=>{
    const { data: data, error: error } = (0, $hhjRL.useOgConsolidationUserState)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const { isTransitionEligible: isTransitionEligible, error: tenantInfoError } = (0, $h4Fhh.useOgTenantInfo)();
    const isEnabled = Boolean((isAdmin || isSiteAdmin) && // Tenant info
    !tenantInfoError && isTransitionEligible && // User state
    !error && data && !data.isBroadcastWidgetDismissed);
    return (0, $eUqFw.useMemo)(()=>({
            isEnabled: isEnabled
        }), [
        isEnabled
    ]);
};

});

parcelRegister("14cXh", function(module, exports) {

$parcel$export(module.exports, "AsyncChangeboardingWidget", () => $0783bf3927b76228$export$18b081c0b87ff753);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $0783bf3927b76228$var$LazyChangeboardingWidget = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("mYrV9")).then(({ BroadcastWidget: BroadcastWidget })=>BroadcastWidget), {
    moduleId: "./src/packages/eoc/changeboarding/src/ui/broadcast-widget/index.tsx"
});
const $0783bf3927b76228$export$18b081c0b87ff753 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "eoc.changeboarding",
        packageName: "jiraEocChangeboarding",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-eoc-changeboarding",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0783bf3927b76228$var$LazyChangeboardingWidget, null)));

});
parcelRegister("mYrV9", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4ZDF5');
        const value = parcelRequire('6oL5p');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4ZDF5").then(()=>parcelRequire('6oL5p'));
}

});


parcelRegister("5W4zT", function(module, exports) {

$parcel$export(module.exports, "AsyncBenefitModal", () => $a5738c8a5aa68e5b$export$efc5bc86e2f54c1c);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $a5738c8a5aa68e5b$var$LazyBenefitModal = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("oNuxl")).then(({ BenefitModal: BenefitModal })=>BenefitModal), {
    moduleId: "./src/packages/eoc/changeboarding/src/ui/benefit-modal/index.tsx"
});
const $a5738c8a5aa68e5b$export$efc5bc86e2f54c1c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "eoc.changeboarding.benefit.modal",
        packageName: "jiraEocChangeboarding",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-eoc-changeboarding-benefit-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a5738c8a5aa68e5b$var$LazyBenefitModal, null)));

});
parcelRegister("oNuxl", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('dgNIr')
        ]);
        const value = parcelRequire('5FwaZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("dgNIr")
    ]).then(()=>parcelRequire('5FwaZ'));
}

});




//# sourceMappingURL=async-eoc-changeboarding-layout-welcome-modal-renderer.e7c627b4.js.map
